import "@cognite/cogs.js/dist/cogs.css";
import "@cognite/cogs-lab/dist/cogs-lab.css";
import { jsx as u, Fragment as k, jsxs as _ } from "react/jsx-runtime";
import { PointerEvents as vg, getWheelEventDelta as Cg, PointerEventsTarget as Ig, Image360Action as Fe, Vector3Pool as Qn, FlexibleControlsType as qe, isFlexibleCameraManager as Pi, CDF_TO_VIEWER_TRANSFORMATION as G, CognitePointCloudModel as xs, CogniteCadModel as Oi, CustomObject as _s, Cognite3DViewer as wg, DefaultNodeAppearance as Ys, ClosestGeometryFinder as cr, isPointVisibleByPlanes as Kc, Overlay3DCollection as xg, PointColorType as et, PointShape as Fn, TreeIndexNodeCollection as Ri, NodeIdNodeCollection as Yc, AnnotationIdPointCloudObjectCollection as _g, PointCloudDMVolumeCollection as Tg, isDMPointCloudModel as dr, isClassicPointCloudModel as Sg, isClassicPointCloudVolume as bg, isDMPointCloudVolume as Ag, IndexSet as Xs, NumericRange as Hi } from "@cognite/reveal";
import Eg, { createContext as Ye, useContext as Xe, useState as M, useEffect as R, useMemo as P, useCallback as Z, useReducer as Mg, useRef as ve, forwardRef as Xc } from "react";
import { remove as lr, isEmpty as Pg, cloneDeep as Mt, split as Og, chunk as Q, maxBy as Zc, max as Rg, partition as Kt, uniqBy as Ue, uniqWith as Dg, concat as kg, zip as Lg, isEqual as Jn, uniqueId as Ho, clamp as Di, uniq as yn, take as Qc, zipWith as Ng, isUndefined as Bg } from "lodash";
import { QueryClient as Fg, QueryClientProvider as Vg, useQuery as j, useQueries as jg, useInfiniteQuery as ur, useQueryClient as Jc, keepPreviousData as zg } from "@tanstack/react-query";
import { Color as D, Group as hr, Box3 as te, Mesh as Ce, MOUSE as qo, Raycaster as Ug, Vector2 as Ct, Vector3 as I, Line3 as ki, AmbientLight as Gg, DirectionalLight as Hg, Quaternion as kt, Plane as ot, Matrix4 as fe, Ray as qg, Float32BufferAttribute as vi, BufferGeometry as Li, LineSegments as qn, BoxGeometry as $g, Euler as Zs, CylinderGeometry as ed, MeshBasicMaterial as qi, SpriteMaterial as Wg, Sprite as Kg, CanvasTexture as Yg, LinearFilter as Xg, NearestFilter as Zg, Uint32BufferAttribute as td, OrthographicCamera as Qg, BackSide as pr, LineBasicMaterial as ei, MeshPhongMaterial as ze, RingGeometry as nd, CircleGeometry as id, DoubleSide as Qs, FrontSide as Js, SphereGeometry as sd, Sphere as Jg, Line as od, Triangle as em, DataTexture as tm, MathUtils as Rt, TextureLoader as rd, RepeatWrapping as oa, PlaneGeometry as nm } from "three";
import { signal as fn, effect as $i } from "@cognite/signals";
import { CaretDownIcon as im, CaretRightIcon as sm, Checkbox as ra, InfoIcon as ad, Tooltip as ce, Body as tt, Button as J, LoaderIcon as Wi, Colors as $o, Loader as om, CounterChip as cd, ImageOffIcon as rm, Flex as U, CloseLargeIcon as dd, ComponentIcon as am, ExpandIcon as cm, CollapseIcon as dm, CloseIcon as ld, Input as Ts, HexagonIcon as lm, Shortcut as um, ChevronUpIcon as ud, ChevronDownIcon as hd, AngleIcon as hm, ArrowLeftIcon as pm, ArrowRightIcon as fm, Axis3DIcon as gm, BugIcon as mm, BorderHorizontalIcon as ym, BorderVerticalIcon as vm, CircleIcon as Cm, ClearAllIcon as Im, CoordinatesIcon as wm, CopyIcon as xm, CropIcon as _m, CubeIcon as Tm, CubesIcon as Sm, CubeFrontLeftIcon as bm, CubeFrontRightIcon as Am, CubeTopIcon as Em, CursorIcon as Mm, CylinderHorizontalIcon as Pm, CylinderVerticalIcon as Om, CylinderArbitraryIcon as Rm, DeleteIcon as Dm, ExpandAlternativeIcon as pd, EyeShowIcon as km, FilterIcon as Lm, FlagIcon as Nm, FlipHorizontalIcon as Bm, FlipVerticalIcon as Fm, FolderIcon as Vm, FolderFilledIcon as jm, GrabIcon as zm, GraphTreeIcon as Um, LeafIcon as Gm, LocationIcon as Hm, PerspectiveIcon as qm, PerspectiveAltIcon as $m, PlaneIcon as Wm, PlusIcon as Km, PointCloudIcon as Ym, PolygonIcon as Xm, RefreshIcon as Zm, RestoreIcon as Qm, RulerIcon as Jm, RulerAlternativeIcon as ey, SaveIcon as ty, ShapesIcon as ny, SettingsIcon as fd, SnowIcon as iy, SunIcon as sy, SyncIcon as oy, VectorLineIcon as ry, VectorZigzagIcon as ay, View360Icon as cy, WaypointIcon as gd, Infobox as md, Slider as dy, Switch as yd, TextLabel as $t, SegmentedControl as aa, Comment as vd, Textarea as ly, Divider as gn, ToolBar as Cd, Menu as uy, Avatar as Id, ShareIcon as fr, LinkIcon as hy, Heading as gr, Dropdown as py, EmptyState as wd, FindIllustration as xd, RangeSlider as fy, SliceIcon as gy, HelpIcon as my, HomeIcon as yy, WorldIcon as vy, ColorPaletteIcon as _d, AssetsIcon as Cy, IconWrapper as Iy, ChevronRightSmallIcon as wy, LayersIcon as xy, AddIcon as _y, RemoveIcon as Ty } from "@cognite/cogs.js";
import We from "assert";
import { createPortal as Sy } from "react-dom";
import b, { css as ca } from "styled-components";
import { AxisGizmoTool as by } from "@cognite/reveal/tools";
import { AxisGizmoOptions as jR } from "@cognite/reveal/tools";
import Ay from "react-draggable";
import { ResizableBox as Ey } from "react-resizable";
import "react-resizable/css/styles.css";
import { radToDeg as Ss, degToRad as My } from "three/src/math/MathUtils.js";
import { OBB as Py } from "three/addons/math/OBB.js";
import { LineSegmentsGeometry as da } from "three/examples/jsm/lines/LineSegmentsGeometry.js";
import { Select as Oy, Option as Ry, Menu as Ge, SelectPanel as $, Dropdown as Td, DataGrid as Dy } from "@cognite/cogs-lab";
import { LineMaterial as eo } from "three/examples/jsm/lines/LineMaterial.js";
import { Wireframe as ti } from "three/examples/jsm/lines/Wireframe.js";
import { mergeGeometries as ky } from "three/examples/jsm/utils/BufferGeometryUtils.js";
import { offset as Ki } from "@floating-ui/dom";
import { useSignalValue as bs } from "@cognite/signals/react";
const Sd = (n, e, t) => {
  const i = n[e];
  return i ? typeof i == "function" ? i() : Promise.resolve(i) : new Promise((s, o) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      o.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + e + (e.split("/").length !== t ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
}, As = () => {
  try {
    let n = window.navigator.language;
    return [n] = n.split("-"), n;
  } catch {
    return;
  }
}, bd = "Create crop box. Select three points in a horizontal plane, then select a fourth point for height.", Ad = "Add vertical slice along Y-axis. Select a point.", Ed = "Add vertical slice. Select two points.", Md = "Add vertical slice along X-axis. Select a point.", Pd = "Add horizontal slice. Select a point.", Od = "All", Rd = "All 3D resources", Dd = "Area", kd = "Asset", Ld = "Box", Nd = "CAD models", Bd = "Cancel", Fd = "Circle", Vd = "Classification", jd = "Apply selected crop box to a model. Otherwise, apply to all slice planes", zd = "Set next crop box or slicing plane as global clipping", Ud = "Set previous crop box or slicing plane as global clipping", Gd = "Show crop boxes and slices on top", Hd = "Show/hide slicing planes and crop boxes that are not selected", qd = "Create, edit crop boxes, and slice planes", $d = "Write a comment", Wd = "Comments", Kd = "Loading contextualized assets", Yd = "Show contextualized assets", Xd = "Fly", Zd = "Orbit", Qd = "Center Orbit", Jd = "Set camera to orbit or fly mode", el = "Copy to clipboard", tl = "Copy URL to share", nl = "Create", il = "Crop box", sl = "Crop boxes and clipping planes", ol = "Cylinder", rl = "Delete", al = "Depth", cl = "Description", dl = "This is the description", ll = "Diameter", ul = "Distance to origin", hl = "Enter last exited 360 image", pl = "Exit 360 image", fl = "Fit view", gl = "Ghost mode", ml = "Go one 360 image back", yl = "Go one 360 image forward", vl = "Height", Cl = "Help", Il = "High fidelity", wl = "Horizontal angle", xl = "Horizontal area", _l = "Horizontal length", Tl = "Image Transparency", Sl = "360 images", bl = "Details", Al = "360 Image historical details", El = "Station :", Ml = "Intensity", Pl = "Back", Ol = "Down", Rl = "Forward", Dl = "Left", kl = "Look down", Ll = "Look left", Nl = "Look right", Bl = "Look up", Fl = `Click and hold to move.
You can also use mouse in conjunction with keys.`, Vl = "Move and look around", jl = "Keyboard", zl = "Right", Ul = "Up", Gl = "Filter 3D resource layers", Hl = "Length", ql = "Line", $l = "360 Markers", Wl = "Measurements", Kl = "Measure horizontal circle. Select at the center and then select to define the radius.", Yl = "Measure vertical cylinder. Select first at the center, second to define the radius, and third for the height.", Xl = "Measure rectangular horizontal Area. Click at three points in a horizontal plan.", Zl = "Measure distance between two points. Click at the start point and the end point.", Ql = "Measure an area of a polygon. Click at least 3 points and end with Esc.", Jl = "Measure the length of a continuous polyline. Click at any number of points and end with Esc.", eu = "Measure rectangular vertical Area. Click at two points in a vertical plan.", tu = "Measure volume of a box. Click at three points in a horizontal plan and the fourth to give it height.", nu = "Show all measurements on top", iu = "Distance measuring tool", su = "Click+drag", ou = "Click and drag to rotate, and pan the view. Use mouse wheel to zoom the view. Left click to select", ru = "Mouse", au = "Rotate", cu = "Select Objects", du = "Click on interactive objects", lu = "Navigate and select", uu = "Zoom / scroll", hu = "Name", pu = "No models found", fu = "No results", gu = "None", mu = "Pan", yu = "Paraboloid", vu = "Point clouds", Cu = "Point color", Iu = "Create Point of Interest", wu = "Delete this Point of Interest", xu = "Write a description for the Point of Interest", _u = "Point of Interest is private", Tu = "Point of Interest is public", Su = "Points of Interest", bu = "Point of interest is private and only visible to you", Au = "Point of Interest is public and visible to anyone", Eu = "Point shape", Mu = "Point size", Pu = "Point filter", Ou = "Polygon", Ru = "Polyline", Du = "Radius", ku = "Redo", Lu = "Rendering detail level", Nu = "High detail might overload CPU/GPU/RAM", Bu = "Reset camera to home", Fu = "3D resources", Vu = "Revisions", ju = "RGB", zu = "No Rule Set Selected", Uu = "Select color overlay", Gu = "Scene", Hu = "Select 3D location", qu = "Search", $u = "Select individual models", Wu = "Selected", Ku = "Send", Yu = "Set camera fly speed", Xu = "Settings", Zu = "Share", Qu = "Show less", Ju = "Show more", eh = "Show or hide axis", th = "Flip side", nh = "Slice", ih = "Vertical slice along Y-axis", sh = "Vertical slice", oh = "Vertical slice along X-axis", rh = "Horizontal slice", ah = "Square", ch = "Total length", dh = "Use gestures to zoom, pan and select", lh = "Touch", uh = "Tap to select", hh = "Zoom", ph = "Try again", fh = "Undo", gh = "Vertical area", mh = "Vertical length", yh = "Visible", vh = "Volume", Ch = "Close", Ih = "Expand", wh = "Minimize", xh = "X-ray", _h = "Y coordinate", Th = "Z coordinate", ni = {
  ADD_CROP_BOX: bd,
  ADD_SLICE_X: Ad,
  ADD_SLICE_XY: Ed,
  ADD_SLICE_Y: Md,
  ADD_SLICE_Z: Pd,
  ALL: Od,
  ALL_3D_RESOURCES: Rd,
  AREA: Dd,
  ASSET: kd,
  BOX: Ld,
  CAD_MODELS: Nd,
  CANCEL: Bd,
  CIRCLE: Fd,
  CLASSIFICATION: Vd,
  CLIP_APPLY: jd,
  CLIP_NEXT: zd,
  CLIP_PREV: Ud,
  CLIP_SHOW_ON_TOP: Gd,
  CLIP_SHOW_SELECTED_ONLY: Hd,
  CLIP_TOOL: qd,
  COMMENT_PLACEHOLDER: $d,
  COMMENTS: Wd,
  CONTEXTUALIZED_ASSETS_LOADING_TOOLTIP: Kd,
  CONTEXTUALIZED_ASSETS_TOOLTIP: Yd,
  CONTROLS_TYPE_FIRST_PERSON: Xd,
  CONTROLS_TYPE_ORBIT: Zd,
  CONTROLS_TYPE_ORBIT_IN_CENTER: Qd,
  CONTROLS_TYPE_TOOLTIP: Jd,
  COPY_TO_CLIPBOARD: el,
  COPY_URL_TO_SHARE: tl,
  CREATE: nl,
  CROP_BOX: il,
  CROP_BOXES_AND_CLIPPING_PLANES: sl,
  CYLINDER: ol,
  DELETE: rl,
  DEPTH: al,
  DESCRIPTION: cl,
  DESCRIPTION_PLACEHOLDER: dl,
  DIAMETER: ll,
  DISTANCE_TO_ORIGIN: ul,
  ENTER_LAST_360: hl,
  EXIT_360: pl,
  FIT_VIEW_TOOLTIP: fl,
  GHOST_MODE: gl,
  GO_BACK_360: ml,
  GO_FORWARD_360: yl,
  HEIGHT: vl,
  HELP_TOOLTIP: Cl,
  HIGH_FIDELITY: Il,
  HORIZONTAL_ANGLE: wl,
  HORIZONTAL_AREA: xl,
  HORIZONTAL_LENGTH: _l,
  IMAGE_TRANSPARENCY: Tl,
  IMAGES_360: Sl,
  IMAGES_360_DETAILS: bl,
  IMAGES_360_DETAILS_TOOLTIP: Al,
  IMAGES_360_STATION: El,
  INTENSITY: Ml,
  KEYBOARD_BACK: Pl,
  KEYBOARD_DOWN: Ol,
  KEYBOARD_FORWARD: Rl,
  KEYBOARD_LEFT: Dl,
  KEYBOARD_LOOK_DOWN: kl,
  KEYBOARD_LOOK_LEFT: Ll,
  KEYBOARD_LOOK_RIGHT: Nl,
  KEYBOARD_LOOK_UP: Bl,
  KEYBOARD_NAVIGATION_DESCRIPTION: Fl,
  KEYBOARD_NAVIGATION_SUBTITLE: Vl,
  KEYBOARD_NAVIGATION_TITLE: jl,
  KEYBOARD_RIGHT: zl,
  KEYBOARD_UP: Ul,
  LAYERS_FILTER_TOOLTIP: Gl,
  LENGTH: Hl,
  LINE: ql,
  "MARKER TRANSPARENCY": "Marker transparency",
  MARKERS_360: $l,
  MEASUREMENTS: Wl,
  MEASUREMENTS_ADD_CIRCLE: Kl,
  MEASUREMENTS_ADD_CYLINDER: Yl,
  MEASUREMENTS_ADD_HORIZONTAL_AREA: Xl,
  MEASUREMENTS_ADD_LINE: Zl,
  MEASUREMENTS_ADD_POLYGON: Ql,
  MEASUREMENTS_ADD_POLYLINE: Jl,
  MEASUREMENTS_ADD_VERTICAL_AREA: eu,
  MEASUREMENTS_ADD_VOLUME: tu,
  MEASUREMENTS_SHOW_ON_TOP: nu,
  MEASUREMENTS_TOOLTIP: iu,
  MOUSE_INSTRUCTIONS: su,
  MOUSE_NAVIGATION_DESCRIPTION: ou,
  MOUSE_NAVIGATION_TITLE: ru,
  MOUSE_ROTATE: au,
  MOUSE_SELECT: cu,
  MOUSE_SELECT_INSTRUCTION: du,
  MOUSE_TOUCH_NAVIGATION_SUBTITLE: lu,
  MOUSE_ZOOM: uu,
  NAME: hu,
  NO_MODELS_FOUND: pu,
  NO_RESULTS: fu,
  NONE: gu,
  PAN: mu,
  PARABOLOID: yu,
  POINT_CLOUDS: vu,
  POINT_COLOR: Cu,
  POINT_OF_INTEREST_CREATE: Iu,
  POINT_OF_INTEREST_DELETE_THIS: wu,
  POINT_OF_INTEREST_DESCRIPTION_PLACEHOLDER: xu,
  POINT_OF_INTEREST_IS_PRIVATE: _u,
  POINT_OF_INTEREST_IS_PUBLIC: Tu,
  POINT_OF_INTEREST_PLURAL: Su,
  POINT_OF_INTEREST_PRIVATE_DESCRIPTION: bu,
  POINT_OF_INTEREST_PUBLIC_DESCRIPTION: Au,
  POINT_SHAPE: Eu,
  POINT_SIZE: Mu,
  POINTS_FILTER: Pu,
  POLYGON: Ou,
  POLYLINE: Ru,
  RADIUS: Du,
  REDO: ku,
  RENDER_QUALITY_SLIDER_HEADER: Lu,
  RENDER_QUALITY_SLIDER_PERFORMANCE_WARNING: Nu,
  RESET_CAMERA_TO_HOME: Bu,
  RESOURCES_3D: Fu,
  REVISIONS: Vu,
  RGB: ju,
  RULESET_NO_SELECTION: zu,
  RULESET_SELECT_HEADER: Uu,
  SCENE: Gu,
  SCENE_SELECT_HEADER: Hu,
  SEARCH_PLACEHOLDER: qu,
  SELECT_INDIVIDUAL_3D_MODELS: $u,
  SELECTED: Wu,
  SEND: Ku,
  SET_CAMERA_FLY_SPEED: Yu,
  SETTINGS_TOOLTIP: Xu,
  SHARE: Zu,
  SHOW_LESS: Qu,
  SHOW_MORE: Ju,
  SHOW_OR_HIDE_AXIS: eh,
  SLICE_FLIP: th,
  SLICE_TOOLTIP: nh,
  SLICE_X: ih,
  SLICE_XY: sh,
  SLICE_Y: oh,
  SLICE_Z: rh,
  SQUARE: ah,
  TOTAL_LENGTH: ch,
  TOUCH_NAVIGATION_DESCRIPTION: dh,
  TOUCH_NAVIGATION_TITLE: lh,
  TOUCH_SELECT: uh,
  TOUCH_ZOOM: hh,
  TRY_AGAIN: ph,
  UNDO: fh,
  VERTICAL_AREA: gh,
  VERTICAL_LENGTH: mh,
  VISIBLE: yh,
  VOLUME: vh,
  WIDGET_WINDOW_CLOSE: Ch,
  WIDGET_WINDOW_EXPAND: Ih,
  WIDGET_WINDOW_MINIMIZE: wh,
  X_RAY: xh,
  "X:COORDINATE": "X coordinate",
  Y_COORDINATE: _h,
  Z_COORDINATE: Th
}, Sh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ADD_CROP_BOX: bd,
  ADD_SLICE_X: Ad,
  ADD_SLICE_XY: Ed,
  ADD_SLICE_Y: Md,
  ADD_SLICE_Z: Pd,
  ALL: Od,
  ALL_3D_RESOURCES: Rd,
  AREA: Dd,
  ASSET: kd,
  BOX: Ld,
  CAD_MODELS: Nd,
  CANCEL: Bd,
  CIRCLE: Fd,
  CLASSIFICATION: Vd,
  CLIP_APPLY: jd,
  CLIP_NEXT: zd,
  CLIP_PREV: Ud,
  CLIP_SHOW_ON_TOP: Gd,
  CLIP_SHOW_SELECTED_ONLY: Hd,
  CLIP_TOOL: qd,
  COMMENTS: Wd,
  COMMENT_PLACEHOLDER: $d,
  CONTEXTUALIZED_ASSETS_LOADING_TOOLTIP: Kd,
  CONTEXTUALIZED_ASSETS_TOOLTIP: Yd,
  CONTROLS_TYPE_FIRST_PERSON: Xd,
  CONTROLS_TYPE_ORBIT: Zd,
  CONTROLS_TYPE_ORBIT_IN_CENTER: Qd,
  CONTROLS_TYPE_TOOLTIP: Jd,
  COPY_TO_CLIPBOARD: el,
  COPY_URL_TO_SHARE: tl,
  CREATE: nl,
  CROP_BOX: il,
  CROP_BOXES_AND_CLIPPING_PLANES: sl,
  CYLINDER: ol,
  DELETE: rl,
  DEPTH: al,
  DESCRIPTION: cl,
  DESCRIPTION_PLACEHOLDER: dl,
  DIAMETER: ll,
  DISTANCE_TO_ORIGIN: ul,
  ENTER_LAST_360: hl,
  EXIT_360: pl,
  FIT_VIEW_TOOLTIP: fl,
  GHOST_MODE: gl,
  GO_BACK_360: ml,
  GO_FORWARD_360: yl,
  HEIGHT: vl,
  HELP_TOOLTIP: Cl,
  HIGH_FIDELITY: Il,
  HORIZONTAL_ANGLE: wl,
  HORIZONTAL_AREA: xl,
  HORIZONTAL_LENGTH: _l,
  IMAGES_360: Sl,
  IMAGES_360_DETAILS: bl,
  IMAGES_360_DETAILS_TOOLTIP: Al,
  IMAGES_360_STATION: El,
  IMAGE_TRANSPARENCY: Tl,
  INTENSITY: Ml,
  KEYBOARD_BACK: Pl,
  KEYBOARD_DOWN: Ol,
  KEYBOARD_FORWARD: Rl,
  KEYBOARD_LEFT: Dl,
  KEYBOARD_LOOK_DOWN: kl,
  KEYBOARD_LOOK_LEFT: Ll,
  KEYBOARD_LOOK_RIGHT: Nl,
  KEYBOARD_LOOK_UP: Bl,
  KEYBOARD_NAVIGATION_DESCRIPTION: Fl,
  KEYBOARD_NAVIGATION_SUBTITLE: Vl,
  KEYBOARD_NAVIGATION_TITLE: jl,
  KEYBOARD_RIGHT: zl,
  KEYBOARD_UP: Ul,
  LAYERS_FILTER_TOOLTIP: Gl,
  LENGTH: Hl,
  LINE: ql,
  MARKERS_360: $l,
  MEASUREMENTS: Wl,
  MEASUREMENTS_ADD_CIRCLE: Kl,
  MEASUREMENTS_ADD_CYLINDER: Yl,
  MEASUREMENTS_ADD_HORIZONTAL_AREA: Xl,
  MEASUREMENTS_ADD_LINE: Zl,
  MEASUREMENTS_ADD_POLYGON: Ql,
  MEASUREMENTS_ADD_POLYLINE: Jl,
  MEASUREMENTS_ADD_VERTICAL_AREA: eu,
  MEASUREMENTS_ADD_VOLUME: tu,
  MEASUREMENTS_SHOW_ON_TOP: nu,
  MEASUREMENTS_TOOLTIP: iu,
  MOUSE_INSTRUCTIONS: su,
  MOUSE_NAVIGATION_DESCRIPTION: ou,
  MOUSE_NAVIGATION_TITLE: ru,
  MOUSE_ROTATE: au,
  MOUSE_SELECT: cu,
  MOUSE_SELECT_INSTRUCTION: du,
  MOUSE_TOUCH_NAVIGATION_SUBTITLE: lu,
  MOUSE_ZOOM: uu,
  NAME: hu,
  NONE: gu,
  NO_MODELS_FOUND: pu,
  NO_RESULTS: fu,
  PAN: mu,
  PARABOLOID: yu,
  POINTS_FILTER: Pu,
  POINT_CLOUDS: vu,
  POINT_COLOR: Cu,
  POINT_OF_INTEREST_CREATE: Iu,
  POINT_OF_INTEREST_DELETE_THIS: wu,
  POINT_OF_INTEREST_DESCRIPTION_PLACEHOLDER: xu,
  POINT_OF_INTEREST_IS_PRIVATE: _u,
  POINT_OF_INTEREST_IS_PUBLIC: Tu,
  POINT_OF_INTEREST_PLURAL: Su,
  POINT_OF_INTEREST_PRIVATE_DESCRIPTION: bu,
  POINT_OF_INTEREST_PUBLIC_DESCRIPTION: Au,
  POINT_SHAPE: Eu,
  POINT_SIZE: Mu,
  POLYGON: Ou,
  POLYLINE: Ru,
  RADIUS: Du,
  REDO: ku,
  RENDER_QUALITY_SLIDER_HEADER: Lu,
  RENDER_QUALITY_SLIDER_PERFORMANCE_WARNING: Nu,
  RESET_CAMERA_TO_HOME: Bu,
  RESOURCES_3D: Fu,
  REVISIONS: Vu,
  RGB: ju,
  RULESET_NO_SELECTION: zu,
  RULESET_SELECT_HEADER: Uu,
  SCENE: Gu,
  SCENE_SELECT_HEADER: Hu,
  SEARCH_PLACEHOLDER: qu,
  SELECTED: Wu,
  SELECT_INDIVIDUAL_3D_MODELS: $u,
  SEND: Ku,
  SETTINGS_TOOLTIP: Xu,
  SET_CAMERA_FLY_SPEED: Yu,
  SHARE: Zu,
  SHOW_LESS: Qu,
  SHOW_MORE: Ju,
  SHOW_OR_HIDE_AXIS: eh,
  SLICE_FLIP: th,
  SLICE_TOOLTIP: nh,
  SLICE_X: ih,
  SLICE_XY: sh,
  SLICE_Y: oh,
  SLICE_Z: rh,
  SQUARE: ah,
  TOTAL_LENGTH: ch,
  TOUCH_NAVIGATION_DESCRIPTION: dh,
  TOUCH_NAVIGATION_TITLE: lh,
  TOUCH_SELECT: uh,
  TOUCH_ZOOM: hh,
  TRY_AGAIN: ph,
  UNDO: fh,
  VERTICAL_AREA: gh,
  VERTICAL_LENGTH: mh,
  VISIBLE: yh,
  VOLUME: vh,
  WIDGET_WINDOW_CLOSE: Ch,
  WIDGET_WINDOW_EXPAND: Ih,
  WIDGET_WINDOW_MINIMIZE: wh,
  X_RAY: xh,
  Y_COORDINATE: _h,
  Z_COORDINATE: Th,
  default: ni
}, Symbol.toStringTag, { value: "Module" }));
function to(n) {
  const e = n.key;
  return e !== void 0 && e in ni;
}
const bh = "en";
let So = bh, Ci = ni;
Ly();
function mn(n) {
  return to(n) ? Ny(n.key) : n.untranslated;
}
async function Ah(n) {
  if (n === bh && Ci === ni) {
    So = n;
    return;
  }
  if (!(n === void 0 || n === So))
    try {
      Ci = await By(n), So = n;
    } catch {
      console.warn("Error loading translation file");
    }
}
async function Ly() {
  const n = async () => {
    await Ah(As());
  };
  window.addEventListener("languagechange", n), await n();
}
function Ny(n) {
  return Ci !== void 0 && Ci[n] !== void 0 ? Ci[n] : ni[n];
}
async function By(n) {
  return (await Sd(/* @__PURE__ */ Object.assign({ "../../../common/i18n/de/reveal-react-components.json": () => import("./reveal-react-components-B8qJEOcJ.js"), "../../../common/i18n/en/reveal-react-components.json": () => Promise.resolve().then(() => Sh), "../../../common/i18n/es/reveal-react-components.json": () => import("./reveal-react-components-BWN78aV9.js"), "../../../common/i18n/fr/reveal-react-components.json": () => import("./reveal-react-components-D29QUjsA.js"), "../../../common/i18n/it/reveal-react-components.json": () => import("./reveal-react-components-DEpviI3t.js"), "../../../common/i18n/ja/reveal-react-components.json": () => import("./reveal-react-components-C7uBKmxv.js"), "../../../common/i18n/ko/reveal-react-components.json": () => import("./reveal-react-components-M5Vfyng6.js"), "../../../common/i18n/lv/reveal-react-components.json": () => import("./reveal-react-components-ChKmAWUz.js"), "../../../common/i18n/nl/reveal-react-components.json": () => import("./reveal-react-components-CyqpRyeX.js"), "../../../common/i18n/pt/reveal-react-components.json": () => import("./reveal-react-components-SYvHRGVh.js"), "../../../common/i18n/sv/reveal-react-components.json": () => import("./reveal-react-components-NvENkMb1.js"), "../../../common/i18n/zh/reveal-react-components.json": () => import("./reveal-react-components-8JUOJeOe.js") }), `../../../common/i18n/${n}/reveal-react-components.json`, 7)).default;
}
const Eh = Ye(null), Mh = (n, e = !0) => {
  const t = n ?? As() ?? "en", [i, s] = M(t), [o, r] = M({});
  return R(() => {
    if (!e)
      return;
    const c = () => {
      const d = As();
      d !== void 0 && d !== i && s(d);
    };
    return window.addEventListener("languagechange", c), () => {
      window.removeEventListener("languagechange", c);
    };
  }, []), R(() => {
    if (!e)
      return;
    (async () => {
      try {
        const d = await Sd(/* @__PURE__ */ Object.assign({ "../../common/i18n/de/reveal-react-components.json": () => import("./reveal-react-components-B8qJEOcJ.js"), "../../common/i18n/en/reveal-react-components.json": () => Promise.resolve().then(() => Sh), "../../common/i18n/es/reveal-react-components.json": () => import("./reveal-react-components-BWN78aV9.js"), "../../common/i18n/fr/reveal-react-components.json": () => import("./reveal-react-components-D29QUjsA.js"), "../../common/i18n/it/reveal-react-components.json": () => import("./reveal-react-components-DEpviI3t.js"), "../../common/i18n/ja/reveal-react-components.json": () => import("./reveal-react-components-C7uBKmxv.js"), "../../common/i18n/ko/reveal-react-components.json": () => import("./reveal-react-components-M5Vfyng6.js"), "../../common/i18n/lv/reveal-react-components.json": () => import("./reveal-react-components-ChKmAWUz.js"), "../../common/i18n/nl/reveal-react-components.json": () => import("./reveal-react-components-CyqpRyeX.js"), "../../common/i18n/pt/reveal-react-components.json": () => import("./reveal-react-components-SYvHRGVh.js"), "../../common/i18n/sv/reveal-react-components.json": () => import("./reveal-react-components-NvENkMb1.js"), "../../common/i18n/zh/reveal-react-components.json": () => import("./reveal-react-components-8JUOJeOe.js") }), `../../common/i18n/${i}/reveal-react-components.json`, 6);
        r(d.default);
      } catch {
        console.warn("Error loading translation file. Default language: English is loaded");
      }
    })().catch(() => {
      console.warn("Translation not found. Default language: English is loaded");
    });
  }, [i]), { currentLanguage: i, t: (c) => to(c) ? o[c.key] !== void 0 ? o[c.key] : ni[c.key] : c.untranslated };
}, W = (n) => {
  const e = Xe(Eh), t = As() ?? "en", i = Mh(
    n ?? t,
    e === null
  );
  return e !== null ? e : i;
}, Fy = ({ appLanguage: n, children: e }) => {
  R(() => {
    Ah(n);
  }, [n]);
  const t = Mh(n);
  return /* @__PURE__ */ u(Eh.Provider, { value: t, children: e });
}, Ph = Ye(null), Vy = ({
  value: n,
  children: e
}) => (zy(n ?? void 0), jy(n ?? void 0), /* @__PURE__ */ u(Ph.Provider, { value: n, children: e })), oe = () => me().viewer, me = () => {
  const n = Xe(Ph);
  if (n === null)
    throw new Error("useRenderTarget must be used within a ViewerProvider");
  return n;
};
function jy(n) {
  R(() => {
    if (n !== void 0)
      return window.renderTargets === void 0 ? window.renderTargets = [n] : window.renderTargets.push(n), () => {
        window.renderTargets !== void 0 && lr(window.renderTargets, (e) => e === n);
      };
  }, [n]);
}
function zy(n) {
  R(() => {
    if (!(n === void 0 || window.renderTarget !== void 0 || window.viewer !== void 0))
      return window.renderTarget = n, window.viewer = n.viewer, () => {
        var e;
        ((e = window.renderTarget) == null ? void 0 : e.viewer) === n.viewer && (window.viewer = void 0), window.renderTarget === n && (window.renderTarget = void 0);
      };
  }, [n]);
}
const Oh = Ye(null), Sn = () => {
  const n = Xe(Oh);
  if (n === null)
    throw new Error(
      "ResourcesInfoContent must be used within a Reveal3DResourcesInfoContextProvider"
    );
  return n;
}, nn = () => {
  const n = Sn();
  return {
    reveal3DResourcesCount: n.reveal3DResourcesCount,
    setRevealResourcesCount: n.setRevealResourcesCount
  };
}, Yi = () => Sn(), Uy = () => {
  const n = Sn();
  return n.reveal3DResourcesExpectedToLoad - n.reveal3DResourceLoadFailCount;
}, Gy = () => Sn().setReveal3DResourcesExpectedToLoad, zO = () => Sn().reveal3DResourcesCount, Hy = () => Sn().model3DStylingLoading, qy = () => Sn().setModel3DStylingLoading, $y = ({
  children: n
}) => {
  const [e, t] = M(0), [i, s] = M(!1), [o, r] = M(0), [a, c] = M(0), d = P(
    () => ({
      reveal3DResourcesCount: e,
      setRevealResourcesCount: t,
      reveal3DResourceLoadFailCount: a,
      setReveal3DResourceLoadFailCount: c,
      reveal3DResourcesExpectedToLoad: o,
      setReveal3DResourcesExpectedToLoad: r,
      model3DStylingLoading: i,
      setModel3DStylingLoading: s
    }),
    [
      e,
      t,
      a,
      c,
      o,
      r,
      i,
      s
    ]
  );
  return /* @__PURE__ */ u(Oh.Provider, { value: d, children: n });
}, mr = Ye(null);
async function bo(n, e) {
  return await e.instances.query(n);
}
function Wy(n, e) {
  return Object.keys(e).forEach((t) => {
    t in n || Object.assign(n, t, []), n[t].push(...e[t]);
  }), n;
}
class Xi {
  constructor(e) {
    const t = e.getBaseUrl(), i = e.project, s = `${t}/api/v1/projects/${i}/models/instances`, o = `${t}/api/v1/projects/${i}/models/views`;
    this._listEndpoint = `${s}/list`, this._byIdsEndpoint = `${s}/byids`, this._inspectEndpoint = `${s}/inspect`, this._searchEndpoint = `${s}/search`, this._listDataModelsEndpoint = `${t}/api/v1/projects/${i}/models/datamodels`, this._viewsByIdEndpoint = `${o}/byids`, this._listViewsEndpoint = o, this._createUpdateInstancesEndpoint = s, this._deleteInstancesEndpoint = `${s}/delete`, this._sdk = e;
  }
  async listViews(e, t = !0) {
    const i = await this._sdk.get(this._listViewsEndpoint, {
      params: {
        includeInheritedProperties: t,
        space: e
      }
    });
    if (i.status === 200)
      return { views: i.data.items };
    throw new Error(`Failed to list views. Status: ${i.status}`);
  }
  // eslint-disable-next-line no-dupe-class-members
  async searchInstances(e, t, i, s = 1e3, o, r) {
    o = Ni(o);
    const a = {
      view: e,
      query: t,
      instanceType: i,
      filter: o,
      properties: r,
      limit: s
    }, c = await this._sdk.post(this._searchEndpoint, { data: a });
    if (c.status === 200)
      return la(e, c.data.items), { instances: c.data.items };
    throw new Error(`Failed to search for instances. Status: ${c.status}`);
  }
  // eslint-disable-next-line no-dupe-class-members
  async filterInstances(e, t, i, s) {
    const o = { filter: e, instanceType: t };
    i !== null && (o.sources = [{ source: i }]), s !== void 0 && (o.cursor = s);
    const r = await this._sdk.post(this._listEndpoint, { data: o });
    if (r.status !== 200)
      throw new Error(`Failed to fetch instances. Status: ${r.status}`);
    const a = r.data.items;
    return la(i, a), {
      instances: r.data.items,
      nextCursor: r.data.nextCursor
    };
  }
  // eslint-disable-next-line no-dupe-class-members
  async filterAllInstances(e, t, i) {
    e = Ni(e);
    let s = await this.filterInstances(e, t, i);
    for (; s.nextCursor !== void 0; ) {
      const o = await this.filterInstances(
        e,
        t,
        i,
        s.nextCursor
      );
      s = {
        instances: [...s.instances, ...o.instances],
        nextCursor: o.nextCursor
      };
    }
    return { instances: s.instances };
  }
  async getByExternalIds(e, t) {
    const i = { items: e, includeTyping: !0 };
    t !== void 0 && (i.sources = t.map((o) => ({ source: o })));
    const s = await this._sdk.post(this._byIdsEndpoint, {
      data: i
    });
    if (s.status === 200)
      return s.data;
    throw new Error(`Failed to fetch instances. Status: ${s.status}`);
  }
  async createInstance(e) {
    const t = {
      items: e,
      autoCreateStartNodes: !1,
      autoCreateEndNodes: !1,
      skipOnVersionConflict: !1,
      replace: !1
    }, i = await this._sdk.post(
      this._createUpdateInstancesEndpoint,
      { data: t }
    );
    if (i.status === 200)
      return i.data;
    throw new Error(`Failed to create instances. Status: ${i.status}`);
  }
  async editInstance(e) {
    const t = {
      items: e,
      autoCreateStartNodes: !1,
      autoCreateEndNodes: !1,
      skipOnVersionConflict: !1,
      replace: !1
    }, i = await this._sdk.post(
      this._createUpdateInstancesEndpoint,
      { data: t }
    );
    if (i.status === 200)
      return i.data;
    throw new Error(`Failed to edit instances. Status: ${i.status}`);
  }
  async deleteInstances(e) {
    if (e.length === 0)
      return { items: [] };
    const t = {
      items: e
    }, i = await this._sdk.post(
      this._deleteInstancesEndpoint,
      { data: t }
    );
    if (i.status === 200)
      return i.data;
    throw new Error(`Failed to delete instances. Status: ${i.status}`);
  }
  async inspectInstances(e) {
    const t = await this._sdk.post(this._inspectEndpoint, { data: e });
    if (t.status === 200)
      return t.data;
    throw new Error("Failed to fetch instances");
  }
  async getViewsByIds(e) {
    const t = await this._sdk.post(this._viewsByIdEndpoint, {
      data: {
        items: e.map((i) => ({
          externalId: i.externalId,
          space: i.space,
          version: i.version
        }))
      }
    });
    if (t.status === 200)
      return t.data;
    throw new Error(`Failed to fetch instances. Status: ${t.status}`);
  }
  async queryAllNodesAndEdges(e, t) {
    let i = await bo(e, this._sdk), s = i.items;
    for (; i.nextCursor !== void 0 && Object.keys(i.nextCursor).length !== 0; ) {
      const o = i.nextCursor !== void 0 ? Object.keys(i.nextCursor) : [];
      let r = {};
      const a = i.nextCursor;
      o.forEach((l) => {
        var h, p;
        t !== void 0 && t.includes(l) && ((h = i.nextCursor) == null ? void 0 : h[l]) !== void 0 && (r = { ...r, [l]: (p = i.nextCursor) == null ? void 0 : p[l] });
      });
      const c = Object.keys(r).length === 0 ? a : r, d = { ...e, cursors: c };
      i = await bo(d, this._sdk), s = Wy(s, i.items);
    }
    return { items: s };
  }
  async queryNodesAndEdges(e) {
    return await bo(e, this._sdk);
  }
  async listDataModels() {
    const e = await this._sdk.get(this._listDataModelsEndpoint, {
      params: { limit: 1e3, includeGlobal: !0 }
    });
    if (e.status === 200)
      return e.data;
    throw new Error(`Failed to fetch data models. Status: ${e.status}`);
  }
}
function la(n, e) {
  if (n === void 0)
    return;
  const t = `${n.externalId}/${n.version}`;
  e.forEach((i) => {
    var o, r;
    const s = (r = (o = i.properties) == null ? void 0 : o[n.space]) == null ? void 0 : r[t];
    s !== void 0 && Object.entries(s).reduce(
      (a, [c, d]) => (a[c] = d, a),
      i.properties
    );
  });
}
function Ni(n) {
  return n !== void 0 && Object.keys(n).length === 0 ? void 0 : n;
}
const yr = Ye(null);
yr.displayName = "CogniteSdkProvider";
mr.displayName = "FdmSdkProvider";
function Ky({ sdk: n, children: e }) {
  const t = P(
    () => ({
      fdmSdk: new Xi(n)
    }),
    [n]
  );
  return /* @__PURE__ */ u(yr.Provider, { value: n, children: /* @__PURE__ */ u(mr.Provider, { value: t, children: e }) });
}
const _e = (n) => {
  const e = Xe(yr);
  if (e === null) {
    if (n !== void 0)
      return n;
    throw new Error(
      "SdkContext not found, add '<SDKProvider value={sdk}>' around your component/app"
    );
  }
  return e;
}, Te = () => {
  const n = Xe(mr);
  if (n === null)
    throw new Error(
      "FdmSdkContext not found, add '<SDKProvider value={sdk}>' around your component/app"
    );
  return n.fdmSdk;
}, Rh = Ye(void 0), ii = () => Xe(Rh);
function Oe(n, e) {
  return n instanceof e;
}
class Dh extends vg {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e) {
    super(), this._activeTool = fn(), this._commands = /* @__PURE__ */ new Set(), this._onPointerMove = (t) => {
      var i;
      t.buttons === 0 && ((i = this.activeTool) == null || i.onHover(t));
    }, this._onKeyDown = (t) => {
      this.onKey(t, !0);
    }, this._onContextMenu = (t) => {
      t.stopPropagation(), t.preventDefault();
    }, this._onKeyUp = (t) => {
      this.onKey(t, !1);
    }, this._onWheel = async (t) => {
      var s;
      const i = Cg(t);
      await ((s = this.activeTool) == null ? void 0 : s.onWheel(t, i)), t.stopPropagation(), t.preventDefault();
    }, this._onFocus = (t) => {
      var i;
      (i = this.activeTool) == null || i.onFocusChanged(!0);
    }, this._onBlur = (t) => {
      var i;
      (i = this.activeTool) == null || i.onFocusChanged(!1);
    }, this._domElement = e, this._pointerEventsTarget = new Ig(this._domElement, this);
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get activeTool() {
    return this._activeTool();
  }
  get activeToolSignal() {
    return this._activeTool;
  }
  get defaultTool() {
    return this._defaultTool;
  }
  get isDefaultToolActive() {
    return this.activeTool === this.defaultTool;
  }
  // ================================================
  // OVERRIDES of PointerEvents
  // ================================================
  get isEnabled() {
    return !0;
  }
  onHover(e) {
    var t;
    (t = this.activeTool) == null || t.onHoverByDebounce(e);
  }
  async onClick(e) {
    var t;
    this._domElement.focus(), await ((t = this.activeTool) == null ? void 0 : t.onClick(e));
  }
  async onDoubleClick(e) {
    var t;
    this._domElement.focus(), await ((t = this.activeTool) == null ? void 0 : t.onDoubleClick(e));
  }
  async onPointerDown(e, t) {
    var i, s;
    this._domElement.focus(), t ? await ((i = this.activeTool) == null ? void 0 : i.onLeftPointerDown(e)) : await ((s = this.defaultTool) == null ? void 0 : s.onRightPointerDown(e));
  }
  async onPointerDrag(e, t) {
    var i, s;
    t ? await ((i = this.activeTool) == null ? void 0 : i.onLeftPointerDrag(e)) : await ((s = this.defaultTool) == null ? void 0 : s.onRightPointerDrag(e));
  }
  async onPointerUp(e, t) {
    var i, s;
    t ? await ((i = this.activeTool) == null ? void 0 : i.onLeftPointerUp(e)) : await ((s = this.defaultTool) == null ? void 0 : s.onRightPointerUp(e));
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  getEqual(e) {
    for (const t of this._commands)
      if (t.equals(e))
        return t;
  }
  add(e) {
    this._commands.add(e);
  }
  setPreviousTool() {
    return this._previousTool === void 0 ? !1 : this.setActiveTool(this._previousTool);
  }
  setDefaultTool(e) {
    return e === void 0 ? !1 : (this._defaultTool = e, this.activateDefaultTool());
  }
  getToolByType(e) {
    for (const t of this._commands)
      if (Oe(t, e))
        return t;
  }
  getCommandByTypeRecursive(e) {
    for (const t of this._commands) {
      if (Oe(t, e))
        return t;
      for (const i of t.getDescendants())
        if (Oe(i, e))
          return i;
    }
  }
  setActiveToolByType(e) {
    for (const t of this._commands)
      if (Oe(t, e))
        return this.setActiveTool(t);
    return !1;
  }
  activateDefaultTool() {
    return this._defaultTool === void 0 ? !1 : this.setActiveTool(this._defaultTool);
  }
  setActiveTool(e) {
    var i;
    if (e === void 0)
      return !1;
    const t = this.activeTool;
    return t === e ? !1 : (t !== void 0 && (this._activeTool(void 0), t.onDeactivate(), this._previousTool = t), this._activeTool(e), (i = this._activeTool()) == null || i.onActivate(), !0);
  }
  update() {
    for (const e of this._commands)
      e.update();
  }
  dispose() {
    for (const e of this._commands)
      e.dispose();
  }
  // ================================================
  // INSTANCE METHODS: Other events
  // ================================================
  onKey(e, t) {
    var i, s, o;
    if (t) {
      const r = e.key.toUpperCase(), a = e.ctrlKey || e.metaKey;
      for (const c of this._commands)
        if (c.hasShortCutKey(r, a, e.shiftKey, e.altKey)) {
          c.invoke();
          return;
        }
    }
    t && (e.key === "Delete" || e.key === "Backspace") ? (i = this.activeTool) == null || i.onDeleteKey() : t && e.key === "Escape" ? (s = this.activeTool) == null || s.onEscapeKey() : (o = this.activeTool) == null || o.onKey(e, t);
  }
  // ==================================================
  // INSTANCE METHODS: Add and remove listeners
  // ==================================================
  addEventListeners() {
    const e = this._domElement;
    e.addEventListener("pointermove", this._onPointerMove), e.addEventListener("keydown", this._onKeyDown), e.addEventListener("keyup", this._onKeyUp), e.addEventListener("wheel", this._onWheel), e.addEventListener("focus", this._onFocus), e.addEventListener("blur", this._onBlur), e.addEventListener("contextmenu", this._onContextMenu), this._pointerEventsTarget.addEventListeners();
  }
  removeEventListeners() {
    const e = this._domElement;
    e.removeEventListener("pointermove", this._onPointerMove), e.removeEventListener("keydown", this._onKeyDown), e.removeEventListener("keyup", this._onKeyUp), e.removeEventListener("wheel", this._onWheel), e.removeEventListener("focus", this._onFocus), e.removeEventListener("blur", this._onBlur), e.removeEventListener("contextmenu", this._onContextMenu), this._pointerEventsTarget.removeEventListeners();
    for (const t of this._commands)
      t.removeEventListeners();
  }
}
var V = /* @__PURE__ */ ((n) => (n[n.Unitless = 0] = "Unitless", n[n.Length = 1] = "Length", n[n.Area = 2] = "Area", n[n.Volume = 3] = "Volume", n[n.Angle = 4] = "Angle", n))(V || {});
const Qe = 1 / 0.3048;
class no {
  constructor() {
    this.isMetric = !0;
  }
  // ==================================================
  // INSTANCE METHODS: Convert number
  // ==================================================
  convertToUnit(e, t) {
    if (!this.isMetric)
      switch (t) {
        case V.Length:
          return e * Qe;
        case V.Area:
          return e * Qe * Qe;
        case V.Volume:
          return e * Qe * Qe * Qe;
      }
    return e;
  }
  convertFromUnit(e, t) {
    if (!this.isMetric)
      switch (t) {
        case V.Length:
          return e / Qe;
        case V.Area:
          return e / (Qe * Qe);
        case V.Volume:
          return e / (Qe * Qe * Qe);
      }
    return e;
  }
  // ==================================================
  // INSTANCE METHODS: Convert number to string
  // ==================================================
  toString(e, t) {
    const i = this.getFractionDigits(t);
    return this.convertToUnit(e, t).toFixed(i);
  }
  toStringWithUnit(e, t) {
    const i = this.toString(e, t), s = this.getUnit(t);
    return Pg(s) ? i : `${i} ${s}`;
  }
  // ==================================================
  // INSTANCE METHODS: Getters
  // ==================================================
  getUnit(e) {
    switch (e) {
      case V.Unitless:
        return "";
      case V.Length:
        return this.isMetric ? "m" : "ft";
      case V.Area:
        return this.isMetric ? "m²" : "ft²";
      case V.Volume:
        return this.isMetric ? "m³" : "ft³";
      case V.Angle:
        return "°";
    }
  }
  getFractionDigits(e) {
    switch (e) {
      case V.Angle:
        return 1;
      default:
        return 2;
    }
  }
}
const vn = new D(1, 1, 1), vr = new D(0, 0, 0);
new D(0.67, 0.67, 0.67);
const Ii = 255;
function Vn(n, e, t = 0.5) {
  const i = 1 - t, s = n.r * t + e.r * i, o = n.g * t + e.g * i, r = n.b * t + e.b * i;
  return new D(s, o, r);
}
function Yy(n, e, t = 0.5, i = !0) {
  let s = { h: 0, s: 0, l: 0 }, o = { h: 0, s: 0, l: 0 };
  s = n.getHSL(s), o = e.getHSL(o), i ? s.h < o.h ? o.h - s.h < 0.5 && (o.h -= 1) : s.h - o.h < 0.5 && (o.h += 1) : s.h < o.h ? o.h - s.h > 0.5 && (o.h -= 1) : s.h - o.h > 0.5 && (o.h += 1);
  const r = 1 - t, a = s.h * t + o.h * r, c = s.s * t + o.s * r, d = s.l * t + o.l * r;
  return new D().setHSL(a, c, d);
}
function Xy(n) {
  return new D(1 - n.r, 1 - n.g, 1 - n.b);
}
function Ao(n) {
  return n * Ii;
}
function at(n, e, t) {
  return new D(n / Ii, e / Ii, t / Ii);
}
function Zy(n, e) {
  return n.toLowerCase() === e.toLowerCase();
}
function Qy(n, e) {
  return Zy(n.replace(" ", ""), e.replace(" ", ""));
}
function Jy(n) {
  const e = Math.sign(n);
  let i = `${Math.abs(Math.round(n * 1e5))}`;
  if (i.length === 3)
    i = `0.00${i}`;
  else if (i.length === 4)
    i = `0.0${i}`;
  else if (i.length === 5)
    i = `0.${i}`;
  else if (i.length >= 6) {
    const s = i.length - 5;
    i = `${i.slice(0, s)}.${i.slice(s)}`;
  } else
    return `${n}`;
  for (; i[i.length - 1] === "0"; )
    i = i.slice(0, -1);
  return i[i.length - 1] === "." && (i = i.slice(0, -1)), e < 0 && (i = `-${i}`), i;
}
class $n {
  constructor(e, t) {
    this.change = e, this.fieldName = t;
  }
  isChanged(e) {
    return this.fieldName === void 0 ? !1 : Qy(this.fieldName, e);
  }
}
class ct {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e, t) {
    this._changes = void 0, typeof e == "symbol" && this.addChange(e, t), e instanceof $n && this.addChangedDescription(e);
  }
  // ==================================================
  // INSTANCE METHODS: Requests
  // ==================================================
  get isEmpty() {
    return this._changes === void 0 || this._changes.length === 0;
  }
  /**
   * Checks if the domain object has been changed based on the specified changes.
   * @param changes - The changes to check.
   * @returns `true` if any of the specified changes are present in the domain object, `false` otherwise.
   */
  isChanged(...e) {
    if (this._changes === void 0)
      return !1;
    for (const t of e)
      if (this._changes.some((i) => i.change === t))
        return !0;
    return !1;
  }
  /**
   * Checks if the domain object has been changed based on the specified change and some specific field names.
   * For instance
   * if (isFieldNameChanged(Changes.renderStyle, 'lineWidth', 'lineColor')) {
   *   // Now you have to update the line material only
   * }
   * @param change - The symbol representing the change.
   * @param fieldNames - The field names to compare against the change symbol.
   * @returns A boolean indicating whether the name has changed or not.
   */
  isFieldNameChanged(e, ...t) {
    const i = this.getChangedDescription(e);
    if (i === void 0)
      return !1;
    for (const s of t)
      if (i.isChanged(s))
        return !0;
    return !1;
  }
  // ==================================================
  // INSTANCE METHODS: Getters
  // ==================================================
  getChangedDescription(e) {
    if (this._changes !== void 0)
      return this._changes.find((t) => t.change === e);
  }
  getChangedDescriptionByType(e) {
    if (this._changes !== void 0) {
      for (const t of this._changes)
        if (Oe(t, e))
          return t;
    }
  }
  // ==================================================
  // INSTANCE METHODS: Operations
  // ==================================================
  addChange(e, t) {
    e !== void 0 && this.addChangedDescription(new $n(e, t));
  }
  addChangedDescription(e) {
    this._changes === void 0 && (this._changes = []), this._changes.push(e);
  }
}
const se = class se {
};
se.visibleState = Symbol("visibleState"), se.active = Symbol("active"), se.expanded = Symbol("expanded"), se.selected = Symbol("selected"), se.focus = Symbol("focus"), se.clipping = Symbol("clipping"), se.naming = Symbol("naming"), se.color = Symbol("color"), se.icon = Symbol("icon"), se.colorMap = Symbol("colorMap"), se.renderStyle = Symbol("renderStyle"), se.unit = Symbol("unit"), se.geometry = Symbol("geometry"), se.dragging = Symbol("dragging"), se.changedPart = Symbol("changedPart"), se.deletedPart = Symbol("deletedPart"), se.addedPart = Symbol("addedPart"), se.newPending = Symbol("newPending"), se.added = Symbol("added"), se.deleted = Symbol("deleted"), se.childDeleted = Symbol("childDeleted"), se.childAdded = Symbol("childAdded"), se.loaded = Symbol("loaded");
let m = se;
var q = /* @__PURE__ */ ((n) => (n[n.All = 0] = "All", n[n.Some = 1] = "Some", n[n.None = 2] = "None", n[n.CanNotBeVisibleNow = 3] = "CanNotBeVisibleNow", n[n.Disabled = 4] = "Disabled", n))(q || {});
function Lt(n) {
  n.splice(0, n.length);
}
function ua(n, e) {
  Lt(n), n.push(...e);
}
function ev(n, e) {
  n.length >= 1 && (n[n.length - 1] = e);
}
function Wn(n, e) {
  const t = n.indexOf(e);
  return t < 0 ? !1 : (kh(n, t), !0);
}
function kh(n, e) {
  n.splice(e, 1);
}
function tv(n, e) {
  let t = 0;
  for (const i of n)
    e(i) && t++;
  return t;
}
const nv = 1e-10;
function iv(n) {
  return n < 0 ? n > -1e-10 : n < nv;
}
function hn(n, e, t) {
  return Math.abs(n - e) < t;
}
function sv(n) {
  const e = Math.round(n) - n;
  return iv(e);
}
function Wo(n, e) {
  return e === 0 ? !1 : sv(n / e);
}
function ov(n) {
  return n % 2 === 0;
}
function Eo(n, e, t) {
  return n < t ? n < e && e < t : t < e && e < n;
}
function Dt(n) {
  return n * n;
}
function Lh(n) {
  let e = 0, t = n, i = !1;
  for (let s = 0; s < 100; s++)
    if (t < 1)
      e -= 1, t *= 10;
    else if (t > 10)
      e += 1, t /= 10;
    else {
      i = !0;
      break;
    }
  if (!i)
    return Number.NaN;
  if (t < 2 ? t = 2 : t < 2.5 ? t = 2.5 : t < 5 ? t = 5 : t = 10, e < 0)
    for (; e !== 0; e++) t /= 10;
  else
    for (; e !== 0; e--) t *= 10;
  return t;
}
function Nh(n, e) {
  let t = n / e;
  return t = Math.round(t), t *= e, t;
}
function ha(n, e) {
  let t = n / e;
  return t = Math.ceil(t), t *= e, t;
}
function pa(n, e) {
  let t = n / e;
  return t = Math.floor(t), t *= e, t;
}
function Es(n) {
  for (; n < 0; )
    n += 2 * Math.PI;
  for (; n >= 2 * Math.PI; )
    n -= 2 * Math.PI;
  return n;
}
function Cr(n) {
  for (; n < 0; )
    n += Math.PI;
  for (; n >= Math.PI; )
    n -= Math.PI;
  return n;
}
function rv(n) {
  for (; n < -Math.PI; )
    n += 2 * Math.PI;
  for (; n >= Math.PI; )
    n -= 2 * Math.PI;
  return n;
}
function av(n, e) {
  return n > e ? 1 : n < e ? -1 : 0;
}
function fa() {
  return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
}
let Mo = 0, Po;
const cv = 50;
function Bh() {
  const n = Fh();
  return Mo = (Mo + 1) % n.length, n[Mo];
}
function dv(n) {
  const e = Fh();
  return e[n % e.length];
}
function Fh() {
  return Po === void 0 && (Po = lv(cv)), Po;
}
function lv(n) {
  const e = 0.618033988749895, t = [];
  let i = 0.5;
  for (let s = 0; s < n; s++) {
    i += e, i %= 1;
    const o = ov(s) ? 0.5 : 1, r = 0.5, a = new D();
    a.setHSL(i, o, r), t.push(a);
  }
  return t;
}
var Re = /* @__PURE__ */ ((n) => (n[n.Specified = 0] = "Specified", n[n.Parent = 1] = "Parent", n[n.Black = 2] = "Black", n[n.White = 3] = "White", n[n.Different = 4] = "Different", n[n.ColorMap = 5] = "ColorMap", n))(Re || {});
class Vh {
  constructor() {
    this._views = [], this._listeners = [];
  }
  /**
   * Notifies the listeners and views about a change in the domain object.
   * The should be called from DomainObject class only
   * @param domainObject - The domain object that has changed.
   * @param change - The change that occurred in the domain object.
   */
  notify(e, t) {
    for (const s of this._listeners)
      s(e, t);
    const i = e.root;
    if (i !== void 0 && i !== e)
      for (const s of i.views._listeners)
        s(e, t);
    for (const s of this._views)
      s.update(t);
  }
  *getByType(e) {
    for (const t of this._views)
      Oe(t, e) && (yield t);
  }
  addView(e) {
    this._views.push(e);
  }
  removeView(e) {
    e.onHide(), e.dispose(), Wn(this._views, e);
  }
  removeAllViews() {
    for (const e of this._views)
      e.onHide(), e.dispose();
    Lt(this._views);
  }
  addEventListener(e) {
    this._listeners.push(e);
  }
  removeEventListener(e) {
    Wn(this._listeners, e);
  }
  removeEventListeners() {
    Lt(this._listeners);
  }
  clear() {
    this.removeEventListeners(), this.removeAllViews();
  }
}
class Ve {
  // Used for toolbars only
  constructor(e) {
    this.left = void 0, this.right = void 0, this.top = void 0, this.bottom = void 0, this._margin = 8, this._padding = 6, this._horizontal = !0, this.left = e.left, this.right = e.right, this.top = e.top, this.bottom = e.bottom, e.margin !== void 0 && (this._margin = e.margin), e.padding !== void 0 && (this._padding = e.padding), e.horizontal !== void 0 && (this._horizontal = e.horizontal);
  }
  get leftPx() {
    return Ve.getStringWithPx(this.left);
  }
  get rightPx() {
    return Ve.getStringWithPx(this.right);
  }
  get topPx() {
    return Ve.getStringWithPx(this.top);
  }
  get bottomPx() {
    return Ve.getStringWithPx(this.bottom);
  }
  get marginPx() {
    return Ve.getStringWithPx(this._margin);
  }
  get paddingPx() {
    return Ve.getStringWithPx(this._padding);
  }
  static getStringWithPx(e) {
    return e === void 0 ? "undefined" : e.toString() + "px";
  }
  get flexFlow() {
    return this._horizontal ? "row" : "column";
  }
  get isHorizontal() {
    return this._horizontal;
  }
  get isHorizontalDivider() {
    return !this._horizontal;
  }
}
const Ot = class Ot {
  // Needed this for testing
  static get needUpdate() {
    return this._idleCallbackId >= 0;
  }
  static update(e) {
    e !== void 0 && (this._idleCallbackId >= 0 || (this._idleCallbackId = window.requestIdleCallback(this.onIdle), this._renderTarget = e));
  }
  static dispose() {
    this._renderTarget = void 0, !(this._idleCallbackId < 0) && window.cancelIdleCallback(this._idleCallbackId);
  }
};
Ot._idleCallbackId = -1, Ot._renderTarget = void 0, Ot.onIdle = () => {
  Ot._renderTarget !== void 0 && (Ot._renderTarget.commandsController.update(), Ot._idleCallbackId = -1, Ot._renderTarget = void 0);
};
let Ie = Ot;
window.requestIdleCallback = // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
window.requestIdleCallback || uv;
function uv(n) {
  const e = Date.now();
  return setTimeout(function() {
    n({
      didTimeout: !1,
      timeRemaining: function() {
        return Math.max(0, 50 - (Date.now() - e));
      }
    });
  }, 1), 1;
}
const qs = class qs {
  // This increment by one when something happens with the domain object
  // ==================================================
  // STATIC METHODS
  // ==================================================
  static show(e) {
    if (e !== void 0) {
      if (!e.hasPanelInfo)
        return;
      this.selectedDomainObject(e);
    } else
      this.hide();
  }
  static hide() {
    this.selectedDomainObject(void 0);
  }
  static notify(e, t) {
    if (e.hasPanelInfo)
      if (e.isSelected) {
        if (t.isChanged(m.deleted)) {
          this.hide();
          return;
        }
        t.isChanged(m.selected) && this.show(e), t.isChanged(
          m.selected,
          m.geometry,
          m.dragging,
          m.naming,
          m.unit
        ) && this.update(this.update() + 1);
      } else
        t.isChanged(m.selected) && this.hide();
  }
};
qs.selectedDomainObject = fn(), qs.update = fn(0);
let Cn = qs;
function hv() {
  return window.navigator.platform.toLowerCase().startsWith("mac");
}
const bi = class bi {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor() {
    this._listeners = [], this._disposables = [], bi._counter++, this._uniqueId = bi._counter;
  }
  get uniqueId() {
    return this._uniqueId;
  }
  // ==================================================
  // VIRTUAL METHODS (To be overridden)
  // =================================================
  get name() {
    var e;
    return this.tooltip === void 0 ? "" : to(this.tooltip) ? this.tooltip.key : (e = this.tooltip) == null ? void 0 : e.untranslated;
  }
  get shortCutKey() {
  }
  get shortCutKeyOnCtrl() {
    return !1;
  }
  get shortCutKeyOnAlt() {
    return !1;
  }
  get shortCutKeyOnShift() {
    return !1;
  }
  get tooltip() {
  }
  get icon() {
  }
  get buttonType() {
    return "ghost";
  }
  get isEnabled() {
    return !0;
  }
  get isVisible() {
    return this.isEnabled;
  }
  /**
   * Gets a value indicating whether the command can be toggled on or off.
   * Override this property if the command can be toggled.
   * You must also override isChecked to get the toggle state.
   */
  get isToggle() {
    return !1;
  }
  get isChecked() {
    return !1;
  }
  /**
   * Gets a value indicating whether the command has data, for instance a reference
   * to a specific domain object. Then the command cannot be reused or shared in the user interface.
   * These command will not be added to the commandsController for updating, so update will
   * not be done automatically. Typically used when the command is created for a specific domain object
   * in the DomainObjectPanel.
   */
  get hasData() {
    return !1;
  }
  *getChildren() {
  }
  *getDescendants() {
    for (const e of this.getChildren())
      yield e, yield* e.getDescendants();
  }
  /*
   * Called when the command is invoked
   * Return true if successful, false otherwise
   * Override this method to implement the command logic
   */
  invokeCore() {
    return !1;
  }
  equals(e) {
    return this.constructor === e.constructor;
  }
  invoke() {
    return this.invokeCore();
  }
  dispose() {
    for (const e of this.getChildren())
      e.dispose();
    for (const e of this._disposables)
      e();
    this.removeEventListeners();
  }
  // ==================================================
  // INSTANCE METHODS: Event listeners
  // ==================================================
  addEventListener(e) {
    this._listeners.push(e);
  }
  removeEventListener(e) {
    Wn(this._listeners, e);
  }
  removeEventListeners() {
    Lt(this._listeners);
  }
  update(e) {
    for (const t of this._listeners)
      t(this, e);
    for (const t of this.getChildren())
      t.update(e);
  }
  // ==================================================
  // INSTANCE METHODS: Others (Not to be overridden)
  // ==================================================
  get label() {
    return this.tooltip !== void 0 ? mn(this.tooltip) : "";
  }
  addDisposable(e) {
    this._disposables.push(e);
  }
  getShortCutKeys() {
    const e = this.shortCutKey;
    if (e === void 0)
      return;
    const t = [];
    return this.shortCutKeyOnCtrl && t.push(hv() ? "Cmd" : "Ctrl"), this.shortCutKeyOnAlt && t.push("Alt"), this.shortCutKeyOnShift && t.push("Shift"), t.push(e), t;
  }
  hasShortCutKey(e, t, i, s) {
    return this.shortCutKey === e && this.shortCutKeyOnCtrl === t && this.shortCutKeyOnShift === i && this.shortCutKeyOnAlt === s;
  }
};
bi._counter = 0;
let Bi = bi;
class z extends Bi {
  constructor() {
    super(...arguments), this._renderTarget = void 0;
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get renderTarget() {
    if (this._renderTarget === void 0)
      throw new Error("Render target is not set. Have you called attach() on this command?");
    return this._renderTarget;
  }
  get rootDomainObject() {
    return this.renderTarget.rootDomainObject;
  }
  get activeTool() {
    return this.renderTarget.commandsController.activeTool;
  }
  getActiveTool(e) {
    const { activeTool: t } = this.renderTarget.commandsController;
    return Oe(t, e) ? t : void 0;
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  invoke() {
    const e = this.invokeCore();
    return e && Ie.update(this._renderTarget), e;
  }
  // ==================================================
  // VIRTUAL METHODS
  // ==================================================
  get undoManager() {
    const { activeTool: e } = this;
    if (e !== void 0)
      return e.undoManager;
  }
  attach(e) {
    this._renderTarget = e, this.attachChildren();
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  attachChildren() {
    for (const e of this.getChildren())
      e instanceof z && e.attach(this.renderTarget);
  }
  addTransaction(e) {
    if (e === void 0)
      return;
    const t = this.undoManager;
    t !== void 0 && t.addTransaction(e) && Ie.update(this.renderTarget);
  }
}
class Ir extends z {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e) {
    super(), this._domainObject = e;
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get hasData() {
    return !0;
  }
}
class jh extends Ir {
  get tooltip() {
    return { key: "DELETE" };
  }
  get icon() {
    return "Delete";
  }
  get buttonType() {
    return "ghost-destructive";
  }
  get isEnabled() {
    return this._domainObject.canBeRemoved;
  }
  invokeCore() {
    return this.addTransaction(this._domainObject.createTransaction(m.deleted)), this._domainObject.removeInteractive();
  }
}
class Zi extends Bi {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e) {
    super(), this.getString = e;
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { key: "COPY_TO_CLIPBOARD" };
  }
  get icon() {
    return "Copy";
  }
  get isEnabled() {
    return this.getString !== void 0;
  }
  get hasData() {
    return !0;
  }
  invokeCore() {
    return this.getString === void 0 ? !1 : (navigator.clipboard.writeText(this.getString()).then((e) => !0).catch((e) => {
      console.error(e);
    }), !0);
  }
}
class io extends z {
  // ==================================================
  // OVERRIDES of BaseCommand
  // ==================================================
  get icon() {
    return "RulerAlternative";
  }
  get tooltip() {
    return { untranslated: "m/ft" };
  }
  get isToggle() {
    return !0;
  }
  get isChecked() {
    return this.rootDomainObject.unitSystem.isMetric;
  }
  invokeCore() {
    const e = this.rootDomainObject.unitSystem;
    return e.isMetric = !e.isMetric, this.rootDomainObject.notify(m.unit), this.rootDomainObject.notifyDescendants(m.unit), !0;
  }
}
function zh(n, e, t = !0) {
  if (!(t && !n.isExpanded) && n.getChildren(e).next().value !== void 0)
    return Array.from(n.getChildren(e));
}
const pv = 500, fv = "gray", gv = "highlight", mv = "black", yv = "highlight", vv = 16, wr = 16, Ms = 6, Uh = 5, Cv = "Loading ....", Iv = "Load more ....", wv = 25, xv = ({
  node: n,
  onClick: e
}) => {
  const [t, i] = M(!1), s = _v(t), o = vv + "px", r = { color: s, marginTop: "0px", width: o, height: o };
  if (n.isParent) {
    const a = n.isExpanded ? im : sm;
    return /* @__PURE__ */ u(
      a,
      {
        onClick: () => {
          e(n);
        },
        onMouseEnter: () => {
          i(!0);
        },
        onMouseLeave: () => {
          i(!1);
        },
        style: r
      }
    );
  }
  return /* @__PURE__ */ u("div", { style: r });
};
function _v(n) {
  return n ? gv : fv;
}
var jn = /* @__PURE__ */ ((n) => (n[n.All = 0] = "All", n[n.Some = 1] = "Some", n[n.None = 2] = "None", n))(jn || {});
const Tv = ({
  node: n,
  onClick: e
}) => {
  if (n.checkboxState === void 0)
    return /* @__PURE__ */ u(k, {});
  if (n.checkboxState === jn.Some)
    return /* @__PURE__ */ u(
      ra,
      {
        indeterminate: !0,
        defaultChecked: !0,
        checked: !0,
        disabled: n.isCheckboxEnabled !== !0,
        onChange: () => {
          e(n);
        }
      }
    );
  const t = n.checkboxState === jn.All;
  return /* @__PURE__ */ u(
    ra,
    {
      checked: t,
      disabled: n.isCheckboxEnabled !== !0,
      onChange: () => {
        e(n);
      }
    }
  );
}, Sv = ({
  node: n,
  getIconFromIconName: e
}) => {
  const t = e(n.icon);
  return /* @__PURE__ */ u(t, { style: { color: n.iconColor, marginTop: "2px" } });
}, bv = ({
  node: n,
  props: e
}) => {
  const t = ad, [i, s] = M(!1), o = Av(i);
  return /* @__PURE__ */ u(
    t,
    {
      style: { color: o, marginTop: "2px" },
      onClick: () => {
        r(n);
      },
      onMouseEnter: () => {
        s(!0);
      },
      onMouseLeave: () => {
        s(!1);
      }
    }
  );
  function r(a) {
    e.onClickInfo !== void 0 && e.onClickInfo(a);
  }
};
function Av(n) {
  return n ? yv : mv;
}
const Ev = ({
  node: n,
  props: e
}) => {
  let t = !0, i = n.label;
  const s = e.maxLabelLength ?? wv;
  i.length > s && (i = i.substring(0, s) + "...", t = !1);
  const o = n.hasBoldLabel === !0;
  return /* @__PURE__ */ u(
    ce,
    {
      content: n.label,
      disabled: t,
      appendTo: document.body,
      enterDelay: pv,
      placement: "right",
      children: /* @__PURE__ */ u(tt, { size: "small", strong: o, children: i })
    }
  );
}, Mv = ({
  node: n,
  onClick: e,
  level: t,
  props: i
}) => {
  const s = Ms / 2 + "px", o = (t + 1) * wr + "px";
  return /* @__PURE__ */ u(
    J,
    {
      type: "secondary",
      size: "small",
      style: {
        gap: s,
        padding: "4px",
        marginTop: s,
        marginLeft: o
      },
      onClick: () => {
        e(n);
      },
      children: i.loadMoreLabel ?? Iv
    }
  );
}, ga = (n) => {
  const e = Ms + "px";
  let t, i;
  return n.level !== void 0 && (t = Uh + "px", i = (n.level + 1) * wr + Ms + "px"), /* @__PURE__ */ _(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "row",
        gap: e,
        marginTop: t,
        marginBottom: t,
        marginLeft: i
      },
      children: [
        /* @__PURE__ */ u(Wi, { style: { marginTop: "2px" } }),
        /* @__PURE__ */ u(tt, { size: "small", strong: !0, children: n.loadingLabel ?? Cv })
      ]
    }
  );
}, Pv = (n, e) => {
  const t = Z(e, [n]);
  R(() => {
    var i;
    if (n !== void 0)
      return t(), (i = n.addTreeNodeListener) == null || i.call(n, t), () => {
        var s;
        (s = n.removeTreeNodeListener) == null || s.call(n, t);
      };
  }, [n, t]);
}, Ko = ({
  node: n,
  level: e,
  props: t
}) => {
  const [i, s] = M(!1), [, o] = Mg((S) => S + 1, 0);
  if (Pv(n, () => {
    o();
  }), n.isVisibleInTree === !1)
    return /* @__PURE__ */ u(k, {});
  const r = zh(n, t.loader), a = Ms + "px", c = Uh + "px", d = e * wr + "px", l = Ov(n, i), h = t.hasHover ?? !0, p = t.hasCheckboxes ?? !0, f = t.onClickInfo !== void 0 && n.hasInfoIcon !== !1, g = n.isLoadingChildren === !0, C = n.isLoadingSiblings === !1 && n.needLoadSiblings === !0 && n.loadSiblings !== void 0;
  return /* @__PURE__ */ _("div", { children: [
    /* @__PURE__ */ _(
      "div",
      {
        id: n.id,
        style: {
          backgroundColor: l,
          flexDirection: "row",
          display: "flex",
          color: Rv(),
          gap: a,
          paddingTop: c,
          paddingBottom: c,
          marginLeft: d,
          borderRadius: "4px"
        },
        onMouseEnter: () => {
          O(n, !0);
        },
        onMouseLeave: () => {
          O(n, !1);
        },
        children: [
          /* @__PURE__ */ u(xv, { node: n, onClick: x, props: t }),
          p && /* @__PURE__ */ u(Tv, { node: n, onClick: w }),
          /* @__PURE__ */ _(
            "div",
            {
              style: {
                flexDirection: "row",
                display: "flex",
                gap: a
              },
              onClick: (S) => {
                v(n), S.stopPropagation(), S.preventDefault();
              },
              children: [
                t.getIconFromIconName !== void 0 && n.icon !== void 0 && /* @__PURE__ */ u(Sv, { node: n, getIconFromIconName: t.getIconFromIconName }),
                g && /* @__PURE__ */ u(ga, { level: void 0, ...t }),
                !g && /* @__PURE__ */ u(Ev, { node: n, props: t })
              ]
            }
          ),
          f && /* @__PURE__ */ u(bv, { node: n, props: t })
        ]
      }
    ),
    r !== void 0 && r.map((S) => /* @__PURE__ */ u(Ko, { node: S, level: e + 1, props: t }, S.id)),
    C && /* @__PURE__ */ u(
      Mv,
      {
        node: n,
        onClick: T,
        level: e,
        props: { ...t }
      }
    ),
    n.isLoadingSiblings === !0 && /* @__PURE__ */ u(ga, { level: e, ...t })
  ] });
  function v(S) {
    t.onSelectNode !== void 0 && t.onSelectNode(S);
  }
  function w(S) {
    S.isCheckboxEnabled !== !0 || S.checkboxState === void 0 || t.onToggleNode !== void 0 && t.onToggleNode(S);
  }
  function x(S) {
    S.isParent && (S.isExpanded = !S.isExpanded);
  }
  function T(S) {
    t.loader !== void 0 && S.loadSiblings !== void 0 && S.loadSiblings(t.loader);
  }
  function O(S, E) {
    h && s(E);
  }
};
function Ov(n, e) {
  if (n.isSelected)
    return $o["surface--interactive--toggled-pressed"];
  if (e)
    return $o["surface--interactive--hover"];
}
function Rv(n) {
  return $o["text-icon--strong"];
}
const Dv = (n) => {
  var o;
  const e = "advancedTreeView", [t, i] = M(((o = n.loader) == null ? void 0 : o.root) ?? n.root);
  if (n.loader !== void 0 && n.loader.loadInitialRoot !== void 0 && n.loader.loadInitialRoot().then(() => {
    var r;
    i((r = n.loader) == null ? void 0 : r.root);
  }), t === void 0)
    return /* @__PURE__ */ u(om, {});
  if (n.showRoot !== !1)
    return /* @__PURE__ */ u(Ko, { node: t, level: 0, props: n }, t.id);
  const s = zh(t, n.loader, !1);
  return s === void 0 ? /* @__PURE__ */ u(k, {}) : /* @__PURE__ */ u("div", { id: e, children: s.map((r) => /* @__PURE__ */ u(Ko, { node: r, level: 0, props: n }, r.id)) });
};
function Le(n) {
  const e = n.root;
  if (e.isRoot)
    return e;
}
function it(n) {
  const e = Le(n);
  return e == null ? void 0 : e.renderTarget;
}
const Ai = class Ai {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor() {
    this._name = void 0, this._color = void 0, this._isSelected = !1, this._isActive = !1, this._isExpanded = !1, this._children = [], this._parent = void 0, this._renderStyle = void 0, this.views = new Vh(), this._treeNodeListeners = [], Ai._counter++, this._uniqueId = Ai._counter;
  }
  // Counter for the unique index
  get uniqueId() {
    return this._uniqueId;
  }
  set uniqueId(e) {
    this._uniqueId = e;
  }
  // ==================================================
  // IMPLEMENTATION of TreeNodeType interface
  // ==================================================
  get id() {
    return this.uniqueId.toString();
  }
  get isVisibleInTree() {
    return !0;
  }
  get isParent() {
    return this.childCount > 0;
  }
  get iconColor() {
    if (this.hasIconColor)
      return this.color.getHexString();
  }
  get hasBoldLabel() {
    return !1;
  }
  get checkboxState() {
    switch (this.getVisibleState()) {
      case q.All:
        return jn.All;
      case q.None:
        return jn.None;
      case q.Some:
        return jn.Some;
      default:
        return;
    }
  }
  get isCheckboxEnabled() {
    return this.getVisibleState() !== q.Disabled;
  }
  *getChildren(e) {
    for (const t of this.children)
      yield t;
  }
  addTreeNodeListener(e) {
    this._treeNodeListeners.push(e);
  }
  removeTreeNodeListener(e) {
    Wn(this._treeNodeListeners, e);
  }
  updateTreeNodeListeners() {
    for (const e of this._treeNodeListeners)
      e(this);
  }
  // to be overridden
  // ==================================================
  // INSTANCE/VIRTUAL METHODS: Naming
  // ==================================================
  get canChangeName() {
    return !0;
  }
  get name() {
    return this._name;
  }
  set name(e) {
    this._name = e;
  }
  get hasIndexOnLabel() {
    return !0;
  }
  get labelExtension() {
  }
  /**
   * Generates a label for the domain object using the provided translation delegate.
   * If the name is provided, the label is set to the name, else
   * the label is constructed based on the object's type name, index, and label extension.
   * The label is used in UI
   * @remarks
   * - If the object's name is already defined, the method returns early without modifying the label.
   * - If the object has an index on the label, the index is appended to the label.
   * - If the object has a label extension, it is appended to the label in parentheses.
   */
  get label() {
    if (this.name !== void 0)
      return this.name;
    let e = mn(this.typeName);
    if (this.hasIndexOnLabel) {
      const i = t(this);
      i !== void 0 && (e += ` ${i + 1}`);
    }
    return this.labelExtension !== void 0 && (e += ` (${this.labelExtension})`), e;
    function t(i) {
      const { parent: s } = i;
      if (s === void 0)
        return;
      let o = 0;
      for (const r of s.children) {
        if (r === i)
          break;
        i.getTypeName() === r.getTypeName() && (o += 1);
      }
      return o;
    }
  }
  // ==================================================
  // INSTANCE/VIRTUAL METHODS: Color
  // ==================================================
  get canChangeColor() {
    return !0;
  }
  get hasIconColor() {
    return !0;
  }
  get color() {
    return this._color === void 0 && (this._color = Bh().clone()), this._color;
  }
  set color(e) {
    this._color = e;
  }
  // ==================================================
  // INSTANCE/VIRTUAL METHODS: Selected
  // ==================================================
  get canBeSelected() {
    return !0;
  }
  get isSelected() {
    return this._isSelected;
  }
  set isSelected(e) {
    this._isSelected = e;
  }
  setSelectedInteractive(e) {
    return this.isSelected === e ? !1 : (this.isSelected = e, this.notify(m.selected), !0);
  }
  // ==================================================
  // INSTANCE/VIRTUAL METHODS: Active
  // ==================================================
  get canBeActive() {
    return !1;
  }
  get isActive() {
    return this._isActive;
  }
  set isActive(e) {
    this._isActive = e;
  }
  setActiveInteractive() {
    if (!this.isActive && this.canBeActive) {
      if (this.parent !== void 0)
        for (const e of this.parent.children)
          e !== this && e.getTypeName() === this.getTypeName() && e.canBeActive && e.isActive && (e.isActive = !1, e.notify(m.active));
      this.isActive = !0, this.notify(m.active);
    }
  }
  // ==================================================
  // INSTANCE/INSTANCE METHODS: Expanded in tree view
  // ==================================================
  get isExpanded() {
    return this._isExpanded;
  }
  set isExpanded(e) {
    this._isExpanded !== e && (this._isExpanded = e, this.notify(m.expanded));
  }
  // ==================================================
  // VIRTUAL METHODS: Appearance in the tree view
  // ==================================================
  get canBeRemoved() {
    return !0;
  }
  canBeSetVisibleNow(e) {
    return !0;
  }
  /**
   * Gets a value indicating whether the domain object is legal.
   * Normally it is legal, but if the object is pending when creating it, it is not legal.
   * @returns {boolean} A boolean value indicating whether the domain object is legal.
   */
  get isLegal() {
    return !0;
  }
  // ==================================================
  // VIRTUAL METHODS: Notification
  // ==================================================
  /**
   * Notifies the registered views and listeners about a change in the domain object.
   * This method should be overridden in derived classes to provide custom implementation.
   * @param change - The change object representing the update.
   * @remarks
   * Always call `super.notifyCore()` in the overrides.
   */
  notifyCore(e) {
    if (this.views.notify(this, e), e.isChanged(m.renderStyle) && this.isRenderStyleRoot) {
      const t = e.getChangedDescription(m.renderStyle);
      if (t !== void 0) {
        const i = new ct(t);
        this.notifyDescendants(i);
      }
    }
    if (e.isChanged(
      m.visibleState,
      m.active,
      m.selected,
      m.childAdded,
      m.childDeleted
    )) {
      const t = it(this);
      t !== void 0 && Ie.update(t);
    }
    this.hasPanelInfo && Cn.notify(this, e), this.updateTreeNodeListeners();
  }
  /**
   * Creates a transaction based on the specified changes. This is used for undoing
   * @param changed - A symbol representing the changes made to the domain object.
   * @returns A Transaction object if the transaction was created successfully, otherwise undefined.
   */
  createTransaction(e) {
  }
  /**
   * Creates a copy of this the domain object. The copy will not include any parent/child relationships, or views
   * @param what - Optional parameter specifying which properties to copy. If not provided, all properties will be copied.
   * @returns A new domain object
   */
  clone(e) {
    throw new Error("Method not implemented.");
  }
  /**
   * Copies the properties from another `DomainObject` instance to this instance.
   * @param domainObject - The `DomainObject` instance to copy from.
   * @param what - Optional parameter specifying which properties to copy. If not provided, all properties will be copied.
   */
  copyFrom(e, t) {
    var i;
    t === void 0 && (this.uniqueId = e.uniqueId), (t === void 0 || t === m.color) && this.canChangeColor && (this.color = e.color.clone()), (t === void 0 || t === m.naming) && (this.name = e.name), (t === void 0 || t === m.renderStyle) && (this._renderStyle = (i = e._renderStyle) == null ? void 0 : i.clone());
  }
  // ==================================================
  // VIRTUAL METHODS: For updating the panel
  // ==================================================
  get hasPanelInfo() {
    return !1;
  }
  getPanelInfo() {
  }
  getPanelInfoStyle() {
    return new Ve({ bottom: 50, left: 0 });
  }
  getPanelToolbar() {
    return [
      new Zi(),
      new io(),
      new jh(this)
    ];
  }
  // ==================================================
  // VIRTUAL METHODS: Others
  // ==================================================
  get icon() {
  }
  /**
   * Removes the core functionality of the domain object.
   * This method should be overridden in derived classes to provide custom implementation.
   * @remarks
   * Always call `super.removeCore()` in the overrides.
   */
  removeCore() {
    this.views.clear();
  }
  // ==================================================
  // VIRTUAL METHODS: Render styles
  // ==================================================
  /**
   * Override if the render style is taken from another domain object, for instance the parent
   * or somewhere else in the hierarchy
   * @returns The render style root
   */
  get renderStyleRoot() {
  }
  /**
   * Override if this domain object is a render style root, se method above
   * @returns true if this is a render style root
   */
  get isRenderStyleRoot() {
    return !1;
  }
  /**
   * Factory method to create the render style for the domain object.
   * Override this method to create a custom render style.
   * @returns The render style
   */
  createRenderStyle() {
  }
  /**
   * Verifies the render style for the domain object, because the render style may
   * be not valid in some cases. In this method you can change the render style.
   * You can also change som fields in the renderStyle to get default values
   * dependent of the domain object itself.
   * Override this method when needed
   */
  verifyRenderStyle(e) {
  }
  // ==================================================
  // VIRTUAL METHODS: Visibility
  // ==================================================
  getVisibleState(e) {
    if (e === void 0 && (e = it(this), e === void 0))
      return q.Disabled;
    let t = 0, i = 0, s = 0;
    for (const o of this.children) {
      const r = o.getVisibleState(e);
      if (r !== q.Disabled && (t++, r === q.All ? i++ : (r === q.None || r === q.CanNotBeVisibleNow) && s++, s < t && t < i))
        return q.Some;
    }
    return t === 0 ? q.Disabled : t === i ? q.All : t === s ? this.canBeSetVisibleNow(e) ? q.None : q.CanNotBeVisibleNow : q.Some;
  }
  setVisibleInteractive(e, t = void 0, i = !0) {
    if (t === void 0 && (t = it(this), t === void 0))
      return !1;
    const s = this.getVisibleState(t);
    if (s === q.Disabled || s === q.None && !this.canBeSetVisibleNow(t))
      return !1;
    let o = !1;
    for (const r of this.children)
      r.setVisibleInteractive(e, t, !1) && (o = !0);
    return o ? (i && this.notifyVisibleStateChange(), !0) : !1;
  }
  // ==================================================
  // INSTANCE METHODS: Notification
  // ==================================================
  notify(e) {
    typeof e == "symbol" ? e = new ct(e) : e instanceof $n && (e = new ct(e)), this.notifyCore(e);
  }
  notifyDescendants(e) {
    typeof e == "symbol" ? e = new ct(e) : e instanceof $n && (e = new ct(e));
    for (const t of this.getDescendants())
      t.notify(e);
  }
  notifyVisibleStateChange() {
    const e = new ct(m.visibleState);
    this.notify(e);
    for (const t of this.getAncestors())
      t.notify(e);
    for (const t of this.getDescendants())
      t.notify(e);
  }
  // ==================================================
  // INSTANCE METHODS: Visibility
  // ==================================================
  toggleVisibleInteractive(e) {
    const t = this.getVisibleState(e);
    t === q.None ? this.setVisibleInteractive(!0, e) : (t === q.Some || t === q.All) && this.setVisibleInteractive(!1, e);
  }
  /**
   * Checks if the domain object is visible in the specified render target.
   * @param renderTarget - The render target to check visibility in.
   * @returns `true` if the domain object is visible in the target, `false` otherwise.
   */
  isVisible(e) {
    const t = this.getVisibleState(e);
    return t === q.Some || t === q.All;
  }
  // ==================================================
  // INSTANCE PROPERTIES: Child-Parent relationship
  // ==================================================
  get children() {
    return this._children;
  }
  get childCount() {
    return this._children.length;
  }
  get childIndex() {
    return this.parent === void 0 ? void 0 : this.parent.children.indexOf(this);
  }
  get parent() {
    return this._parent;
  }
  get root() {
    return this.parent === void 0 ? this : this.parent.root;
  }
  get isRoot() {
    return !1;
  }
  get hasParent() {
    return this._parent !== void 0;
  }
  // ==================================================
  // INSTANCE METHODS: Get a child or children
  // ==================================================
  hasChildByType(e) {
    return this.getChildByType(e) !== void 0;
  }
  getChild(e) {
    return this._children[e];
  }
  getChildByType(e) {
    for (const t of this.children)
      if (Oe(t, e))
        return t;
  }
  getActiveChildByType(e) {
    for (const t of this.children)
      if (t.isActive && Oe(t, e))
        return t;
  }
  *getChildrenByType(e) {
    for (const t of this.children)
      Oe(t, e) && (yield t);
  }
  // ==================================================
  // INSTANCE METHODS: Get descendants (returning a generator)
  // ==================================================
  *getDescendants() {
    for (const e of this.children)
      yield e, yield* e.getDescendants();
  }
  *getThisAndDescendants() {
    yield this;
    for (const e of this.getDescendants())
      yield e;
  }
  *getDescendantsByType(e) {
    for (const t of this.getDescendants())
      Oe(t, e) && (yield t);
  }
  *getThisAndDescendantsByType(e) {
    for (const t of this.getThisAndDescendants())
      Oe(t, e) && (yield t);
  }
  // ==================================================
  // INSTANCE METHODS: Get single descendant
  // (returning a DomainObject | undefined)
  // ==================================================
  getDescendantByType(e) {
    for (const t of this.getDescendants())
      if (Oe(t, e))
        return t;
  }
  getThisOrDescendantByUniqueId(e) {
    for (const t of this.getThisAndDescendants())
      if (t.uniqueId === e)
        return t;
  }
  getSelectedDescendant() {
    for (const e of this.getThisAndDescendants())
      if (e.isSelected)
        return e;
  }
  getSelectedDescendantByType(e) {
    for (const t of this.getDescendantsByType(e))
      if (t.isSelected)
        return t;
  }
  getActiveDescendantByType(e) {
    for (const t of this.getDescendantsByType(e))
      if (t.isActive)
        return t;
  }
  // ==================================================
  // INSTANCE METHODS: Get ancestors
  // ==================================================
  *getAncestors() {
    let e = this.parent;
    for (; e !== void 0; )
      yield e, e = e.parent;
  }
  *getThisAndAncestors() {
    yield this;
    let e = this.parent;
    for (; e !== void 0; )
      yield e, e = e.parent;
  }
  getAncestorByType(e) {
    for (const t of this.getAncestors())
      if (Oe(t, e))
        return t;
  }
  getThisOrAncestorByType(e) {
    for (const t of this.getThisAndAncestors())
      if (Oe(t, e))
        return t;
  }
  // ==================================================
  // INSTANCE METHODS: Child-Parent relationship
  // ==================================================
  addChild(e, t = !1) {
    if (e.hasParent)
      throw Error(`The child ${e.getTypeName()} already has a parent`);
    if (e === this)
      throw Error(`Trying to add illegal child ${e.getTypeName()}`);
    t ? this._children.unshift(e) : this._children.push(e), e._parent = this;
  }
  addChildInteractive(e, t = !1) {
    this.addChild(e, t), this.notify(m.childAdded), e.notify(m.added);
  }
  remove() {
    const { childIndex: e } = this;
    if (e === void 0)
      throw Error(`The child ${this.getTypeName()} is not child of it's parent`);
    return Lt(this._children), this.removeCore(), this.parent !== void 0 && (kh(this.parent.children, e), this._parent = void 0), !0;
  }
  removeInteractive(e = !0) {
    if (e && !this.canBeRemoved)
      return !1;
    for (const i of this.children)
      i.removeInteractive(!1);
    const { parent: t } = this;
    return this.notify(m.deleted), this.remove(), t == null || t.notify(m.childDeleted), !0;
  }
  // ==================================================
  // INSTANCE METHODS: Render styles
  // ==================================================
  getRenderStyle() {
    const e = this.renderStyleRoot;
    return e !== void 0 && e !== this ? e.getRenderStyle() : (this._renderStyle === void 0 && (this._renderStyle = this.createRenderStyle()), this._renderStyle !== void 0 && this.verifyRenderStyle(this._renderStyle), this._renderStyle);
  }
  setRenderStyle(e = void 0) {
    this._renderStyle = e;
  }
  // ==================================================
  // INSTANCE METHODS: Get auto name and color
  // ==================================================
  getTypeName() {
    return to(this.typeName) ? this.typeName.key : this.typeName.untranslated;
  }
  // ==================================================
  // INSTANCE METHODS: Color type
  // Used in the render style to determine which of the color a domain object should have.
  // ==================================================
  supportsColorType(e, t) {
    switch (e) {
      case Re.Specified:
      case Re.Parent:
      case Re.Black:
      case Re.White:
        return !0;
      case Re.ColorMap:
        return t;
      default:
        return !1;
    }
  }
  getColorByColorType(e) {
    switch (e) {
      case Re.Specified:
        return this.color;
      case Re.Parent:
        if (this.parent !== void 0)
          return this.parent.color;
        break;
      case Re.Black:
        return vr;
    }
    return vn;
  }
};
Ai._counter = 0;
let Yt = Ai;
class Gh {
  constructor() {
    this._domainObject = void 0;
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get hasDomainObject() {
    return this._domainObject !== void 0;
  }
  get domainObject() {
    if (this._domainObject === void 0)
      throw Error("The DomainObject is missing in the view");
    return this._domainObject;
  }
  // ==================================================
  // VIRTUAL METHODS
  // ==================================================
  /**
   * Initializes the view.
   * Override this function to initialize your view.
   * @remarks
   * Always call `super.initialize()` in the overrides.
   */
  initialize() {
  }
  /**
   * Updates the view with the given change.
   * Override this function to update your view.
   *
   * @param change - The domain object change to apply to the view.
   * @remarks
   * Always call `super.update()` in the overrides.
   */
  update(e) {
  }
  /**
   * Clears the memory and removes redundant data.
   * This method should be overridden in derived classes.
   * @remarks
   * Always call `super.clearMemory()` in the overrides.
   */
  clearMemory() {
  }
  /**
   * Called when the view is set to be visible.
   * Override this function to perform any necessary actions when the view becomes visible.
   * @remarks
   * Always call `super.onShow()` in the overrides.
   */
  onShow() {
  }
  /**
   * Called when the view is set to NOT visible.
   * Override this function to perform any necessary actions when the view is hidden.
   * @remarks
   * Always call `super.onHide()` in the overrides.
   */
  onHide() {
  }
  /**
   * Dispose the view.
   * Override this function to perform any necessary cleanup when the view is set to NOT visible.
   * This method is called just before the view is removed from the view list and detached.
   * @remarks
   * Always call `super.dispose()` in the overrides.
   */
  dispose() {
    this._domainObject = void 0;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  setDomainObject(e) {
    this._domainObject = e;
  }
}
class bn extends Gh {
  constructor() {
    super(...arguments), this._boundingBox = void 0, this._renderTarget = void 0;
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get hasRenderTarget() {
    return this._renderTarget !== void 0;
  }
  get renderTarget() {
    if (this._renderTarget === void 0)
      throw Error("The RevealRenderTarget is missing in the view");
    return this._renderTarget;
  }
  get style() {
    return this.domainObject.getRenderStyle();
  }
  // ==================================================
  // OVERRIDES of BaseView
  // ==================================================
  update(e) {
    super.update(e), e.isChanged(m.geometry, m.dragging) && (this.invalidateBoundingBox(), this.invalidateRenderTarget());
  }
  clearMemory() {
    super.clearMemory(), this.invalidateBoundingBox();
  }
  onShow() {
    super.onShow(), this.invalidateRenderTarget();
  }
  onHide() {
    super.onHide(), this.invalidateRenderTarget();
  }
  dispose() {
    super.dispose(), this._renderTarget = void 0;
  }
  /**
   * This method is called before rendering the view.
   * Override this function to perform any necessary operations
   * just before rendering. Have in mind that the Object3D are build at the time this is
   * called, so you can only do adjustment on existing object3D's.
   * @remarks
   * Always call `super.beforeRender(camera)` in the overrides.
   */
  beforeRender(e) {
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  get boundingBox() {
    return this._boundingBox === void 0 && (this._boundingBox = this.calculateBoundingBox()), this._boundingBox;
  }
  invalidateBoundingBox() {
    this._boundingBox = void 0;
  }
  attach(e, t) {
    super.setDomainObject(e), this._renderTarget = t;
  }
  invalidateRenderTarget() {
    this.renderTarget.invalidate();
  }
}
var A = /* @__PURE__ */ ((n) => (n[n.None = 0] = "None", n[n.Focus = 1] = "Focus", n[n.Face = 2] = "Face", n[n.Corner = 3] = "Corner", n[n.Rotation = 4] = "Rotation", n[n.Body = 5] = "Body", n[n.Pending = 6] = "Pending", n))(A || {});
function kv(n) {
  for (const e of Hh(n))
    if (xr.has(e))
      return !0;
  return !1;
}
function Lv(n) {
  for (const e of Hh(n)) {
    const t = xr.get(e);
    if (t !== void 0)
      return t();
  }
}
function Je(n, e) {
  Nv(n, () => new e());
}
function Nv(n, e) {
  xr.set(n, e);
}
const xr = /* @__PURE__ */ new Map();
function* Hh(n) {
  let e = t(n);
  for (; ; ) {
    yield e;
    const s = i(e);
    if (s === void 0)
      return;
    e = s;
  }
  function t(s) {
    return s.constructor;
  }
  function i(s) {
    var o;
    return ((o = Object.getPrototypeOf(s.prototype)) == null ? void 0 : o.constructor) ?? void 0;
  }
}
class Me extends Yt {
  constructor() {
    super(...arguments), this.focusType = A.None;
  }
  // ==================================================
  // OVERRIDES of DomainObject
  // ==================================================
  getVisibleState(e) {
    return e === void 0 && (e = it(this), e === void 0) ? q.Disabled : this.getViewByTarget(e) !== void 0 ? q.All : kv(this) ? this.canBeSetVisibleNow(e) ? q.None : q.CanNotBeVisibleNow : q.Disabled;
  }
  setVisibleInteractive(e, t = void 0, i = !0) {
    return t === void 0 && (t = it(this), t === void 0) || e && !this.canBeSetVisibleNow(t) || !this.setVisible(e, t) ? !1 : (i && this.notifyVisibleStateChange(), !0);
  }
  get isLegal() {
    return this.focusType !== A.Pending;
  }
  // ==================================================
  // VIRTUAL METHODS
  // ==================================================
  /**
   * Factory method to create a dragger to interpret the mouse dragging operation
   * This function is used in BaseEditTool
   *
   * @returns The dragger
   */
  createDragger(e) {
  }
  get useClippingInIntersection() {
    return !0;
  }
  getEditToolCursor(e, t) {
  }
  setFocusInteractive(e) {
    if (this.focusType === e)
      return !1;
    const t = this.focusType === A.Pending && e !== A.Pending;
    return this.focusType = e, this.notify(m.focus), t && this.notify(m.geometry), !0;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  getViewByTarget(e) {
    for (const t of this.views.getByType(bn))
      if (t.renderTarget === e)
        return t;
  }
  /**
   * Sets the visibility of the visual domain object for a specific target.
   * @param visible - A boolean indicating whether the visual domain object should be visible or not.
   * @param target - The target RevealRenderTarget where the visual domain object will be attached.
   * @returns A boolean indicating whether the state has changed.
   */
  setVisible(e, t) {
    let i = this.getViewByTarget(t);
    if (e) {
      if (i !== void 0 || (i = Lv(this), i === void 0))
        return !1;
      this.views.addView(i), i.attach(this, t), i.initialize(), i.onShow();
    } else {
      if (i === void 0)
        return !1;
      this.views.removeView(i);
    }
    return !0;
  }
}
class An {
}
const fi = new D().setScalar(1), Bv = new D().setScalar(0.23), Fv = new D().setScalar(0.35), Vv = new D(1, 0, 0), jv = new D(0, 1, 0), zv = new D(0, 0, 1);
class Uv extends An {
  constructor() {
    super(...arguments), this.showAxis = !0, this.showAxisLabel = !0, this.showAxisNumbers = !0, this.showAxisTicks = !0, this.showGrid = !0, this.numberOfTicks = 40, this.tickLength = 5e-3, this.tickFontSize = 2, this.axisLabelFontSize = 4, this.gridColor = Fv, this.wallColor = Bv, this.textColor = fi, this.mainAxisColor = fi, this.xAxisColor = Vn(fi, Vv, 0.6), this.yAxisColor = Vn(fi, jv, 0.6), this.zAxisColor = Vn(fi, zv, 0.6);
  }
  // ==================================================
  // OVERRIDES of BaseStyle
  // ==================================================
  clone() {
    return Mt(this);
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  getAxisColor(e, t) {
    if (!e)
      return this.mainAxisColor;
    switch (t) {
      case 0:
        return this.xAxisColor;
      case 1:
        return this.yAxisColor;
      case 2:
        return this.zAxisColor;
      default:
        throw Error("getAxisColor");
    }
  }
  getAxisLabel(e) {
    switch (e) {
      case 0:
        return "X";
      case 1:
        return "Y";
      case 2:
        return "Z";
      default:
        throw Error("getAxisName");
    }
  }
}
class wi extends Me {
  // ==================================================
  // OVERRIDES of DomainObject
  // ==================================================
  get typeName() {
    return { untranslated: "Axis" };
  }
  get icon() {
    return "Axis3D";
  }
  get hasIconColor() {
    return !1;
  }
  get hasIndexOnLabel() {
    return !1;
  }
  createRenderStyle() {
    return new Uv();
  }
}
class so extends Yt {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e, t) {
    super(), this.unitSystem = new no(), this._renderTarget = e, this._sdk = t, this._fdmSdk = new Xi(t), this.addChild(new wi());
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get renderTarget() {
    return this._renderTarget;
  }
  get sdk() {
    return this._sdk;
  }
  get fdmSdk() {
    return this._fdmSdk;
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get typeName() {
    return { key: "SCENE" };
  }
  get icon() {
    return "GraphTree";
  }
  get hasIconColor() {
    return !1;
  }
  get hasIndexOnLabel() {
    return !1;
  }
  get isRoot() {
    return !0;
  }
  clone(e) {
    const t = new so(this.renderTarget, this.sdk);
    return t.copyFrom(this, e), t;
  }
}
function qh(n) {
  return Math.atan2(-n.y, -n.x) + Math.PI;
}
function Gv(n, e) {
  return Math.sqrt(Dt(n.x - e.x) + Dt(n.y - e.y));
}
function $h(n, e) {
  return Math.abs(n.z - e.z);
}
function Hv(n, e) {
  const t = n.x;
  n.x = t * Math.cos(e) - n.y * Math.sin(e), n.y = t * Math.sin(e) + n.y * Math.cos(e);
}
function qv(n) {
  const e = n.x;
  n.x = -n.y, n.y = e;
}
function $v(n) {
  let e = 0, t = 0;
  for (let i = 0; i < 3; i++) {
    const s = Math.abs(n.getComponent(i));
    s < e || (t = i, e = s);
  }
  return t;
}
function Wv(n, e) {
  return n.x * e.y - n.y * e.x;
}
function Kv(n) {
  let t = n.angle() / (2 * Math.PI);
  for (; t < 0; ) t += 1;
  for (; t > 1; ) t -= 1;
  const i = Math.round(8 * t);
  return i >= 8 ? i - 8 : i < 0 ? i + 8 : i;
}
function Wh(n) {
  switch (n) {
    case 2:
    case 6:
      return "ns-resize";
    case 1:
    case 5:
      return "nesw-resize";
    case 0:
    case 4:
      return "ew-resize";
    case 3:
    case 7:
      return "nwse-resize";
    default:
      return;
  }
}
class gt extends bn {
  constructor() {
    super(...arguments), this._group = new hr(), this._inNeedsUpdate = !1;
  }
  // True if inside needsUpdate. This is to avoid infinite recursion.
  get isEmpty() {
    return this._group.children.length === 0;
  }
  // ==================================================
  // IMPLEMENTATION of ICustomObject
  // some of the methods are virtual and can be overridden,
  // see each method.
  // ==================================================
  get object() {
    return this.needsUpdate && this.removeChildren(), this.isEmpty && this.makeChildren(), this._group;
  }
  get shouldPick() {
    return !0;
  }
  get shouldPickBoundingBox() {
    return !0;
  }
  get isPartOfBoundingBox() {
    return !0;
  }
  get useDepthTest() {
    return !0;
  }
  getBoundingBox(e) {
    return e.copy(this.boundingBox), e;
  }
  intersectIfCloser(e, t) {
    return this.intersectObjectIfCloser(this.object, e, t);
  }
  // ==================================================
  // OVERRIDES of BaseView
  // ==================================================
  initialize() {
    super.initialize(), this.isEmpty && this.makeChildren();
    const { viewer: e } = this.renderTarget;
    e.addCustomObject(this);
  }
  update(e) {
    super.update(e), e.isChanged(m.geometry, m.dragging) && (this.removeChildren(), this.invalidateRenderTarget());
  }
  clearMemory() {
    super.clearMemory(), this.removeChildren();
  }
  dispose() {
    this.removeChildren();
    const { viewer: e } = this.renderTarget;
    e.removeCustomObject(this), super.dispose();
  }
  // ==================================================
  // OVERRIDES of ThreeView
  // ==================================================
  /**
   * Calculates the bounding box of the object.
   * Overrides this if you want to calculate the bounding box in a
   * different way that three.js does it. For instance if you don't
   * want to include text labels in the bounding box.
   *
   * @returns The calculated bounding box.
   */
  calculateBoundingBox() {
    if (this.object === void 0)
      return new te().makeEmpty();
    const e = new te();
    return e.setFromObject(this.object, !0), e;
  }
  /**
   * Determines whether the view needs to be updated just before rendering.
   * Typically needed to be implemented if the update function is not enough and
   * the view depend on other factors as the model bounding box or the camera position.
   * This method can be overridden in derived classes.
   *
   * When it returns true, the view will be rebuild by addChildren().
   * @returns A boolean value indicating whether the view needs to be updated.
   */
  needsUpdateCore() {
    return !1;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  get needsUpdate() {
    if (this._inNeedsUpdate)
      return !1;
    this._inNeedsUpdate = !0;
    const e = this.needsUpdateCore();
    return this._inNeedsUpdate = !1, e;
  }
  makeChildren() {
    if (!this.isEmpty)
      throw Error("Can make the object when it is already made");
    this.addChildren();
  }
  removeChildren() {
    this.isEmpty || (Yo(this._group), this._group.remove(...this._group.children));
  }
  addChild(e) {
    e !== void 0 && this._group.add(e);
  }
  removeChild(e) {
    e !== void 0 && (Yo(e), this._group.remove(e));
  }
  intersectObjectIfCloser(e, t, i) {
    const s = t.raycaster.intersectObject(e, !0);
    if (s === void 0 || s.length === 0)
      return;
    const { point: o, distance: r } = s[0];
    if (i !== void 0 && i < r)
      return;
    const { domainObject: a } = this;
    if (a instanceof Me) {
      if (a.useClippingInIntersection && !t.isVisible(o))
        return;
    } else if (!t.isVisible(o))
      return;
    const c = {
      type: "customObject",
      point: o,
      distanceToCamera: r,
      userData: s[0],
      customObject: this,
      domainObject: a
    };
    return this.shouldPickBoundingBox && (this.boundingBox.isEmpty() || (c.boundingBox = this.boundingBox)), c;
  }
}
function Yo(n) {
  if (n === void 0)
    return;
  if (n instanceof hr)
    for (const t of n.children)
      Yo(t);
  if (!(n instanceof Ce))
    return;
  const e = n.material;
  if (e != null) {
    const t = e.texture;
    t != null && t.dispose(), e.dispose();
  }
}
function It(n) {
  const e = n;
  return (e == null ? void 0 : e.domainObject) !== void 0;
}
function Yv(n) {
  return (n == null ? void 0 : n.type) === "customObject";
}
class Kh {
  constructor() {
    this._transactions = [];
  }
  // ==================================================
  // INSTANCE METHODS
  // =================================================
  /**
   * Adds a transaction to the undo manager.
   *
   * @param transaction - The transaction to be added. If undefined, the transaction will not be added.
   * @returns A boolean indicating whether the ability to undo has changed as a result of adding the transaction.
   */
  addTransaction(e) {
    if (e === void 0)
      return !1;
    const t = this.canUndo;
    return this._transactions.push(e), t !== this.canUndo;
  }
  undo(e) {
    if (this._transactions.length === 0)
      return !1;
    let t = this._transactions.pop();
    if (t === void 0)
      throw new Error("Transaction is undefined");
    let i = t.undo(e), s = t.timeStamp;
    for (let o = this._transactions.length - 1; o >= 0 && !(Math.abs(this._transactions[o].timeStamp - s) > 500); o--) {
      if (t = this._transactions.pop(), t === void 0)
        throw new Error("Transaction is undefined");
      s = t.timeStamp, t.undo(e) && (i = !0);
    }
    return i;
  }
  get canUndo() {
    return this._transactions.length > 0;
  }
  hasUniqueId(e) {
    return this._transactions.find((t) => t.uniqueId === e) !== void 0;
  }
}
const $s = class $s {
};
$s.active = Symbol("active"), $s.deactive = Symbol("deactive");
let Fi = $s;
const Ws = class Ws {
  // ==================================================
  // STATIC METHODS
  // ==================================================
  static setCounterDelegate(e) {
    this._setCounter = e;
  }
  static update() {
    this._setCounter !== void 0 && (this._counter++, this._setCounter(this._counter));
  }
};
Ws._setCounter = void 0, Ws._counter = 0;
let Vi = Ws;
function Xv(n) {
  const e = Zv(n);
  return Yh.get(e);
}
function gi(n, e) {
  Yh.set(n, e);
}
const Yh = /* @__PURE__ */ new Map();
function Zv(n) {
  return n.constructor;
}
class Xh extends z {
  constructor() {
    super(...arguments), this._undoManager = new Kh();
  }
  // ==================================================
  // OVERRIDES
  // =================================================
  get isChecked() {
    return this.activeTool === this;
  }
  invokeCore() {
    return this.isChecked ? this.renderTarget.commandsController.activateDefaultTool() : this.renderTarget.commandsController.setActiveTool(this), !0;
  }
  get undoManager() {
    return this._undoManager;
  }
  // ==================================================
  // VIRTUAL METHODS: To be overridden
  // ==================================================
  get defaultCursor() {
    return "default";
  }
  getAnchoredDialogContent() {
  }
  getToolbarStyle() {
    return new Ve({ bottom: 0, left: 0 });
  }
  onActivate() {
    this.update(Fi.active), this.setDefaultCursor(), this.clearDragging();
  }
  onDeactivate() {
    this.update(Fi.deactive), this.clearDragging();
  }
  clearDragging() {
  }
  onHover(e) {
  }
  onHoverByDebounce(e) {
  }
  async onClick(e) {
    e.button === qo.RIGHT ? await this.openContextMenu(e) : this.isContextMenuOpen() && await this.closeContextMenu(), await Promise.resolve();
  }
  async onDoubleClick(e) {
    await Promise.resolve();
  }
  async onLeftPointerDown(e) {
    await Promise.resolve();
  }
  async onLeftPointerDrag(e) {
    await Promise.resolve();
  }
  async onLeftPointerUp(e) {
    await Promise.resolve();
  }
  async onRightPointerDown(e) {
    await Promise.resolve();
  }
  async onRightPointerDrag(e) {
    await Promise.resolve();
  }
  async onRightPointerUp(e) {
    await Promise.resolve();
  }
  async onWheel(e, t) {
    await Promise.resolve();
  }
  onFocusChanged(e) {
  }
  onKey(e, t) {
  }
  onDeleteKey() {
  }
  onEscapeKey() {
  }
  onUndo() {
  }
  // ==================================================
  // INSTANCE METHODS: Intersections
  // ==================================================
  async getIntersection(e, t) {
    const i = this.renderTarget.viewer, s = i.getPixelCoordinatesFromEvent(e);
    if (t === void 0)
      return await i.getAnyIntersectionFromPixel(s);
    const o = (r) => t === void 0 ? !0 : r instanceof bn ? t(r.domainObject) : !1;
    return await i.getAnyIntersectionFromPixel(s, { predicate: o });
  }
  getSpecificIntersection(e, t) {
    const { renderTarget: i, rootDomainObject: s } = this, { viewer: o } = i, r = o.getPixelCoordinatesFromEvent(e), a = o.createCustomObjectIntersectInput(r);
    let c, d;
    for (const l of s.getDescendants())
      if (!(t !== void 0 && !t(l)))
        for (const h of l.views.getByType(gt)) {
          if (h.renderTarget !== i)
            continue;
          const p = h.intersectIfCloser(a, d);
          p !== void 0 && (d = p.distanceToCamera, c = p);
        }
    if (It(c))
      return c;
  }
  // ==================================================
  // INSTANCE METHODS: Getters
  // ==================================================
  getToolbar() {
    return Xv(this);
  }
  getRaycaster(e) {
    const { renderTarget: t } = this, i = this.getNormalizedPixelCoordinates(e), s = new Ug();
    return s.setFromCamera(i, t.camera), s;
  }
  getRay(e, t = !1) {
    const i = this.getRaycaster(e).ray;
    return t && i.applyMatrix4(this.renderTarget.fromViewerMatrix), i;
  }
  getNormalizedPixelCoordinates(e) {
    const { renderTarget: t } = this, { viewer: i } = t, s = i.getPixelCoordinatesFromEvent(e);
    return i.getNormalizedPixelCoordinates(s);
  }
  // ==================================================
  // INSTANCE METHODS: Misc
  // ==================================================
  setDefaultCursor() {
    this.renderTarget.cursor = this.defaultCursor;
  }
  setCursor(e) {
    this.renderTarget.cursor = e;
  }
  async openContextMenu(e) {
    const t = await this.getIntersection(e);
    this._renderTarget !== void 0 && (this._renderTarget.contextMenuController.contextMenuPositionData = {
      clickEvent: e,
      position: new Ct(e.layerX, e.layerY),
      intersection: t
    }, Vi.update());
  }
  async closeContextMenu() {
    this._renderTarget !== void 0 && (this._renderTarget.contextMenuController.contextMenuPositionData = void 0);
  }
  isContextMenuOpen() {
    var e;
    return ((e = this._renderTarget) == null ? void 0 : e.contextMenuController.contextMenuPositionData) !== void 0;
  }
}
class Qi extends Xh {
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get cameraManager() {
    return this.renderTarget.flexibleCameraManager;
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get icon() {
    return "Grab";
  }
  get tooltip() {
    return { untranslated: "Navigation" };
  }
  onHoverByDebounce(e) {
  }
  onHover(e) {
    this.renderTarget.viewer.onHover360Images(e);
  }
  async onClick(e) {
    await this.renderTarget.viewer.onClick360Images(e).then((i) => (i && Ie.update(this.renderTarget), i)) || (await super.onClick(e), await this.cameraManager.onClick(e));
  }
  async onDoubleClick(e) {
    await this.cameraManager.onDoubleClick(e);
  }
  async onLeftPointerDown(e) {
    await this.cameraManager.onPointerDown(e, !0);
  }
  async onLeftPointerDrag(e) {
    await this.cameraManager.onPointerDrag(e, !0);
  }
  async onLeftPointerUp(e) {
    await this.cameraManager.onPointerUp(e, !0);
  }
  async onRightPointerDown(e) {
    await this.cameraManager.onPointerDown(e, !1);
  }
  async onRightPointerDrag(e) {
    await this.cameraManager.onPointerDrag(e, !1);
  }
  async onRightPointerUp(e) {
    await this.cameraManager.onPointerUp(e, !1);
  }
  async onWheel(e, t) {
    await this.cameraManager.onWheel(e, t);
  }
  onKey(e, t) {
    this.cameraManager.onKey(e, t);
  }
  onEscapeKey() {
    this.renderTarget.isInside360Image ? this.renderTarget.viewer.image360Action(Fe.Exit).then(() => {
      Ie.update(this.renderTarget);
    }) : super.onEscapeKey();
  }
  onFocusChanged(e) {
    this.cameraManager.onFocusChanged(e);
  }
}
class Zh {
  // ==================================================
  // VIRTUAL METHODS: Override these to config the viewer
  // ==================================================
  createTopToolbar() {
    return [];
  }
  createTopToolbarStyle() {
    return new Ve({ left: 0, top: 0, horizontal: !0 });
  }
  createMainToolbar() {
    return [];
  }
  createMainToolbarStyle() {
    return new Ve({ left: 0, top: 48, horizontal: !1 });
  }
  createAxisGizmoTool() {
  }
  createDefaultTool() {
    return new Qi();
  }
  onStartup(e) {
  }
}
class Qh extends Zh {
}
const ma = 1e3, Ei = class Ei {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e, t) {
    this._min = 0, this._max = 0, this._isEmpty = !0, e === void 0 && t !== void 0 ? this.set(t, t) : e !== void 0 && t === void 0 ? this.set(e, e) : e !== void 0 && t !== void 0 && this.set(e, t);
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get isEmpty() {
    return this._isEmpty;
  }
  get isSingular() {
    return this.min === this.max;
  }
  get hasSpan() {
    return !this.isEmpty && !this.isSingular;
  }
  get min() {
    return this._min;
  }
  get max() {
    return this._max;
  }
  get delta() {
    return this._max - this._min;
  }
  get center() {
    return (this._min + this._max) / 2;
  }
  clone() {
    const e = new Ei();
    return e._min = this._min, e._max = this._max, e._isEmpty = this._isEmpty, e;
  }
  // ==================================================
  // INSTANCE METHODS: Requests
  // ==================================================
  equals(e) {
    return e === void 0 ? !1 : this._isEmpty && e._isEmpty ? !0 : this._isEmpty !== e._isEmpty ? !1 : this.min === e.min && this.max === e.max;
  }
  isInside(e) {
    return this.min <= e && e <= this.max;
  }
  // ==================================================
  // INSTANCE METHODS: Getters
  // ==================================================
  toString() {
    return `(${this._min}, ${this._max})`;
  }
  getFraction(e) {
    return (e - this.min) / this.delta;
  }
  getTruncatedFraction(e) {
    const t = this.getFraction(e);
    return t < 0 ? 0 : t > 1 ? 1 : t;
  }
  getValue(e) {
    return e * this.delta + this.min;
  }
  getBestIncrement(e = 50) {
    const t = this.delta / e;
    return Lh(t);
  }
  getNumTicks(e) {
    return Math.round(this.delta / e);
  }
  *getTicks(e) {
    const t = this.clone();
    if (!t.roundByInc(-e) || t.getNumTicks(e) > ma)
      return;
    const i = e / 1e4, s = t.max + i;
    for (let o = t.min; o <= s; o += e)
      yield Math.abs(o) < i ? 0 : o;
  }
  *getFastTicks(e, t) {
    if (!this.roundByInc(-e) || this.getNumTicks(e) > ma)
      return;
    const i = this.max + t;
    for (let s = this.min; s <= i; s += e)
      yield Math.abs(s) < t ? 0 : s;
  }
  getBoldIncrement(e, t = 2) {
    let i = 0;
    const s = e * t;
    for (const o of this.getTicks(e))
      if (Wo(o, s) && (i += 1, i > 2))
        return s;
    return e;
  }
  // ==================================================
  // INSTANCE METHODS: Operations
  // ==================================================
  makeEmpty() {
    this._min = 0, this._max = 0, this._isEmpty = !0;
  }
  set(e, t) {
    this._min = Math.min(e, t), this._max = Math.max(e, t), this._isEmpty = !1;
  }
  translate(e) {
    this.isEmpty || (this._min += e, this._max += e);
  }
  scale(e) {
    this.isEmpty || (this._min *= e, this._max *= e);
  }
  scaleDelta(e) {
    if (this.isEmpty)
      return;
    const { center: t } = this;
    this._min = (this._min - t) * e + t, this._max = (this._max - t) * e + t;
  }
  add(e) {
    Number.isNaN(e) || (this.isEmpty ? (this._isEmpty = !1, this._min = e, this._max = e) : e < this._min ? this._min = e : e > this._max && (this._max = e));
  }
  addRange(e) {
    e.isEmpty || (this.isEmpty ? (this._isEmpty = !1, this._min = e.min, this._max = e.max) : (this.add(e.min), this.add(e.max)));
  }
  expandByMargin(e) {
    this.isEmpty || (this._min -= e, this._max += e, this._min > this._max && ([this._max, this._min] = [this._min, this._max]));
  }
  expandByFraction(e) {
    this.isEmpty || this.expandByMargin(this.delta * e);
  }
  roundByInc(e) {
    if (this.isEmpty)
      return !1;
    if (e < 0) {
      if (this._min = ha(this._min, -e), this._max = pa(this._max, -e), this._min > this._max) return !1;
    } else e > 0 && (this._min = pa(this._min, e), this._max = ha(this._max, e));
    return !0;
  }
};
Ei.empty = new Ei();
let ht = Ei;
const Bn = class Bn {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e, t) {
    this.x = new ht(), this.y = new ht(), this.z = new ht(), e === void 0 && t !== void 0 ? this.set(t, t) : e !== void 0 && t === void 0 ? this.set(e, e) : e !== void 0 && t !== void 0 && this.set(e, t);
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get isEmpty() {
    return this.x.isEmpty || this.y.isEmpty || this.z.isEmpty;
  }
  get min() {
    return new I(this.x.min, this.y.min, this.z.min);
  }
  get max() {
    return new I(this.x.max, this.y.max, this.z.max);
  }
  get delta() {
    return new I(this.x.delta, this.y.delta, this.z.delta);
  }
  get center() {
    return new I(this.x.center, this.y.center, this.z.center);
  }
  get diagonal() {
    return Math.sqrt(Dt(this.x.delta) + Dt(this.y.delta) + Dt(this.z.delta));
  }
  get area() {
    return 2 * (this.x.delta * this.y.delta + this.y.delta * this.z.delta + this.z.delta * this.x.delta);
  }
  get volume() {
    return this.x.delta * this.y.delta * this.z.delta;
  }
  clone() {
    const e = new Bn();
    return e.x = this.x.clone(), e.y = this.y.clone(), e.z = this.z.clone(), e;
  }
  // ==================================================
  // INSTANCE METHODS: Requests
  // ==================================================
  equals(e) {
    return e === void 0 ? !1 : this.x.equals(e.x) && this.y.equals(e.y) && this.z.equals(e.z);
  }
  isInside(e) {
    return this.x.isInside(e.x) && this.y.isInside(e.y) && this.z.isInside(e.z);
  }
  // ==================================================
  // INSTANCE METHODS: Getters
  // ==================================================
  toString() {
    return `(X: ${this.x.toString()}, Y: ${this.y.toString()}, Z: ${this.z.toString()})`;
  }
  getMin(e) {
    return e.set(this.x.min, this.y.min, this.z.min);
  }
  getMax(e) {
    return e.set(this.x.max, this.y.max, this.z.max);
  }
  getDelta(e) {
    return e.set(this.x.delta, this.y.delta, this.z.delta);
  }
  getCenter(e) {
    return e.set(this.x.center, this.y.center, this.z.center);
  }
  getBox(e) {
    return e === void 0 && (e = new te()), e.min.set(this.x.min, this.y.min, this.z.min), e.max.set(this.x.max, this.y.max, this.z.max), e;
  }
  getCornerPoints(e) {
    for (let t = 0; t < 8; t++)
      this.getCornerPoint(t, e[t]);
    return e;
  }
  getCornerPoint(e, t) {
    switch (e) {
      case 0:
        return t.set(this.x.min, this.y.min, this.z.min);
      case 1:
        return t.set(this.x.max, this.y.min, this.z.min);
      case 2:
        return t.set(this.x.max, this.y.max, this.z.min);
      case 3:
        return t.set(this.x.min, this.y.max, this.z.min);
      case 4:
        return t.set(this.x.min, this.y.min, this.z.max);
      case 5:
        return t.set(this.x.max, this.y.min, this.z.max);
      case 6:
        return t.set(this.x.max, this.y.max, this.z.max);
      case 7:
        return t.set(this.x.min, this.y.max, this.z.max);
      default:
        throw Error("getCornerPoint");
    }
  }
  // ==================================================
  // INSTANCE METHODS: Plane intersection
  // ==================================================
  getHorizontalIntersection(e, t) {
    const i = this.getCornerPoint(t, hs());
    return e.projectPoint(i, i);
  }
  getIntersectionOfEdge(e, t, i) {
    const s = this.getCornerPoint(t, hs()), o = this.getCornerPoint(i, hs());
    return ya.set(s, o), e.intersectLine(ya, hs()) ?? void 0;
  }
  getVerticalPlaneIntersection(e, t, i, s) {
    const o = t ? 4 : 0;
    let r = 0;
    for (let a = 0; a < 4; a++) {
      const c = o + a, d = o + (a + 1) % 4, l = this.getIntersectionOfEdge(e, c, d);
      if (l !== void 0) {
        if (r === 0) {
          i.copy(l), r++;
          continue;
        }
        if (r === 1) {
          s.copy(l), r++;
          break;
        }
      }
    }
    return r >= 2;
  }
  // ==================================================
  // INSTANCE METHODS: Operations
  // ==================================================
  makeEmpty() {
    this.x.makeEmpty(), this.y.makeEmpty(), this.z.makeEmpty();
  }
  copy(e) {
    e.isEmpty() ? this.makeEmpty() : this.set(e.min, e.max);
  }
  set(e, t) {
    this.x.set(e.x, t.x), this.y.set(e.y, t.y), this.z.set(e.z, t.z);
  }
  translate(e) {
    this.x.translate(e.x), this.y.translate(e.y), this.z.translate(e.z);
  }
  scale(e) {
    this.x.scale(e), this.y.scale(e), this.z.scale(e);
  }
  add(e) {
    this.x.add(e.x), this.y.add(e.y), this.z.add(e.z);
  }
  addHorizontal(e) {
    this.x.add(e.x), this.y.add(e.y);
  }
  addRange(e) {
    e !== void 0 && (this.x.addRange(e.x), this.y.addRange(e.y), this.z.addRange(e.z));
  }
  expandByMargin(e) {
    this.x.expandByMargin(e), this.y.expandByMargin(e), this.z.expandByMargin(e);
  }
  expandByMargin3(e) {
    this.x.expandByMargin(e.x), this.y.expandByMargin(e.y), this.z.expandByMargin(e.z);
  }
  expandByFraction(e) {
    this.x.expandByFraction(e), this.y.expandByFraction(e), this.z.expandByFraction(e);
  }
  // ==================================================
  // STATIC METHODS
  // ==================================================
  static createCube(e) {
    const t = new Bn();
    return t.x.set(-e, e), t.y.set(-e, e), t.z.set(-e, e), t;
  }
  static getCircleRangeMargin(e, t) {
    const i = e.clone();
    i.multiply(e), i.x > 1 && (i.x = 1), i.y > 1 && (i.y = 1), i.z > 1 && (i.z = 1);
    const s = i.set(Math.sqrt(1 - i.x), Math.sqrt(1 - i.y), Math.sqrt(1 - i.z));
    return s.multiplyScalar(t), s;
  }
};
Bn.empty = new Bn();
let ft = Bn;
const ya = new ki(), Qv = new Qn();
function hs(n) {
  return Qv.getNext(n);
}
function Jv(n, e) {
  const t = new ft(), i = new I();
  {
    const a = n.filter((d) => s(d));
    for (let d = 0; d < 8; d += 4) {
      const l = e.getCornerPoint(d, i);
      r(a, l) && t.z.add(l.z);
    }
    const c = new I(0, 0, 0);
    for (const d of a) {
      const l = d.projectPoint(c, i);
      r(a, l, d) && e.z.isInside(l.z) && t.z.add(l.z);
    }
  }
  {
    const a = n.filter((c) => o(c));
    for (let c = 0; c < 8; c++) {
      const d = e.getCornerPoint(c, i);
      r(a, d) && t.addHorizontal(d);
    }
    for (const c of a) {
      const d = new I(), l = new I();
      if (!e.getVerticalPlaneIntersection(c, !1, d, l))
        continue;
      const h = new Array();
      h.push(new ki(d, l));
      for (const p of a) {
        if (p === c)
          continue;
        const f = h.length;
        for (let g = 0; g < f; g++) {
          const C = h[g], v = p.intersectLine(C, new I());
          v !== null && (h.push(new ki(v, C.end.clone())), C.end.copy(v));
        }
      }
      for (const p of h) {
        const f = p.getCenter(i);
        r(a, f, c) && (t.addHorizontal(p.start), t.addHorizontal(p.end));
      }
    }
  }
  return t;
  function s(a) {
    return a.normal.x === 0 && a.normal.y === 0;
  }
  function o(a) {
    return a.normal.z === 0;
  }
  function r(a, c, d) {
    for (const l of a)
      if (!(d !== void 0 && l === d) && l.distanceToPoint(c) < 0)
        return !1;
    return !0;
  }
}
class e0 {
  constructor() {
    this._contextMenuPosition = void 0;
  }
  get contextMenuPositionData() {
    return this._contextMenuPosition;
  }
  set contextMenuPositionData(e) {
    this._contextMenuPosition = e, Vi.update();
  }
}
class t0 {
  constructor() {
    this._eventHandlers = [], this._stylingMap = /* @__PURE__ */ new Map();
  }
  setStylingGroup(e, t) {
    if (t === void 0) {
      this._stylingMap.delete(e), this.fireChangeEvent();
      return;
    }
    this._stylingMap.set(e, t), this.fireChangeEvent();
  }
  getStylingGroups() {
    return this._stylingMap.values();
  }
  addEventListener(e) {
    this._eventHandlers.push(e);
  }
  removeEventListener(e) {
    return lr(this._eventHandlers, e).length > 0;
  }
  fireChangeEvent() {
    this._eventHandlers.forEach((e) => {
      e();
    });
  }
}
function Nt(n) {
  return Ps(n) || Xt(n);
}
function Ps(n) {
  return typeof n == "object" && n !== null && "externalId" in n && !("space" in n);
}
function Xt(n) {
  return typeof n == "object" && n !== null && "id" in n;
}
function _t(n) {
  return typeof n == "object" && n !== null && "externalId" in n && "space" in n;
}
function UO(n, e) {
  return _t(n) && _t(e) && Jh(n, e) || Nt(n) && Nt(e) && oo(n, e);
}
function Jh(n, e) {
  return n.externalId === e.externalId && n.space === e.space;
}
function oo(n, e) {
  return Xt(n) && Xt(e) && n0(n, e) || Ps(n) && Ps(e) && i0(n, e);
}
function n0(n, e) {
  return n.id === e.id;
}
function i0(n, e) {
  return n.externalId === e.externalId;
}
function dt(n, e) {
  return `${n}/${e}`;
}
function ep(n) {
  const e = Og(n, "/");
  return [Number(e[0]), Number(e[1])];
}
function tp(n, e, t) {
  return `${n}/${e}/${t}`;
}
function X(n) {
  return `${n.space}/${n.externalId}`;
}
function dn(n, e, t) {
  return `${n}/${e}/${t}`;
}
function sn(n, e) {
  throw new Error("Unexpected object: " + n);
}
function ro(n) {
  if (_t(n))
    return X(n);
  if (Xt(n))
    return String(n.id);
  if (Ps(n))
    return n.externalId;
  sn(n);
}
function np(n) {
  const t = n.data.assetRef;
  return t !== void 0 && Nt(t) ? t : void 0;
}
function _r(n) {
  if (ip(n))
    return n.assetRef;
  {
    const t = n.data.assetRef;
    return t !== void 0 && Nt(t) ? t : void 0;
  }
}
function Tr(n) {
  const e = _r(n);
  if (e !== void 0)
    return ro(e);
}
function va(n) {
  return ip(n) ? X(n.annotationIdentifier) : n.id;
}
function ip(n) {
  var e;
  return ((e = n.annotationIdentifier) == null ? void 0 : e.externalId) !== void 0;
}
function sp(n) {
  return n.treeIndex !== void 0 && n.subtreeSize !== void 0;
}
class s0 {
  constructor() {
    this._assetIdsToAssetMappings = /* @__PURE__ */ new Map();
  }
  setAssetIdsToAssetMappingCacheItem(e, t) {
    this._assetIdsToAssetMappings.set(e, Promise.resolve(t));
  }
  async getAssetIdsToAssetMappingCacheItem(e) {
    return await this._assetIdsToAssetMappings.get(e);
  }
  async setAssetMappingsCacheItem(e, t) {
    const i = this.getAssetIdsToAssetMappingCacheItem(e);
    this.setAssetIdsToAssetMappingCacheItem(
      e,
      i.then((s) => s === void 0 ? [t] : (s.push(t), s))
    );
  }
}
class o0 {
  constructor() {
    this._nodeIdsToAssetMappings = /* @__PURE__ */ new Map();
  }
  setNodeIdsToAssetMappingCacheItem(e, t) {
    this._nodeIdsToAssetMappings.set(e, Promise.resolve(t));
  }
  async getNodeIdsToAssetMappingCacheItem(e) {
    return await this._nodeIdsToAssetMappings.get(e);
  }
  async setAssetMappingsCacheItem(e, t) {
    const i = this.getNodeIdsToAssetMappingCacheItem(e);
    this.setNodeIdsToAssetMappingCacheItem(
      e,
      i.then((s) => s === void 0 ? [t] : (s.push(t), s))
    );
  }
}
async function Sr(n, e, t, i) {
  const s = await op(n, e, [t], i);
  return (await i.revisions3D.list3DNodeAncestors(
    n,
    e,
    s[0]
  )).items;
}
async function Os(n, e) {
  const t = Q(e, 100), i = {
    items: []
  };
  for (const s of t) {
    const o = await n.inspectInstances({
      inspectionOperations: { involvedViews: { allVersions: !0 } },
      items: s.map((r) => ({
        instanceType: "node",
        externalId: r.externalId,
        space: r.space
      }))
    });
    i.items.push(...o.items);
  }
  return i;
}
async function op(n, e, t, i) {
  const s = `${i.getBaseUrl()}/api/v1/projects/${i.project}/3d/models/${n}/revisions/${e}/nodes/internalids/bytreeindices`, o = Q(t, 1e3), r = [];
  for (const a of o) {
    const c = await i.post(s, {
      data: { items: a }
    });
    if (c.status === 200)
      r.push(...c.data.items);
    else
      throw Error(
        `treeIndex-nodeId translation failed for treeIndexes ${a.join(",")}`
      );
  }
  return r;
}
async function r0(n, e, t, i) {
  const s = `${i.getBaseUrl()}/api/v1/projects/${i.project}/3d/models/${n}/revisions/${e}/nodes/treeindices/byinternalids`, o = await i.post(s, {
    data: { items: t }
  });
  if (o.status === 200)
    return o.data.items;
  throw new Error(`nodeId-treeIndex translation failed for nodeIds ${t.join(",")}`);
}
async function rp(n, e, t, i) {
  return t.length === 0 ? [] : await i.revisions3D.retrieve3DNodes(
    n,
    e,
    t.map((s) => ({ id: s }))
  );
}
class a0 {
  constructor(e) {
    this._nodeIdsToNode3D = /* @__PURE__ */ new Map(), this._sdk = e;
  }
  async splitChunkInCacheNode3D(e, t, i) {
    const s = [], o = [];
    return await Promise.all(
      e.map(async (r) => {
        const a = dn(t, i, r), c = await this.getNodeIdToNode3DCacheItem(a);
        c !== void 0 ? s.push(c) : o.push(r);
      })
    ), { chunkInCache: s, chunkNotInCache: o };
  }
  async generateNode3DCachePerItem(e, t, i) {
    (await this.getNodesForNodeIds(e, t, i ?? [])).forEach((o) => {
      const r = dn(e, t, o.id);
      this.setNodeIdToNode3DCacheItem(r, Promise.resolve(o));
    });
  }
  async getNodesForNodeIds(e, t, i) {
    const { chunkNotInCache: s, chunkInCache: o } = await this.splitChunkInCacheNode3D(
      i,
      e,
      t
    ), r = await rp(e, t, s, this._sdk);
    return o.concat(r);
  }
  async getNodeIdToNode3DCacheItem(e) {
    return await this._nodeIdsToNode3D.get(e);
  }
  setNodeIdToNode3DCacheItem(e, t) {
    this._nodeIdsToNode3D.set(e, Promise.resolve(t));
  }
}
class c0 {
  constructor(e) {
    this._modelToAssetMappings = /* @__PURE__ */ new Map(), this._sdk = e;
  }
  setModelToAssetMappingCacheItems(e, t) {
    this._modelToAssetMappings.set(e, t);
  }
  async getModelToAssetMappingCacheItems(e) {
    return await this._modelToAssetMappings.get(e);
  }
  async fetchAndCacheMappingsForModel(e, t) {
    const i = dt(e, t), s = this.fetchAssetMappingsForModel(e, t);
    return this.setModelToAssetMappingCacheItems(i, s), await s;
  }
  async fetchAssetMappingsForModel(e, t) {
    return (await this._sdk.assetMappings3D.list(e, t, { limit: 1e3 }).autoPagingToArray({ limit: 1 / 0 })).filter(sp);
  }
}
class d0 {
  constructor(e) {
    this._amountOfAssetIdsChunks = 1, this._sdk = e, this.assetIdsToAssetMappingCache = new s0(), this.nodeIdsToAssetMappingCache = new o0(), this.modelToAssetMappingsCache = new c0(this._sdk), this.nodeIdsToNode3DCache = new a0(this._sdk);
  }
  async getAssetMappingsForLowestAncestor(e, t, i) {
    var l;
    if (i.length === 0)
      return { mappings: [] };
    const s = new Set(i.map((h) => h.treeIndex)), r = (await this.getAssetMappingsForNodes(e, t, i)).filter(
      (h) => s.has(h.treeIndex)
    );
    if (r.length === 0)
      return { mappings: [] };
    const a = (l = Zc(
      r,
      (h) => h.treeIndex
    )) == null ? void 0 : l.treeIndex;
    We(a !== void 0);
    const c = r.filter(
      (h) => h.treeIndex === a
    ), d = i.find(
      (h) => h.treeIndex === a
    );
    return We(d !== void 0), { node: d, mappings: c };
  }
  async getNodesForAssetIds(e, t, i) {
    const s = new Set(i), o = Array.from(s), r = Math.round(o.length / this._amountOfAssetIdsChunks), c = Q(o, r).map(async (f) => await this.getAssetMappingsForAssetIds(e, t, f)), h = (await Promise.all(c)).flat().filter(
      (f) => s.has(f.assetId)
    );
    return (await this.nodeIdsToNode3DCache.getNodesForNodeIds(
      e,
      t,
      h.map((f) => f.nodeId)
    )).reduce((f, g, C) => {
      const v = h[C].assetId, w = f.get(v);
      return w !== void 0 ? w.push(g) : f.set(v, [g]), f;
    }, /* @__PURE__ */ new Map());
  }
  async generateNode3DCachePerItem(e, t, i) {
    await this.nodeIdsToNode3DCache.generateNode3DCachePerItem(e, t, i);
  }
  async generateAssetMappingsCachePerItemFromModelCache(e, t, i) {
    i !== void 0 && i.forEach(async (s) => {
      s.assetMappings.forEach(async (o) => {
        const r = dn(e, t, o.assetId);
        await this.assetIdsToAssetMappingCache.setAssetMappingsCacheItem(r, o);
      });
    });
  }
  async getAssetMappingsForModel(e, t) {
    const i = dt(e, t), s = await this.modelToAssetMappingsCache.getModelToAssetMappingCacheItems(i);
    return s !== void 0 ? s : await this.modelToAssetMappingsCache.fetchAndCacheMappingsForModel(e, t);
  }
  async splitChunkInCacheAssetMappings(e, t, i, s) {
    const o = [], r = [];
    return await Promise.all(
      e.map(async (a) => {
        const c = dn(t, i, a), d = await this.getItemCacheResult(s, c);
        d !== void 0 ? o.push(...d) : r.push(a);
      })
    ), { chunkInCache: o, chunkNotInCache: r };
  }
  async getItemCacheResult(e, t) {
    return e === "nodeIds" ? await this.nodeIdsToAssetMappingCache.getNodeIdsToAssetMappingCacheItem(t) : await this.assetIdsToAssetMappingCache.getAssetIdsToAssetMappingCacheItem(t);
  }
  setItemCacheResult(e, t, i) {
    const s = Promise.resolve(i ?? []);
    e === "nodeIds" ? this.nodeIdsToAssetMappingCache.setNodeIdsToAssetMappingCacheItem(t, s) : this.assetIdsToAssetMappingCache.setAssetIdsToAssetMappingCacheItem(t, s);
  }
  async fetchAssetMappingsRequest(e, t, i, s) {
    if (e.length === 0)
      return [];
    const o = t === "nodeIds" ? { nodeIds: e } : { assetIds: e }, r = (await this._sdk.assetMappings3D.filter(i, s, {
      limit: 1e3,
      filter: o
    }).autoPagingToArray({ limit: 1 / 0 })).filter(sp);
    return await Promise.all(
      r.map(async (a) => {
        const c = dn(
          i,
          s,
          a.assetId
        ), d = dn(i, s, a.nodeId);
        await this.assetIdsToAssetMappingCache.setAssetMappingsCacheItem(c, a), await this.nodeIdsToAssetMappingCache.setAssetMappingsCacheItem(d, a);
      })
    ), e.forEach(async (a) => {
      const c = dn(i, s, a);
      await this.getItemCacheResult(t, c) === void 0 && this.setItemCacheResult(t, c, []);
    }), r;
  }
  async fetchMappingsInQueue(e, t, i, s, o, r) {
    const a = await this.fetchAssetMappingsRequest(
      t[e],
      i,
      s,
      o
    );
    if (r = r.concat(a), e >= t.length - 1)
      return r;
    const c = e + 1;
    return await this.fetchMappingsInQueue(
      c,
      t,
      i,
      s,
      o,
      r
    );
  }
  async fetchAndCacheMappingsForIds(e, t, i, s) {
    if (i.length === 0)
      return [];
    const o = Q(i, 1e3);
    return await this.fetchMappingsInQueue(
      0,
      o,
      s,
      e,
      t,
      []
    );
  }
  async getAssetMappingsForNodes(e, t, i) {
    const s = i.map((l) => l.id), { chunkNotInCache: o, chunkInCache: r } = await this.splitChunkInCacheAssetMappings(
      s,
      e,
      t,
      "nodeIds"
    ), a = o, c = await this.fetchAndCacheMappingsForIds(
      e,
      t,
      a,
      "nodeIds"
    );
    return r.concat(c);
  }
  async getAssetMappingsForAssetIds(e, t, i) {
    const { chunkNotInCache: s, chunkInCache: o } = await this.splitChunkInCacheAssetMappings(
      i,
      e,
      t,
      "assetIds"
    ), r = s, a = await this.fetchAndCacheMappingsForIds(
      e,
      t,
      r,
      "assetIds"
    );
    return o.concat(a);
  }
}
const Ca = {
  connections: [],
  ancestorsWithSameMapping: [],
  firstMappedAncestorTreeIndex: -1
};
class l0 {
  constructor(e, t, i, s, o) {
    this._treeIndexToFdmConnections = /* @__PURE__ */ new Map(), this._cogniteClient = e, this._fdmClient = t, this._fdm3dDataProvider = i, this._modelId = s, this._revisionId = o, this._modelInstances = i.getDMSModels(this._modelId).catch(() => {
    });
  }
  getClosestParentFdmData(e) {
    const t = this._treeIndexToFdmConnections.get(e);
    if (t === void 0)
      return this.findAndCacheNodeDataFromAncestors(e);
    if (t.length === 0)
      return {
        cadAndFdmNodesPromise: Promise.resolve(void 0),
        viewsPromise: Promise.resolve(void 0)
      };
    const i = Promise.resolve({
      cadNode: t[0].cadNode,
      fdmIds: t.map((o) => o.connection.instance)
    }), s = this.assertOrFetchViewsForNodeData(e, t);
    return { cadAndFdmNodesPromise: i, viewsPromise: s };
  }
  async assertOrFetchViewsForNodeData(e, t) {
    if (Ia(t))
      return t.map((o) => o.views);
    const i = t[0].cadNode, s = {
      cadNode: i,
      connections: t.map((o) => o.connection)
    };
    return await this.getAndCacheViewsPromiseForNodeData(s, [
      i.treeIndex,
      e
    ]);
  }
  findAndCacheNodeDataFromAncestors(e) {
    const t = this.getClosestParentMapping(e), i = this.getCadAndConnectionsPromiseForAncestorData(t), s = i.then(
      (r) => r === void 0 ? void 0 : {
        cadNode: r.cadNode,
        fdmIds: r.connections.map((a) => a.instance)
      }
    ), o = this.getViewsPromiseFromDataPromises(
      i,
      t
    );
    return { cadAndFdmNodesPromise: s, viewsPromise: o };
  }
  async getViewsPromiseFromDataPromises(e, t) {
    const i = await e, { ancestorsWithSameMapping: s } = await t, o = s.map((c) => c.treeIndex), r = o.filter((c) => this._treeIndexToFdmConnections.has(c)).sort((c, d) => d - c), a = r.length !== 0 ? this._treeIndexToFdmConnections.get(r[0]) : void 0;
    return Ia(a) ? (this.setCacheDataForTreeIndices(o, a), a.map((c) => c.views)) : await this.getAndCacheViewsPromiseForNodeData(i, o);
  }
  async getCadAndConnectionsPromiseForAncestorData(e) {
    const { connections: t, ancestorsWithSameMapping: i, firstMappedAncestorTreeIndex: s } = await e;
    if (t.length === 0) {
      this.setCacheDataForTreeIndices(
        i.map((r) => r.treeIndex),
        []
      );
      return;
    }
    const o = i.find(
      (r) => r.treeIndex === s
    );
    return We(o !== void 0), { cadNode: o, connections: t };
  }
  setCacheDataForTreeIndices(e, t) {
    e.forEach((i) => {
      this._treeIndexToFdmConnections.set(i, t);
    });
  }
  async getAndCacheViewsPromiseForNodeData(e, t) {
    if (e === void 0) {
      this.setCacheDataForTreeIndices(t, []);
      return;
    }
    const s = (await Os(
      this._fdmClient,
      e.connections.map((r) => r.instance)
    )).items.map((r) => r.inspectionResults.involvedViews), o = e.connections.map((r, a) => ({
      connection: r,
      cadNode: e.cadNode,
      view: s[a]
    }));
    return this.setCacheDataForTreeIndices(t, o), s;
  }
  async getClosestParentMapping(e) {
    const t = await Sr(
      this._modelId,
      this._revisionId,
      e,
      this._cogniteClient
    ), i = await this.getMappingConnectionsForAncestors(t);
    if (i.length === 0)
      return Ca;
    const s = this.combineConnectionsWithTreeIndex(
      i,
      t
    ), o = u0(
      s
    );
    return o === void 0 ? Ca : h0(
      o,
      s,
      t
    );
  }
  combineConnectionsWithTreeIndex(e, t) {
    return e.reduce((i, s) => {
      const o = t.find((r) => r.treeIndex === s.treeIndex);
      return o !== void 0 && i.push({
        connection: s,
        treeIndex: o.treeIndex
      }), i;
    }, new Array());
  }
  async getMappingConnectionsForAncestors(e) {
    const t = e.filter((o) => this._treeIndexToFdmConnections.has(o.treeIndex)).sort((o, r) => r.treeIndex - o.treeIndex)[0];
    if (t !== void 0) {
      const o = this._treeIndexToFdmConnections.get(
        t.treeIndex
      );
      return We(o !== void 0), o.map((r) => r.connection);
    }
    const i = await this._modelInstances;
    return i === void 0 || i.length === 0 ? [] : await this._fdm3dDataProvider.getFdmConnectionsForNodes(
      i,
      this._revisionId,
      e
    );
  }
  async fetchViewsForAllConnections() {
    const e = this.getAllConnections().filter(
      (i) => i.views === void 0 || i.views.length === 0
    );
    if (e.length === 0)
      return;
    const t = await Os(
      this._fdmClient,
      e.map((i) => i.connection.instance)
    );
    e.forEach((i, s) => {
      const o = {
        ...i,
        views: [t.items[s].inspectionResults.involvedViews[0]]
      };
      this.insertTreeIndexMappings(o.cadNode.treeIndex, o);
    });
  }
  insertTreeIndexMappings(e, t) {
    const i = this._treeIndexToFdmConnections.get(e);
    if (i === void 0)
      this._treeIndexToFdmConnections.set(e, [t]);
    else {
      const s = i == null ? void 0 : i.find(
        (o) => o.cadNode.id === t.cadNode.id
      );
      if (s !== void 0) {
        s.views = t.views;
        return;
      }
      i.push(t);
    }
  }
  getAllConnections() {
    return [...this._treeIndexToFdmConnections.values()].flat();
  }
}
function u0(n) {
  return Rg(n.map((e) => e.treeIndex));
}
function h0(n, e, t) {
  const i = e.filter(
    (o) => o.treeIndex === n
  ), s = t.filter((o) => o.treeIndex >= n);
  return {
    connections: i.map((o) => o.connection),
    ancestorsWithSameMapping: s,
    firstMappedAncestorTreeIndex: n
  };
}
function Ia(n) {
  return n === void 0 ? !1 : n == null ? void 0 : n.every(
    (e) => e.views !== void 0 && e.views.length > 0
  );
}
class p0 {
  constructor(e, t, i) {
    this._revisionNodeCaches = /* @__PURE__ */ new Map(), this._completeRevisions = /* @__PURE__ */ new Set(), this._cdfClient = e, this._fdmClient = t, this._fdm3dDataProvider = i;
  }
  async getMappingsForFdmInstances(e, t) {
    const [i, s] = Kt(
      t,
      (c) => {
        const d = dt(c.modelId, c.revisionId);
        return this._completeRevisions.has(d);
      }
    ), o = await this.getNonCachedModelMappings(
      e,
      s
    );
    return [...this.getCachedModelMappings(i, e), ...o];
  }
  getCachedModelMappings(e, t) {
    const i = new Set(t.map(X));
    return e.map((s) => this.getCachedModelMappingForRevision(s, i));
  }
  getCachedModelMappingForRevision(e, t) {
    const i = this.getOrCreateRevisionCache(
      e.modelId,
      e.revisionId
    ), s = wa(
      i.getAllConnections(),
      t
    ), o = xa(
      s.map((r) => [
        r.connection.instance.externalId,
        r.cadNode
      ])
    );
    return {
      ...e,
      mappings: o
    };
  }
  async getNonCachedModelMappings(e, t) {
    if (t.length === 0 || e.length === 0)
      return [];
    const i = new Set(e.map(X)), s = await this.getAndCacheRevisionToConnectionsMap(
      t,
      !1
    );
    return t.map(({ modelId: o, revisionId: r }) => {
      const a = dt(o, r), c = s.get(a);
      return this.getRelevantExternalIdToNodeMapForRevision(
        { modelId: o, revisionId: r },
        c,
        i
      );
    });
  }
  getRelevantExternalIdToNodeMapForRevision({ modelId: e, revisionId: t }, i, s) {
    if (i === void 0 || i.length === 0)
      return { modelId: e, revisionId: t, mappings: /* @__PURE__ */ new Map() };
    const o = wa(i, s), r = xa(
      o.map((a) => [
        a.connection.instance.externalId,
        a.cadNode
      ])
    );
    return {
      modelId: e,
      revisionId: t,
      mappings: r
    };
  }
  async getAllMappingExternalIds(e, t = !1) {
    const [i, s] = Kt(e, (a) => {
      const c = dt(a.modelId, a.revisionId);
      return this._completeRevisions.has(c);
    });
    t && await this.fetchAllViewsForCachedRevisions(i);
    const o = i.map(
      (a) => this.getCachedConnectionsForRevision(a)
    ), r = await this.getAndCacheRevisionToConnectionsMap(
      s,
      t
    );
    return o.forEach(([a, c]) => {
      r.set(a, c);
    }), r;
  }
  async fetchAllViewsForCachedRevisions(e) {
    for (const t of e)
      await this.getOrCreateRevisionCache(t.modelId, t.revisionId).fetchViewsForAllConnections();
  }
  getCachedConnectionsForRevision(e) {
    const t = this.getOrCreateRevisionCache(e.modelId, e.revisionId), i = dt(e.modelId, e.revisionId), s = t.getAllConnections();
    return [i, s];
  }
  writeRevisionDataToCache(e) {
    for (const [t, i] of e.entries()) {
      const [s, o] = ep(t), r = this.getOrCreateRevisionCache(s, o);
      i.forEach((a) => {
        r.insertTreeIndexMappings(
          a.cadNode.treeIndex,
          a
        );
      }), this._completeRevisions.add(t);
    }
  }
  async getAndCacheRevisionToConnectionsMap(e, t) {
    const i = await this._fdm3dDataProvider.getCadConnectionsForRevisions(e), s = t ? await this.getViewsForConnections(i) : i.map((r) => ({ connection: r })), o = await f0(
      s,
      e,
      this._cdfClient
    );
    return this.writeRevisionDataToCache(o), o;
  }
  getClosestParentDataPromises(e, t, i) {
    return this.getOrCreateRevisionCache(e, t).getClosestParentFdmData(i);
  }
  async getViewsForConnections(e) {
    const t = await Os(
      this._fdmClient,
      e.map((s) => s.instance)
    );
    return e.map((s, o) => ({
      connection: s,
      views: t.items[o].inspectionResults.involvedViews
    }));
  }
  getOrCreateRevisionCache(e, t) {
    const i = dt(e, t), s = this._revisionNodeCaches.get(i);
    if (s !== void 0)
      return s;
    const o = new l0(
      this._cdfClient,
      this._fdmClient,
      this._fdm3dDataProvider,
      e,
      t
    );
    return this._revisionNodeCaches.set(i, o), o;
  }
}
async function f0(n, e, t) {
  const i = v0(n), s = await y0(
    i,
    e,
    t
  );
  return n.reduce((o, r) => {
    const a = r.connection.revisionId, c = e.find((l) => l.revisionId === a);
    if (c === void 0) return o;
    const d = g0(
      c,
      s,
      r.connection,
      r.views
    );
    return m0(d, o, c), o;
  }, /* @__PURE__ */ new Map());
}
function g0(n, e, t, i) {
  const s = tp(
    n.modelId,
    n.revisionId,
    t.treeIndex
  ), o = e.get(s);
  return We(o !== void 0), { connection: t, cadNode: o, views: i };
}
function m0(n, e, t) {
  const i = dt(
    t.modelId,
    t.revisionId
  ), s = e.get(i);
  s === void 0 ? e.set(i, [n]) : s.push(n);
}
async function y0(n, e, t) {
  const i = /* @__PURE__ */ new Map(), s = [...n.entries()].map(
    async ([o, r]) => {
      var l;
      const a = (l = e.find((h) => h.revisionId === o)) == null ? void 0 : l.modelId;
      We(a !== void 0);
      const c = await op(a, o, r, t);
      (await rp(a, o, c, t)).forEach((h) => {
        const p = tp(a, o, h.treeIndex);
        i.set(p, h);
      });
    }
  );
  return await Promise.all(s), i;
}
function v0(n) {
  return n.reduce((e, t) => {
    const { treeIndex: i, revisionId: s } = t.connection, o = e.get(s);
    return o !== void 0 ? o.push(i) : e.set(s, [i]), e;
  }, /* @__PURE__ */ new Map());
}
function wa(n, e) {
  return n.filter((t) => {
    const i = X(t.connection.instance);
    return e.has(i);
  });
}
function xa(n) {
  return n.reduce((e, [t, i]) => {
    const s = e.get(t);
    return s === void 0 ? e.set(t, [i]) : s.push(i), e;
  }, /* @__PURE__ */ new Map());
}
function F(n) {
  return n !== void 0;
}
const ge = "cdf_cdm", pt = "cdf_cdm_3d", Rs = {
  externalId: "CogniteDescribable",
  space: ge,
  version: "v1",
  type: "view"
}, xi = {
  externalId: "Cognite3DObject",
  space: ge,
  version: "v1",
  type: "view"
}, _a = {
  externalId: "Cognite3DModel",
  space: ge,
  version: "v1",
  type: "view"
}, br = {
  externalId: "Cognite3DRevision",
  space: ge,
  version: "v1",
  type: "view"
}, C0 = {
  externalId: "CogniteCADRevision",
  space: ge,
  version: "v1",
  type: "view"
}, pe = {
  externalId: "CogniteCADNode",
  space: ge,
  version: "v1",
  type: "view"
}, xe = {
  externalId: "CogniteAsset",
  space: ge,
  version: "v1",
  type: "view"
}, st = {
  externalId: "CogniteVisualizable",
  space: ge,
  version: "v1",
  type: "view"
}, Ke = {
  externalId: "CognitePointCloudVolume",
  space: ge,
  version: "v1",
  type: "view"
}, qt = {
  externalId: "Cognite360Image",
  space: ge,
  version: "v1",
  type: "view"
}, Ds = {
  externalId: "Cognite360ImageAnnotation",
  space: ge,
  version: "v1",
  type: "view"
}, I0 = `${st.externalId}/${st.version}`, ap = `${xe.externalId}/${xe.version}`, Ji = `${pe.externalId}/${pe.version}`, w0 = `${Ke.externalId}/${Ke.version}`;
`${qt.externalId}${qt.version}`;
`${Ds.externalId}${Ds.version}`;
async function x0(n, e) {
  const i = n.map((c) => {
    const d = np(c);
    if (d !== void 0)
      return {
        annotationId: c.id,
        assetId: d
      };
  }).filter(F), o = Ue(
    i,
    (c) => c.assetId
  ).map((c) => c.assetId), r = await cp(o, e), a = /* @__PURE__ */ new Map();
  return r.forEach((c) => {
    i.forEach((d) => {
      oo(d.assetId, c) && a.set(d.annotationId, c);
    });
  }), a;
}
async function _0(n, e) {
  const [t, i] = Kt(n, Nt);
  return [].concat(await cp(t, e)).concat(await T0(i, e));
}
async function T0(n, e) {
  return n.length === 0 ? [] : (await new Xi(e).getByExternalIds(
    n.map((s) => ({ ...s, instanceType: "node" })),
    [xe]
  )).items.map((s) => ({
    ...s,
    properties: s.properties[ge][ap]
  }));
}
async function cp(n, e) {
  const t = Dg(n, oo);
  return (await Promise.all(
    Q(t, 1e3).map(async (s) => await e.assets.retrieve(s, { ignoreUnknownIds: !0 }))
  )).flat();
}
class S0 {
  constructor(e) {
    this._modelToAnnotationAssetMappings = /* @__PURE__ */ new Map(), this._modelToAnnotationMappings = /* @__PURE__ */ new Map(), this._sdk = e;
  }
  async getPointCloudAnnotationAssetsForModel(e, t) {
    const i = dt(e, t), s = this._modelToAnnotationAssetMappings.get(i);
    if (s !== void 0)
      return await s;
    const o = this.fetchAndCacheAssetMappingsForModel(e);
    return this._modelToAnnotationAssetMappings.set(i, o), await o;
  }
  async getPointCloudAnnotationsForModel(e, t) {
    const i = dt(e, t), s = this._modelToAnnotationMappings.get(i);
    if (s !== void 0)
      return s;
    const o = await this.fetchAnnotationForModel(e);
    return this._modelToAnnotationMappings.set(i, o), o;
  }
  async fetchAndCacheAssetMappingsForModel(e) {
    const t = await this.fetchAnnotationForModel(e);
    return await x0(t, this._sdk);
  }
  async fetchAnnotationForModel(e) {
    const t = {
      annotatedResourceIds: [{ id: e }],
      annotatedResourceType: "threedmodel",
      annotationType: "pointcloud.BoundingVolume"
    }, i = await this._sdk.annotations.list({
      filter: t,
      limit: 1e3
    }).autoPagingToArray({ limit: 1 / 0 });
    return We(
      i.every(
        (o) => o.annotationType === "pointcloud.BoundingVolume"
      )
    ), i.filter((o) => np(o) !== void 0);
  }
  async matchPointCloudAnnotationsForModel(e, t, i) {
    const s = await this.getPointCloudAnnotationAssetsForModel(
      e,
      t
    ), o = typeof i == "number" ? i : void 0, r = Array.from(s.entries()).filter(
      ([, a]) => a.id === o
    );
    return r.length > 0 ? new Map(r) : void 0;
  }
}
function b0(n) {
  return A0(n) ? X(n) : String(n.id);
}
function A0(n) {
  return n.externalId !== void 0 && n.space !== void 0;
}
class E0 {
  constructor(e, t) {
    this._annotationToAssetMappings = /* @__PURE__ */ new Map(), this._sdk = e, this._viewer = t;
  }
  async getReveal360Annotations(e) {
    const t = e.sort().join(), i = this._annotationToAssetMappings.get(t);
    if (i !== void 0)
      return i;
    const s = await this.getReveal360AnnotationInfo();
    return s.length === 0 ? [] : (this._annotationToAssetMappings.set(t, s), s);
  }
  async getReveal360AnnotationInfo() {
    if (this._viewer === void 0)
      return [];
    const e = this._viewer.get360ImageCollections(), i = (await Promise.all(
      e.map(async (d) => await d.getAnnotationsInfo("all"))
    )).flat(), s = new Array();
    i.forEach((d) => {
      const l = _r(d.annotationInfo);
      l !== void 0 && s.push(l);
    });
    const o = Ue(s, ro), r = await _0(o, this._sdk), a = new Map(r.map((d) => [b0(d), d]));
    return await this.getAssetWithAnnotationsMapped(i, a);
  }
  async getAssetWithAnnotationsMapped(e, t) {
    const i = e.filter((o) => {
      const r = Tr(o.annotationInfo);
      return r !== void 0 && t.has(r);
    }).map(async (o) => await M0(o, t));
    return (await Promise.all(i)).filter(
      F
    );
  }
}
async function M0(n, e) {
  const t = Tr(n.annotationInfo);
  if (t === void 0)
    return;
  const i = e.get(t);
  if (i === void 0)
    return;
  const s = await n.imageRevision.getAnnotations(), o = va(n.annotationInfo), r = s.find((c) => va(c.annotation) === o);
  if (r === void 0)
    return;
  const a = P0(
    n,
    r
  );
  return {
    asset: i,
    assetAnnotationImage360Info: n,
    position: a
  };
}
function P0(n, e) {
  const t = n.imageEntity.transform;
  return e.getCenter().applyMatrix4(t);
}
function Zt(n) {
  return Ar(n) || Kn(n);
}
function Ar(n) {
  const e = n;
  return e.externalId !== void 0 && e.space !== void 0 && (e.source === "cdm" || e.source === "dm");
}
function Kn(n) {
  return n.siteId !== void 0;
}
function Ee(n) {
  const e = n;
  return e.modelId !== void 0 && e.revisionId !== void 0 && e.modelId !== 0 && e.revisionId !== 0;
}
function Tt(n) {
  const e = n;
  return e.revisionExternalId !== void 0 && e.revisionSpace !== void 0;
}
function Bt(n) {
  return { externalId: n.externalId, space: n.space };
}
async function dp(n, e) {
  const t = `cog_3d_model_${n}`, i = {
    select: {
      models: {
        sources: [
          {
            source: _a,
            properties: ["name", "description", "tags", "aliases", "type", "thumbnail"]
          }
        ]
      }
    },
    with: {
      models: {
        nodes: {
          filter: {
            and: [
              {
                equals: { property: ["node", "externalId"], value: t }
              },
              { hasData: [_a] }
            ]
          }
        }
      }
    }
  };
  return (await e.queryNodesAndEdges(i)).items.models.map(Bt);
}
async function O0(n, e) {
  const t = {
    ...R0,
    parameters: { instanceExternalId: n.externalId, instanceSpace: n.space }
  };
  return (await e.queryNodesAndEdges(t)).items.objects_connected_with_3d;
}
const R0 = {
  with: {
    start_instance: {
      nodes: {
        filter: {
          and: [
            {
              equals: {
                property: ["node", "externalId"],
                value: { parameter: "instanceExternalId" }
              }
            },
            {
              equals: {
                property: ["node", "space"],
                value: { parameter: "instanceSpace" }
              }
            }
          ]
        }
      },
      limit: 1
    },
    start_to_object_edges: {
      edges: {
        from: "start_instance",
        maxDistance: 1,
        direction: "outwards"
      },
      limit: 1e3
    },
    objects_connected_with_3d: {
      nodes: {
        from: "start_to_object_edges",
        chainTo: "destination",
        filter: {
          exists: {
            property: [
              st.space,
              st.externalId,
              "object3D"
            ]
          }
        }
      }
    },
    object_3ds: {
      nodes: {
        from: "objects_connected_with_3d",
        through: { view: st, identifier: "object3D" }
      },
      limit: 1e3
    }
  },
  select: {
    start_instance: {},
    start_to_object_edges: {},
    objects_connected_with_3d: {},
    object_3ds: {}
  }
};
function ao(n) {
  return Number(n.slice(13));
}
function lp(n) {
  return Number(n.slice(16));
}
const up = [
  {
    source: Rs,
    properties: ["name", "description", "tags", "aliases"]
  }
], Er = [
  {
    source: pe,
    properties: [
      ...up[0].properties,
      "object3D",
      "model3D",
      "cadNodeReference",
      "revisions",
      "treeIndexes",
      "subTreeSizes"
    ]
  }
];
async function D0(n, e, t, i, s) {
  const o = i.map((g) => g.treeIndex), r = new Set(o), a = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Map(), d = {
    ...k0,
    parameters: {
      modelReference: Bt(n),
      treeIndexes: o,
      revisionRefs: [Bt(e)]
    }
  }, l = ao(n.externalId), h = await s.queryNodesAndEdges(d);
  h.items.cad_nodes.forEach((g) => {
    const C = g.properties[ge][Ji], v = C.revisions.findIndex(
      (T) => T.externalId === e.externalId && T.space === e.space
    ), w = C.treeIndexes[v];
    r.has(w) && (a.set(X(g), X(C.object3D)), c.set(w, X(g)));
  });
  const p = new Map(
    h.items.assets.map((g) => [
      X(g.properties[ge][I0].object3D),
      g
    ])
  ), f = new Array();
  return [...c.entries()].forEach(([g, C]) => {
    const v = a.get(C);
    if (v === void 0)
      return;
    const w = p.get(v);
    w !== void 0 && f.push({ modelId: l, revisionId: t, treeIndex: g, instance: w });
  }), f;
}
const k0 = {
  with: {
    cad_nodes: {
      nodes: {
        filter: {
          and: [
            {
              equals: {
                property: [
                  pt,
                  pe.externalId,
                  "model3D"
                ],
                value: { parameter: "modelReference" }
              }
            },
            {
              containsAny: {
                property: [
                  pt,
                  pe.externalId,
                  "treeIndexes"
                ],
                values: { parameter: "treeIndexes" }
              }
            },
            {
              containsAny: {
                property: [
                  pt,
                  pe.externalId,
                  "revisions"
                ],
                values: { parameter: "revisionRefs" }
              }
            }
          ]
        }
      }
    },
    objects_3d: {
      nodes: {
        from: "cad_nodes",
        through: { view: pe, identifier: "object3D" },
        direction: "outwards"
      }
    },
    assets: {
      nodes: {
        from: "objects_3d",
        through: { view: xe, identifier: "object3D" },
        direction: "inwards"
      }
    }
  },
  select: {
    cad_nodes: {
      sources: Er
    },
    assets: { sources: [{ source: st, properties: ["object3D"] }] },
    objects_3d: {}
  }
}, L0 = [
  {
    source: C0,
    properties: ["status", "published", "type", "model3D", "revisionId"]
  }
], N0 = {
  with: {
    revision: {
      nodes: {
        filter: {
          and: [
            {
              equals: {
                property: [
                  pt,
                  br.externalId,
                  "model3D"
                ],
                value: { parameter: "modelReference" }
              }
            },
            {
              equals: {
                property: ["node", "externalId"],
                value: { parameter: "revisionExternalId" }
              }
            }
          ]
        }
      },
      limit: 1
    }
  },
  select: {
    revision: {
      sources: L0
    }
  }
};
async function hp(n, e, t) {
  const i = `cog_3d_revision_${e}`, s = {
    ...N0,
    parameters: { modelReference: Bt(n), revisionExternalId: i }
  }, o = await t.queryNodesAndEdges(s);
  if (o.items.revision.length === 0)
    throw new Error(
      `No revision found for ID ${e} on model ${n.space}, ${n.externalId}`
    );
  return o.items.revision[0];
}
const co = [
  {
    source: xe,
    properties: [
      ...up[0].properties,
      "object3D",
      "sourceId",
      "sourceContext",
      "source",
      "sourceCreatedTime",
      "sourceUpdatedTime",
      "sourceCreatedUser",
      "sourceUpdatedUser",
      "parent",
      "root",
      "path",
      "pathLastUpdatedTime",
      "equipment",
      "assetClass",
      "type",
      "files",
      "children",
      "activities",
      "timeSeries"
    ]
  }
], B0 = {
  containsAny: {
    property: [pt, pe.externalId, "revisions"],
    values: { parameter: "revisionRefs" }
  }
}, F0 = {
  containsAny: {
    property: [
      pt,
      Ke.externalId,
      "revisions"
    ],
    values: { parameter: "revisionRefs" }
  }
};
function V0(n) {
  return {
    and: [
      { instanceReferences: n },
      {
        hasData: [br]
      },
      {
        equals: {
          property: ["cdf_cdm_3d", "Cognite3DRevision", "type"],
          value: "Image360"
        }
      }
    ]
  };
}
function j0(n, e, t) {
  return {
    with: {
      cad_nodes: {
        nodes: {
          filter: B0
        },
        limit: t
      },
      cad_object_3d: {
        nodes: {
          from: "cad_nodes",
          through: { view: pe, identifier: "object3D" },
          direction: "outwards"
        },
        limit: t
      },
      cad_assets: {
        nodes: {
          from: "cad_object_3d",
          through: { view: xe, identifier: "object3D" },
          direction: "inwards",
          filter: e
        },
        limit: t
      }
    },
    select: {
      cad_nodes: {
        sources: [
          {
            source: pe,
            properties: ["*"]
          }
        ]
      },
      cad_assets: {
        sources: [
          ...co,
          ...n.map((i) => ({ source: i, properties: ["*"] }))
        ]
      }
    }
  };
}
function z0(n, e, t) {
  return {
    with: {
      pointcloud_volumes: {
        nodes: {
          filter: F0
        },
        limit: t
      },
      pointcloud_object_3d: {
        nodes: {
          from: "pointcloud_volumes",
          through: { view: Ke, identifier: "object3D" },
          direction: "outwards"
        },
        limit: t
      },
      pointcloud_assets: {
        nodes: {
          from: "pointcloud_object_3d",
          through: { view: xe, identifier: "object3D" },
          filter: e
        },
        limit: t
      }
    },
    select: {
      pointcloud_assets: {
        sources: [
          ...co,
          ...n.map((i) => ({ source: i, properties: ["*"] }))
        ]
      }
    }
  };
}
function U0(n, e, t, i) {
  return {
    with: {
      image360_collections: {
        nodes: {
          filter: V0(e)
        },
        limit: i
      },
      image360_revisions: {
        nodes: {
          from: "image360_collections",
          through: { view: qt, identifier: "collection360" },
          direction: "inwards"
        },
        limit: i
      },
      image360_annotations: {
        edges: {
          from: "image360_revisions",
          direction: "inwards",
          filter: { hasData: [Ds] }
        },
        limit: i
      },
      image360_object3ds: {
        nodes: {
          from: "image360_annotations",
          chainTo: "destination",
          filter: { hasData: [xi] }
        },
        limit: i
      },
      image360_assets: {
        nodes: {
          from: "image360_object3ds",
          through: { view: xe, identifier: "object3D" },
          direction: "inwards",
          filter: t
        },
        limit: i
      }
    },
    select: {
      image360_assets: {
        sources: [
          ...co,
          ...n.map((s) => ({ source: s, properties: ["*"] }))
        ]
      }
    }
  };
}
async function G0(n, e, t, i) {
  if (n.length === 0)
    return [];
  const s = 1e3, o = Ni(t), r = await pp(e, n, o, i, s), a = await fp(
    e,
    n,
    o,
    i,
    s
  ), c = await gp(
    e,
    n,
    o,
    i,
    s
  );
  return r.concat(a).concat(c);
}
async function H0(n, e, t, i, s) {
  if (n.length === 0)
    return [];
  const o = Ni(t), r = await pp(e, n, o, s, i), a = await fp(
    e,
    n,
    o,
    s,
    i
  ), c = await gp(
    e,
    n,
    o,
    s,
    i
  );
  return r.concat(a).concat(c);
}
async function pp(n, e, t, i, s) {
  const r = {
    ...j0(n, t, s),
    parameters: { revisionRefs: e }
  }, a = await i.queryAllNodesAndEdges(r, ["cad_nodes"]);
  return q0(
    n,
    a.items.cad_assets,
    a.items.cad_nodes
  );
}
async function fp(n, e, t, i, s) {
  const r = {
    ...z0(n, t, s),
    parameters: { revisionRefs: e }
  };
  return (await i.queryAllNodesAndEdges(r, ["pointcloud_volumes"])).items.pointcloud_assets;
}
async function gp(n, e, t, i, s) {
  const r = {
    ...U0(n, e, t, s),
    parameters: { revisionRefs: e }
  };
  return (await i.queryAllNodesAndEdges(r, ["image360_collections"])).items.image360_assets;
}
function q0(n, e, t) {
  const i = [];
  return t.forEach((s) => {
    const o = s.properties[pe.space][`${pe.externalId}/${pe.version}`], r = o == null ? void 0 : o.object3D;
    e.forEach((a) => {
      n.forEach((c) => {
        const d = a.properties[c.space][`${c.externalId}/${c.version}`], l = _t(d == null ? void 0 : d.object3D) ? d == null ? void 0 : d.object3D : void 0;
        l !== void 0 && r.externalId === l.externalId && r.space === l.space && i.push(a);
      });
    });
  }), Ue(i, (s) => `${s.space}-${s.externalId}`);
}
async function St(n, e) {
  const t = new Array(n.length).fill(void 0);
  let i = 0;
  const s = n.map(
    (a, c) => async () => await a().then((d) => t[c] = d)
  );
  async function o() {
    if (i >= t.length)
      return;
    const a = i;
    i++, await s[a](), await o();
  }
  const r = new Array(e).fill(0).map(async () => {
    await o();
  });
  return await Promise.all(r), t;
}
const $0 = {
  hasData: [Ke]
};
function W0(n) {
  return {
    containsAny: {
      property: [
        pt,
        Ke.externalId,
        "revisions"
      ],
      values: n
    }
  };
}
function K0(n) {
  return {
    instanceReferences: n
  };
}
const Ta = [
  {
    source: qt,
    properties: ["collection360"]
  }
], Sa = [
  {
    source: Ke,
    properties: ["object3D"]
  }
], ba = [
  {
    source: pe,
    properties: ["object3D"]
  }
];
function Aa(n) {
  return {
    nodes: {
      from: n,
      through: { view: pe, identifier: "object3D" },
      filter: {
        containsAny: {
          property: [pt, pe.externalId, "revisions"],
          values: { parameter: "revisionRefs" }
        }
      }
    }
  };
}
function Ea(n) {
  return {
    nodes: {
      from: n,
      through: { view: Ke, identifier: "object3D" },
      filter: {
        containsAny: {
          property: [
            pt,
            Ke.externalId,
            "revisions"
          ],
          values: { parameter: "revisionRefs" }
        }
      }
    }
  };
}
function Ma(n) {
  return {
    edges: {
      from: n,
      direction: "outwards",
      filter: { hasData: [Ds] }
    }
  };
}
function Pa(n, e) {
  return {
    nodes: {
      from: n,
      chainTo: "destination",
      filter: {
        and: [
          {
            hasData: [qt]
          },
          {
            in: {
              property: [
                qt.space,
                `${qt.externalId}/${qt.version}`,
                "collection360"
              ],
              values: e
            }
          }
        ]
      }
    }
  };
}
function Oa(n) {
  return {
    nodes: {
      from: n,
      through: { view: st, identifier: "object3D" },
      direction: "outwards"
    }
  };
}
function Y0(n, e) {
  return {
    with: {
      initial_nodes: {
        nodes: {
          filter: {
            and: [
              K0(n),
              {
                hasData: [st]
              }
            ]
          }
        }
      },
      initial_nodes_object_3ds: Oa("initial_nodes"),
      initial_nodes_cad_nodes: Aa("initial_nodes_object_3ds"),
      initial_nodes_point_cloud_volumes: Ea("initial_nodes_object_3ds"),
      initial_edges_360_image_annotations: Ma(
        "initial_nodes_object_3ds"
      ),
      initial_nodes_360_images: Pa(
        "initial_edges_360_image_annotations",
        e
      ),
      indirectly_referenced_edges: {
        edges: {
          from: "initial_nodes",
          direction: "outwards",
          nodeFilter: {
            hasData: [st]
          }
        }
      },
      indirectly_referenced_nodes: {
        nodes: {
          from: "indirectly_referenced_edges"
        }
      },
      indirect_nodes_object_3ds: Oa("indirectly_referenced_nodes"),
      indirect_nodes_cad_nodes: Aa("indirect_nodes_object_3ds"),
      indirect_nodes_point_cloud_volumes: Ea(
        "indirect_nodes_object_3ds"
      ),
      indirect_edges_360_image_annotations: Ma(
        "indirect_nodes_object_3ds"
      ),
      indirect_nodes_360_images: Pa(
        "indirect_edges_360_image_annotations",
        e
      )
    },
    select: {
      initial_nodes_cad_nodes: {
        sources: ba
      },
      initial_nodes_point_cloud_volumes: { sources: Sa },
      initial_edges_360_image_annotations: {},
      initial_nodes_360_images: { sources: Ta },
      indirect_nodes_cad_nodes: {
        sources: ba
      },
      indirect_nodes_point_cloud_volumes: {
        sources: Sa
      },
      indirect_edges_360_image_annotations: {},
      indirect_nodes_360_images: { sources: Ta }
    }
  };
}
function X0(n, e) {
  var r;
  const t = e.properties, i = Object.keys(t).filter(
    (a) => Z0(a, e)
  ), s = (r = n.properties[e.space]) == null ? void 0 : r[`${e.externalId}/${e.version}`];
  return Object.entries(s).length === 0 ? [] : i.map((a) => {
    const c = s[a];
    if (c === void 0)
      return;
    const { space: d, externalId: l } = c;
    if (!(n.externalId === l && n.space === d))
      return { space: d, externalId: l };
  }).filter(F);
}
function Z0(n, e) {
  const t = e.properties[n];
  if (t.type === void 0 || t.type.type !== "direct" || t.type.list === !0)
    return !1;
  const i = t.type.source;
  return (i == null ? void 0 : i.externalId) === xe.externalId && (i == null ? void 0 : i.space) === xe.space && (i == null ? void 0 : i.version) === xe.version;
}
function Yn(n) {
  return {
    type: "view",
    externalId: n.externalId,
    space: n.space,
    version: n.version
  };
}
async function Q0(n, e, t, i, s) {
  if (n.length === 0 || e.length === 0)
    return [];
  const o = await J0(
    n,
    e,
    i,
    s
  ), r = n.map(async (c) => {
    const d = c.view.space, l = c.view.externalId, h = c.view.version, p = `${l}/${h}`;
    return {
      view: c.view,
      instances: c.instances.filter((f) => {
        var C, v;
        const g = (v = (C = f.properties[d]) == null ? void 0 : C[p]) == null ? void 0 : v.object3D;
        return _t(g) ? o.has(X(g)) : !1;
      })
    };
  });
  return (await Promise.all(r)).map((c) => ({
    view: Yn(c.view),
    instances: c.instances
  })).filter(F);
}
async function J0(n, e, t, i) {
  const s = n.flatMap((h) => h.instances.map(Bt)), o = n.flatMap(
    (h) => h.instances.flatMap(
      (p) => X0(p, h.view)
    )
  ).filter((h) => F(h) && h.externalId !== void 0 && h.space !== void 0), r = kg(s, o), a = Ue(r, X), c = Q(a, 2e3), d = { revisionRefs: e }, l = [];
  for (const h of c) {
    const f = {
      ...Y0(h, e),
      parameters: d
    }, g = await t.queryAllNodesAndEdges(f);
    l.push(
      ...eC(g, i)
    );
  }
  return new Set(l);
}
function eC(n, e) {
  const t = [...n.items.initial_nodes_cad_nodes].concat(e ? n.items.indirect_nodes_cad_nodes : []).map(
    (a) => X(a.properties[ge][Ji].object3D)
  ), i = [...n.items.initial_nodes_point_cloud_volumes].concat(e ? n.items.indirect_nodes_point_cloud_volumes : []).map(
    (a) => X(
      a.properties[ge][w0].object3D
    )
  ), s = new Set(
    [
      ...n.items.initial_nodes_360_images,
      ...e ? n.items.indirect_nodes_360_images : []
    ].map(X)
  ), r = [
    ...n.items.initial_edges_360_image_annotations,
    ...e ? n.items.indirect_edges_360_image_annotations : []
  ].filter((a) => s.has(X(a.endNode))).map(
    (a) => X(a.startNode)
  );
  return [...t, ...i, ...r];
}
const tC = {
  with: {
    asset: {
      nodes: {
        filter: {
          and: [
            {
              equals: {
                property: ["node", "externalId"],
                value: { parameter: "instanceExternalId" }
              }
            },
            {
              equals: {
                property: ["node", "space"],
                value: { parameter: "instanceSpace" }
              }
            }
          ]
        }
      }
    },
    object_3ds: {
      nodes: {
        from: "asset",
        through: {
          view: st,
          identifier: "object3D"
        },
        direction: "outwards"
      }
    },
    cad_nodes: {
      nodes: {
        from: "object_3ds",
        through: { view: pe, identifier: "object3D" }
      }
    }
  },
  select: {
    cad_nodes: { sources: Er }
  }
};
async function nC(n, e) {
  const t = { instanceExternalId: n.externalId, instanceSpace: n.space }, i = {
    ...tC,
    parameters: t
  };
  return (await e.queryAllNodesAndEdges(i)).items.cad_nodes.flatMap((o) => {
    const r = o.properties[ge][Ji];
    return r.revisions.map((a) => ({
      type: "cad",
      addOptions: {
        modelId: ao(r.model3D.externalId),
        revisionId: lp(a.externalId)
      }
    }));
  });
}
const iC = {
  with: {
    cad_nodes: {
      nodes: {
        filter: {
          and: [
            {
              in: {
                property: [
                  pt,
                  pe.externalId,
                  "model3D"
                ],
                values: { parameter: "modelRefs" }
              }
            },
            {
              containsAny: {
                property: [
                  pt,
                  pe.externalId,
                  "revisions"
                ],
                values: { parameter: "revisionRefs" }
              }
            }
          ]
        }
      },
      limit: 1e4
    },
    object_3ds: {
      nodes: {
        from: "cad_nodes",
        through: { view: pe, identifier: "object3D" },
        direction: "outwards",
        filter: {
          hasData: [xi]
        }
      },
      limit: 1e4
    },
    assets: {
      nodes: {
        from: "object_3ds",
        through: { view: xe, identifier: "object3D" },
        direction: "inwards"
      },
      limit: 1e4
    }
  },
  select: {
    cad_nodes: { sources: Er },
    assets: { sources: co }
  }
};
async function sC(n, e) {
  if (n.length === 0)
    return [];
  const t = await cC(n, e), i = oC(t.items.assets), s = rC(t.items.cad_nodes);
  return t.items.cad_nodes.map((r) => {
    const a = r.properties[ge][Ji], c = s.get(X(r));
    if (c === void 0)
      return;
    const d = i.get(c);
    if (d === void 0)
      return;
    const l = aC(n, a);
    if (l !== void 0)
      return {
        ...l,
        instance: Bt(d)
      };
  }).filter(F);
}
function oC(n) {
  return new Map(
    n.map((e) => {
      var t;
      return [
        X((t = e.properties[ge]) == null ? void 0 : t[ap].object3D),
        e
      ];
    })
  );
}
function rC(n) {
  return new Map(
    n.map((e) => [
      X(e),
      X(e.properties[ge][Ji].object3D)
    ])
  );
}
function aC(n, e) {
  const t = n.find(
    ([a, c]) => e.model3D.externalId === a.externalId && e.model3D.space === a.space
  );
  if (t === void 0)
    return;
  const i = e.revisions.findIndex(
    (a) => t[1].externalId === a.externalId && t[1].space === a.space
  );
  if (i === -1)
    return;
  const s = ao(e.model3D.externalId), o = lp(e.revisions[i].externalId), r = e.treeIndexes[i];
  return { modelId: s, revisionId: o, treeIndex: r };
}
async function cC(n, e) {
  const t = {
    modelRefs: n.map(([s, o]) => Bt(s)),
    revisionRefs: n.map(([s, o]) => Bt(o))
  }, i = {
    ...iC,
    parameters: t
  };
  return await e.queryAllNodesAndEdges(i);
}
const dC = 1e3 * 60 * 10, H = [], lC = 1e3, Ra = 2;
class uC {
  constructor(e) {
    this._revisionIdToDMSIdentifier = /* @__PURE__ */ new Map(), this._modelIdToDMSIdentifier = /* @__PURE__ */ new Map(), this._fdmSdk = e;
  }
  is3dView(e) {
    return e.implements.some(
      (t) => t.externalId === xi.externalId && t.space === xi.space && t.version === xi.version
    );
  }
  async getDMSModels(e) {
    const t = this._modelIdToDMSIdentifier.get(e);
    if (t !== void 0)
      return t;
    const i = await dp(e, this._fdmSdk);
    return this._modelIdToDMSIdentifier.set(e, i), i;
  }
  async getDMSRevision(e, t) {
    let i = this._revisionIdToDMSIdentifier.get(t);
    if (i === void 0) {
      const s = await hp(e, t, this._fdmSdk);
      this._revisionIdToDMSIdentifier.set(t, s), i = s;
    }
    if (i === void 0)
      throw Error(`No revision with id ${t} found`);
    return Bt(i);
  }
  async getDMSModelsForIds(e) {
    return (await St(
      e.map((t) => async () => await this.getDMSModels(t)),
      Ra
    )).flat();
  }
  async getDMSRevisionsForRevisionIdsAndModelRefs(e, t) {
    return (await St(
      t.map((i, s) => async () => e[s] === void 0 ? void 0 : await this.getDMSRevision(e[s], i)),
      Ra
    )).filter(F);
  }
  async getEdgeConnected3dInstances(e) {
    return await O0(e, this._fdmSdk);
  }
  async getFdmConnectionsForNodes(e, t, i) {
    e.length !== 1 && console.warn(`Expected 1 CoreDM 3D model, got ${e.length}:`, ...e);
    const s = e[0], o = await this.getDMSRevision(s, t);
    return await D0(s, o, t, i, this._fdmSdk);
  }
  async listMappedFdmNodes(e, t, i, s) {
    const o = await this.getRevisionRefs(e);
    return await H0(
      o,
      t.map((r) => Yn(r)),
      i,
      s,
      this._fdmSdk
    );
  }
  async listAllMappedFdmNodes(e, t, i) {
    const s = await this.getRevisionRefs(e);
    return await G0(s, t, i, this._fdmSdk);
  }
  async filterNodesByMappedTo3d(e, t, i, s) {
    const o = await this.getRevisionRefs(t);
    return await Q0(
      e,
      o,
      i,
      this._fdmSdk,
      s
    );
  }
  async getCadModelsForInstance(e) {
    return await nC(e, this._fdmSdk);
  }
  async getCadConnectionsForRevisions(e) {
    const t = e.filter(Ee);
    if (t.length === 0)
      return H;
    const i = await this.getDMSModelsForIds(t.map((r) => r.modelId)), s = await this.getDMSRevisionsForRevisionIdsAndModelRefs(
      i,
      t.map((r) => r.revisionId)
    ), o = Lg(i, s).filter(
      (r) => F(r[0]) && F(r[1])
    );
    return await sC(o, this._fdmSdk);
  }
  async getRevisionRefs(e) {
    const [t, i] = Kt(e, Ee), s = await this.getDMSModelsForIds(
      t.map((a) => a.modelId)
    ), o = await this.getDMSRevisionsForRevisionIdsAndModelRefs(
      s,
      t.map((a) => a.revisionId)
    ), r = i.map((a) => Tt(a) ? {
      externalId: a.revisionExternalId,
      space: a.revisionSpace
    } : { externalId: a.externalId, space: a.space });
    return o.concat(r);
  }
}
const lo = "cdf_3d_schema", hC = "Cdf3dModel", pC = "1", he = {
  type: "view",
  version: "1",
  externalId: "Cdf3dConnectionProperties",
  space: lo
};
async function fC(n, e) {
  return (await e.queryNodesAndEdges({
    ...gC,
    parameters: {
      instanceExternalId: n.externalId,
      instanceSpace: n.space
    }
  })).items.connected_objects_with_3d.map((i) => ({
    instanceType: "node",
    externalId: i.externalId,
    space: i.space
  }));
}
const gC = {
  with: {
    start_instance: {
      nodes: {
        filter: {
          and: [
            {
              equals: {
                property: ["node", "externalId"],
                value: { parameter: "instanceExternalId" }
              }
            },
            {
              equals: {
                property: ["node", "space"],
                value: { parameter: "instanceSpace" }
              }
            }
          ]
        }
      },
      limit: 1
    },
    start_to_object_edges: {
      edges: {
        from: "start_instance",
        maxDistance: 1,
        direction: "outwards"
      },
      limit: 1e3
    },
    connected_objects_with_3d: {
      nodes: {
        from: "start_to_object_edges",
        chainTo: "destination"
      },
      limit: 1e3
    },
    edges_of_3d_type: {
      edges: {
        from: "connected_objects_with_3d",
        maxDistance: 1,
        direction: "outwards",
        filter: {
          and: [
            {
              hasData: [he]
            }
          ]
        }
      }
    },
    nodes_with_3d_connection: {
      nodes: {
        from: "edges_of_3d_type",
        chainTo: "source"
      },
      limit: 1e3
    }
  },
  select: {
    start_instance: {},
    start_to_object_edges: {},
    connected_objects_with_3d: {},
    edges_of_3d_type: {},
    nodes_with_3d_connection: {}
  }
}, mC = 2;
async function mp(n, e) {
  const t = yC(n);
  return (await St(
    [...t.entries()].map(
      ([s, o]) => async () => await vC(
        s,
        o,
        e
      )
    ),
    mC
  )).flat().filter(F);
}
function yC(n) {
  return n.reduce((e, t) => {
    const i = Number(t.endNode.externalId), s = dt(i, t.properties.revisionId), o = {
      nodeId: t.properties.revisionNodeId,
      revisionId: t.properties.revisionId,
      modelId: i,
      instance: t.startNode
    }, r = e.get(s);
    return r === void 0 ? e.set(s, [o]) : r.push(o), e;
  }, /* @__PURE__ */ new Map());
}
async function vC(n, e, t) {
  const [i, s] = ep(n), o = Q(e, 1e3), r = [];
  for (const a of o) {
    const c = await r0(
      i,
      s,
      a.map((l) => l.nodeId),
      t
    ), d = a.map((l, h) => ({
      modelId: l.modelId,
      revisionId: l.revisionId,
      treeIndex: c[h],
      instance: l.instance
    }));
    r.push(...d);
  }
  return r;
}
async function CC(n, e, t, i, s) {
  const o = s.map((c) => c.id), r = {
    and: [
      {
        in: {
          property: ["edge", "endNode"],
          values: t.map((c) => ({
            externalId: c.externalId,
            space: c.space
          }))
        }
      },
      {
        equals: {
          property: [
            he.space,
            `${he.externalId}/${he.version}`,
            "revisionId"
          ],
          value: i
        }
      },
      {
        in: {
          property: [
            he.space,
            `${he.externalId}/${he.version}`,
            "revisionNodeId"
          ],
          values: o
        }
      }
    ]
  }, a = await n.filterAllInstances(
    r,
    "edge",
    he
  );
  return await mp(a.instances, e);
}
async function yp(n, e) {
  const t = {
    equals: {
      property: ["node", "externalId"],
      value: `${e}`
    }
  }, i = {
    type: "view",
    space: lo,
    externalId: hC,
    version: pC
  };
  return (await n.filterInstances(t, "node", i)).instances;
}
function vp(n, e, t, i = 1e4, s) {
  return t = Ni(t), {
    with: {
      mapped_edges: {
        edges: {
          filter: IC(n)
        },
        limit: i
      },
      mapped_nodes: {
        nodes: {
          from: "mapped_edges",
          chainTo: "source",
          filter: t
        },
        limit: i
      },
      mapped_edges_2: {
        edges: {
          from: "mapped_nodes",
          direction: "inwards",
          maxDistance: 1
        }
      },
      mapped_nodes_2: {
        nodes: {
          from: "mapped_edges_2",
          chainTo: "destination",
          filter: t
        }
      }
    },
    cursors: s,
    select: {
      mapped_nodes_2: {
        sources: e.map((o) => ({ source: o, properties: [] }))
      },
      mapped_edges_2: {},
      mapped_edges: {
        sources: [{ source: he, properties: [] }]
      },
      mapped_nodes: {
        sources: e.map((o) => ({ source: o, properties: [] }))
      }
    }
  };
}
function IC(n) {
  return {
    in: {
      property: [
        he.space,
        `${he.externalId}/${he.version}`,
        "revisionId"
      ],
      values: n.map((e) => e.revisionId)
    }
  };
}
function Cs(n) {
  return Object.keys(n.properties).forEach((e) => {
    const t = n.properties[e], i = {};
    Object.keys(t).forEach((s) => {
      const o = t[s];
      Object.keys(o).length !== 0 && (i[s] = o);
    }), n.properties[e] = i;
  }), n;
}
async function wC(n, e, t, i, s) {
  const o = await n.queryNodesAndEdges(
    vp(e, t, i, s)
  );
  return o.items.mapped_nodes.concat(o.items.mapped_nodes_2);
}
async function xC(n, e, t) {
  const i = _C(e, t, 1e4), s = [];
  for (const o of i) {
    let r = await n.queryNodesAndEdges(o);
    const a = r.items.mapped_nodes, c = r.items.mapped_nodes_2;
    for (s.push(
      ...a.concat(c).map((d) => Cs(d))
    ); !Jn(r.nextCursor, {}); ) {
      o.cursors = r.nextCursor, r = await n.queryNodesAndEdges(o);
      const d = r.items.mapped_nodes.map(
        (h) => Cs(h)
      ), l = r.items.mapped_nodes_2.map(
        (h) => Cs(h)
      );
      s.push(...d.concat(l));
    }
  }
  return s;
}
function _C(n, e, t = 1e4, i) {
  return Q(e, 10).map(
    (o) => vp(n, o, void 0, t, i)
  );
}
function Cp(n) {
  const e = [], t = n.properties;
  return Object.keys(t).forEach((i) => {
    const { space: s, externalId: o } = t[i];
    s !== void 0 && o !== void 0 && e.push({ space: s, externalId: o });
  }), e;
}
async function TC(n, e, t, i, s) {
  const o = e.flatMap((f) => f.instances), r = e.map((f) => f.view);
  if (o.length === 0)
    return e;
  const a = o.flatMap((f) => Cp(f)), c = SC(
    o,
    a,
    t,
    r
  ), d = await n.queryNodesAndEdges(c), { mappedEquipmentFirstLevelMap: l, equipmentSecondLevelMap: h } = await bC(
    n,
    d.items.mapped_edges,
    t,
    i
  ), p = [];
  for (const f of e) {
    const g = f.instances.filter(
      (C) => MC(
        l,
        h,
        C,
        s
      )
    );
    p.push({ view: f.view, instances: g });
  }
  return p;
}
function SC(n, e, t, i, s = 1e3) {
  return {
    with: {
      mapped_nodes: {
        nodes: {
          filter: {
            in: {
              property: ["node", "externalId"],
              values: n.map((o) => o.externalId).concat(e.map((o) => o.externalId))
            }
          }
        },
        limit: s
      },
      mapped_edges: {
        edges: {
          from: "mapped_nodes",
          direction: "outwards",
          nodeFilter: {
            in: {
              property: ["node", "externalId"],
              values: t.map((o) => o.modelId.toString())
            }
          },
          maxDistance: 2
        },
        limit: 1e4
      }
    },
    select: {
      mapped_edges: {
        sources: [{ source: he, properties: ["revisionId", "revisionNodeId"] }]
      },
      mapped_nodes: {
        sources: i.map((o) => ({ source: o, properties: [] }))
      }
    }
  };
}
async function bC(n, e, t, i) {
  const s = {}, o = {}, r = await EC(n, t);
  for (const a of e) {
    const { space: c, externalId: d } = a.endNode, { space: l, externalId: h } = a.startNode, p = t.some(
      ({ modelId: g, revisionId: C }) => g.toString() === d && C.toString() === AC(a)
    ), f = r.get(d);
    if ((f == null ? void 0 : f.find((g) => g.space === c)) !== void 0 && p) {
      const g = `${l}/${h}`, C = s[g];
      s[g] = C !== void 0 ? C.concat(a) : [a];
      continue;
    }
    if (i.includes(c)) {
      const g = `${l}/${h}`, C = o[g];
      o[g] = C !== void 0 ? C.concat(a) : [a];
      continue;
    }
  }
  return { mappedEquipmentFirstLevelMap: s, equipmentSecondLevelMap: o };
}
function AC(n) {
  var e, t, i, s;
  return (s = (i = (t = (e = n.properties) == null ? void 0 : e[lo]) == null ? void 0 : t[`${he.externalId}/${he.version}`]) == null ? void 0 : i.revisionId) == null ? void 0 : s.toString();
}
async function EC(n, e) {
  const t = await Promise.all(
    e.map(async (i) => await yp(n, i.modelId))
  );
  return new Map(
    t.map((i, s) => [`${e[s].modelId}`, i])
  );
}
function MC(n, e, t, i) {
  const s = `${t.space}/${t.externalId}`, o = Cp(t), r = n[s] !== void 0, a = e[s] !== void 0, c = o.length > 0;
  return r ? !0 : a && i ? e[s].some((d) => {
    const { space: l, externalId: h } = d.endNode, p = `${l}/${h}`;
    return n[p] !== void 0;
  }) : c && i ? o.some(
    ({ externalId: l, space: h }) => n[`${h}/${l}`] !== void 0
  ) : !1;
}
async function PC(n, e) {
  const t = {
    ...OC,
    parameters: { instanceExternalId: e.externalId, instanceSpace: e.space }
  };
  return (await n.queryNodesAndEdges(t)).items.model_edges.map((o) => {
    const r = Object.values(Object.values(o.properties)[0])[0], a = o.endNode.externalId, c = Number(a);
    if (!isNaN(c))
      return { type: "cad", addOptions: { modelId: c, revisionId: r.revisionId } };
  }).filter(F);
}
const OC = {
  with: {
    start_instance: {
      nodes: {
        filter: {
          and: [
            {
              equals: {
                property: ["node", "externalId"],
                value: { parameter: "instanceExternalId" }
              }
            },
            {
              equals: {
                property: ["node", "space"],
                value: { parameter: "instanceSpace" }
              }
            }
          ]
        }
      },
      limit: 1
    },
    model_edges: {
      edges: {
        from: "start_instance",
        maxDistance: 1,
        direction: "outwards",
        filter: {
          and: [
            {
              hasData: [he]
            }
          ]
        }
      },
      limit: 1e3
    }
  },
  select: {
    model_edges: {
      sources: [{ source: he, properties: ["revisionId", "revisionNodeId"] }]
    }
  }
};
async function RC(n, e, t) {
  if (n.length === 0) return [];
  const i = n.map((a) => a.revisionId), s = `${he.externalId}/${he.version}`, o = {
    in: {
      property: [lo, s, "revisionId"],
      values: i
    }
  }, r = await e.filterAllInstances(
    o,
    "edge",
    he
  );
  return await mp(r.instances, t);
}
class DC {
  constructor(e, t) {
    this._fdmSdk = e, this._cogniteClient = t;
  }
  is3dView(e) {
    return Object.keys(e.properties).some((t) => t === "inModel3d");
  }
  async getDMSModels(e) {
    return await yp(this._fdmSdk, e);
  }
  async getEdgeConnected3dInstances(e) {
    return await fC(e, this._fdmSdk);
  }
  async getFdmConnectionsForNodes(e, t, i) {
    return await CC(
      this._fdmSdk,
      this._cogniteClient,
      e,
      t,
      i
    );
  }
  async listMappedFdmNodes(e, t, i, s) {
    const o = e.filter((r) => Ee(r));
    return o.length === 0 ? H : await wC(
      this._fdmSdk,
      o,
      t.map(Yn),
      i,
      s
    );
  }
  async listAllMappedFdmNodes(e, t) {
    const i = e.filter((s) => Ee(s));
    return i.length === 0 ? H : await xC(this._fdmSdk, i, t);
  }
  async filterNodesByMappedTo3d(e, t, i, s) {
    const o = t.filter((a) => Ee(a));
    if (o.length === 0)
      return H;
    const r = e.map((a) => ({
      view: Yn(a.view),
      instances: a.instances
    }));
    return await TC(
      this._fdmSdk,
      r,
      o,
      i,
      s
    );
  }
  async getCadModelsForInstance(e) {
    return await PC(this._fdmSdk, e);
  }
  async getCadConnectionsForRevisions(e) {
    const t = e.filter((i) => Ee(i));
    return t.length === 0 ? H : await RC(t, this._fdmSdk, this._cogniteClient);
  }
}
class kC {
  constructor(e, t, { coreDmOnly: i }) {
    const s = new Xi(e), o = i ? new uC(s) : new DC(s, e);
    this._assetMappingAndNode3dCache = new d0(e), this._fdmNodeCache = new p0(e, s, o), this._pointCloudAnnotationCache = new S0(e), this._image360AnnotationCache = new E0(e, t), this._cogniteClient = e, this._fdm3dDataProvider = o, this._coreDmOnly = i;
  }
  get assetMappingAndNode3dCache() {
    return this._assetMappingAndNode3dCache;
  }
  get fdmNodeCache() {
    return this._fdmNodeCache;
  }
  get pointCloudAnnotationCache() {
    return this._pointCloudAnnotationCache;
  }
  get image360Cache() {
    return this._image360AnnotationCache;
  }
  get cogniteClient() {
    return this._cogniteClient;
  }
  get fdm3dDataProvider() {
    return this._fdm3dDataProvider;
  }
  get coreDmOnly() {
    return this._coreDmOnly;
  }
}
const LC = {
  cadBudget: {
    maximumRenderCost: 15e6,
    highDetailProximityThreshold: 0
  },
  pointCloudBudget: {
    numberOfPoints: 3e6
  },
  resolutionOptions: {
    maxRenderResolution: 14e5,
    movingCameraResolutionFactor: 0.5
  }
};
class NC {
  constructor(e) {
    this._disposables = [], this._renderQualitySignal = fn(LC), this._cameraKeyBoardSpeed = fn(1), this._cameraControlsType = fn(qe.Orbit), this._cameraControlsTypeChangeHandler = (t) => {
      const i = this._viewer.cameraManager;
      Pi(i) && this._cameraControlsType(i.options.controlsType);
    }, this._viewer = e, this.copyDefaultValuesFromViewer(), this.addEffect(() => {
      BC(this._renderQualitySignal(), this._viewer);
    }), this.addEffect(() => {
      FC(this._cameraKeyBoardSpeed(), this._viewer);
    }), this.addEffect(() => {
      VC(this._cameraControlsType(), this._viewer);
    });
  }
  get renderQuality() {
    return this._renderQualitySignal;
  }
  get cameraKeyBoardSpeed() {
    return this._cameraKeyBoardSpeed;
  }
  get cameraControlsType() {
    return this._cameraControlsType;
  }
  dispose() {
    for (const e of this._disposables)
      e();
  }
  addEffect(e) {
    this._disposables.push(
      $i(() => {
        e();
      })
    );
  }
  copyDefaultValuesFromViewer() {
    const e = this._viewer.cameraManager;
    Pi(e) && (this._cameraKeyBoardSpeed(e.options.keyboardSpeed), this._cameraControlsType(e.options.controlsType), e.addControlsTypeChangeListener(this._cameraControlsTypeChangeHandler), this._disposables.push(() => {
      e.removeControlsTypeChangeListener(this._cameraControlsTypeChangeHandler);
    }));
  }
}
function BC(n, e) {
  e.setResolutionOptions(n.resolutionOptions), e.cadBudget = n.cadBudget, e.pointCloudBudget = n.pointCloudBudget;
}
function FC(n, e) {
  const t = e.cameraManager;
  Pi(t) && (t.options.keyboardSpeed = n);
}
function VC(n, e) {
  const t = e.cameraManager;
  Pi(t) && (t.options.controlsType = n);
}
const jC = "DirectionalLight";
class Ip {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e, t, i) {
    this._cropBoxUniqueId = void 0, this._config = void 0, this.toViewerMatrix = G.clone(), this.fromViewerMatrix = G.clone().invert(), this.ghostMode = !1, this.cameraChangeHandler = (o, r) => {
      const a = this._directionalLight;
      if (a === void 0)
        return;
      const c = this.camera, d = new I();
      c.getWorldDirection(d), d.negate(), a.position.copy(d);
    }, this._viewer = e;
    const s = (i == null ? void 0 : i.coreDmOnly) ?? !1;
    this._cdfCaches = new kC(t, e, { coreDmOnly: s }), this._commandsController = new Dh(this.domElement), this._commandsController.addEventListeners(), this._contextmenuController = new e0(), this._instanceStylingController = new t0(), this._revealSettingsController = new NC(e), this._rootDomainObject = new so(this, t), this._rootDomainObject.isExpanded = !0, this.initializeLights(), this._viewer.on("cameraChange", this.cameraChangeHandler), this.setConfig(new Qh());
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get viewer() {
    return this._viewer;
  }
  get isInside360Image() {
    return this._viewer.canDoImage360Action(Fe.Exit);
  }
  get active360ImageId() {
    var e;
    return (e = this._viewer.getActive360ImageInfo()) == null ? void 0 : e.image360.id;
  }
  get config() {
    return this._config;
  }
  get rootDomainObject() {
    return this._rootDomainObject;
  }
  get canvas() {
    return this._viewer.canvas;
  }
  get domElement() {
    return this._viewer.domElement;
  }
  get commandsController() {
    return this._commandsController;
  }
  get contextMenuController() {
    return this._contextmenuController;
  }
  get cdfCaches() {
    return this._cdfCaches;
  }
  get instanceStylingController() {
    return this._instanceStylingController;
  }
  get revealSettingsController() {
    return this._revealSettingsController;
  }
  get cursor() {
    return this.domElement.style.cursor;
  }
  set cursor(e) {
    this.domElement.style.cursor = e ?? "default";
  }
  get cameraManager() {
    return this.viewer.cameraManager;
  }
  get flexibleCameraManager() {
    const e = this.cameraManager;
    if (!Pi(e))
      throw new Error("Camera manager is not flexible");
    return e;
  }
  get camera() {
    return this.cameraManager.getCamera();
  }
  // ==================================================
  // INSTANCE PROPERTIES: Get bounding box
  // ==================================================
  get clippedVisualSceneBoundingBox() {
    if (this._clippedBoundingBox === void 0)
      return this.visualSceneBoundingBox;
    const e = this.visualSceneBoundingBox.clone();
    return e.intersect(this._clippedBoundingBox), e;
  }
  get sceneBoundingBox() {
    return this.viewer.getSceneBoundingBox();
  }
  get visualSceneBoundingBox() {
    return this.viewer.getVisualSceneBoundingBox();
  }
  // ==================================================
  // INSTANCE METHODS: Get models from the viewer
  // ==================================================
  *getPointClouds() {
    for (const e of this.viewer.models)
      e instanceof xs && (yield e);
  }
  *getCadModels() {
    for (const e of this.viewer.models)
      e instanceof Oi && (yield e);
  }
  *get360ImageCollections() {
    for (const e of this.viewer.get360ImageCollections())
      yield e;
  }
  // ==================================================
  // INSTANCE METHODS: Convert back and from Viewer coordinates
  // ==================================================
  convertFromViewerCoordinates(e) {
    const t = e.clone();
    return t.applyMatrix4(this.fromViewerMatrix), t;
  }
  convertToViewerCoordinates(e) {
    const t = e.clone();
    return t.applyMatrix4(this.toViewerMatrix), t;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  setDefaultTool(e) {
    const t = this.commandsController.defaultTool;
    if (t !== void 0 && e.equals(t))
      return !1;
    const i = this.commandsController.getEqual(e);
    return i !== void 0 ? this.commandsController.setDefaultTool(i) : (e.attach(this), this.commandsController.add(e), this.commandsController.setDefaultTool(e));
  }
  setActiveToolByType(e) {
    return this.commandsController.setActiveToolByType(e);
  }
  setConfig(e) {
    this._config = e, this.setDefaultTool(e.createDefaultTool());
    const t = e.createAxisGizmoTool();
    t !== void 0 && (t.connect(this._viewer), this._axisGizmoTool = t);
  }
  onStartup() {
    var e;
    (e = this._config) == null || e.onStartup(this), Ie.update(this);
  }
  dispose() {
    var e;
    this._viewer.dispose(), this._ambientLight !== void 0 && this._viewer.removeObject3D(this._ambientLight), this._directionalLight !== void 0 && this._viewer.removeObject3D(this._directionalLight), this.commandsController.removeEventListeners(), this.commandsController.dispose(), (e = this._axisGizmoTool) == null || e.dispose(), this._revealSettingsController.dispose(), Ie.dispose();
  }
  invalidate() {
    this._viewer.requestRedraw();
  }
  initializeLights() {
    this._ambientLight = new Gg(16777215, 0.25), this._directionalLight = new Hg(16777215, 2), this._directionalLight.name = jC, this._directionalLight.position.set(0, 1, 0);
    const e = new _s(this._ambientLight), t = new _s(this._directionalLight);
    e.isPartOfBoundingBox = !1, t.isPartOfBoundingBox = !1, this.viewer.addCustomObject(e), this.viewer.addCustomObject(t);
  }
  // ==================================================
  // INSTANCE METHODS: Fit operations
  // ==================================================
  fitView() {
    return this.viewer.fitCameraToBoundingBox(this.clippedVisualSceneBoundingBox), !0;
  }
  // ==================================================
  // INSTANCE METHODS: Clipping operations (Experimental code)
  // ==================================================
  getGlobalClippingPlanes() {
    return this.viewer.getGlobalClippingPlanes === void 0 ? [] : this.viewer.getGlobalClippingPlanes();
  }
  get isGlobalClippingActive() {
    return this.viewer.getGlobalClippingPlanes === void 0 ? !1 : this.getGlobalClippingPlanes().length > 0;
  }
  get isGlobalCropBoxActive() {
    return this.isGlobalClippingActive && this._cropBoxUniqueId !== void 0;
  }
  isGlobalCropBox(e) {
    return this._cropBoxUniqueId !== void 0 && e.uniqueId === this._cropBoxUniqueId;
  }
  setGlobalClipping(e, t) {
    if (e.length === 0) {
      this.clearGlobalClipping();
      return;
    }
    const i = this.sceneBoundingBox.clone();
    i.applyMatrix4(this.fromViewerMatrix);
    const s = new ft();
    s.copy(i);
    const r = Jv(e, s).getBox();
    for (const a of e)
      a.applyMatrix4(this.toViewerMatrix);
    r.applyMatrix4(this.toViewerMatrix), this.viewer.setGlobalClippingPlanes(e), this._clippedBoundingBox = r, this._cropBoxUniqueId = t == null ? void 0 : t.uniqueId, this.rootDomainObject.notifyDescendants(m.clipping);
  }
  clearGlobalClipping() {
    this.viewer.setGlobalClippingPlanes([]), this._clippedBoundingBox = void 0, this._cropBoxUniqueId = void 0, this.rootDomainObject.notifyDescendants(m.clipping);
  }
  // ==================================================
  // INSTANCE METHODS: Cursor
  // See: https://developer.mozilla.org/en-US/docs/Web/CSS/cursor
  // ==================================================
  setDefaultCursor() {
    this.cursor = "default";
  }
  setNavigateCursor() {
    this.cursor = "pointer";
  }
  setCrosshairCursor() {
    this.cursor = "crosshair";
  }
  /**
   * Sets the resize cursor based on two points in 3D space to the resize
   * // cursor has a correct direction.
   * @param point1 - The first point in CDF space.
   * @param point2 - The second point in CDF space.
   */
  getResizeCursor(e, t) {
    e = this.convertToViewerCoordinates(e), t = this.convertToViewerCoordinates(t);
    const i = this.viewer.worldToScreen(e, !1);
    if (i === null)
      return;
    const s = this.viewer.worldToScreen(t, !1);
    if (s === null)
      return;
    const o = s == null ? void 0 : s.sub(i).normalize();
    return o.y = -o.y, Wh(Kv(o));
  }
}
const wp = Ye(void 0), zC = ({ children: n }) => {
  const [e, t] = M(void 0), i = ii(), s = Z(
    (r) => {
      i !== void 0 && (i.sceneLoadedRef.current = r), t(r);
    },
    [i]
  ), o = P(() => (i == null ? void 0 : i.sceneLoadedRef.current) ?? e, [e, i]);
  return /* @__PURE__ */ u(wp.Provider, { value: { loadedScene: o, setScene: s }, children: n });
}, GO = () => {
  const n = Xe(wp);
  if (n === void 0)
    throw new Error("useLoadedScene must be used within a LoadedSceneProvider");
  return n;
}, UC = (n, e) => {
  const t = ve(void 0);
  GC(n, t), HC(e, n, t);
}, GC = (n, e) => {
  const t = oe();
  R(() => {
    n === void 0 || xp(n, e.current) || t.cameraManager.setCameraState(n);
  }, [n]);
}, HC = (n, e, t) => {
  const i = oe();
  R(() => {
    const s = () => {
      const o = i.cameraManager.getCameraState();
      e !== void 0 && xp(e, o) || (t.current = {
        position: o.position.clone(),
        target: o.target.clone(),
        rotation: o.rotation.clone()
      }, n == null || n(o));
    };
    return i.cameraManager.on("cameraStop", s), () => {
      i.cameraManager.off("cameraStop", s);
    };
  }, [e, n, t]);
};
function xp(n, e) {
  if (n === void 0 && e === void 0)
    return !0;
  if (n === void 0 || e === void 0)
    return !1;
  const t = 1e-3, {
    position: i,
    target: s,
    rotation: o
  } = n, { position: r, target: a, rotation: c } = e, d = i.distanceToSquared(r) <= t, l = s.distanceToSquared(a) <= t, h = c ?? new kt().identity(), f = (o ?? new kt().identity()).angleTo(h) <= t;
  return d && l && f;
}
const qC = (n) => {
  const e = WC(n), t = P(() => new Fg({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: !1
      }
    }
  }), []);
  return e === null ? /* @__PURE__ */ u(k, {}) : /* @__PURE__ */ u(Ky, { sdk: n.sdk, children: /* @__PURE__ */ u(Vg, { client: t, children: /* @__PURE__ */ u(Fy, { appLanguage: n.appLanguage, children: /* @__PURE__ */ u(zC, { children: /* @__PURE__ */ _(Vy, { value: e, children: [
    /* @__PURE__ */ u(
      $C,
      {
        cameraState: n.cameraState,
        setCameraState: n.setCameraState
      }
    ),
    /* @__PURE__ */ u($y, { children: n.children })
  ] }) }) }) }) });
}, $C = ({
  cameraState: n,
  setCameraState: e
}) => (UC(n, e), null), WC = ({
  color: n,
  sdk: e,
  viewerOptions: t,
  useCoreDm: i
}) => {
  const s = ii(), [o, r] = M(null);
  return R(() => {
    const c = a();
    if (s !== void 0)
      return s.isRevealContainerMountedRef.current = !0, () => {
        if (s === void 0) {
          c.dispose();
          return;
        }
        s.isRevealContainerMountedRef.current = !1;
      };
  }, []), o;
  function a() {
    let c = s == null ? void 0 : s.renderTargetRef.current;
    if (c === void 0) {
      const d = new wg({
        ...t,
        sdk: e,
        useFlexibleCameraManager: !0,
        hasEventListeners: !1
      });
      c = new Ip(d, e, { coreDmOnly: i }), s !== void 0 && (s.renderTargetRef.current = c);
    }
    return c.viewer.setBackgroundColor({ color: n, alpha: 1 }), r(c), c;
  }
}, KC = () => {
  const n = oe(), [e, t] = M(!1), i = Z(() => {
    t(!0), window.addEventListener("pointerup", s);
  }, [t]), s = Z(() => {
    t(!1), window.removeEventListener("pointerup", s);
  }, [t]);
  return R(() => (n.domElement.addEventListener("pointerdown", i), () => {
    n.domElement.removeEventListener("pointerdown", i);
  }), [i]), e;
}, YC = () => {
  const n = KC();
  R(() => {
    const e = document.getElementsByTagName("body")[0];
    return n && (e.style.userSelect = "none"), () => {
      e.style.userSelect = "";
    };
  }, [n]);
};
function XC({ children: n }) {
  const e = oe(), t = ve(null);
  return R(() => {
    t.current !== null && t.current.appendChild(e.domElement);
  }, [t.current]), YC(), /* @__PURE__ */ u("div", { style: { width: "100%", height: "100%", overflow: "hidden" }, ref: t, children: Sy(n, e.domElement) });
}
function HO({ children: n, ...e }) {
  return /* @__PURE__ */ u(qC, { ...e, children: /* @__PURE__ */ u(XC, { children: n }) });
}
const ZC = ({
  revisionCount: n,
  revisionDetailsExpanded: e,
  setRevisionDetailsExpanded: t,
  fallbackLanguage: i
}) => {
  const { t: s } = W(i), o = () => {
    t(!e);
  };
  return /* @__PURE__ */ u(JC, { isExpanded: e, children: /* @__PURE__ */ u(ce, { content: s({ key: "IMAGES_360_DETAILS_TOOLTIP" }), children: /* @__PURE__ */ _(QC, { onClick: o, isExpanded: e, children: [
    !e && /* @__PURE__ */ _(Da, { type: "tertiary", children: [
      s({ key: "IMAGES_360_DETAILS" }),
      /* @__PURE__ */ u(cd, { counter: n, label: " Historic" })
    ] }),
    e && /* @__PURE__ */ u(Da, { type: "tertiary", children: s({ key: "IMAGES_360_DETAILS" }) })
  ] }) }) });
}, Da = b(J)`
  && {
    border-radius: 6px;
    border: 0px !important;
    width: fit-content;
    padding: 0px !important;
    grid-gap: 6px;

    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
  }
`, QC = b.div`
  left: 30px;
  bottom: 30px;
  display: flex;
  flex-direction: row;
  background: #ffffff;
`, JC = b.div`
  position: relative;
  left: calc(100% - 200px);
  width: fit-content;
  height: 28px;
  background-color: white;
  padding: 8px 10px;
  align-items: center;
  display: flex;
  border-radius: 6px;

  ${({ isExpanded: n }) => n && `
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  `}
`, eI = ({
  imageUrl: n,
  isActive: e,
  isLoading: t
}) => {
  const i = P(() => n !== void 0 ? /* @__PURE__ */ u("div", { children: /* @__PURE__ */ u("img", { src: n, alt: "thumbnail" }) }) : t ? /* @__PURE__ */ u(Wi, {}) : /* @__PURE__ */ u(rm, {}), [n, t]);
  return /* @__PURE__ */ _(tI, { isActive: e, children: [
    " ",
    i,
    " "
  ] });
}, tI = b.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  width: 160px;
  min-width: 56px;
  height: 90px;
  border: 2px solid #d9d9d9;
  border-radius: 12px;
  gap: 6px;

  img {
    max-height: 100%;
    max-width: 100%;
  }

  svg {
    color: #0000008c;
  }

  ${({ isActive: n }) => n && `
    border: 4px solid #4A67FB;
  `}
`, _p = Xc(
  ({
    stationId: n,
    stationName: e,
    revisionCollection: t,
    activeRevision: i,
    setActiveRevision: s,
    viewer: o,
    fallbackLanguage: r
  }, a) => {
    const { t: c } = W(r), d = ve(null), l = async (f, g) => {
      if (o !== void 0 && f.image360Entity !== void 0) {
        s(g);
        const C = f.image360Entity.getRevisions(), v = f.index;
        v >= 0 && v < C.length && await o.enter360Image(f.image360Entity, C[v]);
      }
    };
    function h(f) {
      return f.current !== void 0;
    }
    function p(f) {
      h(a) && (a.current = f.currentTarget.scrollLeft);
    }
    return R(() => {
      d.current !== null && h(a) && (d.current.scrollLeft = a.current);
    }, []), /* @__PURE__ */ _(cI, { children: [
      /* @__PURE__ */ _(iI, { direction: "column", children: [
        /* @__PURE__ */ u(nI, { children: e }),
        /* @__PURE__ */ _(sI, { children: [
          c({ key: "IMAGES_360_STATION" }),
          " ",
          n
        ] })
      ] }),
      /* @__PURE__ */ u(oI, { onScroll: p, ref: d, children: /* @__PURE__ */ u(rI, { children: t.map((f, g) => /* @__PURE__ */ _(
        aI,
        {
          onClick: () => {
            l(f, g);
          },
          children: [
            /* @__PURE__ */ u(
              eI,
              {
                isActive: i === g,
                imageUrl: f.imageUrl,
                isLoading: !1
              },
              g
            ),
            /* @__PURE__ */ u(tt, { size: "x-small", style: { height: "16px" }, children: f.date })
          ]
        },
        Ho()
      )) }) })
    ] });
  }
);
_p.displayName = "Image360HistoricalSummary";
const nI = b(U)`
  align-items: flex-start;
  margin-bottom: 10px;

  //Restrict text length
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
`, iI = b(U)`
  max-width: 25%;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: -0.014em;
  font-feature-settings: 'cv05' on;
  color: rgba(0, 0, 0, 0.9);
`, sI = b(tt).attrs({
  size: "x-small"
})`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.006em;
  font-feature-settings: 'ss04' on;
  color: rgba(0, 0, 0, 0.9);

  //Restrict text length
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
`, oI = b.div`
  width: 70%;
  height: fit-content;
  overflow-x: auto;
  padding: 0 0 5px 0;

  /* Customize scrollbar styles */
  scrollbar-width: thin;
  scrollbar-color: #999999 #d9d9d9;

  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background-color: #d9d9d9;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #999999;
    border-radius: 2px;
  }
`, rI = b.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 6px;
  justify-content: flex-end;
  min-width: fit-content;
`, aI = b.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0.8;
  gap: 10px;
`, cI = b.div`
  display: flex;
  height: fit-content;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  padding: 16px 16px 8px 16px;
  background: #ffffff;
  box-shadow: 0px -4px 12px rgba(0, 0, 0, 0.25);
`, dI = (n) => {
  if (n === void 0)
    return "";
  const e = n.getFullYear(), t = String(n.getMonth() + 1).padStart(2, "0"), i = String(n.getDate()).padStart(2, "0"), s = String(n.getHours()).padStart(2, "0"), o = String(n.getMinutes()).padStart(2, "0");
  return `${e}.${t}.${i} ${s}:${o}`;
};
function lI(n) {
  const e = n.id;
  return typeof e == "string" ? e : e.externalId;
}
const uI = ({
  viewer: n,
  image360Entity: e,
  onExpand: t,
  fallbackLanguage: i
}) => {
  const [s, o] = M(!1), [r, a] = M(0), [c, d] = M([]), [l, h] = M([]), [p, f] = M("100px"), g = ve(0);
  return R(() => ((async () => {
    if (e !== void 0) {
      const v = e.getRevisions(), w = v.map((O) => O.date), x = await Promise.all(
        v.map(async (O) => await O.getPreviewThumbnailUrl())
      );
      h(x);
      const T = w.map((O, S) => ({
        date: dI(O),
        imageUrl: x[S],
        index: S,
        image360Entity: e
      }));
      g.current = 0, d(T), a(0);
    }
  })(), () => {
    l.forEach((v) => {
      v !== void 0 && URL.revokeObjectURL(v);
    }), h([]);
  }), [e]), R(() => {
    f(s ? "100%" : "100px"), t !== void 0 && t(s);
  }, [s]), /* @__PURE__ */ u(hI, { style: { minWidth: p }, children: /* @__PURE__ */ _(k, { children: [
    /* @__PURE__ */ u(
      ZC,
      {
        revisionCount: c.length,
        revisionDetailsExpanded: s,
        setRevisionDetailsExpanded: o,
        fallbackLanguage: i
      },
      Ho()
    ),
    s && /* @__PURE__ */ u(
      _p,
      {
        ref: g,
        viewer: n,
        stationId: e !== void 0 ? lI(e) : void 0,
        stationName: e == null ? void 0 : e.label,
        activeRevision: r,
        setActiveRevision: a,
        revisionCollection: c,
        fallbackLanguage: i
      },
      Ho()
    )
  ] }) });
}, hI = b.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: fit-content;
  width: 100%;
`, Tp = () => {
  const n = oe(), { reveal3DResourcesCount: e } = nn();
  return P(() => n.get360ImageCollections(), [n, e]);
};
function qO({
  appLanguage: n,
  enableExitButton: e = !0
}) {
  const t = oe(), [i, s] = M(), [o, r] = M(!1), a = Z((h) => {
    r(h);
  }, []), c = Z(() => {
    s(void 0);
  }, [s]), d = Z(() => {
    t.exit360Image();
  }, [t]), l = Tp();
  return R(() => (l.forEach((h) => {
    h.on("image360Entered", s), h.on("image360Exited", c);
  }), () => {
    l.forEach((h) => {
      h.off("image360Entered", s), h.off("image360Exited", c);
    });
  }), [t, l, s, c]), /* @__PURE__ */ u(k, { children: i !== void 0 && /* @__PURE__ */ _(k, { children: [
    /* @__PURE__ */ u(gI, { isExpanded: o, children: /* @__PURE__ */ u(
      uI,
      {
        viewer: t,
        image360Entity: i,
        onExpand: a,
        fallbackLanguage: n
      }
    ) }),
    e && /* @__PURE__ */ u(fI, { children: /* @__PURE__ */ u(
      pI,
      {
        icon: /* @__PURE__ */ u(dd, {}),
        type: "tertiary",
        onClick: d
      }
    ) })
  ] }) });
}
const pI = b(J)`
  border-radius: 8px;
`, fI = b.div`
  position: absolute;
  right: 20px;
  top: 20px;
  background-color: #ffffff;
  height: 36px;
  width: 36px;
  border-radius: 8px;
  outline: none;
`, gI = b.div`
  position: absolute;
  bottom: ${({ isExpanded: n }) => n ? "0px" : "40px"};
  display: flex;
  flex-direction: column;
  height: fit-content;
  width: fit-content;
  max-width: 100%;
  min-width: 100%;
  transition: transform 0.25s ease-in-out;
  transform: ${({ isExpanded: n }) => n ? "translateY(0)" : "translateY(100%)"};
  z-index: 100;
`, mI = ({
  position: n,
  children: e,
  style: t,
  sticky: i,
  stickyMargin: s
}) => {
  const o = oe(), r = s ?? 0, { projectedPoint: a, visible: c } = yI(n, o), d = ve(null), l = vI(
    d,
    o.domElement,
    i ?? !1,
    r,
    a
  ), h = II(a, l, t);
  return c ? /* @__PURE__ */ u(
    "div",
    {
      ref: d,
      style: {
        ...h,
        position: "absolute",
        left: "0px",
        top: "0px"
      },
      children: e
    }
  ) : /* @__PURE__ */ u(k, {});
};
function yI(n, e) {
  const [t, i] = M(new Ct()), [s, o] = M(!1), r = Z(
    (a, c) => {
      const d = c.clone().sub(a).normalize(), l = n.clone().sub(a).normalize();
      o(l.dot(d) > 0);
      const h = e.worldToScreen(n.clone());
      h !== null && i(h);
    },
    [e, n]
  );
  return R(() => (e.cameraManager.on("cameraChange", r), r(
    e.cameraManager.getCameraState().position,
    e.cameraManager.getCameraState().target
  ), () => {
    e.cameraManager.off("cameraChange", r);
  }), [r]), { visible: s, projectedPoint: t };
}
function vI(n, e, t, i, s) {
  const [o, r] = M(new Ct());
  return R(() => {
    if (t && n.current !== null) {
      const a = CI(
        n.current.getBoundingClientRect(),
        e.getBoundingClientRect(),
        o,
        i
      );
      a.equals(o) || r(a);
    } else
      r(new Ct());
  }, [
    s.x,
    s.y,
    t,
    i,
    e.clientWidth,
    e.clientHeight
  ]), o;
}
function CI(n, e, t, i) {
  const s = t.clone(), o = new DOMRect(
    n.left - e.left - t.x,
    n.top - e.top - t.y,
    n.width,
    n.height
  ), r = i, a = e.width - o.width - i, c = i, d = e.height - o.height - i;
  return s.x = Di(
    0,
    r - o.left,
    a - o.left
  ), s.y = Di(
    0,
    c - o.top,
    d - o.top
  ), Math.min(
    a - o.left,
    Math.max(r - o.left, 0)
  ), s;
}
function II(n, e, t) {
  const i = `translateX(calc(${n.x}px + ${e.x}px))
translateY(calc(${n.y}px + ${e.y}px))`, s = { ...t }, o = s.transform;
  return s.transform = `${o ?? ""} ${i}`, s;
}
function $O({ children: n }) {
  const e = ve(), t = ve(!1), i = ve();
  return R(() => () => {
    var s;
    (s = e.current) == null || s.dispose(), e.current = void 0;
  }, []), /* @__PURE__ */ u(
    Rh.Provider,
    {
      value: {
        renderTargetRef: e,
        isRevealContainerMountedRef: t,
        sceneLoadedRef: i
      },
      children: n
    }
  );
}
const WO = ({ options: n }) => {
  const e = oe();
  return R(() => {
    const t = new by(n);
    return t.connect(e), () => {
      t.dispose();
    };
  }, [e, n]), /* @__PURE__ */ u(k, {});
}, wI = ({
  header: n,
  type: e,
  title: t,
  subtitle: i,
  children: s,
  alignActions: o
}) => /* @__PURE__ */ _(xI, { className: "widget-header", children: [
  !!(n ?? t ?? i) && /* @__PURE__ */ u(TI, { children: /* @__PURE__ */ _(SI, { children: [
    e !== void 0 && n !== void 0 && /* @__PURE__ */ u(ce, { content: e, children: /* @__PURE__ */ u(AI, { type: "Component" }) }),
    /* @__PURE__ */ _("div", { children: [
      /* @__PURE__ */ u(bI, { children: n }),
      /* @__PURE__ */ u(tt, { size: "small", children: i })
    ] })
  ] }) }),
  /* @__PURE__ */ u(_I, { align: o ?? "right", children: s })
] }), xI = b.div`
  min-height: 48px;
  display: flex;
  padding: 0px 0px 0px 10px;

  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`, _I = b.div`
  ${({ align: n }) => n === "left" ? ca`
          justify-content: flex-start;
        ` : ca`
          justify-content: flex-end;
        `};

  width: 100%;
  display: flex;
  gap: 8px;
  padding: 10px;
`, TI = b.div`
  width: 70%;
`, SI = b.div`
  display: flex;
  gap: 4px;
  align-items: center;
  & > * {
    min-width: 0;
  }

  .cogs-tooltip__content {
    display: flex;
  }
`, bI = b(tt)`
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`, AI = b(am)`
  height: 16px !important;
  size: 36px !important;
`, EI = ({ children: n, ...e }, t) => /* @__PURE__ */ u(MI, { ref: t, ...e, children: n }), MI = b.div`
  height: 100%;
  min-width: 20%;
  min-height: 10%;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  background-color: white;
`, Xo = Eg.forwardRef(EI);
Xo.Header = wI;
const ka = 150, PI = 75, OI = 0.4, RI = 0.7, Sp = 400, DI = 48, kI = 150;
function En(n) {
  return function(t) {
    const i = ve(null), s = (o) => {
      o.stopPropagation();
    };
    return R(() => {
      const o = i.current;
      if (o !== null)
        return o.addEventListener("dblclick", s), o.addEventListener("pointerdown", s), o.addEventListener("wheel", s), o.addEventListener("keydown", s), () => {
          o.removeEventListener("dblclick", s), o.removeEventListener("pointerdown", s), o.removeEventListener("wheel", s), o.removeEventListener("keydown", s);
        };
    }, []), /* @__PURE__ */ u("div", { ref: i, children: /* @__PURE__ */ u(n, { ...t }) });
  };
}
const LI = b.div`
  width: 100%;
  height: 100%;
  padding: 0px 10px 10px 10px;
`, NI = b.div`
  height: 100%;
  overflow: auto;
`, BI = b.div`
  position: absolute;
  left: ${({ isMinimized: n }) => n ? "auto" : "calc(60% - 20px)"};
  right: ${({ isMinimized: n }) => n ? "0px" : "auto"};
  top: 50px;
  width: ${({ isMinimized: n }) => n ? "300px" : "100%"};
  height: auto;
  min-width: 20%;
  min-height: 10%;
  max-width: ${({ isMinimized: n }) => n ? "300px" : "100%"};
`, KO = ({
  title: n,
  subtitle: e,
  header: t,
  type: i,
  children: s,
  headerElement: o,
  onClose: r,
  onResize: a
}) => {
  const { t: c } = W(), [d, l] = M(!1), [h, p] = M({ x: 0, y: 0 }), g = oe().domElement, C = FI(g, d, a);
  if (g === void 0)
    return /* @__PURE__ */ u(k, {});
  const v = () => {
    d || p({ x: 0, y: 0 }), l((O) => !O);
  }, w = () => {
    r == null || r();
  }, x = (O, S) => {
    O.stopPropagation();
    const { x: E, y: B, node: L } = S, { left: le, top: N, width: ee } = L.getBoundingClientRect(), {
      width: ie,
      height: ue,
      left: Ze,
      top: pi
    } = g.getBoundingClientRect();
    le + ee - ka < Ze || N < pi || le + ka > Ze + ie || N + PI > pi + ue || p({ x: E, y: B });
  }, T = (O, S) => {
    const { size: E } = S;
    a == null || a(E.width, E.height);
  };
  return /* @__PURE__ */ u(
    VI,
    {
      isMinimized: d,
      style: d ? {
        position: "absolute",
        right: "10px"
      } : {},
      children: /* @__PURE__ */ u(Ay, { onDrag: x, position: h, handle: ".widget-header", children: /* @__PURE__ */ u(
        Ey,
        {
          width: C.width,
          height: C.height,
          minConstraints: [Sp, kI],
          maxConstraints: [g.clientWidth, g.clientHeight],
          resizeHandles: d ? [] : ["se", "ne", "e", "s"],
          onResize: T,
          children: /* @__PURE__ */ _(Xo, { children: [
            /* @__PURE__ */ _(Xo.Header, { title: n, type: i, header: t, subtitle: e, children: [
              o !== void 0 && o,
              /* @__PURE__ */ u(
                ce,
                {
                  content: c(d ? { key: "WIDGET_WINDOW_EXPAND" } : { key: "WIDGET_WINDOW_MINIMIZE" }),
                  placement: "top",
                  children: /* @__PURE__ */ u(
                    J,
                    {
                      type: "ghost",
                      icon: d ? /* @__PURE__ */ u(cm, {}) : /* @__PURE__ */ u(dm, {}),
                      onClick: v
                    }
                  )
                }
              ),
              /* @__PURE__ */ u(ce, { content: c({ key: "WIDGET_WINDOW_CLOSE" }), placement: "top", children: /* @__PURE__ */ u(J, { type: "ghost", icon: /* @__PURE__ */ u(ld, {}), onClick: w }) })
            ] }),
            /* @__PURE__ */ u(NI, { children: !d && /* @__PURE__ */ u(LI, { children: s }) })
          ] })
        }
      ) })
    }
  );
}, FI = (n, e, t) => {
  const [i, s] = M({ width: 0, height: 0 });
  return R(() => {
    if (n === void 0)
      return;
    const o = () => {
      const a = n.clientWidth, c = n.clientHeight, d = e ? Sp : a * OI, l = e ? DI : c * RI;
      s({ width: d, height: l }), t == null || t(d, l);
    };
    o();
    const r = new ResizeObserver(o);
    return r.observe(n), () => {
      r.disconnect();
    };
  }, [e, n]), i;
}, VI = En(BI), YO = ({
  Content: n
}) => {
  const e = me(), [t, i] = M(0);
  Vi.setCounterDelegate(i);
  const s = e.contextMenuController.contextMenuPositionData;
  return s === void 0 ? /* @__PURE__ */ u(k, {}) : /* @__PURE__ */ u(
    jI,
    {
      $position: s.position,
      onClick: () => {
        e.contextMenuController.contextMenuPositionData = void 0;
      },
      children: /* @__PURE__ */ u(n, { contextMenuData: s })
    }
  );
}, jI = En(b.div`
  position: absolute;
  left: ${(n) => n.$position.x}px;
  top: ${(n) => n.$position.y}px;
`);
class bp extends z {
  get icon() {
    return "ExpandAlternative";
  }
  get tooltip() {
    return { key: "FIT_VIEW_TOOLTIP" };
  }
  invokeCore() {
    const { renderTarget: e } = this;
    return e.fitView();
  }
}
class Xn extends z {
  // False if part of a group
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e, t = !0) {
    super(), this._value = e, this._standAlone = t;
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get shortCutKey() {
    switch (this._value) {
      case qe.FirstPerson:
        return "2";
      case qe.Orbit:
        return "1";
      default:
        return super.shortCutKey;
    }
  }
  equals(e) {
    return e instanceof Xn ? this._value === e._value : !1;
  }
  get icon() {
    switch (this._value) {
      case qe.FirstPerson:
        return "Plane";
      case qe.Orbit:
        return "Circle";
      case qe.OrbitInCenter:
        return "Coordinates";
      default:
        return;
    }
  }
  get tooltip() {
    switch (this._value) {
      case qe.FirstPerson:
        return { key: "CONTROLS_TYPE_FIRST_PERSON" };
      case qe.Orbit:
        return { key: "CONTROLS_TYPE_ORBIT" };
      case qe.OrbitInCenter:
        return { key: "CONTROLS_TYPE_ORBIT_IN_CENTER" };
      default:
        return super.tooltip ?? { untranslated: "" };
    }
  }
  get isChecked() {
    return this._value === this.currentControlsType();
  }
  invokeCore() {
    return this._value === this.currentControlsType() ? !1 : (this.currentControlsType(this._value), !0);
  }
  attach(e) {
    super.attach(e), this._standAlone && this.addDisposable(
      $i(() => {
        this.currentControlsType(), this.update();
      })
    );
  }
  get currentControlsType() {
    return this.renderTarget.revealSettingsController.cameraControlsType;
  }
}
class zI extends z {
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { key: "SHOW_OR_HIDE_AXIS" };
  }
  get icon() {
    return "Axis3D";
  }
  get isEnabled() {
    return !0;
  }
  get isToggle() {
    return !0;
  }
  get isChecked() {
    const { renderTarget: e, rootDomainObject: t } = this, i = t.getDescendantByType(wi);
    return i === void 0 ? !1 : i.isVisible(e);
  }
  invokeCore() {
    const { renderTarget: e, rootDomainObject: t } = this;
    let i = t.getDescendantByType(wi);
    return i === void 0 && (i = new wi(), t.addChildInteractive(i)), i.toggleVisibleInteractive(e), !0;
  }
}
var y = /* @__PURE__ */ ((n) => (n[n.None = 0] = "None", n[n.Line = 1] = "Line", n[n.Polyline = 2] = "Polyline", n[n.Polygon = 3] = "Polygon", n[n.HorizontalArea = 4] = "HorizontalArea", n[n.VerticalArea = 5] = "VerticalArea", n[n.Box = 6] = "Box", n[n.Cylinder = 7] = "Cylinder", n[n.HorizontalCircle = 8] = "HorizontalCircle", n[n.HorizontalCylinder = 9] = "HorizontalCylinder", n[n.VerticalCylinder = 10] = "VerticalCylinder", n[n.PlaneX = 11] = "PlaneX", n[n.PlaneY = 12] = "PlaneY", n[n.PlaneZ = 13] = "PlaneZ", n[n.PlaneXY = 14] = "PlaneXY", n))(y || {});
class Mn extends Qi {
  constructor() {
    super(...arguments), this._dragger = void 0;
  }
  // ==================================================
  // OVERRIDES of BaseTool
  // ==================================================
  get defaultCursor() {
    return "crosshair";
  }
  clearDragging() {
    super.clearDragging(), this._dragger = void 0;
  }
  async onLeftPointerDown(e) {
    if (this._dragger = await this.createDragger(e), this._dragger === void 0) {
      await super.onLeftPointerDown(e);
      return;
    }
    this._dragger.onPointerDown(e), this.deselectAll(this._dragger.domainObject), this._dragger.domainObject.setSelectedInteractive(!0);
  }
  async onLeftPointerDrag(e) {
    if (this._dragger === void 0) {
      await super.onLeftPointerDrag(e);
      return;
    }
    const t = this.getRay(e, !0);
    this._dragger.onPointerDrag(e, t) && (this._dragger.isChanged = !0);
  }
  async onLeftPointerUp(e) {
    this._dragger === void 0 ? await super.onLeftPointerUp(e) : (this._dragger.onPointerUp(e), this._dragger.isChanged && this.addTransaction(this._dragger.transaction), this._dragger = void 0);
  }
  onActivate() {
    super.onActivate();
    const e = this.getSelected();
    Cn.show(e);
  }
  onDeactivate() {
    super.onDeactivate(), Cn.hide();
  }
  // ==================================================
  // VIRTUAL METHODS
  // ==================================================
  /**
   * Determines whether the specified domain object can be selected or dragged by this edit tool.
   * Override this function of the selection mechanism should be used.
   * @param domainObject - The domain object to be accepted.
   * @returns `true` if the domain object can be accepted, `false` otherwise.
   */
  canBeSelected(e) {
    return !1;
  }
  /**
   * Override this function to create custom dragger
   * with other creation logic.
   */
  async createDragger(e) {
    const t = await this.getIntersection(e);
    if (t === void 0 || !It(t))
      return;
    const i = this.getIntersectedSelectableDomainObject(t);
    if (i === void 0)
      return;
    const s = this.getRay(e), o = this.renderTarget.fromViewerMatrix, r = t.point.clone();
    return r.applyMatrix4(o), s.applyMatrix4(o), i.createDragger({ intersection: t, point: r, ray: s });
  }
  /**
   * Deselects all selectable objects except for the specified object.
   * If no object is specified, all visual domain objects will be deselected.
   * @param except - The visual domain object to exclude from deselection.
   */
  deselectAll(e) {
    for (const t of this.getSelectable())
      e !== void 0 && t === e || t.setSelectedInteractive(!1);
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  *getSelectable() {
    const { rootDomainObject: e } = this;
    for (const t of e.getDescendantsByType(Me))
      this.canBeSelected(t) && (yield t);
  }
  *getSelectableByType(e) {
    for (const t of this.getSelectable())
      Oe(t, e) && (yield t);
  }
  /**
   * Retrieves the selected VisualDomainObject.
   * Use only if single selection is expected.
   * @returns The selected DomainObject, or undefined if no object is selected.
   */
  getSelected() {
    for (const e of this.getSelectable())
      if (e.isSelected)
        return e;
  }
  /**
   * Retrieves all selected domain objects.
   * Use only if multi selection is expected.
   * @returns A generator that yields each selected domain object.
   */
  *getAllSelected() {
    for (const e of this.getSelectable())
      e.isSelected && (yield e);
  }
  /**
   * Sets the visibility of all selectable objects.
   * @param visible - A boolean indicating whether the objects should be visible or not.
   */
  setAllVisible(e) {
    for (const t of this.getSelectable())
      t.setVisibleInteractive(e, this.renderTarget);
  }
  /**
   * Retrieves the intersected visual domain object from the given intersection.
   * @param intersection - The intersection to retrieve the domain object from.
   * @returns The intersected visual domain object, or undefined if no valid domain object is found.
   */
  getIntersectedSelectableDomainObject(e) {
    if (!It(e))
      return;
    const { domainObject: t } = e;
    if (t instanceof Me && this.canBeSelected(t))
      return t;
  }
}
function UI(n) {
  return n.activeTool instanceof Mn;
}
class Qt extends An {
  constructor() {
    super(...arguments), this.depthTest = !0;
  }
}
class be {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e = 0) {
    if (this._face = 0, !La(e))
      throw new Error("Invalid face in constructor " + e);
    this._face = e;
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get face() {
    return this._face;
  }
  set face(e) {
    if (!La(e))
      throw new Error("Invalid face in setter" + e);
    this._face = e;
  }
  /**
   * Gets the axis index corresponding to this face.
   * @returns The axis index (0 for X, 1 for Y, 2 for Z).
   */
  get index() {
    return this._face % 3;
  }
  /**
   * Gets the tangent index 1 corresponding to this face.
   * @returns The axis index (0 for X, 1 for Y, 2 for Z).
   */
  get tangentIndex1() {
    return (this.index + 1) % 3;
  }
  /**
   * Gets the tangent index 2 corresponding to this face.
   * @returns The axis index (0 for X, 1 for Y, 2 for Z).
   */
  get tangentIndex2() {
    return (this.index + 2) % 3;
  }
  /**
   * Gets the sign of the face.
   * Returns `1` if the face index is less than 3, otherwise returns `-1`.
   * This can be used to determine the orientation of the box face.
   */
  get sign() {
    return this._face < 3 ? 1 : -1;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  copy(e) {
    return this._face = e._face, this;
  }
  equals(e) {
    return this.face === e.face;
  }
  /**
   * Determines the box face corresponding to the given position vector relative to the box center.
   * The face is selected based on the axis with the largest absolute value in the position vector.
   *
   * - If the x component is largest, sets the face to 0 (positive x) or 3 (negative x).
   * - If the y component is largest, sets the face to 1 (positive y) or 4 (negative y).
   * - If the z component is largest, sets the face to 2 (positive z) or 5 (negative z).
   *
   * @param positionAtFace - The position vector relative to the box center.
   * @returns The current instance with the updated face.
   */
  fromPositionAtFace(e) {
    const t = Math.abs(e.x), i = Math.abs(e.y), s = Math.abs(e.z);
    return t >= i && t >= s ? this._face = e.x > 0 ? 0 : 3 : i >= t && i >= s ? this._face = e.y > 0 ? 1 : 4 : this._face = e.z > 0 ? 2 : 5, this;
  }
  /**
   * Projects a 3D point onto the 2D plane corresponding to the current box face.
   *
   * The mapping of the 3D coordinates to 2D depends on the value of `this.face`:
   * - For faces 1 and 4, returns (x, z).
   * - For faces 2 and 5, returns (x, y).
   * - For all other faces, returns (y, z).
   *
   * @param positionAtFace - The 3D position to project onto the face's plane.
   * @returns A `Vector2` representing the projected 2D coordinates on the face's plane.
   */
  getPlanePoint(e) {
    switch (this.face) {
      case 1:
      case 4:
        return new Ct(e.x, e.z);
      case 2:
      case 5:
        return new Ct(e.x, e.y);
      default:
        return new Ct(e.y, e.z);
    }
  }
  getNormal(e) {
    return e === void 0 && (e = new I()), e.setScalar(0), e.setComponent(this.index, this.sign);
  }
  getTangent1(e) {
    return e === void 0 && (e = new I()), e.setScalar(0), e.setComponent(this.tangentIndex1, 1);
  }
  getTangent2(e) {
    return e === void 0 && (e = new I()), e.setScalar(0), e.setComponent(this.tangentIndex2, 1);
  }
  getCenter(e) {
    return e === void 0 && (e = new I()), e.setScalar(0), e.setComponent(this.index, this.sign * 0.5);
  }
  // ==================================================
  // STATIC METHODS
  // ==================================================
  static *getAllFaces(e) {
    e === void 0 && (e = new be());
    for (let t = 0; t < 6; t++)
      e.face = t, yield e;
  }
  static createClippingPlanes(e, t) {
    const i = [], s = new I(), o = new I();
    for (const r of be.getAllFaces()) {
      if (t !== void 0 && r.index === t)
        continue;
      r.getCenter(s), r.getNormal(o).negate();
      const a = new ot().setFromNormalAndCoplanarPoint(o, s);
      a.applyMatrix4(e), i.push(a);
    }
    return i;
  }
  static equals(e, t) {
    return e === void 0 ? t === void 0 : t === void 0 ? !1 : e.equals(t);
  }
}
function La(n) {
  return n >= 0 && n <= 5;
}
function es(n) {
  switch (n) {
    case y.Line:
      return "VectorLine";
    case y.Polyline:
      return "VectorZigzag";
    case y.Polygon:
      return "Polygon";
    case y.PlaneX:
      return "CubeFrontLeft";
    case y.PlaneY:
      return "CubeFrontRight";
    case y.PlaneZ:
      return "CubeTop";
    case y.PlaneXY:
      return "Perspective";
    case y.HorizontalArea:
      return "PerspectiveAlt";
    case y.VerticalArea:
      return "Perspective";
    case y.Box:
      return "Cube";
    case y.HorizontalCircle:
      return "Circle";
    case y.Cylinder:
      return "CylinderArbitrary";
    case y.VerticalCylinder:
      return "CylinderVertical";
    case y.HorizontalCylinder:
      return "CylinderHorizontal";
    case y.None:
      return "Cursor";
    default:
      throw new Error("Unrecognized PrimitiveType");
  }
}
class Ap {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e, t) {
    this.timeStamp = Date.now(), this.uniqueId = e.uniqueId, this.changed = t;
    const i = e.parent;
    i !== void 0 && (this._parentUniqueId = i.uniqueId);
  }
  // ==================================================
  // INSTANCE METHODS
  // =================================================
  undo(e) {
    const t = e.rootDomainObject, i = this.changed === m.deleted ? this._parentUniqueId : this.uniqueId;
    if (i === void 0)
      return !1;
    const s = t.getThisOrDescendantByUniqueId(i);
    return s === void 0 ? !1 : (this.undoCore(s, e), !0);
  }
}
class ts extends Ap {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e, t) {
    super(e, t), t === m.deleted ? this.copy = e.clone() : t !== m.added && (this.copy = e.clone(t));
  }
  // ==================================================
  // VIRTUAL METHODS (To be overridden)
  // =================================================
  undoCore(e, t) {
    switch (this.changed) {
      case m.added:
        e.removeInteractive();
        break;
      case m.deleted: {
        if (this.copy === void 0)
          return !1;
        const i = this.copy;
        e.addChildInteractive(i), i.setVisibleInteractive(!0, t);
        break;
      }
      default:
        if (this.copy === void 0)
          return !1;
        e.copyFrom(this.copy, this.changed), e.notify(this.changed), e.setVisibleInteractive(!0, t);
        break;
    }
    return !0;
  }
}
const sa = class sa extends Me {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor() {
    super(), this.focusFace = void 0;
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get renderStyle() {
    return this.getRenderStyle();
  }
  // ==================================================
  // OVERRIDES of DomainObject
  // ==================================================
  get icon() {
    return es(this.primitiveType);
  }
  createTransaction(e) {
    return new ts(this, e);
  }
  // ==================================================
  // OVERRIDES of VisualDomainObject
  // ==================================================
  setFocusInteractive(e, t) {
    const i = this.focusType === A.Pending && e !== A.Pending;
    if (e === A.None) {
      if (this.focusType === A.None)
        return !1;
      this.focusType = A.None, this.focusFace = void 0;
    } else {
      if (e === this.focusType && be.equals(this.focusFace, t))
        return !1;
      this.focusType = e, this.focusFace = t;
    }
    return this.notify(m.focus), i && this.notify(m.geometry), !0;
  }
  clear() {
    this.focusType = A.None, this.focusFace = void 0;
  }
};
sa.GizmoOnly = "GizmoOnly";
let bt = sa;
class Mr extends Mn {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e = y.None) {
    super(), this._creator = void 0, this.primitiveType = e, this._defaultPrimitiveType = e;
  }
  get isSelectMode() {
    return this.primitiveType === y.None;
  }
  // ==================================================
  // OVERRIDES of BaseTool
  // ==================================================
  onDeactivate() {
    this.escape(), super.onDeactivate();
  }
  clearDragging() {
    super.clearDragging(), this._creator = void 0;
  }
  onDeleteKey() {
    const e = this.getSelected();
    e !== void 0 && (this.addTransaction(e.createTransaction(m.deleted)), e.removeInteractive()), this._creator = void 0;
  }
  onEscapeKey() {
    const e = this.isSelectMode;
    this.escape(), Ie.update(this.renderTarget), e && super.onEscapeKey();
  }
  async onHoverByDebounce(e) {
    if (!this.isSelectMode) {
      if (this._creator !== void 0) {
        const { _creator: s } = this;
        if (!s.preferIntersection) {
          const a = this.getRay(e);
          if (s.addPoint(a, void 0, !0)) {
            this.setDefaultCursor();
            return;
          }
        }
        const o = await this.getIntersection(e);
        if (o === void 0) {
          if (s !== void 0 && s.preferIntersection) {
            const a = this.getRay(e);
            if (s.addPoint(a, void 0, !0)) {
              this.setDefaultCursor();
              return;
            }
          }
          this.renderTarget.setNavigateCursor();
          return;
        }
        if (this.getIntersectedSelectableDomainObject(o) !== void 0) {
          this.renderTarget.setNavigateCursor();
          return;
        }
        const r = this.getRay(e);
        if (s.addPoint(r, o.point, !0)) {
          this.setDefaultCursor();
          return;
        }
        this.renderTarget.setNavigateCursor();
        return;
      } else if (await this.tryStartOnHover(e))
        return;
    }
    const t = await this.getIntersection(e), i = this.getIntersectedSelectableDomainObject(t);
    if (!It(t) || i === void 0) {
      this.defocusAll(), this.isSelectMode || t === void 0 ? this.renderTarget.setNavigateCursor() : this.setDefaultCursor();
      return;
    }
    this.setFocus(i, t);
  }
  async onClick(e) {
    const { renderTarget: t } = this;
    let i = this._creator;
    if (i !== void 0 && !i.preferIntersection) {
      const r = this.getRay(e);
      if (i.addPoint(r)) {
        this.endCreatorIfFinished(i);
        return;
      }
    }
    const s = await this.getIntersection(e);
    if (s === void 0)
      return;
    if (i !== void 0) {
      const r = this.getRay(e);
      i.addPoint(r, s.point) && this.endCreatorIfFinished(i);
      return;
    }
    const o = this.getIntersectedSelectableDomainObject(s);
    if (o !== void 0) {
      this.deselectAll(o), o.setSelectedInteractive(!0);
      return;
    }
    if (i === void 0) {
      if (i = this.createCreator(), i === void 0) {
        await super.onClick(e);
        return;
      }
      const r = this.getRay(e);
      if (!i.addPoint(r, s.point))
        return;
      const { domainObject: a } = i;
      this.initializeStyle(a), this.deselectAll(), this.getOrCreateParent().addChildInteractive(a), a.setSelectedInteractive(!0), a.setVisibleInteractive(!0, t), this.addTransaction(a.createTransaction(m.added)), this._creator = i;
    }
    this.endCreatorIfFinished(i);
  }
  async onLeftPointerDown(e) {
    this._creator === void 0 && await super.onLeftPointerDown(e);
  }
  onUndo() {
    if (this._creator === void 0)
      return;
    const e = this._creator.domainObject;
    e !== void 0 && !e.isLegal && (e.hasParent && e.removeInteractive(), this._creator = void 0);
  }
  // ==================================================
  // VIRTUAL METHODS
  // ==================================================
  createCreator() {
  }
  getOrCreateParent() {
    return this.rootDomainObject;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  escape() {
    this._creator !== void 0 && this._creator.escape() ? this.endCreatorIfFinished(this._creator, !0) : (this.setDefaultPrimitiveType(), this._creator = void 0);
  }
  setFocus(e, t) {
    if (e instanceof bt) {
      const s = t.userData;
      if (s === void 0) {
        this.defocusAll(), this.renderTarget.cursor = void 0;
        return;
      }
      this.defocusAll(e), e.setFocusInteractive(s.focusType, s.face);
    } else
      this.defocusAll(e), e.setFocusInteractive(A.Focus);
    const i = this.renderTarget.convertFromViewerCoordinates(t.point);
    this.renderTarget.cursor = e.getEditToolCursor(this.renderTarget, i);
  }
  defocusAll(e) {
    for (const t of this.getSelectable())
      e !== void 0 && t === e || t instanceof Me && t.setFocusInteractive(A.None);
  }
  initializeStyle(e) {
    const t = this.getDepthTestOnFirstSelectable();
    if (t === void 0)
      return;
    const i = e.getRenderStyle();
    i instanceof Qt && (i.depthTest = t);
  }
  getDepthTestOnFirstSelectable() {
    for (const e of this.getSelectable()) {
      const t = e.getRenderStyle();
      if (t instanceof Qt)
        return t.depthTest;
    }
  }
  setDefaultPrimitiveType() {
    return this.primitiveType === this._defaultPrimitiveType ? !1 : (this.primitiveType = this._defaultPrimitiveType, Ie.update(this.renderTarget), !0);
  }
  endCreatorIfFinished(e, t = !1) {
    (t || e.isFinished) && (this.setDefaultPrimitiveType(), this._creator = void 0);
  }
  async tryStartOnHover(e) {
    const t = this.createCreator();
    if (t === void 0 || !t.canStartOnHover)
      return !1;
    const i = await this.getIntersection(e);
    if (i === void 0)
      return !1;
    const s = this.getRay(e);
    if (!t.addPoint(s, i.point, !0))
      return !1;
    const { domainObject: o } = t;
    return this.initializeStyle(o), this.deselectAll(), this.getOrCreateParent().addChildInteractive(o), o.setSelectedInteractive(!0), o.setVisibleInteractive(!0, this.renderTarget), this.addTransaction(o.createTransaction(m.added)), this._creator = t, !0;
  }
}
function zn(n, e, t, i) {
  i === void 0 && (i = new I());
  const s = n.distanceToPoint(t) * 100, o = t.clone().addScaledVector(e, -s), r = t.clone().addScaledVector(e, +s);
  return n.distanceSqToSegment(o, r, void 0, i), i;
}
const Na = G.clone().invert();
class ns {
  constructor() {
    this._points = [], this._lastIsPending = !1;
  }
  // If true, the last point is hover and not confirmed.
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get points() {
    return this._points;
  }
  get pointCount() {
    return this.points.length;
  }
  get notPendingPointCount() {
    return this.lastIsPending ? this.pointCount - 1 : this.pointCount;
  }
  get firstPoint() {
    return this.points[0];
  }
  get lastPoint() {
    return this.points[this.pointCount - 1];
  }
  get lastNotPendingPoint() {
    return this.points[this.notPendingPointCount - 1];
  }
  get lastIsPending() {
    return this._lastIsPending;
  }
  set lastIsPending(e) {
    this._lastIsPending = e;
  }
  // ==================================================
  // VIRTUAL METHODS
  // ==================================================
  /**
   * Gets the value indicating whether to prefer intersection with something.
   * If this is true, it will first try to intersect an object. If false the point
   * will normally be calculated based on the previous point and the ray in addPointCore
   *
   * @returns {boolean} The value indicating whether to prefer intersection.
   */
  get preferIntersection() {
    return !1;
  }
  /**
   * This functions returns true only if the first point can start on hover.
   * This is to indicate where the object can be created when hovering.
   *
   * @returns {boolean} The value indicating whether to start on hover.
   */
  get canStartOnHover() {
    return !1;
  }
  /**
   * Handles the escape key press event.
   *
   * @returns {boolean} Returns true if the pending object is created successfully, false if it is removed
   */
  escape() {
    return this.notPendingPointCount >= this.minimumPointCount ? !0 : (this.domainObject.removeInteractive(), !1);
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  get isFinished() {
    return this.notPendingPointCount >= this.maximumPointCount;
  }
  addPoint(e, t, i = !1) {
    return t = t == null ? void 0 : t.clone(), this.convertToCdfCoords(e, t), this.addPointCore(e, t, i);
  }
  addRawPoint(e, t) {
    this.lastIsPending ? ev(this.points, e) : this.points.push(e), this._lastIsPending = t;
  }
  removePendingPoint() {
    this.lastIsPending && (this.points.pop(), this._lastIsPending = !1);
  }
  convertToCdfCoords(e, t) {
    e.applyMatrix4(Na), t !== void 0 && t.applyMatrix4(Na);
  }
}
const Ba = new I(0, 0, 1);
class Pr extends ns {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e) {
    super(), this._domainObject = e, this._domainObject.focusType = A.Pending;
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get domainObject() {
    return this._domainObject;
  }
  get minimumPointCount() {
    return this.maximumPointCount;
  }
  get maximumPointCount() {
    switch (this._domainObject.primitiveType) {
      case y.VerticalArea:
        return 2;
      case y.HorizontalArea:
        return 3;
      case y.Box:
        return 4;
      default:
        throw new Error("Unknown primitiveType");
    }
  }
  addPointCore(e, t, i) {
    const s = this._domainObject;
    return t = this.recalculatePoint(t, e, s.primitiveType), t === void 0 ? !1 : (this.addRawPoint(t, i), this.rebuild(), s.notify(m.geometry), this.isFinished && s.setFocusInteractive(A.Focus), !0);
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  recalculatePoint(e, t, i) {
    if (i === y.VerticalArea)
      return e;
    if (this.notPendingPointCount === 1 || this.notPendingPointCount === 2) {
      const s = new ot().setFromNormalAndCoplanarPoint(Ba, this.firstPoint);
      return t.intersectPlane(s, new I()) ?? void 0;
    } else if (this.notPendingPointCount === 3 && i === y.Box)
      return zn(t, Ba, this.points[2], e);
    return e;
  }
  /**
   * Create the box by adding points. The first point will make a box with a center and a tiny size.
   * The second point will give the zRotation and the size.x and center.x
   * The third will give the size.y and center.y
   * The third will give the size.z and center.z
   */
  rebuild() {
    if (this.pointCount === 0)
      throw new Error("Cannot create a box without points");
    const e = this._domainObject, { box: t } = e;
    if (this.pointCount === 1) {
      t.forceMinSize(), t.center.copy(this.firstPoint), e.primitiveType !== y.VerticalArea && (t.center.z += t.size.z / 2);
      return;
    }
    if (this.pointCount === 2) {
      const s = new I().subVectors(this.firstPoint, this.lastPoint);
      t.rotation.z = Es(qh(s));
    }
    const i = e.primitiveType;
    if (this.pointCount <= 3) {
      const s = new I(), o = new I();
      this.getCenterAndSizeFromBoundingBox(t.rotation.z, s, o), t.center.x = s.x, t.size.x = o.x, i === y.VerticalArea ? (t.center.z = s.z, t.center.y = s.y, t.size.z = o.z) : (t.center.y = s.y, t.size.y = o.y), t.forceMinSize();
    } else {
      const s = this.points[2], o = this.points[3], r = $h(s, o), a = (s.z + o.z) / 2;
      t.size.z = r, t.center.z = a;
    }
  }
  getCenterAndSizeFromBoundingBox(e, t, i) {
    const s = new fe().makeRotationZ(e), o = s.clone().invert(), r = new ft();
    for (const a of this.points) {
      const c = a.clone();
      c.applyMatrix4(o), r.add(c);
    }
    r.getCenter(t), r.getDelta(i), t.applyMatrix4(s);
  }
}
const je = 1e-6;
class is {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  /**
   * Represents a base dragger object.
   * @param props - Contains the ray amd the clicked point in CDF coordinates
   * @param domainObject - The domain object to act on
   */
  constructor(e, t) {
    this.ray = new qg(), this._unitSystem = void 0, this.isChanged = !1, this.point = e.point, this.ray = e.ray;
    const i = Le(t);
    i !== void 0 && (this._unitSystem = i.unitSystem);
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get transaction() {
    return this._transaction;
  }
  set transaction(e) {
    this._transaction = e;
  }
  /**
   * Called just after the dragger is created and the pointer is down.
   * @param _event - The pointer event object.
   */
  onPointerDown(e) {
  }
  /**
   * Called just before the dragger is deleted.
   * @param _event - The pointer event.
   */
  onPointerUp(e) {
    this.isChanged && this.domainObject.notify(m.geometry);
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  getBestValue(e, t, i) {
    if (e < i && (e = i), !t || this._unitSystem === void 0)
      return e;
    const s = this._unitSystem.convertToUnit(e, V.Length), o = Lh(s / 25), r = Nh(s, o), a = this._unitSystem.convertFromUnit(r, V.Length);
    return a < i ? i : a;
  }
}
class $e {
  static createLineSegmentsAsPositions(e, t) {
    const i = [];
    for (let s = 0; s < t.length; s++) {
      const o = 3 * t[s];
      i.push(e[o], e[o + 1], e[o + 2]);
    }
    return i;
  }
  static createBufferGeometry(e) {
    const t = new vi(e, 3);
    return new Li().setAttribute("position", t);
  }
  static createLineSegmentsGeometryByPosition(e) {
    const t = $e.createBufferGeometry(e), i = new qn(t);
    return new da().fromLineSegments(i);
  }
  static createLineSegmentsGeometryByVertices(e) {
    const t = new Li().setFromPoints(e), i = new qn(t);
    return new da().fromLineSegments(i);
  }
}
function* Ep(n, e) {
  e === void 0 && (e = new I()), e.set(n.min.x, n.min.y, n.min.z), yield e, e.set(n.max.x, n.min.y, n.min.z), yield e, e.set(n.max.x, n.max.y, n.min.z), yield e, e.set(n.min.x, n.max.y, n.min.z), yield e, e.set(n.min.x, n.min.y, n.max.z), yield e, e.set(n.max.x, n.min.y, n.max.z), yield e, e.set(n.max.x, n.max.y, n.max.z), yield e, e.set(n.min.x, n.max.y, n.max.z), yield e;
}
const Mp = 0.5, Fa = GI();
class nt {
  static createUnitGeometry() {
    return new $g(1, 1, 1);
  }
  static expandBoundingBox(e, t) {
    const i = new I();
    for (const s of Fa)
      i.copy(s), i.applyMatrix4(t), e.expandByPoint(i);
  }
  static createOrientedBox(e) {
    const t = new Py(new I(), new I().setScalar(Mp));
    return t.applyMatrix4(e), t;
  }
  static createLineSegmentsGeometry() {
    const e = nt.createPositions();
    return $e.createLineSegmentsGeometryByPosition(e);
  }
  static createPositions() {
    const e = Fa.flatMap((r) => [r.x, r.y, r.z]), t = [0, 1, 1, 2, 2, 3, 3, 0], i = [4, 5, 5, 6, 6, 7, 7, 4], s = [0, 4, 1, 5, 2, 6, 3, 7], o = [...t, ...i, ...s];
    return $e.createLineSegmentsAsPositions(e, o);
  }
  static createLineSegmentsBufferGeometry() {
    const e = nt.createPositions();
    return $e.createBufferGeometry(e);
  }
}
function GI() {
  const n = new te(new I().setScalar(-0.5), new I().setScalar(Mp)), e = [];
  for (const t of Ep(n))
    e.push(t.clone());
  return e;
}
class Pp {
  constructor() {
    this.confidence = void 0, this.label = void 0;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  getBoundingBox() {
    const e = new te().makeEmpty();
    return this.expandBoundingBox(e), e;
  }
}
const Se = class Se extends Pp {
  constructor() {
    super(...arguments), this.size = new I().setScalar(Se.MinSize), this.center = new I(), this.rotation = new Zs(0, 0, 0);
  }
  // ==================================================
  // OVERRIDES of Primitive
  // ==================================================
  get primitiveType() {
    return y.Box;
  }
  get diagonal() {
    return this.size.length();
  }
  get area() {
    return 2 * (this.size.x * this.size.y + this.size.y * this.size.z + this.size.z * this.size.x);
  }
  get volume() {
    return this.size.x * this.size.y * this.size.z;
  }
  getMatrix() {
    return this.getScaledMatrix(this.size);
  }
  setMatrix(e) {
    const t = new kt();
    e.decompose(this.center, t, this.size), this.rotation.setFromQuaternion(t);
  }
  expandBoundingBox(e) {
    nt.expandBoundingBox(e, this.getMatrix());
  }
  isPointInside(e, t) {
    const i = this.getMatrix();
    return i.premultiply(t), nt.createOrientedBox(i).containsPoint(e);
  }
  intersectRay(e, t) {
    const i = this.getMatrix();
    return i.premultiply(t), nt.createOrientedBox(i).intersectRay(e, new I()) ?? void 0;
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get hasHorizontalArea() {
    const { size: e } = this;
    return Se.isValidSize(e.x) && Se.isValidSize(e.y);
  }
  get hasArea() {
    const { size: e } = this;
    let t = 0;
    return Se.isValidSize(e.x) && t++, Se.isValidSize(e.y) && t++, Se.isValidSize(e.z) && t++, t >= 2;
  }
  get hasVolume() {
    const { size: e } = this;
    return Se.isValidSize(e.x) && Se.isValidSize(e.y) && Se.isValidSize(e.z);
  }
  get horizontalArea() {
    return this.size.x * this.size.y;
  }
  get verticalArea() {
    return this.size.x * this.size.z;
  }
  get hasXYRotation() {
    return this.rotation.x !== 0 || this.rotation.y !== 0;
  }
  get zRotationInDegrees() {
    const e = this.hasXYRotation ? Es(this.rotation.z) : Cr(this.rotation.z);
    return Ss(e);
  }
  // ==================================================
  // INSTANCE METHODS: Getters
  // ==================================================
  getRotationMatrix(e = new fe()) {
    return e.identity(), e.makeRotationFromEuler(this.rotation);
  }
  getScaledMatrix(e, t = new fe()) {
    return t.identity(), t.makeRotationFromEuler(this.rotation), t.setPosition(this.center), t.scale(e);
  }
  getRotationInDegrees(e) {
    return e === 2 ? this.zRotationInDegrees : Ss(rv(this.getRotationAngleByComponent(e)));
  }
  getRotationAngleByComponent(e) {
    if (e === 0)
      return this.rotation.x;
    if (e === 1)
      return this.rotation.y;
    if (e === 2)
      return this.rotation.z;
    throw new Error("Invalid component: " + e);
  }
  // ==================================================
  // INSTANCE METHODS: Operations
  // ==================================================
  copy(e) {
    return this.size.copy(e.size), this.center.copy(e.center), this.rotation.copy(e.rotation), this;
  }
  clear() {
    this.size.setScalar(Se.MinSize), this.center.setScalar(0), this.rotation.set(0, 0, 0);
  }
  forceMinSize() {
    const { size: e } = this;
    e.x = Math.max(Se.MinSize, e.x), e.y = Math.max(Se.MinSize, e.y), e.z = Math.max(Se.MinSize, e.z);
  }
  // ==================================================
  // STATIC METHODS:
  // ==================================================
  static isValidSize(e) {
    return e > Se.MinSize;
  }
};
Se.MinSize = 0.01;
let ye = Se;
const HI = 15;
class qI extends is {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e, t) {
    super(e, t), this._normal = new I(), this._planeOfFace = new ot(), this._centerOfFace = new I(), this._cornerSign = new I(), this._originalBox = new ye();
    const i = e.intersection.userData;
    this._domainObject = t, this._face = i.face, this._focusType = i.focusType, this._cornerSign.copy(i.cornerSign), this._face.getNormal(this._normal), this._face.getCenter(this._centerOfFace), this._rotationMatrix = t.box.getRotationMatrix(), this._normal.applyMatrix4(this._rotationMatrix), this._normal.normalize(), this._planeOfFace.setFromNormalAndCoplanarPoint(this._normal, this.point);
    const s = t.box.getMatrix();
    this._centerOfFace.applyMatrix4(s), this._originalBox.copy(t.box);
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get face() {
    return this._face;
  }
  get focusType() {
    return this._focusType;
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get domainObject() {
    return this._domainObject;
  }
  onPointerDown(e) {
    this._domainObject.setFocusInteractive(this.focusType, this.face);
  }
  onPointerDrag(e, t) {
    return this.transaction === void 0 && (this.transaction = this._domainObject.createTransaction(m.geometry)), this.applyByFocusType(this.focusType, t, e.shiftKey) ? (this.domainObject.notify(m.dragging), !0) : !1;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  applyByFocusType(e, t, i) {
    switch (e) {
      case A.Face:
        return this.moveFace(t, i);
      case A.Corner:
        return this.resize(t);
      case A.Body:
        return this.translate(t, i);
      case A.Rotation:
        return this.rotate(t, i);
      default:
        return !1;
    }
  }
  translate(e, t) {
    const i = e.intersectPlane(this._planeOfFace, yt());
    if (i === null)
      return !1;
    const s = i.sub(this.point);
    if (s.length() < je)
      return !1;
    if (t) {
      const a = this._rotationMatrix.clone().invert();
      s.applyMatrix4(a);
      const c = $v(s);
      for (let d = 0; d < 3; d++)
        d !== c && s.setComponent(d, 0);
      s.applyMatrix4(this._rotationMatrix);
    }
    const o = this._originalBox, { box: r } = this._domainObject;
    return r.copy(o), r.center.add(s), !0;
  }
  moveFace(e, t) {
    const i = yt();
    zn(e, this._normal, this.point, i);
    const s = this._planeOfFace.distanceToPoint(i);
    if (Math.abs(s) < je)
      return !1;
    const o = this._originalBox, { box: r } = this._domainObject;
    r.copy(o);
    const { size: a, center: c } = r, d = this._face.index;
    let l;
    if (this._domainObject.primitiveType !== y.Box)
      l = this._face.sign * s;
    else {
      const p = s + a.getComponent(d), f = this.getBestValue(p, t, ye.MinSize);
      if (hn(f, o.size.getComponent(d), je))
        return !1;
      a.setComponent(d, f);
      const g = a.getComponent(d) - o.size.getComponent(d);
      l = this._face.sign * g / 2;
    }
    const h = yt();
    return h.setComponent(d, l), h.applyMatrix4(this._rotationMatrix), c.add(h), !0;
  }
  resize(e) {
    const t = e.intersectPlane(this._planeOfFace, yt());
    if (t === null)
      return !1;
    const i = this._planeOfFace.projectPoint(this.point, yt()), s = this._rotationMatrix.clone().invert(), o = t.sub(i);
    if (o.applyMatrix4(s), o.multiply(this._cornerSign), o.length() < je)
      return !1;
    const r = this._originalBox, { box: a } = this._domainObject;
    a.copy(r);
    const { size: c, center: d } = a;
    if (c.add(o), a.forceMinSize(), c.distanceTo(r.size) < je)
      return !1;
    const h = yt().subVectors(c, r.size).divideScalar(2);
    return h.multiply(this._cornerSign), h.applyMatrix4(this._rotationMatrix), d.add(h), !0;
  }
  rotate(e, t) {
    const i = this._domainObject;
    if (!i.canRotateComponent(this._face.index))
      return !1;
    const s = e.intersectPlane(this._planeOfFace, yt());
    if (s === null)
      return !1;
    const o = yt().subVectors(this.point, this._centerOfFace).normalize(), r = yt().subVectors(s, this._centerOfFace).normalize(), a = yt().crossVectors(r, o).normalize();
    let c = r.angleTo(o);
    if (Math.abs(c) < je)
      return !1;
    this._normal.dot(a) > 0 && (c = -c);
    const d = this._originalBox, { box: l } = i;
    l.copy(d), t && (c = f(c, this._face.index));
    const h = this._rotationMatrix.clone(), p = new fe().makeRotationAxis(this._normal, c);
    return h.premultiply(p), l.rotation.setFromRotationMatrix(h), !0;
    function f(g, C) {
      const v = d.getRotationAngleByComponent(C);
      let w;
      return C === 2 ? w = l.hasXYRotation ? Es(g + v) : Cr(g + v) : w = Es(g + v), w = x(w), w - v;
      function x(T) {
        let O = Ss(T);
        return O = Nh(O, HI), My(O);
      }
    }
  }
}
const $I = new Qn();
function yt(n) {
  return $I.getNext(n);
}
class si {
  constructor() {
    this.items = [];
  }
  add(e) {
    const t = new KI(e);
    this.items.push(t);
  }
  getItemsByQuantity(e) {
    return this.items.filter((t) => t.quantity === e);
  }
}
class WI {
  constructor(e) {
    this.translationInput = e;
  }
  getText() {
    return mn(this.translationInput);
  }
}
class KI extends WI {
  constructor(e) {
    super(e.translationInput), this.icon = void 0, this.icon = e.icon, this.value = e.value ?? 0, this.quantity = e.quantity ?? V.Unitless;
  }
}
class Op extends Qt {
  constructor() {
    super(...arguments), this.colorType = Re.Specified, this.showLabel = !0, this.addLabels = !0, this.labelColor = vn.clone(), this.labelBgColor = new D("#232323"), this.labelOpacity = 0.9, this.relativeTextSize = 0.05;
  }
  // Relative to diagonal of the object for box and average of length of line segments for line
}
class oi extends Op {
  constructor() {
    super(...arguments), this.showLines = !0, this.lineWidth = 1, this.selectedLineWidth = 1, this.lineColor = vr.clone(), this.selectedLineColor = vn.clone(), this.showSolid = !0, this.solidOpacityUse = !0, this.selectedSolidOpacity = 0.5, this.solidOpacity = this.selectedSolidOpacity / 4;
  }
  // ==================================================
  // OVERRIDES of BaseStyle
  // ==================================================
  clone() {
    return Mt(this);
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  getSolidOpacity(e) {
    return this.solidOpacityUse ? e ? this.selectedSolidOpacity : this.solidOpacity : 1;
  }
  getLineWidth(e) {
    return e ? this.selectedLineWidth : this.lineWidth;
  }
  getLineColor(e) {
    return e ? this.selectedLineColor : this.lineColor;
  }
}
class uo extends bt {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e = y.Box) {
    super(), this.box = new ye(), this._primitiveType = e;
  }
  // ==================================================
  // OVERRIDES of DomainObject
  // ==================================================
  get typeName() {
    switch (this.primitiveType) {
      case y.HorizontalArea:
        return { key: "HORIZONTAL_AREA" };
      case y.VerticalArea:
        return { key: "VERTICAL_AREA" };
      case y.Box:
        return { key: "VOLUME" };
      default:
        throw new Error("Unknown PrimitiveType");
    }
  }
  createRenderStyle() {
    return new oi();
  }
  createDragger(e) {
    if (e.intersection.userData !== void 0)
      return new qI(e, this);
  }
  get hasPanelInfo() {
    return !0;
  }
  getPanelInfo() {
    const e = new si(), { primitiveType: t } = this, i = this.focusType !== A.Pending, { box: s } = this, { size: o } = s, r = ye.isValidSize(o.x), a = ye.isValidSize(o.y), c = ye.isValidSize(o.z);
    return (i || r) && d({ key: "LENGTH" }, o.x, V.Length), t !== y.VerticalArea && (i || a) && d({ key: "DEPTH" }, o.y, V.Length), t !== y.HorizontalArea && (i || c) && d({ key: "HEIGHT" }, o.z, V.Length), t !== y.Box && (i || s.hasArea) && d({ key: "AREA" }, this.area, V.Area), t === y.Box && (i || s.hasHorizontalArea) && d({ key: "HORIZONTAL_AREA" }, s.horizontalArea, V.Area), t === y.Box && (i || s.hasVolume) && d({ key: "VOLUME" }, s.volume, V.Volume), s.rotation.z !== 0 && i && d({ key: "HORIZONTAL_ANGLE" }, s.zRotationInDegrees, V.Angle), e;
    function d(l, h, p) {
      e.add({ translationInput: l, value: h, quantity: p });
    }
  }
  copyFrom(e, t) {
    super.copyFrom(e, t), (t === void 0 || t === m.geometry) && this.box.copy(e.box);
  }
  getEditToolCursor(e, t) {
    if (this.focusType === A.Body)
      return "move";
    if (this.focusType === A.Face) {
      if (this.focusFace === void 0)
        return;
      const i = this.focusFace.getCenter(), s = this.box.getMatrix();
      return i.applyMatrix4(s), e.getResizeCursor(this.box.center, i);
    } else if (this.focusType === A.Corner) {
      if (this.focusFace === void 0 || t === void 0)
        return;
      const i = this.focusFace.getCenter(), s = this.box.getMatrix();
      return i.applyMatrix4(s), e.getResizeCursor(t, i);
    } else return this.focusType === A.Rotation ? "grab" : void 0;
  }
  // ==================================================
  // OVERRIDES of SolidDomainObject
  // ==================================================
  get primitiveType() {
    return this._primitiveType;
  }
  clear() {
    super.clear(), this.box.clear();
  }
  // ==================================================
  // VIRTUAL METHODS
  // ==================================================
  canRotateComponent(e) {
    return e === 2;
  }
  // ==================================================
  // INSTANCE METHODS / PROPERTIES: Geometrical getters
  // ==================================================
  get area() {
    const { box: e } = this;
    switch (this.primitiveType) {
      case y.HorizontalArea:
        return e.horizontalArea;
      case y.VerticalArea:
        return e.verticalArea;
      case y.Box:
        return e.area;
      default:
        throw new Error("Unknown MeasureType type");
    }
  }
  expandBoundingBox(e) {
    this.box.expandBoundingBox(e);
  }
}
class YI extends is {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e, t) {
    super(e, t), this._boundingBox = void 0, this._domainObject = t, this._plane = this._domainObject.plane.clone();
    const i = Le(this._domainObject);
    if (i === void 0)
      return;
    const s = i.renderTarget.sceneBoundingBox;
    this._boundingBox = s.clone(), this._boundingBox.applyMatrix4(i.renderTarget.fromViewerMatrix);
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get domainObject() {
    return this._domainObject;
  }
  onPointerDown(e) {
    this._domainObject.setFocusInteractive(A.Focus);
  }
  onPointerDrag(e, t) {
    const i = zn(t, this._plane.normal, this.point);
    if (this._boundingBox !== void 0 && !this._boundingBox.containsPoint(i))
      return !1;
    const s = new ot().setFromNormalAndCoplanarPoint(this._plane.normal, i);
    return s.equals(this._domainObject.plane) || hn(s.constant, this._domainObject.plane.constant, je) ? !1 : (this.transaction === void 0 && (this.transaction = this._domainObject.createTransaction(m.geometry)), this._domainObject.plane.copy(s), this._domainObject.makeFlippingConsistent(), this.domainObject.notify(m.dragging), !0);
  }
}
const Va = new I(0, 0, 0);
class ho extends Me {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e) {
    super(), this.plane = new ot(), this._backSideColor = void 0, this._primitiveType = e;
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get renderStyle() {
    return this.getRenderStyle();
  }
  get primitiveType() {
    return this._primitiveType;
  }
  get backSideColor() {
    return this._backSideColor === void 0 && (this._backSideColor = Xy(this.color)), this._backSideColor;
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get icon() {
    return es(this.primitiveType);
  }
  get typeName() {
    switch (this.primitiveType) {
      case y.PlaneX:
        return { untranslated: "Vertical plane along Y-axis" };
      case y.PlaneY:
        return { untranslated: "Vertical plane along X-axis" };
      case y.PlaneZ:
        return { untranslated: "Horizontal plane" };
      case y.PlaneXY:
        return { untranslated: "Vertical plane" };
      default:
        throw new Error("Unknown PrimitiveType");
    }
  }
  createRenderStyle() {
    const e = new oi();
    return e.selectedSolidOpacity = 0.5, e.solidOpacity = e.selectedSolidOpacity / 2, e.lineWidth = 1, e.selectedLineWidth = 2, e;
  }
  createDragger(e) {
    return new YI(e, this);
  }
  get hasPanelInfo() {
    return !0;
  }
  getPanelInfo() {
    const e = new si();
    switch (this.primitiveType) {
      case y.PlaneX:
        t({ key: "X:COORDINATE" }, this.coordinate, V.Length);
        break;
      case y.PlaneY:
        t({ key: "Y_COORDINATE" }, this.coordinate, V.Length);
        break;
      case y.PlaneZ:
        t({ key: "Z_COORDINATE" }, this.coordinate, V.Length);
        break;
      case y.PlaneXY:
        t({ key: "DISTANCE_TO_ORIGIN" }, this.coordinate, V.Length), t({ key: "HORIZONTAL_ANGLE" }, Ss(this.angle), V.Angle);
        break;
    }
    return e;
    function t(i, s, o) {
      e.add({ translationInput: i, value: s, quantity: o });
    }
  }
  notifyCore(e) {
    super.notifyCore(e), e.isChanged(m.added) && this.makeFlippingConsistent();
  }
  createTransaction(e) {
    return new ts(this, e);
  }
  copyFrom(e, t) {
    var i;
    super.copyFrom(e, t), (t === void 0 || t === m.geometry) && this.plane.copy(e.plane), (t === void 0 || t === m.color) && (this._backSideColor = (i = e._backSideColor) == null ? void 0 : i.clone());
  }
  // ==================================================
  // OVERRIDES of VisualDomainObject
  // ==================================================
  getEditToolCursor(e, t) {
    return "move";
  }
  // ==================================================
  // INSTANCE METHODS / PROPERTIES: Geometrical getters
  // ==================================================
  get coordinate() {
    const e = this.plane.projectPoint(Va, new I());
    switch (this.primitiveType) {
      case y.PlaneX:
        return e.x;
      case y.PlaneY:
        return e.y;
      case y.PlaneZ:
        return e.z;
      case y.PlaneXY:
        return e.distanceTo(Va);
      default:
        throw new Error("Unknown PrimitiveType");
    }
  }
  get angle() {
    const e = this.plane.normal.clone();
    Hv(e, Math.PI / 2);
    const t = qh(e);
    return Cr(t);
  }
  // ==================================================
  // INSTANCE METHODS: Others
  // ==================================================
  flip() {
    const { plane: e } = this;
    e.negate();
  }
  makeFlippingConsistent() {
    const e = Le(this);
    if (e !== void 0)
      for (const t of e.getDescendantsByType(ho)) {
        if (this.primitiveType !== t.primitiveType || this === t)
          continue;
        const i = new I(0, 0, 0), s = this.plane.projectPoint(i, new I());
        t.plane.distanceToPoint(s) < 0 && (t.flip(), t.notify(m.geometry));
        const o = t.plane.projectPoint(i, new I());
        this.plane.distanceToPoint(o) < 0 && (this.flip(), this.notify(m.geometry));
        break;
      }
  }
}
class XI extends Ir {
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { key: "SLICE_FLIP" };
  }
  get icon() {
    return this._domainObject.primitiveType === y.PlaneZ ? "FlipHorizontal" : "FlipVertical";
  }
  invokeCore() {
    return this.addTransaction(this._domainObject.createTransaction(m.geometry)), this._domainObject.flip(), this._domainObject.notify(m.geometry), !0;
  }
}
class De extends ho {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e) {
    super(e), this.color = new D(D.NAMES.orangered), this._backSideColor = new D(D.NAMES.palegreen);
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get typeName() {
    switch (this.primitiveType) {
      case y.PlaneX:
        return { key: "SLICE_X" };
      case y.PlaneY:
        return { key: "SLICE_Y" };
      case y.PlaneZ:
        return { key: "SLICE_Z" };
      case y.PlaneXY:
        return { key: "SLICE_XY" };
      default:
        throw new Error("Unknown PrimitiveType");
    }
  }
  getPanelToolbar() {
    const e = super.getPanelToolbar();
    return e.push(new XI(this)), e;
  }
  notifyCore(e) {
    super.notifyCore(e), e.isChanged(
      m.selected,
      m.deleted,
      m.added,
      m.geometry,
      m.dragging
    ) && (e.isChanged(m.deleted) && (this.focusType = A.Pending), this.updateClippingPlanes());
  }
  get useClippingInIntersection() {
    return !1;
  }
  clone(e) {
    const t = new De(this.primitiveType);
    return t.copyFrom(this, e), t;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  updateClippingPlanes() {
    const e = Le(this);
    if (e === void 0)
      return;
    const t = e.renderTarget;
    t.isGlobalClippingActive && (t.isGlobalCropBoxActive || ji(e));
  }
}
function ji(n) {
  const e = [];
  for (const t of n.getDescendantsByType(De)) {
    const i = t.plane.clone();
    t.focusType !== A.Pending && e.push(i);
  }
  return n.renderTarget.setGlobalClipping(e), !0;
}
class lt extends uo {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor() {
    super(), this.color = new D(D.NAMES.orange);
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get icon() {
    return "Crop";
  }
  get typeName() {
    return { key: "CROP_BOX" };
  }
  createRenderStyle() {
    const e = new oi();
    return e.showLabel = !1, e;
  }
  notifyCore(e) {
    super.notifyCore(e), e.isChanged(
      m.selected,
      m.deleted,
      m.added,
      m.geometry,
      m.dragging
    ) && (e.isChanged(m.deleted) && (this.focusType = A.Pending), this.updateClippingPlanes(e));
  }
  get useClippingInIntersection() {
    return !1;
  }
  get hasBoldLabel() {
    const e = it(this);
    return e === void 0 || !e.isGlobalClippingActive ? !1 : e.isGlobalCropBox(this);
  }
  clone(e) {
    const t = new lt();
    return t.copyFrom(this, e), t;
  }
  // ==================================================
  // INSTANCE METHODS: Others
  // ==================================================
  setThisAsGlobalCropBox() {
    const e = Le(this);
    if (e === void 0)
      return;
    if (this.focusType === A.Pending) {
      ji(e);
      return;
    }
    const t = this.createClippingPlanes();
    e.renderTarget.setGlobalClipping(t, this);
  }
  createClippingPlanes() {
    if (Le(this) === void 0)
      return [];
    const t = this.box.getMatrix();
    return be.createClippingPlanes(t);
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  updateClippingPlanes(e) {
    const t = Le(this);
    if (t === void 0)
      return;
    const i = t.renderTarget;
    if (!i.isGlobalClippingActive)
      return;
    const s = i.isGlobalCropBox(this);
    if (s && (e.isChanged(m.deleted) || e.isChanged(m.selected) && !this.isSelected)) {
      ji(t);
      return;
    }
    (s || this.isSelected) && e.isChanged(m.geometry, m.dragging) ? this.setThisAsGlobalCropBox() : e.isChanged(m.selected) && this.isSelected && this.setThisAsGlobalCropBox();
  }
}
class ZI extends ns {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e) {
    super(), this._domainObject = e, this._domainObject.focusType = A.Pending;
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get domainObject() {
    return this._domainObject;
  }
  get canStartOnHover() {
    return !1;
  }
  get preferIntersection() {
    return !0;
  }
  get minimumPointCount() {
    return this.maximumPointCount;
  }
  get maximumPointCount() {
    switch (this._domainObject.primitiveType) {
      case y.PlaneX:
      case y.PlaneY:
      case y.PlaneZ:
        return 1;
      case y.PlaneXY:
        return 2;
      default:
        throw new Error("Unknown primitiveType");
    }
  }
  addPointCore(e, t, i) {
    if (t === void 0)
      return !1;
    const s = this._domainObject;
    return this.addRawPoint(t, i), this.rebuild(e), s.notify(m.geometry), this.isFinished && s.setFocusInteractive(A.Focus), !0;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  rebuild(e) {
    if (this.pointCount === 0)
      throw new Error("Cannot create a plane without points");
    const t = this._domainObject;
    let i;
    switch (t.primitiveType) {
      case y.PlaneX:
        i = new I(1, 0, 0);
        break;
      case y.PlaneY:
        i = new I(0, 1, 0);
        break;
      case y.PlaneZ:
        i = new I(0, 0, 1);
        break;
      case y.PlaneXY:
        this.pointCount === 1 ? i = e.direction.clone().normalize() : (i = new I().subVectors(this.lastPoint, this.firstPoint).normalize(), qv(i));
        break;
      default:
        return;
    }
    e.direction.dot(i) < 0 && i.negate(), t.plane.setFromNormalAndCoplanarPoint(i, this.firstPoint);
  }
}
class ri extends Yt {
  // ==================================================
  // OVERRIDES of DomainObject
  // ==================================================
  get typeName() {
    return { untranslated: "Folder" };
  }
  get hasIconColor() {
    return !1;
  }
  get hasIndexOnLabel() {
    return !1;
  }
  get icon() {
    return "Folder";
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  clone(e) {
    const t = new ri();
    return t.copyFrom(this, e), t;
  }
}
class ja extends ri {
  get typeName() {
    return { key: "CROP_BOXES_AND_CLIPPING_PLANES" };
  }
}
class Or extends Mr {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor() {
    super(y.None);
  }
  // ==================================================
  // OVERRIDES of BaseCommand
  // ==================================================
  get icon() {
    return "Crop";
  }
  get tooltip() {
    return { key: "CLIP_TOOL" };
  }
  // ==================================================
  // OVERRIDES of BaseTool
  // ==================================================
  onActivate() {
    super.onActivate(), this.setAllVisible(!0);
  }
  onDeactivate() {
    super.onDeactivate(), this.setAllVisible(!1);
  }
  // ==================================================
  // OVERRIDES of BaseEditTool
  // ==================================================
  canBeSelected(e) {
    return e instanceof lt || e instanceof De;
  }
  // ==================================================
  // OVERRIDES of PrimitiveEditTool
  // ==================================================
  getOrCreateParent() {
    const e = this.rootDomainObject.getDescendantByType(ja);
    if (e !== void 0)
      return e;
    const t = new ja();
    return t.isExpanded = !0, this.renderTarget.rootDomainObject.addChildInteractive(t), t;
  }
  createCreator() {
    switch (this.primitiveType) {
      case y.PlaneX:
      case y.PlaneY:
      case y.PlaneZ:
      case y.PlaneXY:
        return new ZI(new De(this.primitiveType));
      case y.Box:
        return new Pr(new lt());
      default:
        return;
    }
  }
}
class Rp extends Op {
  constructor() {
    super(...arguments), this.pipeRadius = 0.02, this.selectedPipeRadius = this.pipeRadius * 2, this.lineWidth = 1, this.selectedLineWidth = this.lineWidth * 2, this.transparent = !1, this.renderOrder = void 0, this.showSolid = !1, this.solidOpacityUse = !0, this.selectedSolidOpacity = 0.5, this.solidOpacity = this.selectedSolidOpacity / 2;
  }
  // ==================================================
  // OVERRIDES of BaseStyle
  // ==================================================
  clone() {
    return Mt(this);
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  getSolidOpacity(e) {
    return this.solidOpacityUse ? e ? this.selectedSolidOpacity : this.solidOpacity : 1;
  }
}
class zi {
  static getSignedHorizontalArea(e) {
    const t = e.length;
    if (t < 3)
      return 0;
    let i = 0;
    const s = e[0], o = new I(), r = new I();
    for (let a = 1; a <= t; a++)
      r.copy(e[a % t]), r.sub(s), i += Wv(o, r), o.copy(r);
    return i / 2;
  }
  static getCenter(e) {
    const t = zi.getBoundingBox(e);
    if (t !== void 0)
      return t.getCenter(new I());
  }
  static getBoundingBox(e) {
    if (e.length === 0)
      return;
    const t = new te();
    for (const i of e)
      t.expandByPoint(i);
    return t;
  }
}
class Rr extends Me {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e) {
    super(), this.points = [], this._primitiveType = e;
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get renderStyle() {
    return this.getRenderStyle();
  }
  get primitiveType() {
    return this._primitiveType;
  }
  get pointCount() {
    return this.points.length;
  }
  get lineSegmentCount() {
    return this.primitiveType === y.Polygon ? this.pointCount : this.pointCount - 1;
  }
  get firstPoint() {
    return this.points[0];
  }
  get lastPoint() {
    return this.points[this.pointCount - 1];
  }
  get isClosed() {
    return this.primitiveType === y.Polygon && this.pointCount >= 3;
  }
  // ==================================================
  // OVERRIDES of DomainObject
  // ==================================================
  get icon() {
    return es(this.primitiveType);
  }
  get typeName() {
    switch (this.primitiveType) {
      case y.Line:
        return { key: "LINE" };
      case y.Polyline:
        return { key: "POLYLINE" };
      case y.Polygon:
        return { key: "POLYGON" };
      default:
        throw new Error("Unknown PrimitiveType");
    }
  }
  get isLegal() {
    if (!super.isLegal)
      return !1;
    switch (this.primitiveType) {
      case y.Line:
        return this.pointCount === 2;
      case y.Polyline:
        return this.pointCount >= 2;
      case y.Polygon:
        return this.pointCount >= 3;
      default:
        throw new Error("Unknown PrimitiveType");
    }
  }
  createRenderStyle() {
    return new Rp();
  }
  get hasPanelInfo() {
    return !0;
  }
  getPanelInfo() {
    if (this.focusType === A.Pending && this.pointCount <= 1)
      return;
    const e = new si();
    switch (this.primitiveType) {
      case y.Line:
        t({ key: "LENGTH" }, this.getTotalLength()), t({ key: "HORIZONTAL_LENGTH" }, this.getHorizontalLength()), t({ key: "VERTICAL_LENGTH" }, this.getVerticalLength());
        break;
      case y.Polyline:
        t({ key: "TOTAL_LENGTH" }, this.getTotalLength()), t({ key: "HORIZONTAL_LENGTH" }, this.getHorizontalLength());
        break;
      case y.Polygon:
        t({ key: "TOTAL_LENGTH" }, this.getTotalLength()), t({ key: "HORIZONTAL_LENGTH" }, this.getHorizontalLength()), this.isClosed && t({ key: "HORIZONTAL_AREA" }, this.getHorizontalArea(), V.Area);
        break;
      default:
        throw new Error("Unknown PrimitiveType type");
    }
    return e;
    function t(i, s, o = V.Length) {
      e.add({ translationInput: i, value: s, quantity: o });
    }
  }
  createTransaction(e) {
    return new ts(this, e);
  }
  copyFrom(e, t) {
    if (super.copyFrom(e, t), t === void 0 || t === m.geometry) {
      Lt(this.points);
      for (const i of e.points)
        this.points.push(i.clone());
    }
  }
  // ==================================================
  // VIRTUAL METHODS: To be overridden
  // ==================================================
  getTransformedPoint(e) {
    return e;
  }
  getCopyOfTransformedPoint(e, t) {
    return t.copy(e), t;
  }
  getTriangleIndexes() {
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  getTotalLength() {
    let e = this.isClosed ? this.getTransformedPoint(this.lastPoint) : void 0, t = 0;
    for (const i of this.points) {
      const s = this.getTransformedPoint(i);
      e !== void 0 && (t += s.distanceTo(e)), e = s;
    }
    return t;
  }
  getAverageLength() {
    const { lineSegmentCount: e } = this;
    return e <= 0 ? 0 : this.getTotalLength() / e;
  }
  getHorizontalLength() {
    let e = this.isClosed ? this.getTransformedPoint(this.lastPoint) : void 0, t = 0;
    for (const i of this.points) {
      const s = this.getTransformedPoint(i);
      e !== void 0 && (t += Gv(s, e)), e = s;
    }
    return t;
  }
  getVerticalLength() {
    let e = this.isClosed ? this.getTransformedPoint(this.lastPoint) : void 0, t = 0;
    for (const i of this.points) {
      const s = this.getTransformedPoint(i);
      e !== void 0 && (t += $h(s, e)), e = s;
    }
    return t;
  }
  getHorizontalArea() {
    if (!this.isClosed)
      return 0;
    const e = this.points.map((t) => this.getTransformedPoint(t));
    return Math.abs(zi.getSignedHorizontalArea(e));
  }
  getBoundingBox() {
    const e = new te().makeEmpty();
    return this.expandBoundingBox(e), e;
  }
  expandBoundingBox(e) {
    for (const t of this.points) {
      const i = this.getTransformedPoint(t);
      e.expandByPoint(i);
    }
  }
}
class Un extends Rr {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e) {
    super(e), this.color = new D(D.NAMES.red);
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  clone(e) {
    const t = new Un(this.primitiveType);
    return t.copyFrom(this, e), t;
  }
}
class Gn extends uo {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e) {
    super(e), this.color = new D(D.NAMES.magenta);
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  clone(e) {
    const t = new Gn(this.primitiveType);
    return t.copyFrom(this, e), t;
  }
}
class Dp extends ns {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e, t) {
    super(), this._domainObject = e, this._domainObject.focusType = A.Pending, this._undoManager = t;
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get preferIntersection() {
    return !0;
  }
  get domainObject() {
    return this._domainObject;
  }
  get minimumPointCount() {
    switch (this._domainObject.primitiveType) {
      case y.Polygon:
        return 3;
      default:
        return 2;
    }
  }
  get maximumPointCount() {
    switch (this._domainObject.primitiveType) {
      case y.Line:
        return 2;
      default:
        return Number.MAX_SAFE_INTEGER;
    }
  }
  addPointCore(e, t, i) {
    if (t = this.transformInputPoint(e, t, i), t === void 0)
      return !1;
    const s = this._domainObject;
    if (this.lastIsPending && s.points.pop(), this.pointCount !== s.pointCount && (ua(this.points, s.points), this.lastIsPending = !1), this.addRawPoint(t, i), !i && s.hasParent && this._undoManager !== void 0) {
      const o = this._undoManager.hasUniqueId(s.uniqueId);
      this._undoManager.addTransaction(
        s.createTransaction(o ? m.geometry : m.added)
      ) && Ie.update(it(s));
    }
    return ua(s.points, this.points), s.notify(m.geometry), this.isFinished && s.setFocusInteractive(A.Focus), !0;
  }
  escape() {
    const e = this._domainObject;
    return this.notPendingPointCount < this.minimumPointCount ? (e.removeInteractive(), !1) : (this.lastIsPending && (e.points.pop(), this.removePendingPoint(), e.notify(m.geometry)), e.setFocusInteractive(A.Focus), !0);
  }
  // ==================================================
  // VIRTUAL METHODS
  // ==================================================
  transformInputPoint(e, t, i) {
    if (!i || this.notPendingPointCount === 1 || t !== void 0)
      return t;
    const s = this.lastNotPendingPoint, o = new ot().setFromNormalAndCoplanarPoint(e.direction, s), r = e.intersectPlane(o, new I());
    if (r !== null)
      return r;
  }
}
class za extends ri {
  get typeName() {
    return { key: "MEASUREMENTS" };
  }
}
const QI = new I(0, 0, 1), He = class He extends Pp {
  constructor() {
    super(...arguments), this.radius = He.MinSize, this.centerA = new I(0, 0, -He.HalfMinSize), this.centerB = new I(0, 0, +He.HalfMinSize), this._center = new I(), this._axis = new I(), this._size = new I();
  }
  get endCapArea() {
    return Math.PI * this.radius * this.radius;
  }
  // ==================================================
  // OVERRIDES of Primitive
  // ==================================================
  get primitiveType() {
    return y.Cylinder;
  }
  get area() {
    return 2 * Math.PI * this.radius * this.height + 2 * this.endCapArea;
  }
  get volume() {
    return Math.PI * Dt(this.radius) * this.height;
  }
  get diagonal() {
    return Math.sqrt(Dt(this.radius) + Dt(this.height));
  }
  getMatrix() {
    return new fe().compose(this.center, this.getQuaternion(), this.size);
  }
  setMatrix(e) {
    const t = new I(0, 0, -0.5).applyMatrix4(e), i = new I(0, 0, 0.5).applyMatrix4(e), s = new I();
    e.decompose(new I(), new kt(), s), this.centerA.copy(t), this.centerB.copy(i), this.radius = s.x / 2;
  }
  expandBoundingBox(e) {
    const t = new ft(this.centerA, this.centerB);
    t.expandByMargin3(ft.getCircleRangeMargin(this.axis, this.radius)), e.union(t.getBox());
  }
  isPointInside(e, t) {
    const { centerA: i, centerB: s } = this.getCenters(t), o = new I().addVectors(i, s).divideScalar(2), r = i.sub(s), a = r.length();
    r.normalize();
    const c = o.sub(e), d = r.dot(c);
    return r.multiplyScalar(d), r.sub(c), !(r.length() > this.radius || Math.abs(d) > a / 2);
  }
  intersectRay(e, t) {
    const { centerA: i, centerB: s } = this.getCenters(t), { radius: o } = this, r = e.origin, a = e.direction, c = new I().subVectors(s, i), d = c.dot(a);
    if (d > 0) {
      const S = (c.dot(i) - c.dot(r)) / d, E = e.at(S, new I());
      if (E.distanceTo(i) <= o)
        return E;
    }
    if (d < 0) {
      const S = (c.dot(s) - c.dot(r)) / d, E = e.at(S, new I());
      if (E.distanceTo(s) <= o)
        return E;
    }
    const l = new I().subVectors(r, i), h = c.dot(c), p = c.dot(l), f = h - d * d, g = h * l.dot(a) - p * d, C = h * l.dot(l) - p * p - o * o * h, v = g * g - f * C;
    if (v < 0)
      return;
    const w = Math.sqrt(v), x = (-g - w) / f, T = p + x * d;
    if (T > 0 && T < h)
      return e.at(x, new I());
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get height() {
    return this.centerA.distanceTo(this.centerB);
  }
  get center() {
    return this._center.addVectors(this.centerB, this.centerA).divideScalar(2);
  }
  get size() {
    return this._size.set(this.diameter, this.diameter, this.height);
  }
  get axis() {
    return this._axis.subVectors(this.centerB, this.centerA).normalize();
  }
  get diameter() {
    return 2 * this.radius;
  }
  // ==================================================
  // INSTANCE METHODS: Getters
  // ==================================================
  getRotationMatrix(e = new fe()) {
    return e.identity(), e.makeRotationFromQuaternion(this.getQuaternion());
  }
  getScaledMatrix(e, t = new fe()) {
    return t.compose(this.center, this.getQuaternion(), e);
  }
  getQuaternion() {
    return new kt().setFromUnitVectors(QI, this.axis);
  }
  getCenters(e) {
    const t = this.centerA.clone(), i = this.centerB.clone();
    return t.applyMatrix4(e), i.applyMatrix4(e), { centerA: t, centerB: i };
  }
  // ==================================================
  // INSTANCE METHODS: Operations
  // ==================================================
  copy(e) {
    return this.radius = e.radius, this.centerA.copy(e.centerA), this.centerB.copy(e.centerB), this;
  }
  clear() {
    this.radius = He.MinSize, this.centerA.set(0, 0, -He.HalfMinSize), this.centerB.set(0, 0, +He.HalfMinSize);
  }
  forceMinSize() {
    this.radius = Math.max(this.radius, He.MinSize);
  }
  // ==================================================
  // STATIC METHODS:
  // ==================================================
  static isValidSize(e) {
    return e > He.MinSize;
  }
};
He.MinSize = 0.01, He.HalfMinSize = He.MinSize * 0.5;
let Y = He;
class JI extends is {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e, t) {
    super(e, t), this._normal = new I(), this._planeOfFace = new ot(), this._originalCylinder = new Y();
    const i = e.intersection.userData;
    if (this._domainObject = t, this._face = i.face, this._focusType = i.focusType, this._face.index === 2) {
      this._face.getNormal(this._normal);
      const s = t.cylinder.getRotationMatrix();
      this._normal.applyMatrix4(s), this._normal.normalize(), this._planeOfFace.setFromNormalAndCoplanarPoint(this._normal, this.point);
    }
    this._originalCylinder.copy(t.cylinder);
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get face() {
    return this._face;
  }
  get focusType() {
    return this._focusType;
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get domainObject() {
    return this._domainObject;
  }
  onPointerDown(e) {
    this._domainObject.setFocusInteractive(this.focusType, this.face);
  }
  onPointerDrag(e, t) {
    return this.transaction === void 0 && (this.transaction = this._domainObject.createTransaction(m.geometry)), this.applyByFocusType(this.focusType, t, e.shiftKey) ? (this.domainObject.notify(m.dragging), !0) : !1;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  applyByFocusType(e, t, i) {
    switch (e) {
      case A.Face:
        return this.moveFace(t, i);
      case A.Body:
        return this.translate(t);
      case A.Rotation:
        return this.rotate(t);
      default:
        return !1;
    }
  }
  translate(e) {
    if (this._face.index !== 2)
      return !1;
    const t = e.intersectPlane(this._planeOfFace, rt());
    if (t === null)
      return !1;
    const i = t.sub(this.point);
    if (i.length() < je)
      return !1;
    const { cylinder: s } = this._domainObject, o = this._originalCylinder;
    return s.copy(o), s.centerA.add(i), s.centerB.add(i), !0;
  }
  moveFace(e, t) {
    return this._face.index !== 2 ? this.moveRadius(e, t) : this._domainObject.primitiveType === y.HorizontalCircle ? this.moveAlongAxis(e) : this.moveEndCaps(e, t);
  }
  moveRadius(e, t) {
    const { cylinder: i } = this._domainObject, o = new ki(i.centerA, i.centerB).closestPointToPoint(this.point, !0, rt()), r = rt().subVectors(o, this.point).normalize(), c = zn(e, r, o).distanceTo(o), d = this.getBestValue(c, t, Y.MinSize);
    return hn(d, i.radius, je) ? !1 : (i.radius = d, !0);
  }
  moveEndCaps(e, t) {
    const i = rt();
    zn(e, this._normal, this.point, i);
    const s = this._planeOfFace.distanceToPoint(i);
    if (Math.abs(s) < je)
      return !1;
    const o = this._originalCylinder, r = this.getBestValue(
      o.height + s,
      t,
      Y.MinSize
    );
    if (Math.abs(r - o.height) < je)
      return !1;
    const { cylinder: a } = this._domainObject;
    a.copy(o);
    const { centerA: c, centerB: d } = a, l = rt().subVectors(c, d).normalize().multiplyScalar(r);
    return this._face.face === 2 ? d.subVectors(c, l) : c.addVectors(d, l), !0;
  }
  moveAlongAxis(e) {
    const t = rt();
    zn(e, this._normal, this.point, t);
    const i = this._planeOfFace.distanceToPoint(t), s = this._originalCylinder, { cylinder: o } = this._domainObject;
    o.copy(s);
    const { centerA: r, centerB: a } = o, c = rt().subVectors(r, a).normalize().multiplyScalar(i);
    return this._face.face === 2 && c.negate(), c.length() < je ? !1 : (r.add(c), a.add(c), !0);
  }
  rotate(e) {
    if (this._face.index !== 2)
      return !1;
    const t = e.intersectPlane(this._planeOfFace, rt());
    if (t === null)
      return !1;
    const i = rt().subVectors(t, this.point);
    if (i.length() < je)
      return !1;
    const { cylinder: s } = this._domainObject, o = this._originalCylinder;
    s.copy(o);
    const { centerA: r, centerB: a } = s;
    if (this._face.face === 2) {
      a.add(i);
      const c = rt().subVectors(r, a).normalize().multiplyScalar(o.height);
      a.subVectors(r, c);
    } else {
      r.add(i);
      const c = rt().subVectors(r, a).normalize().multiplyScalar(o.height);
      r.addVectors(a, c);
    }
    return !0;
  }
}
const ew = new Qn();
function rt(n) {
  return ew.getNext(n);
}
class Dr extends bt {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e = y.Cylinder) {
    super(), this.cylinder = new Y(), this._primitiveType = e;
  }
  // ==================================================
  // OVERRIDES of DomainObject
  // ==================================================
  get typeName() {
    switch (this.primitiveType) {
      case y.HorizontalCylinder:
      case y.VerticalCylinder:
      case y.Cylinder:
        return { key: "CYLINDER" };
      case y.HorizontalCircle:
        return { key: "CIRCLE" };
      default:
        throw new Error("Unknown PrimitiveType");
    }
  }
  createRenderStyle() {
    return new oi();
  }
  createDragger(e) {
    if (e.intersection.userData !== void 0)
      return new JI(e, this);
  }
  get hasPanelInfo() {
    return !0;
  }
  getPanelInfo() {
    const e = new si(), { cylinder: t } = this, i = Y.isValidSize(t.radius), s = Y.isValidSize(t.height) && this.primitiveType !== y.HorizontalCircle;
    return i && (o({ key: "RADIUS" }, t.radius, V.Length), o({ key: "DIAMETER" }, t.diameter, V.Length)), s && o({ key: "HEIGHT" }, t.height, V.Length), i && (this.primitiveType === y.HorizontalCircle ? o({ key: "AREA" }, t.endCapArea, V.Area) : o({ key: "AREA" }, t.area, V.Area)), i && s && o({ key: "VOLUME" }, t.volume, V.Volume), e;
    function o(r, a, c) {
      e.add({ translationInput: r, value: a, quantity: c });
    }
  }
  copyFrom(e, t) {
    super.copyFrom(e, t), (t === void 0 || t === m.geometry) && this.cylinder.copy(e.cylinder);
  }
  // ==================================================
  // OVERRIDES of VisualDomainObject
  // ==================================================
  getEditToolCursor(e, t) {
    if (this.focusType === A.Body)
      return "move";
    if (this.focusType === A.Face) {
      if (this.focusFace === void 0)
        return;
      const { cylinder: i } = this;
      if (this.focusFace.index === 2)
        return e.getResizeCursor(i.centerA, i.centerB);
      {
        if (t === void 0)
          return;
        const o = new ki(i.centerA, i.centerB).closestPointToPoint(t, !1, new I());
        return e.getResizeCursor(t, o);
      }
    } else return this.focusType === A.Rotation ? "grab" : void 0;
  }
  // ==================================================
  // OVERRIDES of SolidDomainObject
  // ==================================================
  get primitiveType() {
    return this._primitiveType;
  }
  clear() {
    super.clear(), this.cylinder.clear();
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  get canMoveCaps() {
    return this.primitiveType === y.Cylinder;
  }
  expandBoundingBox(e) {
    this.cylinder.expandBoundingBox(e);
  }
}
class Hn extends Dr {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e) {
    super(e), this.color = new D(D.NAMES.magenta);
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  clone(e) {
    const t = new Hn(this.primitiveType);
    return t.copyFrom(this, e), t;
  }
}
const Oo = new I(0, 0, 1);
class kp extends ns {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e, t, i = !1) {
    super(), this._radius = Y.MinSize, this._radiusOrder = 1, this._otherCenterOrder = 2, this._primitiveType = t ?? e.primitiveType, this._domainObject = e, this._domainObject.focusType = A.Pending, i && (this._radiusOrder = 2, this._otherCenterOrder = 1);
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get domainObject() {
    return this._domainObject;
  }
  get minimumPointCount() {
    return this.maximumPointCount;
  }
  get maximumPointCount() {
    return this._domainObject.primitiveType === y.HorizontalCircle ? 2 : 3;
  }
  addPointCore(e, t, i) {
    const s = this._domainObject;
    return t = this.recalculatePoint(t, e), t === void 0 ? !1 : (this.addRawPoint(t, i), this.rebuild(), s.notify(m.geometry), this.isFinished && s.setFocusInteractive(A.Focus), !0);
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  recalculatePoint(e, t) {
    if (this.notPendingPointCount === this._otherCenterOrder)
      if (this._primitiveType === y.HorizontalCylinder)
        if (e === void 0) {
          const i = new ot().setFromNormalAndCoplanarPoint(Oo, this.firstPoint);
          return t.intersectPlane(i, new I()) ?? void 0;
        } else
          return e.x = this.firstPoint.x, e.y = this.firstPoint.y, e;
      else if (e === void 0) {
        const i = t.origin.distanceTo(this.firstPoint) * 100, s = this.firstPoint.clone().addScaledVector(Oo, -i), o = this.firstPoint.clone().addScaledVector(Oo, +i), r = new I();
        return t.distanceSqToSegment(s, o, void 0, r), r;
      } else
        return e.z = this.firstPoint.z, e;
    else if (this.notPendingPointCount === this._radiusOrder) {
      const { center: i, axis: s } = this._domainObject.cylinder;
      if (this._radiusOrder === 1) {
        const d = new ot().setFromNormalAndCoplanarPoint(s, i), l = t.intersectPlane(d, new I());
        if (l !== null)
          return this._radius = l == null ? void 0 : l.distanceTo(i), this._radius = Math.max(this._radius, Y.MinSize), l;
      }
      const o = t.origin.distanceTo(i) * 100, r = i.clone().addScaledVector(s, -o), a = i.clone().addScaledVector(s, +o), c = new I();
      return this._radius = Math.sqrt(t.distanceSqToSegment(r, a, c, void 0)), this._radius = Math.max(this._radius, Y.MinSize), c;
    }
    return e;
  }
  /**
   * Create the cylinder by adding points. The first point will make a centerA.
   * The second/third point will give the centerB.
   * The third/second will give radius. The radius is already calculated in the recalculatePoint
   */
  rebuild() {
    if (this.pointCount === 0)
      throw new Error("Cannot create a cylinder without points");
    const { cylinder: e } = this._domainObject;
    if (this.pointCount === 1) {
      const { centerA: t, centerB: i } = e;
      t.copy(this.firstPoint), i.copy(this.firstPoint), this._primitiveType === y.HorizontalCylinder ? (t.x -= Y.HalfMinSize, t.y -= Y.HalfMinSize, i.x += Y.HalfMinSize, i.y += Y.HalfMinSize) : (t.z -= Y.HalfMinSize, i.z += Y.HalfMinSize);
    } else if (this.pointCount - 1 === this._otherCenterOrder) {
      const { centerA: t, centerB: i } = e;
      t.copy(this.firstPoint), i.copy(this.lastPoint);
    } else this.pointCount - 1 === this._radiusOrder && (e.radius = this._radius);
    e.forceMinSize();
  }
}
class kr extends Mr {
  // ==================================================
  // OVERRIDES of BaseCommand
  // ==================================================
  get icon() {
    return "Ruler";
  }
  get tooltip() {
    return { key: "MEASUREMENTS" };
  }
  // ==================================================
  // OVERRIDES of BaseTool
  // ==================================================
  onActivate() {
    if (super.onActivate(), !this.renderTarget.isGlobalClippingActive) {
      this.setAllVisible(!0);
      return;
    }
    const e = this.renderTarget.clippedVisualSceneBoundingBox, t = new te();
    for (const i of this.getSelectable())
      (i instanceof Gn || i instanceof Un || i instanceof Hn) && (t.makeEmpty(), i.expandBoundingBox(t), t.applyMatrix4(G), !e.intersectsBox(t)) || i.setVisibleInteractive(!0, this.renderTarget);
  }
  onDeactivate() {
    super.onDeactivate(), this.setAllVisible(!1);
  }
  // ==================================================
  // OVERRIDES of BaseEditTool
  // ==================================================
  canBeSelected(e) {
    return e instanceof Gn || e instanceof Un || e instanceof Hn;
  }
  // ==================================================
  // OVERRIDES of PrimitiveEditTool
  // ==================================================
  getOrCreateParent() {
    const e = this.rootDomainObject.getDescendantByType(za);
    if (e !== void 0)
      return e;
    const t = new za();
    return t.isExpanded = !0, this.renderTarget.rootDomainObject.addChildInteractive(t), t;
  }
  createCreator() {
    switch (this.primitiveType) {
      case y.Line:
      case y.Polyline:
      case y.Polygon:
        return new Dp(new Un(this.primitiveType), this.undoManager);
      case y.HorizontalArea:
      case y.VerticalArea:
      case y.Box:
        return new Pr(new Gn(this.primitiveType));
      case y.VerticalCylinder:
      case y.HorizontalCircle:
        return new kp(new Hn(this.primitiveType));
      default:
        return;
    }
  }
}
var ks = /* @__PURE__ */ ((n) => (n[n.Dropdown = 0] = "Dropdown", n[n.Segmented = 1] = "Segmented", n))(ks || {});
class Pn extends z {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e = 0) {
    super(), this._children = void 0, this.optionType = e;
  }
  get children() {
    return this._children === void 0 && (this._children = this.createChildren()), this._children;
  }
  get hasChildren() {
    return this._children !== void 0 && this._children.length > 0;
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  *getChildren() {
    if (this._children !== void 0)
      for (const e of this._children)
        yield e;
  }
  // ==================================================
  // VIRTUAL METHODS
  // ==================================================
  createChildren() {
    return [];
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  get selectedChild() {
    const e = this.children;
    if (e !== void 0)
      return e.find((t) => t.isChecked);
  }
  get checkedCount() {
    return this.children !== void 0 ? tv(this.children, (e) => e.isChecked) : 0;
  }
  add(e) {
    const t = this.children;
    t !== void 0 && t.push(e);
  }
}
const tw = [0.5, 1, 2, 5, 10, 20];
class Lp extends Pn {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e = tw) {
    super();
    for (const t of e)
      this.add(new nw(t));
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { key: "SET_CAMERA_FLY_SPEED" };
  }
  attach(e) {
    super.attach(e), this.addDisposable(
      $i(() => {
        this.renderTarget.revealSettingsController.cameraKeyBoardSpeed(), this.update();
      })
    );
  }
}
let nw = class extends z {
  constructor(e) {
    super(), this._value = e;
  }
  get tooltip() {
    return { untranslated: `${this._value.toString()}x` };
  }
  get isChecked() {
    return this._value === this.currentKeyBoardSpeed();
  }
  invokeCore() {
    return this._value === this.currentKeyBoardSpeed() ? !1 : (this.currentKeyBoardSpeed(this._value), !0);
  }
  get currentKeyBoardSpeed() {
    return this.renderTarget.revealSettingsController.cameraKeyBoardSpeed;
  }
};
class iw {
  constructor(e) {
    this._poiCommentCache = /* @__PURE__ */ new Map(), this._poiProvider = e;
  }
  async getPoiCommentsForPoi(e) {
    const t = Ua(e), i = this._poiCommentCache.get(t);
    if (i !== void 0)
      return i;
    const s = await this._poiProvider.getPointsOfInterestComments(e);
    return this._poiCommentCache.set(t, s), s;
  }
  async postCommentForPoi(e, t) {
    const i = await this._poiProvider.postPointsOfInterestComment(e, t), s = Ua(e), o = this._poiCommentCache.get(s);
    return o !== void 0 ? o.push(i) : this._poiCommentCache.set(s, [i]), i;
  }
  async fetchPoisForScene(e) {
    return await this._poiProvider.fetchPointsOfInterest(e);
  }
  async deletePointsOfInterest(e) {
    e.length !== 0 && await this._poiProvider.deletePointsOfInterest(e);
  }
  async upsertPointsOfInterest(e) {
    return e.length === 0 ? [] : await this._poiProvider.upsertPointsOfInterest(e);
  }
  getDataProvider() {
    return this._poiProvider;
  }
}
function Ua(n) {
  return typeof n == "string" ? n : JSON.stringify(n);
}
var Pe = /* @__PURE__ */ ((n) => (n[n.Default = 0] = "Default", n[n.PendingDeletion = 1] = "PendingDeletion", n[n.PendingCreation = 2] = "PendingCreation", n))(Pe || {});
function sw(n, e, t, i, s) {
  const o = n.clone().applyMatrix4(G.clone().invert());
  return {
    positionX: o.x,
    positionY: o.y,
    positionZ: o.z,
    scene: e,
    sceneState: {},
    name: t,
    description: i,
    instanceRef: s
  };
}
const Np = Symbol("poiMarker");
function ow(n, e, t, i, s) {
  return {
    type: "customObject",
    marker: Np,
    point: n,
    distanceToCamera: e,
    customObject: t,
    domainObject: i,
    userData: s
  };
}
function Zo(n) {
  return n.marker === Np;
}
function Bp(n, e) {
  if (n.every(Xt))
    return {
      assetIds: n.map((t) => t.id),
      style: { cad: e, pointcloud: e, image360: e }
    };
  if (n.every(_t))
    return {
      fdmAssetExternalIds: n,
      style: { cad: e, pointcloud: e, image360: e }
    };
  throw Error("Error, all instances must be of same type in createInstanceStyle");
}
const Ga = Symbol(
  "poi3d-selected-associated-instance-styling"
);
class Ft extends Me {
  constructor(e) {
    super(), this._currentScene = void 0, this._pointsOfInterest = [], this._poisCache = new iw(e);
  }
  get typeName() {
    return { key: "POINT_OF_INTEREST_PLURAL" };
  }
  get icon() {
    return "Waypoint";
  }
  get hasIconColor() {
    return !1;
  }
  get hasIndexOnLabel() {
    return !1;
  }
  get canBeRemoved() {
    return !1;
  }
  addPendingPointsOfInterest(e) {
    const t = {
      properties: e,
      status: Pe.PendingCreation,
      id: this._poisCache.getDataProvider().createNewId()
    };
    return this._pointsOfInterest.push(t), this.notify(m.geometry), t;
  }
  removePointsOfInterest(e) {
    e.status === Pe.PendingCreation ? lr(this._pointsOfInterest, (t) => e === t) : this._pointsOfInterest.includes(e) && (e.status = Pe.PendingDeletion), this.notify(m.geometry);
  }
  get pointsOfInterest() {
    return this._pointsOfInterest;
  }
  get selectedPointsOfInterest() {
    return this._selectedPointsOfInterest;
  }
  async save() {
    const e = Le(this);
    if (e === void 0 || e.fdmSdk === void 0)
      return;
    this._selectedPointsOfInterest !== void 0 && (this._selectedPointsOfInterest.status === Pe.PendingCreation || this._selectedPointsOfInterest.status === Pe.PendingDeletion) && this.setSelectedPointOfInterest(void 0);
    const [i, s] = Kt(
      this._pointsOfInterest,
      (c) => c.status === Pe.PendingDeletion
    ), o = this._poisCache.deletePointsOfInterest(i.map((c) => c.id)), r = this._pointsOfInterest.filter(
      (c) => c.status === Pe.PendingCreation
    ), a = await this._poisCache.upsertPointsOfInterest(r);
    this._pointsOfInterest = s.filter((c) => c.status === Pe.Default).concat(
      a.map((c) => ({
        status: Pe.Default,
        properties: c.properties,
        id: c.id
      }))
    ), await o, this.notify(m.geometry);
  }
  setSelectedPointOfInterest(e) {
    this._selectedPointsOfInterest = e, this.setAssociatedInstanceStyle(e), this.notify(m.selected);
  }
  setAssociatedInstanceStyle(e) {
    var s;
    const t = (s = it(this)) == null ? void 0 : s.instanceStylingController;
    if ((e == null ? void 0 : e.properties.instanceRef) === void 0) {
      t == null || t.setStylingGroup(
        Ga,
        void 0
      );
      return;
    }
    const i = Bp(
      [e.properties.instanceRef],
      Ys.Highlighted
    );
    t == null || t.setStylingGroup(
      Ga,
      i
    );
  }
  async updatePointsOfInterest(e) {
    return await this._poisCache.upsertPointsOfInterest(e);
  }
  async postCommentForPoi(e, t) {
    const i = await this._poisCache.postCommentForPoi(e.id, t);
    return this.notify(m.addedPart), i;
  }
  async getCommentsForPoi(e) {
    return await this._poisCache.getPoiCommentsForPoi(e.id);
  }
  hasPendingPointsOfInterest() {
    return this._pointsOfInterest.some(
      (e) => e.status === Pe.PendingCreation
    );
  }
  hasPendingDeletionPointsOfInterest() {
    return this._pointsOfInterest.some(
      (e) => e.status === Pe.PendingDeletion
    );
  }
  getScene() {
    return this._currentScene;
  }
  async setCurrentScene(e) {
    if (e === this._currentScene || (this._currentScene = e, this._pointsOfInterest = [], e === void 0))
      return;
    const t = await this._poisCache.fetchPoisForScene(e);
    this._pointsOfInterest = t.map((i) => ({
      id: i.id,
      properties: i.properties,
      status: Pe.Default
    })), this.notify(m.geometry);
  }
}
function rw(n) {
  return {
    items: n.map(({ id: e, properties: t }) => ({
      externalId: e,
      name: t.name ?? "",
      description: t.description ?? "",
      position: [t.positionX, t.positionY, t.positionZ],
      sceneState: {},
      scene: t.scene,
      visibility: t.visibility ?? "PRIVATE",
      assetRef: aw(t.instanceRef)
    }))
  };
}
function aw(n) {
  if (n !== void 0) {
    if (Xt(n))
      return n;
    if (_t(n))
      return { externalId: n.externalId, instanceSpace: n.space };
  }
}
async function ps(n, e) {
  if (e.length === 0)
    return /* @__PURE__ */ new Map();
  const t = yn(e), s = (await n.profiles.retrieve(t.map((o) => ({ userIdentifier: o })))).filter(F).map((o) => [o.userIdentifier, o.displayName ?? void 0]);
  return new Map(s);
}
class cw {
  constructor(e) {
    this._sdk = e, this._createUrl = (t) => `apps/v1/projects/${t}/storage/3d/poi`, this._listUrl = (t) => `apps/v1/projects/${t}/storage/3d/poi/list`, this._deleteUrl = (t) => `apps/v1/projects/${t}/storage/3d/poi/delete`, this._getCommentsUrl = (t) => `apps/v1/projects/${t}/storage/3d/poi/comment/list`, this._postCommentUrl = (t) => `apps/v1/projects/${t}/storage/3d/poi/comment`, this._byidsUrl = (t) => `apps/v1/projects/${t}/storage/3d/poi/byids`;
  }
  async upsertPointsOfInterest(e) {
    const t = rw(e), i = await this._sdk.put(
      `${this._sdk.getBaseUrl()}/${this._createUrl(this._sdk.project)}`,
      {
        data: t
      }
    );
    if (i.status !== 200)
      throw Error(
        `An error occured while creating points of interest: ${JSON.stringify(i.data)}, status code: ${i.status}`
      );
    const s = i.data.items.map((r) => r.ownerId), o = await ps(this._sdk, s);
    return i.data.items.forEach((r) => {
      const a = o.get(r.ownerId) ?? "Unknown";
      r.ownerId = a;
    }), i.data.items.map(Ha);
  }
  async fetchPointsOfInterest(e) {
    const t = await this._sdk.post(
      `${this._sdk.getBaseUrl()}/${this._listUrl(this._sdk.project)}`,
      { data: { filter: { scene: e } } }
    );
    if (t.status !== 200)
      throw Error(
        `An error occured while fetching points of interest: ${JSON.stringify(t.data)}, status code: ${t.status}`
      );
    const i = t.data.items.map((o) => o.ownerId), s = await ps(this._sdk, i);
    return t.data.items.forEach((o) => {
      const r = s.get(o.ownerId) ?? "Unknown";
      o.ownerId = r;
    }), t.data.items.map(Ha);
  }
  async deletePointsOfInterest(e) {
    const t = await this._sdk.post(
      `${this._sdk.getBaseUrl()}/${this._deleteUrl(this._sdk.project)}`,
      {
        data: { items: e.map((i) => ({ externalId: i })) }
      }
    );
    if (t.status !== 200)
      throw Error(
        `An error occured while deleting points of interest: ${JSON.stringify(t.data)}, status code: ${t.status}`
      );
  }
  async getPointsOfInterestComments(e) {
    const t = await this._sdk.post(
      `${this._sdk.getBaseUrl()}/${this._getCommentsUrl(this._sdk.project)}`,
      { data: { externalId: e } }
    );
    if (t.status !== 200)
      throw Error(
        `An error occured while fetching points of interest comments: ${JSON.stringify(t.data)}, status code: ${t.status}`
      );
    const i = await ps(
      this._sdk,
      t.data.map((s) => s.ownerId)
    );
    return t.data.forEach((s) => {
      const o = i.get(s.ownerId) ?? "Unknown";
      s.ownerId = o;
    }), t.data;
  }
  async postPointsOfInterestComment(e, t) {
    const i = await this._sdk.post(
      `${this._sdk.getBaseUrl()}/${this._postCommentUrl(this._sdk.project)}`,
      { data: { poi3dExternalId: e, content: t } }
    );
    if (i.status !== 200)
      throw Error(
        `An error occured occured while posting points of interest comment: ${JSON.stringify(i.data)}, status code: ${i.status}`
      );
    const o = (await ps(this._sdk, [i.data.ownerId])).get(i.data.ownerId) ?? "Unknown";
    return i.data.ownerId = o, i.data;
  }
  createNewId() {
    return crypto.randomUUID();
  }
}
function Ha(n) {
  var e, t;
  return {
    id: n.externalId,
    properties: {
      name: n.name,
      description: n.description,
      ownerId: n.ownerId,
      createdTime: n.createdTime,
      positionX: n.position[0],
      positionY: n.position[1],
      positionZ: n.position[2],
      visibility: n.visibility,
      scene: {
        externalId: ((e = n.scene) == null ? void 0 : e.externalId) ?? "dummy-scene-external-id",
        space: ((t = n.scene) == null ? void 0 : t.space) ?? "dummy-scene-space"
      },
      instanceRef: dw(n == null ? void 0 : n.assetRef),
      sceneState: n.sceneState
    }
  };
}
function dw(n) {
  if (n !== void 0) {
    if (lw(n))
      return { id: n.id };
    if (uw(n))
      return { externalId: n.externalId, space: n.instanceSpace };
    throw Error("Unrecognized PoI external reference type");
  }
}
function lw(n) {
  return n.id !== void 0;
}
function uw(n) {
  return n.externalId !== void 0 && n.instanceSpace !== void 0;
}
const Ks = class Ks {
  // ==================================================
  // STATIC METHODS
  // ==================================================
  static setCounterDelegate(e) {
    this._setCounter = e;
  }
  static update() {
    this._setCounter !== void 0 && (this._counter++, this._setCounter(this._counter));
  }
};
Ks._setCounter = void 0, Ks._counter = 0;
let Ls = Ks;
class Fp extends z {
  getCancelButtonLabel() {
  }
  get contents() {
    return this._contents ?? [];
  }
  get onFinish() {
    return this._onFinish;
  }
  set onFinish(e) {
    this._onFinish = e;
  }
  set onCancel(e) {
    this._onCancel = e;
  }
  get onCancel() {
    return this._onCancel;
  }
  invokeWithContent(e) {
    this._contents = e;
    const t = this.invoke();
    return this._contents = hw(this._contents), t;
  }
}
function hw(n) {
  return n.map((e) => e.type === "text" || e.type === "comment" || e.type === "commentWithButtons" ? {
    type: e.type,
    content: ""
  } : e.type === "customInput" || e.type === "submitButtons" ? {
    type: e.type,
    content: void 0
  } : e);
}
const ne = {
  all: ["cdf"],
  all3DResources: () => [...ne.all, "all-3d-resources"],
  // ASSETS
  assetsById: (n) => [...fs, n],
  // DM nodes
  dmNodesById: (n) => [...pw, n],
  // Points of interest
  poiCommentsById: (n) => [...gw, n],
  // TIMESERIES
  timeseriesById: (n) => [...gs, n],
  timeseriesLatestDatapoint: () => [...gs, "latest-datapoints"],
  // TIMESERIES RELATIONSHIPS WITH ASSETS
  timeseriesLinkedToAssets: () => [...gs, "timeseries-linked-assets"],
  // Point Cloud Annotations
  pointCloudAnnotationMappings: (n) => [...kn, "point-cloud-annotation-mappings", n],
  pointCloudAnnotationForAssetIds: (n, e) => [...kn, ...fs, "point-cloud-all-annotations", n, e],
  pointCloudAnnotationForAssetId: (n, e) => [...kn, ...fs, "asset-annotation-mapping-for-a-model", n, e],
  // PointCloud Volume for CoreDM
  pointCloudDMVolumeMappings: (n) => [...kn, "point-cloud-dm-volume-mappings", n],
  pointCloudDMVolumeAssetMappings: (n, e) => [
    ...kn,
    ...fw,
    "point-cloud-dm-volume-asset-mappings",
    n,
    e
  ],
  pointCloudDMModelIdRevisionIds: (n) => [...kn, "point-cloud-dm-model-id-revision-ids", n],
  pointCloudDMVolumeAssetMappingsWithViews: (n) => [...fs, "point-cloud-dm-volume-asset-mappings-with-views", n],
  modelRevisionId: (n) => [...mw, "model-revision-id", n],
  timeseriesFromRelationship: () => [...gs, "timeseries-relationship"]
}, fs = [...ne.all, "assets"], pw = [...ne.all, "dm"], fw = [...ne.all, "asset-instance-refs"], gw = [...ne.all, "pois"], gs = [...ne.all, "timeseries"], kn = [...ne.all, "models"], mw = [...ne.all, "revisions"], Ns = async (n, e) => e.length === 0 ? [] : await n.assets.retrieve(e, { ignoreUnknownIds: !0 }), Vp = (n) => {
  const e = _e();
  return j({
    queryKey: ne.assetsById(n),
    queryFn: async () => await Ns(e, n),
    enabled: n.length > 0
  });
}, yw = (n, e) => {
  const t = Te();
  return j({
    queryKey: ne.dmNodesById(n),
    queryFn: async () => n.length === 0 ? [] : (await t.getByExternalIds(
      n.map((s) => ({ ...s, instanceType: "node" })),
      e
    )).items,
    enabled: n.length > 0
  });
}, vw = [Rs], qa = 20, jp = ({ instance: n }) => {
  const [e, t] = P(
    () => [
      Nt(n) ? [n] : H,
      _t(n) ? [n] : H
    ],
    [n]
  ), { data: i } = Vp(e), { data: s } = yw(t, vw), o = P(() => {
    var d, l;
    if (!(i === void 0 && s === void 0))
      return i !== void 0 && i.length > 0 ? i[0].name : s !== void 0 && s.length > 0 ? ((l = (d = s[0].properties.cdf_cdm) == null ? void 0 : d[`${Rs.externalId}/${Rs.version}`]) == null ? void 0 : l.name) ?? s[0].externalId : "Unknown";
  }, [i, s]), r = o == null ? void 0 : o.toString(), a = (r == null ? void 0 : r.length) !== void 0 && r.length > qa, c = a ? `${r == null ? void 0 : r.slice(0, qa)}...` : r;
  return /* @__PURE__ */ u(ce, { disabled: !a, content: r, children: /* @__PURE__ */ u(Ts, { icon: /* @__PURE__ */ u(lm, {}), value: c, disabled: !0 }) }, r);
};
class Cw extends Fp {
  constructor(e, t) {
    super(), this.poisPlaceholders = [
      { key: "NAME" },
      { key: "POINT_OF_INTEREST_DESCRIPTION_PLACEHOLDER" }
    ], this.poiContents = [
      { type: "text", content: "" },
      { type: "comment", content: "" },
      { type: "customInput", content: "" },
      { type: "submitButtons", content: void 0 }
    ], this.setCustomInputAsInstanceReference = (i) => {
      this.poiContents.forEach((s) => {
        s.type === "customInput" && (s.content = /* @__PURE__ */ u(jp, { instance: i }));
      });
    }, this._point = e, this._scene = t, this._placeholders = this.poisPlaceholders, this._contents = this.poiContents;
  }
  get associatedInstance() {
    return this._associatedInstance;
  }
  set associatedInstance(e) {
    this._associatedInstance = e;
  }
  get contents() {
    return this._contents ?? [];
  }
  getPostButtonLabel() {
    return { key: "CREATE" };
  }
  getCancelButtonLabel() {
    return { key: "CANCEL" };
  }
  getPlaceholderByIndex(e) {
    var t;
    return ((t = this._placeholders) == null ? void 0 : t[e]) ?? void 0;
  }
  getAllPlaceholders() {
    return this._placeholders ?? [];
  }
  get hasData() {
    return !0;
  }
  invokeCore() {
    if (this._contents === void 0)
      return !1;
    const e = this.renderTarget.rootDomainObject.getDescendantByType(
      Ft
    );
    if (e === void 0)
      return !1;
    const t = Iw(this._contents), i = t[0], s = t[1], o = e.addPendingPointsOfInterest(
      sw(
        this._point,
        this._scene,
        i,
        s,
        this._associatedInstance
      )
    );
    return e.save().then(() => {
      var r;
      (r = this.onFinish) == null || r.call(this), e.setSelectedPointOfInterest(o);
    }), !0;
  }
}
function Iw(n) {
  return n.map((e) => {
    if (e.type === "text" || e.type === "comment" || e.type === "commentWithButtons")
      return e.content;
  }).filter((e) => F(e));
}
const Lr = async (n, e, t, i) => n === void 0 || e === void 0 || t === void 0 ? void 0 : (await Promise.all(
  t.map(
    async (a) => await i.matchPointCloudAnnotationsForModel(
      n,
      e,
      a
    )
  )
)).filter(F).flatMap(
  (a) => Array.from(a.entries()).map(([c, d]) => ({
    annotationId: c,
    asset: d
  }))
);
async function ww(n, e) {
  const t = n.viewer, i = n.cdfCaches, s = i.coreDmOnly, o = t.getPixelCoordinatesFromEvent(e), r = await t.getAnyIntersectionFromPixel(o), a = await t.get360AnnotationIntersectionFromPixel(
    e.offsetX,
    e.offsetY
  ), c = a == null ? void 0 : a.annotation.annotation, d = c !== void 0 ? _r(c) : void 0;
  if (!s && d !== void 0)
    return [d];
  if (r !== void 0) {
    if (r.type === "cad")
      return await Sw(r, i);
    if (r.type === "pointcloud")
      return await xw(r, i);
  }
}
async function xw(n, e) {
  return Tt(n.model.modelIdentifier) ? Tw(
    n
  ) : await _w(
    n,
    e
  );
}
async function _w(n, e) {
  var s, o, r;
  if (e.coreDmOnly)
    return [];
  if (((s = n.volumeMetadata) == null ? void 0 : s.assetRef) !== void 0 && Nt(n.volumeMetadata.assetRef))
    return [n.volumeMetadata.assetRef];
  const t = (r = (o = n.volumeMetadata) == null ? void 0 : o.assetRef) == null ? void 0 : r.externalId;
  if (t === void 0)
    return [];
  const i = await Lr(
    n.model.modelIdentifier.modelId,
    n.model.modelIdentifier.revisionId,
    [t],
    e.pointCloudAnnotationCache
  );
  return (i == null ? void 0 : i.map((a) => ({ id: a.asset.id }))) ?? H;
}
function Tw(n) {
  var e;
  return ((e = n.volumeMetadata) == null ? void 0 : e.assetRef) === void 0 ? H : [n.volumeMetadata.assetRef];
}
async function Sw(n, e) {
  const t = bw(n, e), i = Aw(n, e), [s, o] = await Promise.all([t, i]);
  return [...s, ...o];
}
async function bw(n, e) {
  var i;
  return ((i = await e.fdmNodeCache.getClosestParentDataPromises(
    n.model.modelId,
    n.model.revisionId,
    n.treeIndex
  ).cadAndFdmNodesPromise) == null ? void 0 : i.fdmIds) ?? H;
}
async function Aw(n, e) {
  if (e.coreDmOnly)
    return [];
  const t = await Sr(
    n.model.modelId,
    n.model.revisionId,
    n.treeIndex,
    e.cogniteClient
  );
  return (await e.assetMappingAndNode3dCache.getAssetMappingsForLowestAncestor(
    n.model.modelId,
    n.model.revisionId,
    t
  )).mappings.map((s) => ({ id: s.assetId }));
}
const $a = Symbol("poi3d-assigned-instance-styling");
class po extends Mn {
  constructor() {
    super(...arguments), this._isCreating = !1;
  }
  get icon() {
    return "Waypoint";
  }
  get shortCutKey() {
    return "P";
  }
  onEscapeKey() {
    this.closeCreateCommandDialog();
  }
  get tooltip() {
    return { key: "POINT_OF_INTEREST_CREATE" };
  }
  onActivate() {
    super.onActivate();
    let e = this.getPointsOfInterestDomainObject();
    e === void 0 && (e = this.initializePointsOfInterestDomainObject()), e.setVisibleInteractive(!0, this.renderTarget), this.setIsCreating(!0), this.setCursor("copy");
  }
  onDeactivate() {
    super.onDeactivate(), this.getPointsOfInterestDomainObject().setSelectedPointOfInterest(void 0), this.setIsCreating(!1), this.setCursor("default"), this.setAssignedInstance(void 0);
  }
  async onClick(e) {
    if (this._isCreating) {
      await this.initiateCreatePointOfInterest(e), this.setIsCreating(!1);
      return;
    }
    await this.selectOverlayFromClick(e);
  }
  attach(e) {
    super.attach(e), this.initializePointsOfInterestDomainObject();
  }
  getAnchoredDialogContent() {
    return this._anchoredDialogContent;
  }
  getPointsOfInterestDomainObject() {
    return this.initializePointsOfInterestDomainObject();
  }
  initializePointsOfInterestDomainObject() {
    const e = this.rootDomainObject.getDescendantByType(
      Ft
    );
    if (e !== void 0)
      return e;
    const t = new Ft(
      new cw(
        this.rootDomainObject.sdk
      )
    );
    return this.rootDomainObject.addChildInteractive(t), t;
  }
  get isCreating() {
    return this._isCreating;
  }
  setIsCreating(e) {
    this._isCreating = e, e ? this.renderTarget.setCrosshairCursor() : this.renderTarget.setNavigateCursor();
  }
  setAssignedInstance(e) {
    if (e === void 0) {
      this.renderTarget.instanceStylingController.setStylingGroup(
        $a,
        void 0
      );
      return;
    }
    const t = Bp([e], Ys.Highlighted);
    this.renderTarget.instanceStylingController.setStylingGroup(
      $a,
      t
    );
  }
  setAnchoredDialogContent(e) {
    this._anchoredDialogContent = e, Ls.update();
  }
  openCreateCommandDialog(e, t) {
    const i = this.getPointsOfInterestDomainObject(), s = i == null ? void 0 : i.getScene();
    if (s === void 0)
      return;
    const o = new Cw(e, s);
    o.attach(this.renderTarget);
    const r = [
      {
        eventName: "keydown",
        callback: (d) => {
          d instanceof KeyboardEvent && d.key === "Escape" && this.onEscapeKey();
        }
      }
    ], a = () => {
      this.closeCreateCommandDialog();
    }, c = () => {
      a();
    };
    o.onFinish = a, o.onCancel = c, this.setAnchoredDialogContent({
      contentCommands: [o],
      position: e,
      onCloseCallback: c,
      customListeners: r
    }), ww(this.renderTarget, t).then((d) => {
      if (d !== void 0 && d.length !== 0) {
        const l = d[0];
        this.setAssignedInstance(l), o.associatedInstance = l, o.setCustomInputAsInstanceReference(l);
      }
    });
  }
  closeCreateCommandDialog() {
    this.setAnchoredDialogContent(void 0), this.renderTarget.commandsController.activateDefaultTool();
  }
  async selectOverlayFromClick(e) {
    const t = await this.getIntersection(e);
    if (t === void 0 || !Zo(t)) {
      await super.onClick(e);
      return;
    }
    t.domainObject.setSelectedPointOfInterest(t.userData);
  }
  async initiateCreatePointOfInterest(e) {
    const t = await this.getIntersection(e);
    if (t === void 0 || Zo(t)) {
      this.closeCreateCommandDialog();
      return;
    }
    this.openCreateCommandDialog(t.point, e);
  }
}
function Ew(n) {
  return n === "top" || n === "bottom" ? "row" : "column";
}
function Mw(n) {
  return n === "top" || n === "bottom" ? "vertical" : "horizontal";
}
function ss(n) {
  switch (n) {
    case "top":
      return "bottom";
    case "bottom":
      return "top";
    case "left":
      return "right";
    case "right":
      return "left";
    default:
      return "top";
  }
}
function fo(n) {
  return n.buttonType;
}
function zp(n, e) {
  if (!n.hasData) {
    const t = e.commandsController.getEqual(n);
    if (t !== void 0)
      return t;
    e.commandsController.add(n);
  }
  return n instanceof z && n.attach(e), n;
}
const ai = ({
  label: n,
  command: e,
  inverted: t = !0
}) => {
  if (n === void 0)
    return /* @__PURE__ */ u(k, {});
  const i = e == null ? void 0 : e.getShortCutKeys();
  return /* @__PURE__ */ _(Pw, { children: [
    /* @__PURE__ */ u(Ow, { children: n }),
    i !== void 0 && /* @__PURE__ */ u(um, { keys: i, inverted: t })
  ] }, n);
}, Pw = b.div`
  display: flex;
  flex-direction: row;
`, Ow = b.div`
  margin-right: 4px;
`, Nr = "4px 8px", Wa = "rgba(0, 0, 0, 0.7)", go = 500;
function On(n) {
  const e = me();
  return P(() => zp(n, e), [n]);
}
function Rw(n, e) {
  const [t, i] = M(e), s = Z(() => {
    i(e());
  }, [n]);
  return R(() => (s(), n == null || n.addEventListener(s), () => {
    n == null || n.removeEventListener(s);
  }), [n, s]), t;
}
function Ae(n, e) {
  const [t, i] = M(e), s = Z(() => {
    i(e());
  }, [n]);
  return R(() => (s(), n.addEventListener(s), () => {
    n.removeEventListener(s);
  }), [n, s]), t;
}
function mt(n) {
  return {
    icon: Dw(n),
    uniqueId: kw(n),
    isVisible: Rn(n),
    isEnabled: Lw(n),
    isChecked: Nw(n)
  };
}
function Dw(n) {
  return Ae(n, () => n.icon);
}
function kw(n) {
  return Ae(n, () => n.uniqueId);
}
function Rn(n) {
  return Ae(n, () => n.isVisible);
}
function Lw(n) {
  return Ae(n, () => n.isEnabled);
}
function Nw(n) {
  return Ae(n, () => n.isChecked);
}
function Bw(n) {
  return Ae(n, () => n.value);
}
const Up = ({
  inputCommand: n,
  placement: e,
  usedInSettings: t = !1
}) => {
  const i = On(n);
  return Rn(i) ? t ? /* @__PURE__ */ u(Vw, { command: i }) : /* @__PURE__ */ u(Fw, { command: i, placement: e }) : /* @__PURE__ */ u(k, {});
}, Fw = ({
  command: n,
  placement: e
}) => {
  var l;
  const { uniqueId: t, isEnabled: i } = mt(n), [s, o] = M(!1);
  if (n.children === void 0)
    return /* @__PURE__ */ u(k, {});
  const r = n.label, a = (l = n.selectedChild) == null ? void 0 : l.label, c = r === void 0 || s, d = s ? ud : hd;
  return /* @__PURE__ */ u(
    Ge,
    {
      onOpenChange: (h) => {
        o(h);
      },
      open: s,
      placement: "bottom-start",
      disableCloseOnClickInside: !0,
      renderTrigger: (h) => /* @__PURE__ */ u(
        ce,
        {
          content: /* @__PURE__ */ u(ai, { label: r, command: n }),
          disabled: c,
          enterDelay: go,
          placement: ss(e),
          children: /* @__PURE__ */ u(
            J,
            {
              style: {
                padding: "8px 4px"
              },
              type: fo(n),
              icon: /* @__PURE__ */ u(d, {}),
              disabled: !i,
              iconPlacement: "left",
              "aria-label": n.label,
              toggled: s,
              ...h,
              onClick: (p) => {
                var f;
                p.stopPropagation(), p.preventDefault(), (f = h.onClick) == null || f.call(h, p);
              },
              children: a
            },
            t
          )
        }
      ),
      children: n.children.map((h) => jw(h, o))
    }
  );
}, Vw = ({ command: n }) => {
  const e = n.label;
  return n.children === void 0 ? /* @__PURE__ */ u(k, {}) : /* @__PURE__ */ _(Gw, { children: [
    /* @__PURE__ */ u(zw, { children: e }),
    /* @__PURE__ */ u(
      Uw,
      {
        defaultValue: n.selectedChild,
        fullWidth: !0,
        "aria-label": n.label,
        onChange: (t, i) => {
          i == null || i.invoke();
        },
        children: n.children.map((t) => /* @__PURE__ */ u(Ry, { value: t, children: t.label }, t.uniqueId))
      }
    )
  ] });
};
function jw(n, e) {
  const { uniqueId: t, isEnabled: i, isChecked: s } = mt(n);
  return /* @__PURE__ */ u(
    Ge.ItemToggled,
    {
      disabled: !i,
      toggled: s,
      label: n.label,
      onClick: () => {
        n.invoke(), e(!1);
      }
    },
    t
  );
}
const zw = b.label`
  flex: 1 1;
`, Uw = b(Oy)`
  flex: 1 1;
`, Gw = b.div`
  display: flex;
  flex-direction: row;
  align-self: stretch;
  align-items: center;
  padding: ${Nr};
`, Hw = [
  ["Angle", hm],
  ["ArrowLeft", pm],
  ["ArrowRight", fm],
  ["Axis3D", gm],
  ["Bug", mm],
  ["BorderHorizontal", ym],
  ["BorderVertical", vm],
  ["Circle", Cm],
  ["ClearAll", Im],
  ["CloseLarge", dd],
  ["Coordinates", wm],
  ["Copy", xm],
  ["Crop", _m],
  ["Cube", Tm],
  ["Cubes", Sm],
  ["CubeFrontLeft", bm],
  ["CubeFrontRight", Am],
  ["CubeTop", Em],
  ["Cursor", Mm],
  ["CylinderHorizontal", Pm],
  ["CylinderVertical", Om],
  ["CylinderArbitrary", Rm],
  ["Delete", Dm],
  ["ExpandAlternative", pd],
  ["EyeShow", km],
  ["Filter", Lm],
  ["Flag", Nm],
  ["FlipHorizontal", Bm],
  ["FlipVertical", Fm],
  ["Folder", Vm],
  ["FolderFilled", jm],
  ["Grab", zm],
  ["GraphTree", Um],
  ["Info", ad],
  ["Leaf", Gm],
  ["Location", Hm],
  ["Perspective", qm],
  ["PerspectiveAlt", $m],
  ["Plane", Wm],
  ["Plus", Km],
  ["PointCloud", Ym],
  ["Polygon", Xm],
  ["Refresh", Zm],
  ["Restore", Qm],
  ["Ruler", Jm],
  ["RulerAlternative", ey],
  ["Save", ty],
  ["Shapes", ny],
  ["Settings", fd],
  ["Snow", iy],
  ["Sun", sy],
  ["Sync", oy],
  ["VectorLine", ry],
  ["VectorZigzag", ay],
  ["View360", cy],
  ["Waypoint", gd]
], Ka = (n) => /* @__PURE__ */ u(k, {}), Mi = class Mi {
  static install(e, t) {
    Mi._icons.set(e, t);
  }
  static getIcon(e) {
    return e === void 0 ? Ka : Mi._icons.get(e) ?? Ka;
  }
};
Mi._icons = new Map(Hw);
let Bs = Mi;
const In = ({ iconName: n, ...e }) => {
  const t = Bs.getIcon(n);
  return /* @__PURE__ */ u(t, { ...e });
}, qw = ({
  inputCommand: n,
  placement: e
}) => {
  const t = me(), i = On(n), { icon: s, uniqueId: o, isVisible: r, isEnabled: a, isChecked: c } = mt(i);
  if (!r)
    return /* @__PURE__ */ u(k, {});
  const d = i.label;
  return /* @__PURE__ */ u(
    ce,
    {
      content: /* @__PURE__ */ u(ai, { label: d, command: i }),
      disabled: d === void 0,
      enterDelay: go,
      placement: ss(e),
      children: /* @__PURE__ */ u(
        J,
        {
          type: fo(i),
          icon: /* @__PURE__ */ u(In, { iconName: s }),
          disabled: !a,
          toggled: c,
          "aria-label": d,
          iconPlacement: "left",
          onClick: () => {
            i.invoke(), t.domElement.focus();
          }
        },
        o
      )
    }
  );
}, $w = ({
  command: n
}) => {
  const e = On(n), t = Rn(e), i = Ae(e, () => e.content), s = Ae(e, () => e.status);
  return t ? /* @__PURE__ */ u(Ww, { status: s, children: mn(i) }) : null;
}, Ww = b(md)`
  display: flex;
  padding: 8px 12px;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;
var we = /* @__PURE__ */ ((n) => (n[n.Contextualized = 0] = "Contextualized", n[n.Approved = 1] = "Approved", n[n.Suggested = 2] = "Suggested", n[n.Rejected = 3] = "Rejected", n))(we || {});
const Ya = [
  3,
  2,
  1,
  0
  /* Contextualized */
];
class Gp extends Qt {
  constructor() {
    super(...arguments), this.contextualizedColor = 13920994, this.suggestedColor = 16776960, this.approvedColor = 65280, this.rejectedColor = 16711680, this.pendingColor = 5089023, this.hoveredColor = 16776960, this.blankColor = 16777215, this.blankOpacity = 0.333, this.lineWidth = 2, this.selectedLineWidth = 4, this.pendingLineWidth = 6;
  }
  // ==================================================
  // OVERRIDES of BaseStyle
  // ==================================================
  clone() {
    return Mt(this);
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  getColorByStatus(e) {
    switch (e) {
      case we.Contextualized:
        return this.contextualizedColor;
      case we.Approved:
        return this.approvedColor;
      case we.Suggested:
        return this.suggestedColor;
      default:
        return this.rejectedColor;
    }
  }
}
class wt extends $n {
  constructor(e, t) {
    super(e), this.annotation = t;
  }
}
class Kw {
}
class cn extends Kw {
  constructor(e, t) {
    super(), this.id = e, this.externalId = t;
  }
}
class Vt {
  constructor() {
    this.id = 0, this.modelId = 0, this.assetId = void 0, this.status = "suggested", this.primitives = new Array(), this.confidence = void 0, this.label = void 0, this.selectedIndex = void 0;
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get isEmpty() {
    return this.primitives.length === 0;
  }
  get isSingle() {
    return this.primitives.length === 1;
  }
  get hasAssetRef() {
    return this.assetId !== void 0;
  }
  get resultingCdfStatus() {
    return this.hasAssetRef ? "approved" : this.status;
  }
  get firstPrimitive() {
    return this.isEmpty ? void 0 : this.primitives[0];
  }
  get selectedPrimitive() {
    const e = this.selectedIndex;
    if (!(e === void 0 || e < 0 || e >= this.primitives.length))
      return this.primitives[e];
  }
  get firstLabel() {
    return this.isEmpty ? void 0 : this.primitives[0].label;
  }
  get firstConfidence() {
    return this.isEmpty ? void 0 : this.primitives[0].confidence;
  }
  get primitiveType() {
    var e;
    return ((e = this.selectedPrimitive) == null ? void 0 : e.primitiveType) ?? y.None;
  }
  // ==================================================
  // INSTANCE METHODS: Requests
  // ==================================================
  equalId(e) {
    return this.id === e.id;
  }
  // ==================================================
  // INSTANCE METHODS: Getters/Setters asset ref
  // ==================================================
  getAssetRefId() {
    if (this.assetId instanceof cn)
      return this.assetId.id;
  }
  setAssetRefId(e) {
    this.assetId instanceof cn && (this.assetId.id = e), this.assetId = new cn(e);
  }
  getAssetRefExternalId() {
    if (this.assetId instanceof cn)
      return this.assetId.externalId;
  }
  setAssetRefExternalId(e) {
    this.assetId instanceof cn && (this.assetId.externalId = e), this.assetId = new cn(void 0, e);
  }
  // ==================================================
  // INSTANCE METHODS: Getters/Setters other
  // ==================================================
  getBoundingBox() {
    const e = new te().makeEmpty();
    return this.expandBoundingBox(e), e;
  }
  getStatus() {
    return this.primitives.length === 0 ? we.Rejected : this.hasAssetRef ? we.Contextualized : this.status === "approved" ? we.Approved : this.status === "suggested" ? we.Suggested : we.Rejected;
  }
  setSelectedPrimitive(e) {
    this.selectedIndex = this.primitives.indexOf(e);
  }
  // ==================================================
  // INSTANCE METHODS:
  // ==================================================
  removeSelectedPrimitive() {
    const e = this.selectedPrimitive;
    return this.selectedIndex = void 0, !(e === void 0 || !Wn(this.primitives, e));
  }
  expandBoundingBox(e) {
    for (const t of this.primitives)
      t.expandBoundingBox(e);
  }
  remap(e) {
    const t = e.find((i) => i.equalId(this));
    if (t !== void 0)
      return this !== t && (t.selectedIndex = this.selectedIndex), t;
  }
  align(e) {
    const { selectedPrimitive: t } = this;
    if (t === void 0)
      return !1;
    if (t instanceof ye)
      t.rotation.x = 0, t.rotation.y = 0;
    else if (t instanceof Y) {
      const i = t.centerA, s = t.centerB;
      if (e ? i.z = s.z = (i.z + s.z) / 2 : (i.x = s.x = (i.x + s.x) / 2, i.y = s.y = (i.y + s.y) / 2), i.distanceTo(s) < t.radius / 4)
        return !1;
    } else
      return !1;
    return !0;
  }
  // ==================================================
  // STATIC METHODS:
  // ==================================================
  static create(e) {
    const t = new Vt();
    return t.selectedIndex = 0, t.status = "approved", t.primitives.push(e), t;
  }
  static areEqualIncludeSelected(e, t, i) {
    return e === void 0 && t === void 0 ? !0 : e === void 0 || t === void 0 ? !1 : e === t && e.selectedIndex === i;
  }
  static areEqual(e, t) {
    return e === void 0 && t === void 0 ? !0 : e === void 0 || t === void 0 ? !1 : e === t;
  }
}
class wn extends uo {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor() {
    super(), this.color = new D(D.NAMES.white);
  }
  // ==================================================
  // OVERRIDES of DomainObject
  // ==================================================
  get typeName() {
    return { key: "BOX" };
  }
  createRenderStyle() {
    const e = new oi();
    return e.showLabel = !1, e.solidOpacity = 0.3333, e;
  }
  clone(e) {
    const t = new wn();
    return t.copyFrom(this, e), t;
  }
  notifyCore(e) {
    super.notifyCore(e);
    const t = e.getChangedDescription(m.geometry);
    t !== void 0 && !t.isChanged(bt.GizmoOnly) ? this.updateSelectedAnnotationFromThis(!1) : e.isChanged(m.dragging) && this.updateSelectedAnnotationFromThis(!0);
  }
  getPanelToolbar() {
    return [new Zi(), new io()];
  }
  get isVisibleInTree() {
    return !1;
  }
  // ==================================================
  // OVERRIDES of VisualDomainObject
  // ==================================================
  get useClippingInIntersection() {
    return !1;
  }
  // ==================================================
  // OVERRIDES of BoxDomainObject
  // ==================================================
  canRotateComponent(e) {
    return !0;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  createAnnotation() {
    const e = new ye();
    return e.copy(this.box), Vt.create(e);
  }
  updateThisFromAnnotation(e) {
    const t = e.selectedPrimitive;
    return t instanceof ye ? (this.box.copy(t), !0) : !1;
  }
  updateSelectedAnnotationFromThis(e) {
    const t = this.parent;
    if (t === void 0)
      return !1;
    const i = t.selectedAnnotation;
    if (i === void 0)
      return !1;
    const s = i.selectedPrimitive;
    if (!(s instanceof ye))
      return !1;
    s.copy(this.box);
    const o = e ? m.dragging : m.changedPart, r = new wt(o, i);
    return t.notify(r), !0;
  }
}
class xn extends Dr {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e = y.Cylinder) {
    super(e), this.color = new D(D.NAMES.white);
  }
  // ==================================================
  // OVERRIDES of DomainObject
  // ==================================================
  get typeName() {
    return { key: "CYLINDER" };
  }
  createRenderStyle() {
    const e = new oi();
    return e.showLabel = !1, e.solidOpacity = 0.3333, e;
  }
  clone(e) {
    const t = new xn();
    return t.copyFrom(this, e), t;
  }
  notifyCore(e) {
    super.notifyCore(e);
    const t = e.getChangedDescription(m.geometry);
    t !== void 0 && !t.isChanged(bt.GizmoOnly) ? this.updateSelectedAnnotationFromThis(!1) : e.isChanged(m.dragging) && this.updateSelectedAnnotationFromThis(!0);
  }
  getPanelToolbar() {
    return [new Zi(), new io()];
  }
  get isVisibleInTree() {
    return !1;
  }
  // ==================================================
  // OVERRIDES of VisualDomainObject
  // ==================================================
  get useClippingInIntersection() {
    return !1;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  createAnnotation() {
    const e = new Y();
    return e.copy(this.cylinder), Vt.create(e);
  }
  updateThisFromAnnotation(e) {
    const t = e.selectedPrimitive;
    return t instanceof Y ? (this.cylinder.copy(t), !0) : !1;
  }
  updateSelectedAnnotationFromThis(e) {
    const t = this.parent;
    if (t === void 0)
      return !1;
    const i = t.selectedAnnotation;
    if (i === void 0)
      return !1;
    const s = i.selectedPrimitive;
    if (!(s instanceof Y))
      return !1;
    s.copy(this.cylinder);
    const o = e ? m.dragging : m.changedPart, r = new wt(o, i);
    return t.notify(r), !0;
  }
}
const Hp = 0.2, Xa = "threedmodel", Za = "pointcloud.BoundingVolume", Yw = "3d-management", Xw = "0.0.1", Zw = "3d-management";
class qp {
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  static async update(e, t) {
    const i = [
      {
        id: t.id,
        update: {
          status: {
            set: t.resultingCdfStatus
          },
          data: {
            set: {
              region: Qa(t.primitives),
              assetRef: {
                id: t.getAssetRefId(),
                externalId: t.getAssetRefExternalId()
              },
              confidence: t.confidence,
              label: t.label
            }
          }
        }
      }
    ];
    return await e.annotations.update(i), !0;
  }
  static async create(e, t) {
    const i = [
      {
        status: t.resultingCdfStatus,
        data: {
          region: Qa(t.primitives),
          assetRef: {
            id: t.getAssetRefId(),
            externalId: t.getAssetRefExternalId()
          },
          confidence: t.confidence,
          label: t.label
        },
        annotatedResourceType: Xa,
        annotatedResourceId: t.modelId,
        annotationType: Za,
        creatingApp: Yw,
        creatingAppVersion: Xw,
        creatingUser: Zw
      }
    ], s = await e.annotations.create(i);
    return t.id = s[0].id, !0;
  }
  static async delete(e, t) {
    const i = [{ id: t.id }];
    return await e.annotations.delete(i), !0;
  }
  // ==================================================
  // STATIC METHODS
  // ==================================================
  static async fetchAllAnnotations(e, t) {
    const i = await e.annotations.list({
      filter: {
        annotatedResourceType: Xa,
        annotationType: Za,
        annotatedResourceIds: [{ id: t }]
      },
      limit: 1e3
    }).autoPagingToArray({ limit: 1 / 0 }), s = [];
    for (const o of i) {
      const r = new Vt();
      r.id = o.id, r.modelId = o.annotatedResourceId;
      const a = o.data;
      r.confidence = a.confidence, r.label = a.label;
      const c = new cn();
      a.assetRef !== void 0 && (a.assetRef.id !== void 0 && (c.id = a.assetRef.id), a.assetRef.externalId !== void 0 && (c.externalId = a.assetRef.externalId)), r.assetId = c, r.status = o.status, r.primitives = Qw(a.region), s.push(r);
    }
    return s;
  }
}
function Qw(n) {
  const e = [];
  for (const t of n) {
    const i = Jw(t);
    if (i === void 0) {
      console.error("The primitive is not a box or a cylinder");
      continue;
    }
    e.push(i);
  }
  return e;
}
function Jw(n) {
  if (n.box !== void 0)
    return ex(n.box);
  if (n.cylinder !== void 0)
    return tx(n.cylinder);
}
function ex(n) {
  const e = new fe().fromArray(n.matrix).transpose(), t = new ye();
  return t.setMatrix(e), t.label = n.label, t.confidence = n.confidence, t;
}
function tx(n) {
  const e = new Y();
  return e.centerA.copy(new I(...n.centerA)), e.centerB.copy(new I(...n.centerB)), e.radius = n.radius * (1 + Hp), e.label = n.label, e.confidence = n.confidence, e;
}
function Qa(n) {
  const e = [];
  for (const t of n) {
    const i = nx(t);
    if (i === void 0) {
      console.error("The Cdf geometry is not a box or a cylinder");
      continue;
    }
    e.push(i);
  }
  return e;
}
function nx(n) {
  return n instanceof ye ? { box: ix(n) } : n instanceof Y ? { cylinder: sx(n) } : void 0;
}
function ix(n) {
  return {
    matrix: n.getMatrix().transpose().elements,
    confidence: n.confidence,
    label: n.label
  };
}
function sx(n) {
  return {
    centerA: n.centerA.toArray(),
    centerB: n.centerB.toArray(),
    radius: n.radius / (1 + Hp),
    confidence: n.confidence,
    label: n.label
  };
}
class ke extends Me {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor() {
    super(), this._annotations = [], this._focusType = A.None, this.selectedAnnotation = void 0, this.focusAnnotation = void 0, this.pendingAnnotation = void 0, this.applyPendingWhenCreated = !1;
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get annotations() {
    return this._annotations;
  }
  set annotations(e) {
    this._annotations = e, this.selectedAnnotation !== void 0 && (this.selectedAnnotation = this.selectedAnnotation.remap(e), this.selectedAnnotation === void 0 && this.removeGizmoInteractive()), this.focusAnnotation !== void 0 && (this.focusAnnotation = this.focusAnnotation.remap(e)), this.pendingAnnotation !== void 0 && (this.pendingAnnotation = this.pendingAnnotation.remap(e), this.pendingAnnotation === void 0 && this.removeGizmoInteractive());
    const t = this.getGizmo();
    t !== void 0 && t.notify(m.geometry), this.notify(m.geometry);
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get renderStyle() {
    return super.getRenderStyle();
  }
  // ==================================================
  // OVERRIDES of DomainObject
  // ==================================================
  get icon() {
    return "Cube";
  }
  get typeName() {
    return { untranslated: "Annotations" };
  }
  createRenderStyle() {
    return new Gp();
  }
  // ==================================================
  // INSTANCE METHODS: Interactive operations
  // ==================================================
  removeSelectedAnnotationInteractive() {
    if (this.selectedAnnotation === void 0 || this.annotations === void 0)
      return !1;
    let e;
    if (this.selectedAnnotation.isSingle) {
      if (e = Wn(this.annotations, this.selectedAnnotation), e) {
        const t = new wt(
          m.deletedPart,
          this.selectedAnnotation
        );
        this.notify(t), this.removeGizmoInteractive(), this.selectedAnnotation = void 0;
      }
    } else if (e = this.selectedAnnotation.removeSelectedPrimitive(), e) {
      const t = new wt(
        m.changedPart,
        this.selectedAnnotation
      );
      this.notify(t), this.removeGizmoInteractive();
    }
    return e;
  }
  setSelectedInteractive(e) {
    return this.isSelected === e ? !1 : (this.isSelected = e, this.notify(m.selected), !0);
  }
  setSelectedAnnotationInteractive(e, t, i = !0) {
    if (Vt.areEqualIncludeSelected(this.selectedAnnotation, e, t))
      return !1;
    if (this.selectedAnnotation = e, this.selectedAnnotation !== void 0 && (this.selectedAnnotation.selectedIndex = t, this.setSelectedInteractive(!0)), this.setFocusAnnotationInteractive(A.None), this.notify(m.selected), i)
      if (e !== void 0) {
        const s = this.getOrCreateGizmoByAnnotation(e);
        if (s !== void 0) {
          const o = new ct(m.geometry, bt.GizmoOnly);
          o.addChange(m.color), s.notify(o), s.setFocusInteractive(A.Body), s.setSelectedInteractive(!0), s.setVisibleInteractive(!0);
        }
      } else
        this.removeGizmoInteractive();
    return !0;
  }
  setFocusAnnotationInteractive(e, t) {
    return Vt.areEqual(this.focusAnnotation, t) && this._focusType === e ? !1 : (this._focusType = e, this.focusAnnotation = t, this.notify(m.focus), !0);
  }
  applyPendingAnnotationInteractive(e) {
    return this.pendingAnnotation === void 0 ? !1 : (e !== void 0 && (this.pendingAnnotation = e), this.annotations.push(this.pendingAnnotation), this.notify(new wt(m.addedPart, this.pendingAnnotation)), this.setSelectedAnnotationInteractive(this.pendingAnnotation, 0), this.setVisibleInteractive(!0), this.pendingAnnotation = void 0, !0);
  }
  cancelPendingAnnotationInteractive() {
    return this.pendingAnnotation === void 0 ? !1 : (this.removeGizmoInteractive(), this.pendingAnnotation = void 0, !0);
  }
  // ==================================================
  // INSTANCE METHODS: Get or create the gizmo
  // ==================================================
  getGizmo() {
    const e = this.getDescendantByType(wn);
    return e !== void 0 ? e : this.getDescendantByType(xn);
  }
  getOrCreateGizmo(e) {
    const t = this.getGizmo();
    if ((e === y.HorizontalCylinder || e === y.VerticalCylinder) && (e = y.Cylinder), t !== void 0 && t.primitiveType === e)
      return t;
    t !== void 0 && t.removeInteractive(!1);
    const i = ox(e);
    return i !== void 0 && this.addChildInteractive(i), i;
  }
  getOrCreateGizmoByAnnotation(e) {
    const t = this.getOrCreateGizmo(e.primitiveType);
    if (t === void 0 || !t.updateThisFromAnnotation(e))
      return;
    const i = this.renderStyle, s = t.renderStyle;
    return s.showLines = !0, s.lineWidth = i.lineWidth, s.selectedLineWidth = i.selectedLineWidth, s.depthTest = i.depthTest, t.color.set(i.getColorByStatus(e.getStatus())), t;
  }
  getOrCreateGizmoForPending(e) {
    const t = this.getOrCreateGizmo(e);
    if (t === void 0)
      return;
    t.clear();
    const i = this.renderStyle, s = t.renderStyle;
    return s.showLines = !0, s.lineWidth = i.lineWidth, s.selectedLineWidth = i.selectedLineWidth, s.depthTest = !1, t.color.set(i.pendingColor), t;
  }
  removeGizmoInteractive() {
    const e = this.getGizmo();
    e !== void 0 && e.removeInteractive(!1);
  }
  // ==================================================
  // INSTANCE METHODS: Create, update, delete
  // ==================================================
  fetch(e) {
    const t = Le(this);
    return t === void 0 ? !1 : (qp.fetchAllAnnotations(t.sdk, e).then((i) => {
      this.setSelectedInteractive(!0), this.setVisibleInteractive(!0), this.notify(m.loaded);
    }), !0);
  }
}
function ox(n) {
  switch (n) {
    case y.Box:
      return new wn();
    case y.Cylinder:
      return new xn();
    default:
      return;
  }
}
class rx {
  // Pending annotation has empty array
  constructor(e, t) {
    this.annotations = [], this.status = e, this.selected = t;
  }
  get length() {
    return this.annotations.length;
  }
  get isEmpty() {
    return this.length === 0;
  }
  includes(e) {
    return this.annotations.includes(e);
  }
  add(e) {
    this.annotations.push(e);
  }
}
const an = 0.5, $p = 5, Ut = $p * 6;
class Wt {
  static createUnitGeometry() {
    return new ed(an, an, 1, Ut);
  }
  static createLineSegmentsGeometry() {
    const e = Wt.createPositions();
    return $e.createLineSegmentsGeometryByPosition(e);
  }
  static createPositions() {
    const e = 2 * Math.PI / Ut, t = [];
    for (let o = 0; o <= Ut; o++) {
      const r = o * e;
      t.push(an * Math.sin(r)), t.push(an * Math.cos(r)), t.push(-0.5);
    }
    for (let o = 0; o <= Ut; o++) {
      const r = o * e;
      t.push(an * Math.sin(r)), t.push(an * Math.cos(r)), t.push(an);
    }
    const i = [];
    for (let o = 0; o < Ut; o++)
      i.push(o, o + 1);
    const s = 1 + Ut;
    for (let o = 0; o < Ut; o++)
      i.push(o + s, o + 1 + s);
    for (let o = 0; o < Ut; o += $p)
      i.push(o, o + s);
    return $e.createLineSegmentsAsPositions(t, i);
  }
  static createLineSegmentsBufferGeometry() {
    const e = Wt.createPositions();
    return $e.createBufferGeometry(e);
  }
}
function ax({ annotations: n, globalMatrix: e, status: t, selected: i, startIndex: s, groupSize: o }, r) {
  if (n.length === 0)
    return;
  const a = [], c = new rx(t, i), d = o === void 0 ? n.length : Math.min(s + o, n.length), l = new I();
  let h;
  for (let g = s; g < d; g++) {
    const C = n[g];
    for (const v of C.primitives) {
      const w = v.getMatrix();
      if (w === void 0)
        continue;
      const x = lx(v);
      x !== void 0 && (w.premultiply(e), h === void 0 && (l.setFromMatrixPosition(w), h = Ja(l, -1)), w.premultiply(h), ux(a, x, w));
    }
    if (c.add(C), o !== void 0 && c.length >= o)
      break;
  }
  const p = $e.createLineSegmentsGeometryByPosition(a), f = new ti(p, r);
  return h = Ja(l), f.matrix = h, f.matrixAutoUpdate = !1, f.computeLineDistances(), f.userData = c, f;
}
const cx = Wt.createPositions(), dx = nt.createPositions();
function lx(n) {
  return n instanceof ye ? dx : n instanceof Y ? cx : void 0;
}
function Ja(n, e = 1) {
  return new fe().makeTranslation(
    e * n.x,
    e * n.y,
    e * n.z
  );
}
function ux(n, e, t) {
  const i = new I(), s = new Array(e.length);
  for (let o = 0; o < e.length; o += 3) {
    const r = e[o], a = e[o + 1], c = e[o + 2];
    i.set(r, a, c), i.applyMatrix4(t), s[o] = i.x, s[o + 1] = i.y, s[o + 2] = i.z;
  }
  n.push(...s);
}
function hx(n, e, t) {
  const i = new cr(t.origin);
  for (const s of n)
    for (const o of s.primitives) {
      const r = o.intersectRay(t, e);
      if (r === void 0)
        continue;
      const a = i.getClosestGeometry();
      if (a === void 0 || !(a === void 0 ? !1 : a.primitive.isPointInside(r, e) || o.isPointInside(a.point, e))) {
        i.addLazy(
          r,
          () => new ec(s, o, r)
        );
        continue;
      }
      a.volume === void 0 && (a.volume = a.primitive.volume);
      const d = o.volume;
      if (d > a.volume)
        continue;
      i.clear();
      const l = new ec(s, o, r);
      l.volume = d, i.add(r, l);
    }
  return i;
}
class ec {
  constructor(e, t, i) {
    this.volume = void 0, this.annotation = e, this.primitive = t, this.point = i;
  }
  get primitiveIndex() {
    const e = this.annotation.primitives.indexOf(this.primitive);
    return e >= 0 ? e : void 0;
  }
}
const px = new I();
function tc(n, e) {
  if (e.isEmpty())
    return !1;
  for (const t of Ep(e, px))
    if (Kc(n, t))
      return !0;
  return !1;
}
const nc = "focus-annotation-name", ic = 100;
class fx extends gt {
  // ==================================================
  // CONSTRUCTORS
  // ==================================================
  constructor() {
    super(), this.globalMatrix = new fe(), this.globalMatrix = G.clone(), this.contextLineMaterial = Gt(), this.approvedLineMaterial = Gt(), this.suggestedLineMaterial = Gt(), this.rejectedLineMaterial = Gt(), this.contextSelectedLineMaterial = Gt(), this.approvedSelectedLineMaterial = Gt(), this.suggestedSelectedLineMaterial = Gt(), this.rejectedSelectedLineMaterial = Gt(), this.focusAnnotationMaterial = new qi();
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get style() {
    return super.style;
  }
  // ==================================================
  // OVERRIDES of BaseView
  // ==================================================
  update(e) {
    super.update(e), e.isChanged(m.renderStyle) && (this.updateRenderStyle(), this.invalidateRenderTarget()), e.isChanged(m.selected) && (this.updateSelectedAnnotation(), this.invalidateRenderTarget()), e.isChanged(m.focus) && (this.updateFocusAnnotation(), this.invalidateRenderTarget()), e.isChanged(m.clipping) && (this.removeChildren(), this.invalidateRenderTarget());
    const t = e.getChangedDescriptionByType(wt);
    if (t !== void 0)
      if (t.change === m.addedPart)
        this.removeChildren(), this.invalidateRenderTarget();
      else {
        const i = t.annotation;
        for (const s of this.getWireframes()) {
          const o = mi(s);
          if (o === void 0 || o.isEmpty || !o.includes(i))
            continue;
          const r = t.change === m.deletedPart ? o.annotations.filter((a) => a !== i) : o.annotations;
          this.addWireframeFromMultipleAnnotations({
            annotations: r,
            globalMatrix: this.globalMatrix,
            status: o.status,
            selected: o.selected,
            startIndex: 0
          }), this._group.remove(s), Ro(s), this.invalidateRenderTarget();
          break;
        }
      }
  }
  // ==================================================
  // OVERRIDES of GroupThreeView
  // ==================================================
  get useDepthTest() {
    return this.style.depthTest;
  }
  calculateBoundingBox() {
    const e = this.domainObject.annotations, t = new te().makeEmpty(), i = this.renderTarget.getGlobalClippingPlanes();
    if (i.length === 0) {
      for (const s of e)
        s.expandBoundingBox(t);
      t.applyMatrix4(this.globalMatrix);
    } else {
      const s = new te();
      for (const o of e)
        s.makeEmpty(), o.expandBoundingBox(s), s.applyMatrix4(this.globalMatrix), tc(i, s) && t.union(s);
    }
    return t;
  }
  addChildren() {
    const { domainObject: e } = this;
    this.updateRenderStyle();
    const t = e.annotations;
    if (t === void 0)
      return;
    const i = this.renderTarget.getGlobalClippingPlanes(), s = new te();
    for (const o of Ya) {
      const r = t.filter((a) => a.getStatus() !== o ? !1 : i.length === 0 ? !0 : (s.makeEmpty(), a.expandBoundingBox(s), s.applyMatrix4(this.globalMatrix), tc(i, s)));
      for (let a = 0; a < r.length; a += ic)
        this.addWireframeFromMultipleAnnotations({
          annotations: r,
          globalMatrix: this.globalMatrix,
          status: o,
          selected: !1,
          startIndex: a,
          groupSize: ic
        });
    }
    this.updateSelectedAnnotation(), this.updateFocusAnnotation();
  }
  intersectIfCloser(e, t) {
    const { domainObject: i } = this, s = hx(
      this.getAnnotations(),
      this.globalMatrix,
      e.raycaster.ray
    ), o = s.getClosestGeometry();
    if (o === void 0 || t !== void 0 && s.minDistance > t)
      return;
    const { annotation: r } = o, a = r.getBoundingBox();
    return a.applyMatrix4(this.globalMatrix), {
      type: "customObject",
      distanceToCamera: s.minDistance,
      point: o.point,
      customObject: this,
      domainObject: i,
      boundingBox: a,
      userData: o
    };
  }
  // ==================================================
  // INSTANCE METHODS: Selected annotation
  // ==================================================
  updateSelectedAnnotation() {
    const e = this.domainObject.selectedAnnotation;
    e === void 0 ? this.clearSelectedAnnotation() : this.styleAnnotation(e, !0);
  }
  clearSelectedAnnotation() {
    for (const e of this.getWireframes())
      this.styleWireframe(e, !1);
  }
  // ==================================================
  // INSTANCE METHODS: Focus Annotation
  // ==================================================
  updateFocusAnnotation() {
    const e = this.domainObject.focusAnnotation;
    if (this.clearFocusAnnotation(), e === void 0)
      return;
    const t = this.domainObject.selectedAnnotation, i = t == null ? void 0 : t.selectedPrimitive, s = new hr();
    s.name = nc, this.addChild(s);
    for (const o of e.primitives) {
      if (i !== void 0 && i === o)
        continue;
      const r = o.getMatrix();
      if (r === void 0)
        continue;
      r.premultiply(this.globalMatrix);
      const a = o instanceof Y, c = gx(r, this.focusAnnotationMaterial, a);
      s.add(c);
    }
  }
  clearFocusAnnotation() {
    const e = this._group.getObjectByName(nc);
    e !== void 0 && (this._group.remove(e), Ro(e));
  }
  // ==================================================
  // INSTANCE METHODS: Style annotation
  // ==================================================
  updateRenderStyle() {
    const { style: e } = this;
    for (const t of Ya)
      this.setStyle(e, t, !1), this.setStyle(e, t, !0);
    this.focusAnnotationMaterial.color.set(e.blankColor), this.focusAnnotationMaterial.transparent = !0, this.focusAnnotationMaterial.opacity = e.blankOpacity, this.focusAnnotationMaterial.depthTest = !0;
  }
  styleWireframe(e, t) {
    const i = mi(e);
    i !== void 0 && (i.selected = t, e.material = this.getLineMaterial(i.status, t));
  }
  styleAnnotation(e, t) {
    let i;
    for (const s of this.getWireframes()) {
      const o = mi(s);
      o !== void 0 && (o.isEmpty || (o.includes(e) ? o.length === 1 ? this.styleWireframe(s, t) : i = s : this.styleWireframe(s, !1)));
    }
    if (i !== void 0) {
      const s = mi(i), o = s.annotations.filter((a) => a !== e);
      this.addWireframeFromMultipleAnnotations({
        annotations: o,
        globalMatrix: this.globalMatrix,
        status: s.status,
        selected: s.selected,
        startIndex: 0
      });
      const r = [e];
      r.length > 0 && this.addWireframeFromMultipleAnnotations({
        annotations: r,
        globalMatrix: this.globalMatrix,
        status: s.status,
        selected: t,
        startIndex: 0
      }), this._group.remove(i), Ro(i);
    }
  }
  // ==================================================
  // INSTANCE METHODS: Misc
  // ==================================================
  *getWireframes() {
    for (const e of Wp(this._group))
      yield e;
  }
  *getAnnotations() {
    for (const e of this.getWireframes()) {
      const t = mi(e);
      if (t !== void 0 && !t.isEmpty)
        for (const i of t.annotations)
          yield i;
    }
  }
  // ==================================================
  // INSTANCE METHODS: Get Material
  // ==================================================
  getLineMaterial(e, t) {
    switch (t) {
      case !0:
        switch (e) {
          case we.Contextualized:
            return this.contextSelectedLineMaterial;
          case we.Approved:
            return this.approvedSelectedLineMaterial;
          case we.Suggested:
            return this.suggestedSelectedLineMaterial;
          case we.Rejected:
            return this.rejectedSelectedLineMaterial;
          default:
            return this.suggestedSelectedLineMaterial;
        }
      case !1:
        switch (e) {
          case we.Contextualized:
            return this.contextLineMaterial;
          case we.Approved:
            return this.approvedLineMaterial;
          case we.Suggested:
            return this.suggestedLineMaterial;
          case we.Rejected:
            return this.rejectedLineMaterial;
          default:
            return this.suggestedLineMaterial;
        }
    }
  }
  setStyle(e, t, i) {
    const s = this.getLineMaterial(t, i);
    s.linewidth = i ? e.selectedLineWidth : e.lineWidth, s.depthTest = e.depthTest, s.color.set(e.getColorByStatus(t));
  }
  // ==================================================
  // INSTANCE METHODS: Create Wireframes
  // ==================================================
  addWireframeFromMultipleAnnotations(e) {
    const t = this.getLineMaterial(e.status, e.selected), i = ax(e, t);
    i !== void 0 && this.addChild(i);
  }
}
function Gt() {
  return new eo({
    resolution: new Ct(800, 800),
    dashed: !1,
    depthTest: !0,
    dashScale: 8
  });
}
function gx(n, e, t) {
  const i = t ? Wt.createUnitGeometry() : nt.createUnitGeometry();
  t && i.applyMatrix4(G.clone().invert());
  const s = new Ce(i, e);
  return s.applyMatrix4(n), s;
}
function* Wp(n) {
  if (n !== null) {
    for (const e of n.children)
      if (e instanceof ti && (yield e), !(e instanceof Ce))
        for (const t of Wp(e))
          yield t;
  }
}
function mi(n) {
  return n.userData;
}
function Ro(n) {
  n.traverse((e) => {
    (e instanceof ti || e instanceof Ce) && e.geometry.dispose();
  });
}
const mx = "sans-serif";
function Qo(n, e, t, i) {
  const s = Ix(n, t, i);
  if (s !== void 0)
    return vx(s, e);
}
function yx(n, e, t) {
  const i = t.clone();
  i.multiply(n.scale), i.divideScalar(2), i.add(e), n.position.copy(i);
}
function vx(n, e) {
  const t = Cx(n), i = new Wg({ map: t }), s = new Kg(i);
  return s.scale.set(e * n.width / n.height, e, 1), s;
}
function Cx(n) {
  const e = new Yg(n);
  return e.minFilter = Xg, e.magFilter = Zg, e.needsUpdate = !0, e;
}
function Ix(n, e, t) {
  const o = xx(60), r = document.createElement("canvas"), a = r.getContext("2d");
  if (a === null)
    return;
  a.font = o;
  const c = a.measureText(n).width, d = 2 * 2, l = c + 2 * d, h = 60 + d;
  return r.width = l, r.height = h, a.clearRect(0, 0, r.width, r.height), t !== void 0 && (a.fillStyle = "#" + t.getHexString(), a.beginPath(), a.roundRect(0, 0, l, h, 10), a.fill()), a.font = o, a.textBaseline = "middle", a.textAlign = "center", a.translate(l / 2, h / 2), a.fillStyle = "#" + e.getHexString(), a.fillText(n, 0, 2), r;
}
function wx(n) {
  return `${n}px ${mx}`;
}
function xx(n) {
  return `Normal ${wx(n)}`;
}
class mo {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e, t = !0, i = !1) {
    this.normals = void 0, this.uvs = void 0, this.triangleIndexes = [], this.uniqueIndex = 0, this.positions = new Float32Array(3 * e), t && (this.normals = new Float32Array(3 * e)), i && (this.uvs = new Float32Array(2 * e));
  }
  get isFilled() {
    return this.uniqueIndex === this.positions.length / 3;
  }
  // ==================================================
  // INSTANCE METHODS: Creators
  // ==================================================
  createBufferGeometry() {
    const e = new Li();
    return e.setAttribute("position", new vi(this.positions, 3, !0)), this.normals !== void 0 && e.setAttribute("normal", new vi(this.normals, 3, !1)), e.setIndex(new td(this.triangleIndexes, 1, !0)), this.uvs !== void 0 && e.setAttribute("uv", new vi(this.uvs, 2, !0)), e;
  }
  // ==================================================
  // INSTANCE METHODS: Add to triangle strip
  // ==================================================
  addPairWithNormals(e, t, i, s, o = 0) {
    if (this.uniqueIndex >= 2) {
      const r = this.uniqueIndex - 2, a = this.uniqueIndex - 1, c = this.uniqueIndex, d = this.uniqueIndex + 1;
      this.addTriangle(r, d, c), this.addTriangle(r, a, d);
    }
    this.add(e, i, o), this.add(t, s, o);
  }
  addPairWithNormal(e, t, i, s = 0) {
    this.addPairWithNormals(e, t, i, i, s);
  }
  addTriangle(e, t, i) {
    this.triangleIndexes.push(e, t, i);
  }
  add(e, t, i = 0, s = 0) {
    this.setAt(this.uniqueIndex, e, t, i, s), this.uniqueIndex++;
  }
  addPosition(e) {
    this.setPositionAt(this.uniqueIndex, e), this.uniqueIndex++;
  }
  // ==================================================
  // INSTANCE METHODS: Set at position
  // ==================================================
  setAt(e, t, i, s = 0, o = 0) {
    this.setPositionAt(e, t), this.setNormalAt(e, i), this.setUvAt(e, s, o);
  }
  setPositionAt(e, t) {
    const i = 3 * e;
    this.positions[i + 0] = t.x, this.positions[i + 1] = t.y, this.positions[i + 2] = t.z;
  }
  setNormalAt(e, t) {
    if (this.normals === void 0)
      return;
    const i = 3 * e;
    this.normals[i + 0] = t.x, this.normals[i + 1] = t.y, this.normals[i + 2] = t.z;
  }
  setUvAt(e, t = 0, i = 0) {
    if (this.uvs === void 0)
      return;
    const s = 2 * e;
    this.uvs[s + 0] = t, this.uvs[s + 1] = i;
  }
}
const Do = "faceIndex1", sc = "faceIndex2", oc = "mainAxis";
class _x extends gt {
  constructor() {
    super(), this._sceneBoundingBox = new te().makeEmpty(), this._expandedSceneBoundingBox = new ft(), this._corners = new Array(8).fill(null).map(() => new I()), this._faceCenters = new Array(6).fill(null).map(() => new I());
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get style() {
    return super.style;
  }
  // ==================================================
  // OVERRIDES of BaseView
  // ==================================================
  update(e) {
    super.update(e), !this.isEmpty && e.isChanged(m.renderStyle) && (this.removeChildren(), this.invalidateBoundingBox(), this.invalidateRenderTarget());
  }
  // ==================================================
  // OVERRIDES of ThreeView
  // ==================================================
  beforeRender(e) {
    if (super.beforeRender(e), this.isEmpty)
      return;
    let t, i;
    e instanceof Qg ? t = e.getWorldDirection(Ht()) : i = e.position;
    for (const s of this.object.children)
      this.updateVisibleAxis(s, i, t);
  }
  // ==================================================
  // OVERRIDES of GroupThreeView
  // ==================================================
  get shouldPick() {
    return !1;
  }
  get isPartOfBoundingBox() {
    return !1;
  }
  needsUpdateCore() {
    const t = this.renderTarget.clippedVisualSceneBoundingBox;
    return t.equals(this._sceneBoundingBox) ? !1 : (this._sceneBoundingBox.copy(t), this._expandedSceneBoundingBox.copy(t), this._expandedSceneBoundingBox.isEmpty || this._expandedSceneBoundingBox.expandByFraction(0.02), !0);
  }
  addChildren() {
    const e = this._expandedSceneBoundingBox;
    if (e.isEmpty)
      return;
    this.initializeCornersAndCenters(e);
    const t = Sx(e), { style: i } = this;
    for (let a = 0; a < 6; a++)
      this.addFace(i, t, a);
    const s = Tx(e, i.numberOfTicks), o = e.diagonal * i.tickLength, r = { style: i, useFace: t, increment: s, tickLength: o };
    e.x.hasSpan && (this.addAxis(r, 0, 1, 0, 1, 2), this.addAxis(r, 3, 2, 0, 2, 4), this.addAxis(r, 7, 6, 0, 4, 5), this.addAxis(r, 4, 5, 0, 1, 5)), e.y.hasSpan && (this.addAxis(r, 3, 0, 1, 0, 2), this.addAxis(r, 1, 2, 1, 2, 3), this.addAxis(r, 5, 6, 1, 3, 5), this.addAxis(r, 7, 4, 1, 0, 5)), e.z.hasSpan && (this.addAxis(r, 0, 4, 2, 0, 1), this.addAxis(r, 1, 5, 2, 1, 3), this.addAxis(r, 2, 6, 2, 3, 4), this.addAxis(r, 3, 7, 2, 0, 4)), i.showGrid && (this.addGrid(r, 0, 1, 2), this.addGrid(r, 1, 0, 2), this.addGrid(r, 2, 0, 1), this.addGrid(r, 3, 1, 2), this.addGrid(r, 4, 0, 2), this.addGrid(r, 5, 0, 1));
  }
  // ==================================================
  // INSTANCE METHODS: Add axis
  // ==================================================
  addAxis(e, t, i, s, o, r) {
    const { style: a, useFace: c } = e;
    !c[o] && !c[r] || (a.showAxis && this.addAxisLine(a, t, i, s, o, r), this.addAxisTickMarksAndLabels(e, t, i, s, o, r));
  }
  addAxisLine(e, t, i, s, o, r) {
    for (let a = 0; a < 2; a++) {
      const c = a === 0, d = e.getAxisColor(c, rc(s)), l = c ? 2 : 1, h = [];
      h.push(...this._corners[t]), h.push(...this._corners[i]);
      const p = ko(h, d, l);
      this.setUserDataOnAxis(p, o, r, c), this.addChild(p);
    }
  }
  addAxisTickMarksAndLabels(e, t, i, s, o, r) {
    const a = new ht(
      this._corners[t].getComponent(s),
      this._corners[i].getComponent(s)
    );
    if (a.isEmpty)
      return;
    let c = 0, d = 0;
    const { style: l, tickLength: h, increment: p } = e, f = a.getBoldIncrement(p), g = Ax(o, r, new I());
    if (g.normalize(), l.showAxisTicks || l.showAxisNumbers) {
      const C = [], v = l.tickFontSize * h;
      for (const w of a.getTicks(p)) {
        const x = Ht(this._corners[t]);
        x.setComponent(s, w);
        const T = Ht(x);
        if (l.showAxisTicks && (T.addScaledVector(g, h), C.push(...x), C.push(...T)), l.showAxisNumbers) {
          if (!Wo(w, f))
            continue;
          d === 0 && (c = w), d += 1, T.addScaledVector(g, 2 * h);
          const O = Jy(s === 2 ? -w : w), S = Qo(O, v, l.textColor);
          if (S === void 0)
            continue;
          S.position.copy(T), this.addChild(S), this.setUserDataOnAxis(S, o, r, !0);
        }
      }
      if (l.showAxisTicks) {
        const w = ko(C, l.mainAxisColor, 1);
        this.setUserDataOnAxis(w, o, r, !0), this.addChild(w);
      }
    }
    if (l.showAxisLabel) {
      const C = l.axisLabelFontSize * h, v = Ht();
      let w = c + Math.round(0.5 * d - 0.5) * f;
      f === p ? w -= p / 2 : w -= p, v.copy(this._corners[t]), v.setComponent(s, w), v.addScaledVector(g, h * 5);
      const x = Qo(
        l.getAxisLabel(rc(s)),
        C,
        l.textColor
      );
      if (x === void 0)
        return;
      yx(x, v, g), this.addChild(x), this.setUserDataOnAxis(x, o, r, !0);
    }
  }
  // ==================================================
  // INSTANCE METHODS: Add face
  // ==================================================
  addFace(e, t, i) {
    if (!t[i])
      return;
    const s = Lo(i), o = new mo(4);
    o.addPosition(this._corners[s[0]]), o.addPosition(this._corners[s[1]]), o.addPosition(this._corners[s[2]]), o.addPosition(this._corners[s[3]]), o.addTriangle(0, 1, 2), o.addTriangle(0, 2, 3);
    const r = new qi({
      color: e.wallColor,
      side: pr,
      polygonOffset: !0,
      polygonOffsetFactor: 1,
      polygonOffsetUnits: 4
    }), a = new Ce(o.createBufferGeometry(), r);
    this.setUserDataOnFace(a, i), this.addChild(a);
  }
  // ==================================================
  // INSTANCE METHODS: Add grid
  // ==================================================
  addGrid(e, t, i, s) {
    const { style: o, useFace: r, increment: a } = e;
    if (!r[t])
      return;
    const c = Lo(t), d = [];
    this.addGridInOneDirection(d, a, c[0], c[1], c[3], i), this.addGridInOneDirection(d, a, c[0], c[3], c[1], s);
    const l = ko(d, o.gridColor, 1);
    this.setUserDataOnFace(l, t), this.addChild(l);
  }
  addGridInOneDirection(e, t, i, s, o, r) {
    const a = Ht(this._corners[i]), c = this._corners[s], d = Ht(this._corners[o]), l = new ht(a.getComponent(r), c.getComponent(r));
    if (l.isEmpty)
      return;
    const h = l.getBoldIncrement(t);
    for (const p of l.getTicks(t))
      Wo(p, h) && (a.setComponent(r, p), d.setComponent(r, p), e.push(...a), e.push(...d));
  }
  // ==================================================
  // INSTANCE METHODS: Visibility
  // ==================================================
  setUserDataOnFace(e, t) {
    e.userData[Do] = t;
  }
  setUserDataOnAxis(e, t, i, s) {
    e.userData[Do] = t, e.userData[sc] = i, e.userData[oc] = s;
  }
  updateVisibleAxis(e, t, i) {
    const s = e.userData[Do];
    if (s === void 0)
      return;
    const o = this.isFaceVisible(s, t, i), r = e.userData[sc];
    if (r === void 0) {
      e.visible = o;
      return;
    }
    const a = this.isFaceVisible(r, t, i);
    e.userData[oc] ? e.visible = o !== a : e.visible = o && a;
  }
  isFaceVisible(e, t, i) {
    if (i === void 0) {
      if (t === void 0)
        return !1;
      i = Ht().subVectors(this._faceCenters[e], t);
    }
    const s = bx(e, Ht());
    return i.dot(s) > 0.02;
  }
  initializeCornersAndCenters(e) {
    if (!e.isEmpty) {
      e.getCornerPoints(this._corners);
      for (let t = 0; t < 6; t++) {
        const i = Lo(t), s = this._faceCenters[t];
        s.copy(this._corners[i[0]]), s.add(this._corners[i[1]]), s.add(this._corners[i[2]]), s.add(this._corners[i[3]]), s.divideScalar(4);
      }
    }
  }
}
function Tx(n, e) {
  let t = 0;
  return n.x.hasSpan && (t = Math.max(t, n.x.getBestIncrement(e))), n.y.hasSpan && (t = Math.max(t, n.y.getBestIncrement(e))), n.z.hasSpan && (t = Math.max(t, n.z.getBestIncrement(e))), t;
}
function rc(n) {
  return n === 1 ? 2 : n === 2 ? 1 : n;
}
function Sx(n) {
  const e = new Array(6);
  return e[0] = n.y.hasSpan && n.z.hasSpan, e[1] = n.x.hasSpan && n.z.hasSpan, e[2] = n.x.hasSpan && n.y.hasSpan, e[3] = n.y.hasSpan && n.z.hasSpan, e[4] = n.x.hasSpan && n.z.hasSpan, e[5] = n.x.hasSpan && n.y.hasSpan, e;
}
function ko(n, e, t) {
  const i = $e.createBufferGeometry(n), s = new ei({ color: e, linewidth: t });
  return new qn(i, s);
}
function bx(n, e) {
  switch (n) {
    case 0:
      return e.set(-1, 0, 0);
    case 1:
      return e.set(0, -1, 0);
    case 2:
      return e.set(0, 0, -1);
    case 3:
      return e.set(1, 0, 0);
    case 4:
      return e.set(0, 1, 0);
    case 5:
      return e.set(0, 0, 1);
    default:
      throw Error("getFaceNormal");
  }
}
function Lo(n) {
  switch (n) {
    case 0:
      return [3, 0, 4, 7];
    case 1:
      return [0, 1, 5, 4];
    case 2:
      return [3, 2, 1, 0];
    case 3:
      return [1, 2, 6, 5];
    case 4:
      return [2, 3, 7, 6];
    case 5:
      return [4, 5, 6, 7];
    default:
      return [0, 0, 0, 0];
  }
}
function Ax(n, e, t) {
  return t.setScalar(0), (n === 0 || e === 0) && (t.x = -Math.SQRT1_2), (n === 3 || e === 3) && (t.x = Math.SQRT1_2), (n === 1 || e === 1) && (t.y = -Math.SQRT1_2), (n === 4 || e === 4) && (t.y = Math.SQRT1_2), (n === 2 || e === 2) && (t.z = -Math.SQRT1_2), (n === 5 || e === 5) && (t.z = Math.SQRT1_2), t;
}
const Ex = new Qn();
function Ht(n) {
  return Ex.getNext(n);
}
class Kp {
  /**
   * Creates a new instance of PrimitivePickInfo.
   * @param face The face of the box that was picked.
   * @param focusType The type of focus on the picked box.
   * @param cornerSign Indicates the corner of the face.
   */
  constructor(e, t, i) {
    this.face = e, this.focusType = t, this.cornerSign = i ?? new I();
  }
}
const ac = 0.15, No = new ht(0.6, 0.75), cc = new D(1, 1, 1), dc = new be(2), lc = 32, Nn = 100;
class Mx extends gt {
  constructor() {
    super(...arguments), this._sprites = [], this._visibleFaces = new Array(6);
  }
  // Just for avoiding allocation
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get style() {
    return super.style;
  }
  // ==================================================
  // OVERRIDES of BaseView
  // ==================================================
  update(e) {
    super.update(e), e.isChanged(
      m.selected,
      m.focus,
      m.renderStyle,
      m.color,
      m.unit
    ) && (this.removeChildren(), this.invalidateBoundingBox(), this.invalidateRenderTarget());
  }
  // ==================================================
  // OVERRIDES of ThreeView
  // ==================================================
  beforeRender(e) {
    super.beforeRender(e), !this.isEmpty && this.updateLabels(e);
  }
  // ==================================================
  // OVERRIDES of GroupThreeView
  // ==================================================
  get useDepthTest() {
    const { domainObject: e } = this;
    return e.focusType === A.Pending || e.isSelected ? !1 : this.style.depthTest;
  }
  addChildren() {
    const { domainObject: e, style: t } = this, i = this.getMatrix(), { focusType: s } = e;
    if (t.showSolid && this.addChild(this.createSolid(i)), t.showLines && (t.getLineWidth(e.isSelected) === 1 ? this.addChild(this.createLines(i)) : this.addChild(this.createWireframe(i))), Ox(s)) {
      const o = this.getRotationMatrix();
      this.addRotationRing(i, o), this.addEdgeCircles(i, o);
    }
    if (t.showLabel)
      this.addLabels(i);
    else if (s === A.Rotation) {
      const o = e.focusFace;
      if (o !== void 0) {
        const r = this.getTextHeight(this.style.relativeTextSize);
        this.addChild(this.createRotationLabel(i, r, o));
      }
    }
  }
  intersectIfCloser(e, t) {
    const { domainObject: i } = this;
    if (i.focusType === A.Pending)
      return;
    const s = this.getMatrix(), o = nt.createOrientedBox(s), r = e.raycaster.ray, a = o.intersectRay(r, Ne());
    if (a === null)
      return;
    const c = a.distanceTo(r.origin);
    if (t !== void 0 && t < c || i.useClippingInIntersection && !e.isVisible(a))
      return;
    const d = Ne(a).applyMatrix4(s.invert()), l = new be().fromPositionAtFace(d);
    if (!this.isFaceVisible(l))
      return;
    const h = new I(), p = this.renderTarget.convertFromViewerCoordinates(a), f = this.getPickedFocusType(p, l, h), g = {
      type: "customObject",
      point: a,
      distanceToCamera: c,
      userData: new Kp(l, f, h),
      customObject: this,
      domainObject: i
    };
    return this.shouldPickBoundingBox && (g.boundingBox = this.boundingBox), g;
  }
  // ==================================================
  // INSTANCE METHODS: Getters
  // ==================================================
  getTextHeight(e) {
    return e * this.domainObject.box.diagonal;
  }
  getFaceRadius(e) {
    const { size: t } = this.domainObject.box, i = t.getComponent(e.tangentIndex1), s = t.getComponent(e.tangentIndex2);
    return (i + s) / 4;
  }
  getMatrix() {
    const { domainObject: e } = this, t = e.box.getMatrix();
    return t.premultiply(G), t;
  }
  getRotationMatrix() {
    const { domainObject: e } = this, t = e.box.getRotationMatrix();
    return t.premultiply(G), t;
  }
  // ==================================================
  // INSTANCE METHODS: Create Object3D's
  // ==================================================
  createSolid(e) {
    const { domainObject: t, style: i } = this, s = new ze();
    Yp(s, t, i);
    const o = nt.createUnitGeometry(), r = new Ce(o, s);
    return r.renderOrder = Nn, r.applyMatrix4(e), r;
  }
  createLines(e) {
    const { domainObject: t, style: i } = this, s = new ei();
    Xp(s, t, i, this.useDepthTest);
    const o = nt.createLineSegmentsBufferGeometry(), r = new qn(o, s);
    return r.renderOrder = Nn, r.applyMatrix4(e), r;
  }
  createWireframe(e) {
    const { domainObject: t, style: i } = this, s = new eo();
    Br(s, t, i, this.useDepthTest);
    const o = nt.createLineSegmentsGeometry(), r = new ti(o, s);
    return r.renderOrder = Nn, r.applyMatrix4(e), r;
  }
  createRotationLabel(e, t, i) {
    if (!this.isFaceVisible(i))
      return;
    const { domainObject: s } = this;
    if (!s.canRotateComponent(i.index))
      return;
    const o = Le(s);
    if (o === void 0)
      return;
    const r = s.box.getRotationInDegrees(i.index);
    if (r === 0)
      return;
    const a = o.unitSystem.toStringWithUnit(r, V.Angle), c = _i(a, this.style, t);
    if (c === void 0)
      return;
    const d = i.getCenter(Ne());
    return d.applyMatrix4(e), Bo(d, s, t), c.position.copy(d), c;
  }
  createPendingLabel(e, t, i) {
    if (!this.isFaceVisible(i))
      return;
    const s = _i("Pending", this.style, t);
    if (s === void 0)
      return;
    const o = i.getCenter(Ne());
    return o.applyMatrix4(e), Bo(o, this.domainObject, t), s.position.copy(o), s;
  }
  createRotationRing(e, t, i, s) {
    const o = this.getFaceRadius(s), r = No.max * o, a = No.min * o, c = new nd(a, r, lc), d = new Ce(c, i);
    d.renderOrder = Nn;
    const l = s.getCenter(Ne());
    return l.applyMatrix4(e), d.position.copy(l), Fs(d, s, t), d;
  }
  createEdgeCircle(e, t, i, s) {
    const { domainObject: o } = this, r = o.box.size.getComponent(s.tangentIndex1);
    if (!ye.isValidSize(r))
      return;
    const a = o.box.size.getComponent(s.tangentIndex2);
    if (!ye.isValidSize(a))
      return;
    const c = ac * this.getFaceRadius(s), d = new id(c, lc);
    i.transparent = !0, i.depthWrite = !1;
    const l = new Ce(d, i);
    l.renderOrder = Nn;
    const h = s.getCenter(Ne());
    return h.applyMatrix4(e), l.position.copy(h), Fs(l, s, t), l;
  }
  // ==================================================
  // INSTANCE METHODS: Add Object3D's
  // ==================================================
  addLabels(e) {
    const { domainObject: t, style: i } = this, s = Le(t);
    if (s === void 0)
      return;
    const o = this.getTextHeight(i.relativeTextSize);
    Lt(this._sprites);
    for (let a = 0; a < 3; a++) {
      const c = t.box.size.getComponent(a);
      if (!ye.isValidSize(c)) {
        this._sprites.push(void 0);
        continue;
      }
      const d = s.unitSystem.toStringWithUnit(c, V.Length), l = _i(d, i, o);
      if (l === void 0) {
        this._sprites.push(void 0);
        continue;
      }
      this._sprites.push(l), this.addChild(l);
    }
    this.updateLabels(this.renderTarget.camera);
    const { focusType: r } = t;
    r === A.Pending && t.box.hasArea ? this.addChild(this.createPendingLabel(e, o, dc)) : Px(r) && this.addChild(this.createRotationLabel(e, o, dc));
  }
  updateLabels(e) {
    const { domainObject: t, style: i } = this, s = this.getMatrix(), o = this.getRotationMatrix(), r = Ne(t.box.center);
    r.applyMatrix4(G);
    const a = e.getWorldPosition(Ne()), c = r.sub(a).normalize(), d = new be(), l = this._visibleFaces;
    for (const p of be.getAllFaces(d)) {
      const f = d.getNormal(Ne());
      f.applyMatrix4(o), l[p.face] = f.dot(c) < 0;
    }
    const h = this.getTextHeight(i.relativeTextSize);
    for (let p = 0; p < this._sprites.length; p++) {
      const f = this._sprites[p];
      if (f !== void 0) {
        f.visible = !1;
        for (let g = 0; g < 2; g++) {
          const C = (p + (g === 0 ? 1 : 4)) % 6;
          if (!l[C])
            continue;
          d.face = C;
          const v = this.isFaceVisible(d), w = d.getCenter(Ne());
          for (let x = 0; x < 2; x++) {
            const T = (p + (x === 0 ? 2 : 5)) % 6;
            if (!l[T] || (d.face = T, !v && !this.isFaceVisible(d)))
              continue;
            const S = d.getCenter(Ne()).add(w);
            S.applyMatrix4(s), Bo(S, t, h), S.addScaledVector(c, -h / 2), f.position.copy(S), f.visible = !0;
            break;
          }
          if (f.visible)
            break;
        }
      }
    }
  }
  addEdgeCircles(e, t) {
    const { domainObject: i, style: s } = this;
    let o = i.focusFace;
    this.domainObject.focusType !== A.Face && (o = void 0);
    const r = new ze();
    pn(r, i, s, !1, this.useDepthTest);
    for (const a of be.getAllFaces())
      this.isFaceVisible(a) && (o !== void 0 && o.equals(a) || this.addChild(this.createEdgeCircle(e, t, r, a)));
    if (o !== void 0 && this.isFaceVisible(o)) {
      const a = new ze();
      pn(a, i, s, !0, this.useDepthTest), this.addChild(this.createEdgeCircle(e, t, a, o));
    }
  }
  addRotationRing(e, t) {
    const { domainObject: i, style: s } = this;
    let o = i.focusFace;
    (this.domainObject.focusType !== A.Rotation || o !== void 0 && !i.canRotateComponent(o.index)) && (o = void 0);
    for (const r of be.getAllFaces()) {
      if (!this.isFaceVisible(r) || !i.canRotateComponent(r.index) || o !== void 0 && o.equals(r))
        continue;
      const a = new ze();
      pn(a, i, s, !1, this.useDepthTest), a.clippingPlanes = be.createClippingPlanes(e, r.index), this.addChild(this.createRotationRing(e, t, a, r));
    }
    if (o !== void 0 && this.isFaceVisible(o)) {
      const r = new ze();
      pn(r, i, s, !0, this.useDepthTest), r.clippingPlanes = be.createClippingPlanes(e, o.index), this.addChild(this.createRotationRing(e, t, r, o));
    }
  }
  // ==================================================
  // INSTANCE METHODS: For picking
  // ==================================================
  getPickedFocusType(e, t, i) {
    const { domainObject: s } = this, o = Ne().setScalar(this.getFaceRadius(t)), r = s.box.getScaledMatrix(o);
    r.invert();
    const a = Ne(e).applyMatrix4(r), d = t.getPlanePoint(a).length();
    i.copy(this.getCornerSign(e, t));
    const l = this.getCorner(i, t);
    return d < ac ? A.Face : e.distanceTo(l) < 0.2 * this.getFaceRadius(t) ? A.Corner : s.canRotateComponent(t.index) && No.isInside(d) ? A.Rotation : A.Body;
  }
  getCornerSign(e, t) {
    const { domainObject: i } = this, s = Ne().setScalar(this.getFaceRadius(t)), o = i.box.getScaledMatrix(s);
    o.invert();
    const r = e.clone().applyMatrix4(o);
    return r.setComponent(t.index, 0), r.setComponent(
      t.tangentIndex1,
      Math.sign(r.getComponent(t.tangentIndex1))
    ), r.setComponent(
      t.tangentIndex2,
      Math.sign(r.getComponent(t.tangentIndex2))
    ), r;
  }
  getCorner(e, t) {
    const { domainObject: i } = this, o = t.getCenter(new I()).addScaledVector(e, 0.5), r = i.box.getMatrix();
    return o.applyMatrix4(r), o;
  }
  isFaceVisible(e) {
    const { domainObject: t } = this;
    switch (t.primitiveType) {
      case y.VerticalArea:
        return e.index === 1;
      // Y Face visible
      case y.HorizontalArea:
        return e.index === 2;
    }
    return !0;
  }
}
function Px(n) {
  switch (n) {
    case A.Face:
    case A.Body:
    case A.Pending:
      return !1;
    default:
      return !0;
  }
}
function Ox(n) {
  switch (n) {
    case A.Pending:
    case A.None:
      return !1;
    default:
      return !0;
  }
}
function Yp(n, e, t) {
  const i = e.getColorByColorType(t.colorType);
  n.polygonOffset = !0, n.polygonOffsetFactor = 1, n.polygonOffsetUnits = 4, n.color = i, n.opacity = t.getSolidOpacity(e.isSelected), n.transparent = !0, n.emissive = i, n.emissiveIntensity = 0.2, n.side = Qs, n.flatShading = !0, n.depthWrite = !1, n.depthTest = t.depthTest;
}
function Xp(n, e, t, i) {
  const s = e.getColorByColorType(t.colorType);
  n.color = s, n.transparent = !0, n.depthWrite = !1, n.depthTest = i;
}
function Br(n, e, t, i) {
  const s = e.getColorByColorType(t.colorType);
  n.color = s, n.transparent = !0, n.depthWrite = !1, n.depthTest = i, n.linewidth = t.getLineWidth(e.isSelected), n.resolution = new Ct(1e3, 1e3), n.worldUnits = !1;
}
function pn(n, e, t, i, s) {
  n.color = cc, n.polygonOffset = !0, n.polygonOffsetFactor = 1, n.polygonOffsetUnits = 4, n.transparent = !0, n.emissive = cc, n.emissiveIntensity = i ? 0.9 : 0.2, n.side = Js, n.flatShading = !0, n.depthWrite = !1, n.depthTest = s;
}
function Bo(n, e, t) {
  e.primitiveType !== y.VerticalArea && (n.y += 1.1 * t / 2);
}
function Fs(n, e, t) {
  switch (n.rotation.setFromRotationMatrix(t), e.face) {
    case 0:
      n.rotateY(Math.PI / 2);
      break;
    case 3:
      n.rotateY(-Math.PI / 2);
      break;
    case 2:
      n.rotateY(0);
      break;
    case 5:
      n.rotateY(Math.PI);
      break;
    case 1:
      n.rotateX(-Math.PI / 2);
      break;
    case 4:
      n.rotateX(Math.PI / 2);
      break;
  }
}
function _i(n, e, t) {
  const i = Qo(n, t, e.labelColor, e.labelBgColor);
  if (i !== void 0)
    return i.material.transparent = !0, i.material.opacity = e.labelOpacity, i.material.depthTest = e.depthTest, i.renderOrder = Nn, i;
}
const Rx = new Qn();
function Ne(n) {
  return Rx.getNext(n);
}
class Dx extends An {
  clone() {
    return Mt(this);
  }
}
class Jo extends Me {
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get model() {
    return this._model;
  }
  // ==================================================
  // CONSTRUCTORS
  // ==================================================
  constructor(e) {
    super(), this._model = e;
  }
  // ==================================================
  // OVERRIDES of DomainObject
  // ==================================================
  get typeName() {
    return { untranslated: "CAD" };
  }
  get icon() {
    return "Cubes";
  }
  get hasIconColor() {
    return !1;
  }
  createRenderStyle() {
    return new Dx();
  }
  removeCore() {
    var t;
    super.removeCore();
    const e = (t = it(this)) == null ? void 0 : t.viewer;
    ((e == null ? void 0 : e.models.includes(this._model)) ?? !1) && (e == null || e.removeModel(this._model));
  }
}
class kx extends bn {
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get style() {
    return super.style;
  }
  get model() {
    return this.domainObject.model;
  }
  // ==================================================
  // OVERRIDES of BaseView
  // ==================================================
  update(e) {
    super.update(e), e.isChanged(m.renderStyle) && this.invalidateRenderTarget();
  }
  onShow() {
    const e = this.model;
    e !== void 0 && (super.onShow(), e.visible = !0);
  }
  onHide() {
    const e = this.model;
    e !== void 0 && (e.visible = !1, super.onHide());
  }
  // ==================================================
  // OVERRIDES of ThreeView
  // ==================================================
  calculateBoundingBox() {
    const e = this.model;
    if (e === void 0)
      return new te().makeEmpty();
    const t = new te();
    return e.getModelBoundingBox(t, !0);
  }
}
const uc = 0.2, Lx = 0.9, Fo = new ht(0.4, 0.7), hc = 32, yi = 100, pc = new be(2), fc = new be(5), gc = "HeightLabel", mc = "RadiusLabel";
class Nx extends gt {
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get style() {
    return super.style;
  }
  // ==================================================
  // OVERRIDES of BaseView
  // ==================================================
  update(e) {
    super.update(e), e.isChanged(
      m.selected,
      m.focus,
      m.renderStyle,
      m.color,
      m.unit
    ) && (this.removeChildren(), this.invalidateBoundingBox(), this.invalidateRenderTarget());
  }
  // ==================================================
  // OVERRIDES of ThreeView
  // ==================================================
  beforeRender(e) {
    super.beforeRender(e), !this.isEmpty && this.updateLabels(e);
  }
  // ==================================================
  // OVERRIDES of GroupThreeView
  // ==================================================
  get useDepthTest() {
    const { domainObject: e } = this;
    return e.focusType === A.Pending || e.isSelected ? !1 : this.style.depthTest;
  }
  addChildren() {
    const { domainObject: e, style: t } = this, i = this.getMatrix(), { focusType: s } = e;
    t.showSolid && this.addChild(this.createSolid(i)), t.showLines && (t.getLineWidth(e.isSelected) === 1 ? this.addChild(this.createLines(i)) : this.addChild(this.createWireframe(i))), Bx(s) && (e.canMoveCaps && (this.addChild(this.createRotationRing(i, pc)), this.addChild(this.createRotationRing(i, fc))), this.addEdgeCircles(i)), t.showLabel && this.addLabels();
  }
  intersectIfCloser(e, t) {
    const { domainObject: i } = this;
    if (i.focusType === A.Pending)
      return;
    const { cylinder: s } = i, o = s.centerA.clone(), r = s.centerB.clone();
    o.applyMatrix4(G), r.applyMatrix4(G);
    const a = e.raycaster.ray, c = s.intersectRay(a, G);
    if (c === void 0)
      return;
    const d = this.getMatrix(), l = c.distanceTo(a.origin);
    if (t !== void 0 && t < l || i.useClippingInIntersection && !e.isVisible(c))
      return;
    const h = Be(c).applyMatrix4(d.invert()), p = new be().fromPositionAtFace(h), f = this.renderTarget.convertFromViewerCoordinates(c), g = this.getPickedFocusType(f, p), C = {
      type: "customObject",
      point: c,
      distanceToCamera: l,
      userData: new Kp(p, g),
      customObject: this,
      domainObject: i
    };
    return this.shouldPickBoundingBox && (C.boundingBox = this.boundingBox), C;
  }
  // ==================================================
  // INSTANCE METHODS: Getters
  // ==================================================
  getFaceRadius() {
    return this.domainObject.cylinder.radius / 2;
  }
  getMatrix() {
    const { domainObject: e } = this, t = e.cylinder.getMatrix();
    return t.premultiply(G), t;
  }
  // ==================================================
  // INSTANCE METHODS: Create Object3D's
  // ==================================================
  createSolid(e) {
    const { domainObject: t } = this, { style: i } = this, s = new ze();
    Yp(s, t, i);
    const o = Wt.createUnitGeometry();
    o.applyMatrix4(this.renderTarget.fromViewerMatrix);
    const r = new Ce(o, s);
    return r.renderOrder = yi, r.applyMatrix4(e), r;
  }
  createLines(e) {
    const { domainObject: t } = this, { style: i } = this, s = new ei();
    Xp(s, t, i, this.useDepthTest);
    const o = Wt.createLineSegmentsBufferGeometry(), r = new qn(o, s);
    return r.renderOrder = yi, r.applyMatrix4(e), r;
  }
  createWireframe(e) {
    const { domainObject: t } = this, { style: i } = this, s = new eo();
    Br(s, t, i, this.useDepthTest);
    const o = Wt.createLineSegmentsGeometry(), r = new ti(o, s);
    return r.renderOrder = yi, r.applyMatrix4(e), r;
  }
  createRotationRing(e, t) {
    if (!this.isFaceVisible(t))
      return;
    const { domainObject: i, style: s } = this, { focusType: o } = i, r = this.getFaceRadius(), a = Fo.max * 2 * r, c = Fo.min * 2 * r, d = new nd(c, a, hc), l = new ze();
    pn(
      l,
      i,
      s,
      o === A.Rotation,
      this.useDepthTest
    );
    const h = new Ce(d, l);
    h.renderOrder = yi;
    const p = t.getCenter(Be());
    p.applyMatrix4(e), h.position.copy(p);
    const f = i.cylinder.getRotationMatrix();
    return f.premultiply(G), Fs(h, t, f), h;
  }
  createEdgeCircle(e, t, i) {
    const { domainObject: s } = this, o = 2 * uc * this.getFaceRadius(), r = new id(o, hc);
    t.transparent = !0, t.depthWrite = !1;
    const a = new Ce(r, t);
    a.renderOrder = yi;
    const c = i.getCenter(Be());
    c.applyMatrix4(e), a.position.copy(c);
    const d = s.cylinder.getRotationMatrix();
    return d.premultiply(G), Fs(a, i, d), a;
  }
  // ==================================================
  // INSTANCE METHODS: Add Object3D's
  // ==================================================
  addEdgeCircles(e) {
    const { domainObject: t, style: i } = this;
    let s = t.focusFace;
    this.domainObject.focusType !== A.Face && (s = void 0);
    const o = new ze();
    pn(o, t, i, !1, this.useDepthTest);
    for (const r of be.getAllFaces())
      this.isFaceVisible(r) && (s === void 0 || !s.equals(r)) && this.addChild(this.createEdgeCircle(e, o, r));
    if (s !== void 0 && this.isFaceVisible(s)) {
      const r = new ze();
      pn(r, t, i, !0, this.useDepthTest), this.addChild(this.createEdgeCircle(e, r, s));
    }
  }
  // ==================================================
  // INSTANCE METHODS: Labels
  // ==================================================
  addLabels() {
    const e = this.domainObject.primitiveType;
    (e === y.VerticalCylinder || e === y.HorizontalCircle) && this.addChild(this.createRadiusLabel(mc)), e === y.VerticalCylinder && this.addChild(this.createHeightLabel(gc));
  }
  createRadiusLabel(e) {
    const t = this.domainObject.cylinder.radius;
    if (!Y.isValidSize(t))
      return;
    const i = this.getRadiusLabelHeight();
    return this.createLabel(e, t, i);
  }
  createHeightLabel(e) {
    const t = this.domainObject.cylinder.height;
    if (!Y.isValidSize(t * 0.99))
      return;
    const i = this.getHeightLabelHeight();
    return this.createLabel(e, t, i);
  }
  getRadiusLabelHeight() {
    const { style: e, domainObject: t } = this;
    return e.relativeTextSize * 2 * t.cylinder.radius;
  }
  getHeightLabelHeight() {
    const { style: e, domainObject: t } = this;
    return e.relativeTextSize * t.cylinder.height;
  }
  createLabel(e, t, i) {
    const o = this.getUnitSystem().toStringWithUnit(t, V.Length), r = _i(o, this.style, i);
    return r !== void 0 && (r.name = e), r;
  }
  updateLabels(e) {
    const t = this._group.getObjectByName(mc), i = this._group.getObjectByName(gc);
    if (t === void 0 && i === void 0)
      return;
    const { domainObject: s } = this, o = this.getMatrix(), r = s.cylinder.radius, a = pc.getCenter(Be()), c = fc.getCenter(Be());
    a.applyMatrix4(o), c.applyMatrix4(o);
    const d = Be().subVectors(a, c).normalize(), l = e.getWorldPosition(Be()), h = Be().subVectors(a, l).normalize(), p = Be().crossVectors(h, d).normalize();
    if (t !== void 0) {
      const g = this.getRadiusLabelHeight(), C = Be(a).addScaledVector(p, r / 2);
      f(C, g), t.position.copy(C), t.visible = h.y <= 0;
    }
    if (i !== void 0) {
      const g = Be().crossVectors(p, d).normalize(), C = Be().addVectors(a, c).multiplyScalar(0.5);
      C.addScaledVector(g, r), i.position.copy(C), i.visible = !0;
    }
    function f(g, C) {
      g.y += 1.1 * C / 2;
    }
  }
  getPickedFocusType(e, t) {
    const { domainObject: i } = this, s = Be().setScalar(this.getFaceRadius()), o = i.cylinder.getScaledMatrix(s);
    o.invert();
    const r = Be(e).applyMatrix4(o), c = t.getPlanePoint(r).length() / 2;
    return !this.isFaceVisible(t) || c < uc ? A.Face : i.canMoveCaps && Fo.isInside(c) ? A.Rotation : c > Lx && i.primitiveType === y.HorizontalCircle ? (t.face = 0, A.Face) : A.Body;
  }
  isFaceVisible(e) {
    return e.index === 2;
  }
  getUnitSystem() {
    var e;
    return ((e = Le(this.domainObject)) == null ? void 0 : e.unitSystem) ?? new no();
  }
}
function Bx(n) {
  switch (n) {
    case A.Pending:
    case A.None:
      return !1;
    default:
      return !0;
  }
}
const Fx = new Qn();
function Be(n) {
  return Fx.getNext(n);
}
class Vx extends Qt {
  constructor() {
    super(...arguments), this.radius = 1, this.opacity = 0.75;
  }
  // ==================================================
  // OVERRIDES of BaseStyle
  // ==================================================
  clone() {
    return Mt(this);
  }
}
class jx extends is {
  // Correction for picking the sphere other places than in the center
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e, t) {
    super(e, t), this._domainObject = t, this._center = this._domainObject.center.clone(), this._plane = new ot().setFromNormalAndCoplanarPoint(this.ray.direction, this._center);
    const i = this.ray.intersectPlane(this._plane, new I());
    if (i === null)
      throw new Error("Failed to intersect plane");
    this._offset = i.sub(this._center);
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get domainObject() {
    return this._domainObject;
  }
  onPointerDrag(e, t) {
    const i = t.intersectPlane(this._plane, new I());
    return i === null || (i.sub(this._offset), i.distanceTo(this._center) < je) ? !1 : (this.transaction === void 0 && (this.transaction = this._domainObject.createTransaction(m.geometry)), this._domainObject.center.copy(i), this.domainObject.notify(m.dragging), !0);
  }
}
class xt extends Me {
  constructor() {
    super(...arguments), this.center = new I();
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get renderStyle() {
    return super.getRenderStyle();
  }
  // ==================================================
  // OVERRIDES of DomainObject
  // ==================================================
  get icon() {
    return "Circle";
  }
  get typeName() {
    return { untranslated: "Example" };
  }
  get canBeRemoved() {
    return !0;
  }
  createRenderStyle() {
    return new Vx();
  }
  createDragger(e) {
    return new jx(e, this);
  }
  get hasPanelInfo() {
    return !0;
  }
  getPanelInfo() {
    const e = new si();
    return t({ key: "X:COORDINATE" }, this.center.x, V.Length), t({ key: "Y_COORDINATE" }, this.center.y, V.Length), t({ key: "Z_COORDINATE" }, this.center.z, V.Length), e;
    function t(i, s, o) {
      e.add({ translationInput: i, value: s, quantity: o });
    }
  }
  getPanelInfoStyle() {
    return new Ve({ bottom: 50, left: 0 });
  }
  createTransaction(e) {
    return new ts(this, e);
  }
  clone(e) {
    const t = new xt();
    return t.copyFrom(this, e), t;
  }
  copyFrom(e, t) {
    super.copyFrom(e, t), (t === void 0 || t === m.geometry) && this.center.copy(e.center);
  }
  // ==================================================
  // OVERRIDES of VisualDomainObject
  // ==================================================
  getEditToolCursor(e, t) {
    return "move";
  }
}
class zx extends gt {
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get style() {
    return super.style;
  }
  // ==================================================
  // OVERRIDES of BaseView
  // ==================================================
  update(e) {
    super.update(e), e.isChanged(m.selected, m.renderStyle, m.color, m.clipping) && (this.clearMemory(), this.invalidateRenderTarget());
  }
  // ==================================================
  // OVERRIDES of GroupThreeView
  // ==================================================
  get useDepthTest() {
    return this.style.depthTest;
  }
  addChildren() {
    const { domainObject: e, style: t, renderTarget: i } = this, s = new sd(t.radius, 32, 16), o = new ze({
      color: e.color,
      emissive: vn,
      emissiveIntensity: e.isSelected ? 0.4 : 0,
      shininess: 5,
      opacity: t.opacity,
      transparent: !0,
      depthTest: t.depthTest
    });
    o.clippingPlanes = i.getGlobalClippingPlanes();
    const r = new Ce(s, o), a = e.center.clone();
    a.applyMatrix4(G), r.position.copy(a), this.addChild(r);
  }
  // Do actually not need this because the base class takes care of this
  intersectIfCloser(e, t) {
    const { domainObject: i, style: s } = this, o = e.raycaster.ray, r = i.center.clone();
    r.applyMatrix4(G);
    const a = new Jg(r, s.radius), c = o.intersectSphere(a, new I());
    if (c === null)
      return;
    const d = c.distanceTo(o.origin);
    if (t !== void 0 && t < d || i.useClippingInIntersection && !e.isVisible(c))
      return;
    const l = {
      type: "customObject",
      point: c,
      distanceToCamera: d,
      customObject: this,
      domainObject: i
    };
    return this.shouldPickBoundingBox && (l.boundingBox = this.boundingBox), l;
  }
}
class Ux extends An {
  clone() {
    return Mt(this);
  }
}
class Is extends Me {
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get model() {
    return this._model;
  }
  // ==================================================
  // CONSTRUCTORS
  // ==================================================
  constructor(e) {
    super(), this._model = e, this._updateCallback = () => {
      Ie.update(it(this));
    }, this._model.on("image360Entered", this._updateCallback), this._model.on("image360Exited", this._updateCallback);
  }
  // ==================================================
  // OVERRIDES of DomainObject
  // ==================================================
  get typeName() {
    return { untranslated: "Image360" };
  }
  get icon() {
    return "View360";
  }
  get hasIconColor() {
    return !1;
  }
  createRenderStyle() {
    return new Ux();
  }
  removeCore() {
    var e, t;
    super.removeCore(), (t = (e = it(this)) == null ? void 0 : e.viewer) == null || t.remove360ImageSet(this._model), this._model.off("image360Entered", this._updateCallback), this._model.off("image360Exited", this._updateCallback);
  }
}
class Gx extends bn {
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get style() {
    return super.style;
  }
  get model() {
    return this.domainObject.model;
  }
  // ==================================================
  // OVERRIDES of BaseView
  // ==================================================
  update(e) {
    super.update(e), e.isChanged(m.renderStyle) && this.invalidateRenderTarget();
  }
  onShow() {
    const e = this.model;
    e !== void 0 && (super.onShow(), e.setIconsVisibility(!0));
  }
  onHide() {
    const e = this.model;
    e !== void 0 && (e.setIconsVisibility(!1), super.onHide());
  }
  // ==================================================
  // OVERRIDES of ThreeView
  // ==================================================
  calculateBoundingBox() {
    const e = this.model;
    if (e === void 0)
      return new te().makeEmpty();
    const t = new te().makeEmpty(), i = new I();
    for (const s of e.image360Entities)
      i.setFromMatrixPosition(s.transform), t.expandByPoint(i);
    return t;
  }
}
const Hx = new I(0, 1, 0), yc = "Solid";
class qx extends gt {
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get style() {
    return super.style;
  }
  // ==================================================
  // OVERRIDES of BaseView
  // ==================================================
  update(e) {
    super.update(e), e.isChanged(
      m.selected,
      m.focus,
      m.renderStyle,
      m.color,
      m.unit
    ) && (this.removeChildren(), this.invalidateBoundingBox(), this.invalidateRenderTarget());
  }
  // ==================================================
  // OVERRIDES of GroupThreeView
  // ==================================================
  get useDepthTest() {
    return this.style.depthTest;
  }
  addChildren() {
    this.addChild(this.createPipe()), this.addChild(this.createLines()), this.addChild(this.createSolid()), this.style.showLabel && this.addLabels();
  }
  intersectIfCloser(e, t) {
    const { domainObject: i, style: s } = this;
    if (i.focusType === A.Pending)
      return;
    const o = this._group.getObjectByName(yc);
    if (o !== void 0) {
      const v = this.intersectObjectIfCloser(
        o,
        e,
        t
      );
      if (v !== void 0)
        return v;
    }
    const r = Xx(i, s);
    if (r <= 0)
      return;
    const { points: a, pointCount: c } = i;
    if (c < 2)
      return;
    const d = new I(), l = new I(), h = new I(), p = Dt(r), f = e.raycaster.ray, g = new cr(f.origin);
    t !== void 0 && (g.minDistance = t);
    const C = i.lineSegmentCount;
    for (let v = 0; v <= C; v++) {
      if (i.getCopyOfTransformedPoint(a[v % c], l), l.applyMatrix4(G), v === 0) {
        d.copy(l);
        continue;
      }
      const w = f.distanceSqToSegment(d, l, void 0, h);
      if (d.copy(l), w > p)
        continue;
      if (i instanceof Me) {
        if (i.useClippingInIntersection && !e.isVisible(h))
          return;
      } else if (!e.isVisible(h))
        return;
      if (!g.isClosest(h))
        continue;
      const x = {
        type: "customObject",
        point: h.clone(),
        distanceToCamera: g.minDistance,
        customObject: this,
        domainObject: i
      };
      g.setClosestGeometry(x);
    }
    return g.getClosestGeometry();
  }
  // ==================================================
  // INSTANCE METHODS:
  // ==================================================
  createPipe() {
    const { domainObject: e, style: t } = this, i = Yx(e, t);
    if (i <= 0)
      return;
    const { points: s, pointCount: o } = e;
    if (o < 2)
      return;
    const r = [], a = new I(), c = new I(), d = new kt(), l = new I(), h = new I(), p = e.lineSegmentCount;
    for (let C = 0; C <= p; C++) {
      if (e.getCopyOfTransformedPoint(s[C % o], c), c.applyMatrix4(G), C > 0) {
        const v = a.distanceTo(c), w = new ed(i, i, v, 6, 1);
        h.copy(c).sub(a).normalize(), d.setFromUnitVectors(Hx, h), w.applyQuaternion(d), l.copy(c).add(a).divideScalar(2), w.translate(l.x, l.y, l.z), r.push(w);
      }
      a.copy(c);
    }
    const f = new ze();
    Wx(f, e, t);
    const g = new Ce(ky(r, !1), f);
    return t.renderOrder !== void 0 && (g.renderOrder = t.renderOrder), g;
  }
  createSolid() {
    const { domainObject: e, style: t } = this;
    if (!t.showSolid)
      return;
    const { points: i, pointCount: s } = e;
    if (s < 3)
      return;
    const o = e.getTriangleIndexes();
    if (o === void 0)
      return;
    const r = [];
    for (let h = 0; h < e.pointCount; h++) {
      const p = e.getCopyOfTransformedPoint(i[h], new I());
      p.applyMatrix4(G), r.push(...p);
    }
    const a = e.getColorByColorType(t.colorType), c = new Li();
    c.setAttribute("position", new vi(r, 3)), c.setIndex(new td(o, 1));
    const d = new qi({
      color: a,
      depthTest: t.depthTest,
      transparent: !0,
      opacity: t.getSolidOpacity(e.isSelected),
      side: Qs
    }), l = new Ce(c, d);
    return t.renderOrder !== void 0 && (l.renderOrder = t.renderOrder), l.name = yc, l;
  }
  createLines() {
    const { domainObject: e, style: t } = this, i = $x(e);
    if (i === void 0)
      return;
    const s = e.getColorByColorType(t.colorType), o = e.isSelected ? t.selectedLineWidth : t.lineWidth, r = $e.createBufferGeometry(i), a = new ei({
      linewidth: o,
      color: s,
      depthTest: t.depthTest,
      transparent: t.transparent
    }), c = new od(r, a);
    return t.renderOrder !== void 0 && (c.renderOrder = t.renderOrder), c;
  }
  addLabels() {
    var a;
    const { domainObject: e, style: t } = this;
    let i = this.getTextHeight(t.relativeTextSize);
    i <= 0 && (i = 1);
    const s = ((a = Le(e)) == null ? void 0 : a.unitSystem) ?? new no(), o = new I();
    let r = e.isClosed ? e.getTransformedPoint(e.lastPoint) : void 0;
    for (const c of e.points) {
      const d = e.getTransformedPoint(c);
      if (r !== void 0) {
        const l = d.distanceTo(r);
        o.copy(d).add(r).divideScalar(2), o.applyMatrix4(G);
        const h = s.toStringWithUnit(l, V.Length), p = _i(h, t, i);
        p !== void 0 && (Kx(o, e, t, i), p.position.copy(o), this.addChild(p));
      }
      r = d;
    }
  }
  getTextHeight(e) {
    return e * this.domainObject.getAverageLength();
  }
}
function $x(n) {
  const { points: e, pointCount: t } = n;
  if (t < 2)
    return;
  const i = [], s = n.lineSegmentCount;
  for (let o = 0; o <= s; o++) {
    const r = n.getCopyOfTransformedPoint(e[o % t], new I());
    r.applyMatrix4(G), i.push(...r), o > 0 && o < s - 1 && i.push(...r);
  }
  return i;
}
function Wx(n, e, t) {
  const i = e.getColorByColorType(t.colorType);
  n.color = i, n.opacity = 1, n.transparent = !0, n.emissive = i, n.emissiveIntensity = e.isSelected ? 0.75 : 0.5, n.side = Js, n.flatShading = !1, n.depthWrite = !1, n.depthTest = t.depthTest;
}
function Kx(n, e, t, i) {
  e.primitiveType !== y.VerticalArea && (n.y += 1.1 * i / 2 + t.pipeRadius);
}
function Yx(n, e) {
  return n.isSelected ? e.selectedPipeRadius : e.pipeRadius;
}
function Xx(n, e) {
  return 1.5 * e.selectedPipeRadius;
}
class Zx extends gt {
  constructor() {
    super(...arguments), this._sceneBoundingBox = new te().makeEmpty(), this._sceneRange = new ft();
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get style() {
    return super.style;
  }
  // ==================================================
  // OVERRIDES of BaseView
  // ==================================================
  update(e) {
    super.update(e), e.isChanged(
      m.selected,
      m.focus,
      m.renderStyle,
      m.color,
      m.unit
    ) && (this.removeChildren(), this.invalidateBoundingBox(), this.invalidateRenderTarget());
  }
  // ==================================================
  // OVERRIDES of ThreeView
  // ==================================================
  beforeRender(e) {
    super.beforeRender(e);
  }
  // ==================================================
  // OVERRIDES of GroupThreeView
  // ==================================================
  get isPartOfBoundingBox() {
    return !1;
  }
  get useDepthTest() {
    return this.style.depthTest;
  }
  needsUpdateCore() {
    const t = this.renderTarget.sceneBoundingBox;
    return t.equals(this._sceneBoundingBox) ? !1 : (this._sceneBoundingBox.copy(t), this._sceneRange.copy(t), !0);
  }
  addChildren() {
    const { style: e, domainObject: t } = this, i = this.createCorners();
    i !== void 0 && (e.showSolid && this.addSolid(i), e.showLines && (e.getLineWidth(t.isSelected) === 1 ? this.addChild(this.createLines(i)) : this.addChild(this.createWireframe(i))));
  }
  intersectIfCloser(e, t) {
    const { domainObject: i } = this;
    if (i.focusType === A.Pending)
      return;
    const s = i.plane.clone();
    s.applyMatrix4(G);
    const o = e.raycaster.ray, r = o.intersectPlane(s, new I());
    if (r === null)
      return;
    if (i.primitiveType === y.PlaneZ) {
      if (!this._sceneRange.x.isInside(r.x) || !this._sceneRange.z.isInside(r.z))
        return;
    } else if (!this._sceneRange.isInside(r))
      return;
    const a = r.distanceTo(o.origin);
    if (t !== void 0 && t < a || i.useClippingInIntersection && !e.isVisible(r))
      return;
    const c = {
      type: "customObject",
      point: r,
      distanceToCamera: a,
      customObject: this,
      domainObject: i
    };
    return this.shouldPickBoundingBox && (c.boundingBox = this.boundingBox), c;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  createLines(e) {
    const t = [e[0], e[1], e[3], e[2], e[0]], { domainObject: i, style: s } = this, o = new ei({});
    o.color = Cc(i, s);
    const r = new Li().setFromPoints(t);
    return new od(r, o);
  }
  createWireframe(e) {
    const t = [
      e[0],
      e[1],
      e[1],
      e[3],
      e[3],
      e[2],
      e[2],
      e[0]
    ], { domainObject: i, style: s } = this, o = new eo();
    Br(o, i, s, this.useDepthTest), o.color = Cc(i, s);
    const r = $e.createLineSegmentsGeometryByVertices(t);
    return new ti(r, o);
  }
  addSolid(e) {
    const { domainObject: t, style: i } = this, s = new mo(4), o = t.plane.normal;
    if (s.addPairWithNormal(e[0], e[1], o), s.addPairWithNormal(e[2], e[3], o), !s.isFilled)
      return;
    const r = s.createBufferGeometry();
    {
      const a = new ze();
      vc(a, t, i, Js);
      const c = new Ce(r, a);
      this.addChild(c);
    }
    {
      const a = new ze();
      vc(a, t, i, pr);
      const c = new Ce(r, a);
      this.addChild(c);
    }
  }
  createCorners() {
    const { domainObject: e } = this, { plane: t } = e;
    if (this._sceneBoundingBox.isEmpty())
      return;
    const i = this._sceneBoundingBox.clone();
    i.applyMatrix4(this.renderTarget.fromViewerMatrix);
    const s = new ft();
    s.copy(i);
    let o, r, a, c;
    if (e.primitiveType === y.PlaneZ)
      o = s.getHorizontalIntersection(t, 0), r = s.getHorizontalIntersection(t, 1), a = s.getHorizontalIntersection(t, 3), c = s.getHorizontalIntersection(t, 2);
    else
      for (let h = 0; h < 2; h++) {
        const p = new I(), f = new I();
        s.getVerticalPlaneIntersection(t, h > 0, p, f) && (h === 0 ? (o = p, r = f) : (a = p, c = f));
      }
    if (o === void 0 || r === void 0 || a === void 0 || c === void 0)
      return;
    const l = em.getNormal(o, r, a, new I()).normalize().angleTo(t.normal);
    return Math.abs(l) > Math.PI / 2 && ([o, r] = [r, o], [a, c] = [c, a]), o.applyMatrix4(G), r.applyMatrix4(G), a.applyMatrix4(G), c.applyMatrix4(G), [o, r, a, c];
  }
}
function vc(n, e, t, i) {
  const s = i === Js ? e.color : e.backSideColor;
  n.polygonOffset = !0, n.polygonOffsetFactor = 1, n.polygonOffsetUnits = 4, n.color = s, n.opacity = t.getSolidOpacity(e.isSelected), n.transparent = !0, n.emissive = s, n.emissiveIntensity = 0.2, n.side = i, n.flatShading = !0, n.depthWrite = !1, n.depthTest = t.depthTest;
}
function Cc(n, e) {
  const t = n.isSelected || n.focusType !== A.None;
  return e.getLineColor(t);
}
class Qx extends An {
  clone() {
    return Mt(this);
  }
}
class er extends Me {
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get model() {
    return this._model;
  }
  // ==================================================
  // CONSTRUCTORS
  // ==================================================
  constructor(e) {
    super(), this._model = e;
  }
  // ==================================================
  // OVERRIDES of DomainObject
  // ==================================================
  get typeName() {
    return { untranslated: "PointCloud" };
  }
  get icon() {
    return "PointCloud";
  }
  get hasIconColor() {
    return !1;
  }
  createRenderStyle() {
    return new Qx();
  }
  removeCore() {
    var t;
    super.removeCore();
    const e = (t = it(this)) == null ? void 0 : t.viewer;
    ((e == null ? void 0 : e.models.includes(this._model)) ?? !1) && (e == null || e.removeModel(this._model));
  }
}
class Jx extends bn {
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get style() {
    return super.style;
  }
  get model() {
    return this.domainObject.model;
  }
  // ==================================================
  // OVERRIDES of BaseView
  // ==================================================
  update(e) {
    super.update(e), e.isChanged(m.renderStyle) && this.invalidateRenderTarget();
  }
  onShow() {
    const e = this.model;
    e !== void 0 && (super.onShow(), e.visible = !0);
  }
  onHide() {
    const e = this.model;
    e !== void 0 && (e.visible = !1, super.onHide());
  }
  // ==================================================
  // OVERRIDES of ThreeView
  // ==================================================
  calculateBoundingBox() {
    const e = this.model;
    if (e === void 0)
      return new te().makeEmpty();
    const t = new te();
    return e.getModelBoundingBox(t);
  }
}
const e_ = new D("#C945DB"), t_ = new D("#33AA33"), n_ = new D("#5151ce"), i_ = new D("#AA3333");
function Zp(n, e) {
  if (e)
    return n_;
  return t(n);
  function t(i) {
    switch (i) {
      case Pe.Default:
        return e_;
      case Pe.PendingDeletion:
        return i_;
      case Pe.PendingCreation:
        return t_;
      default:
        sn(i);
    }
  }
}
class Qp extends gt {
  constructor() {
    super(...arguments), this._overlayCollection = new xg([], { maxPointSize: 32 });
  }
  calculateBoundingBox() {
    const e = new te().makeEmpty();
    for (const t of this._overlayCollection.getOverlays())
      t.getVisible() && e.expandByPoint(t.getPosition());
    return e;
  }
  addChildren() {
    const e = this.domainObject.pointsOfInterest, t = this.domainObject.selectedPointsOfInterest, i = s_(e, t);
    this._overlayCollection.removeAllOverlays(), this._overlayCollection.addOverlays(i), this.updateClipping(), this.addChild(this._overlayCollection);
  }
  update(e) {
    super.update(e), e.isChanged(m.geometry, m.dragging) ? (this.clearMemory(), this.invalidateRenderTarget(), this.invalidateBoundingBox()) : e.isChanged(m.clipping) ? (this.updateClipping(), this.invalidateRenderTarget(), this.invalidateBoundingBox()) : e.isChanged(m.selected) && (this.updateColors(), this.invalidateRenderTarget());
  }
  intersectIfCloser(e, t) {
    const { domainObject: i } = this, s = new cr(
      e.raycaster.ray.origin
    );
    t !== void 0 && (s.minDistance = t);
    const o = this._overlayCollection.intersectOverlays(
      e.normalizedCoords,
      e.camera
    );
    if (o === void 0 || !o.getVisible())
      return;
    const r = o.getPosition();
    if (!s.isClosest(r))
      return;
    const a = ow(
      r,
      s.minDistance,
      this,
      i,
      o.getContent()
    );
    return s.setClosestGeometry(a), s.getClosestGeometry();
  }
  getOverlays() {
    return this._overlayCollection;
  }
  updateClipping() {
    const e = this.renderTarget.getGlobalClippingPlanes();
    this._overlayCollection.getOverlays().forEach((t) => {
      const i = Kc(e, t.getPosition());
      i !== t.getVisible() && t.setVisible(i);
    });
  }
  updateColors() {
    const e = this.domainObject.selectedPointsOfInterest;
    this._overlayCollection.getOverlays().forEach((t) => {
      const i = t.getColor(), s = Zp(
        t.getContent().status,
        t.getContent() === e
      );
      i.equals(s) || t.setColor(s);
    });
  }
}
function s_(n, e) {
  return n.map((t) => ({
    position: o_(t),
    content: t,
    color: Zp(t.status, t === e)
  }));
}
function o_(n) {
  return new I(
    n.properties.positionX,
    n.properties.positionY,
    n.properties.positionZ
  ).applyMatrix4(G);
}
var At = /* @__PURE__ */ ((n) => (n.None = "None", n.Seismic = "Seismic", n.SeismicReverse = "Seismic Reverse", n.Rainbow = "Rainbow", n.RainbowReverse = "Rainbow Reverse", n.GreyScale = "GreyScale", n.GreyScaleReverse = "GreyScale Reverse", n.Terrain = "terrain", n))(At || {});
class Ic extends An {
  constructor() {
    super(...arguments), this.showContours = !0, this.contoursColorType = Re.Black, this.showSolid = !0, this.solidColorType = Re.ColorMap, this.solidColorMapType = At.Rainbow, this.solidContourVolume = 0.5, this.solidContourUse = !0, this.solidShininess = 0.03, this.solidShininessUse = !0, this.solidOpacity = 0.5, this.solidOpacityUse = !1, this.increment = 0;
  }
  // ==================================================
  // OVERRIDES of BaseStyle
  // ==================================================
  clone() {
    return Mt(this);
  }
}
class r_ extends Me {
  constructor() {
    super(...arguments), this._grid = void 0;
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get grid() {
    return this._grid;
  }
  set grid(e) {
    this._grid = e;
  }
  get renderStyle() {
    return this.getRenderStyle();
  }
  // ==================================================
  // OVERRIDES of DomainObject
  // ==================================================
  get typeName() {
    return { untranslated: "Terrain" };
  }
  createRenderStyle() {
    return new Ic();
  }
  verifyRenderStyle(e) {
    if (!(e instanceof Ic))
      return;
    const { grid: t } = this;
    if (t === void 0)
      return;
    const { boundingBox: i } = t, s = i.z;
    s.isEmpty || !s.hasSpan || (e.increment <= 0 || // Not set
    e.increment > s.delta || // Too large
    e.increment < s.delta / 200) && (e.increment = s.getBestIncrement(20));
  }
}
class a_ {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e) {
    this._tempRange = new ht(), this._positions = [], this._increment = e, this._tolerance = this._increment / 1e3;
  }
  // ==================================================
  // INSTANCE METHODS: Create functions
  // ==================================================
  createContoursAsPositions(e) {
    const t = new I(), i = new I(), s = new I(), o = new I();
    for (let r = 0; r < e.nodeSize.i - 1; r++)
      for (let a = 0; a < e.nodeSize.j - 1; a++) {
        const c = e.getRelativeNodePosition(r + 0, a + 0, t), d = e.getRelativeNodePosition(r + 1, a + 0, i), l = e.getRelativeNodePosition(r + 1, a + 1, s), h = e.getRelativeNodePosition(r + 0, a + 1, o);
        let p = 0;
        c && (p += 1), l && (p += 1), l && (p += 1), h && (p += 1), !(p < 3) && (c || this.addTriangle(i, s, o), (p === 4 || !d) && this.addTriangle(t, s, o), l || this.addTriangle(t, i, o), (p === 4 || !h) && this.addTriangle(t, i, s));
      }
    return this._positions;
  }
  // ==================================================
  // INSTANCE METHODS: Helpers
  // ==================================================
  addTriangle(e, t, i) {
    this._tempRange.set(Math.min(e.z, t.z, i.z), Math.max(e.z, t.z, i.z));
    for (const s of this._tempRange.getFastTicks(this._increment, this._tolerance)) {
      const o = Number(s);
      this.addLevelAt(o, e, t, i);
    }
  }
  addLevelAt(e, t, i, s) {
    hn(t.z, e, this._tolerance) && (t.z = e + this._tolerance), hn(i.z, e, this._tolerance) && (i.z = e + this._tolerance), hn(s.z, e, this._tolerance) && (s.z = e + this._tolerance), hn(t.z, i.z, this._tolerance) && (i.z = t.z + this._tolerance);
    const o = Eo(t.z, e, i.z), r = Eo(i.z, e, s.z), a = Eo(s.z, e, t.z);
    let c = 0;
    return o && c++, r && c++, a && c++, c !== 2 ? !1 : (o && this.addLinearInterpolation(t, i, e), r && this.addLinearInterpolation(i, s, e), a && this.addLinearInterpolation(s, t, e), !0);
  }
  addLinearInterpolation(e, t, i) {
    const s = (i - e.z) / (t.z - e.z);
    this._positions.push((t.x - e.x) * s + e.x, (t.y - e.y) * s + e.y, i);
  }
}
class Fr extends mo {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e, t) {
    const [i, s] = Fr.createUniqueIndexes(e);
    super(s, !0, t), this.makeBuffers(e, i), this.makeTriangleIndexes(e, i);
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  makeBuffers(e, t) {
    const { zRange: i } = e, s = new I(), o = new I();
    for (let r = e.nodeSize.j - 1; r >= 0; r--)
      for (let a = e.nodeSize.i - 1; a >= 0; a--) {
        const c = e.getNodeIndex(a, r), d = t[c];
        if (d < 0 || !e.getRelativeNodePosition(a, r, s))
          continue;
        e.getNormal(a, r, s.z, !0, o);
        const l = i.getFraction(s.z);
        this.setAt(d, s, o, l);
      }
  }
  makeTriangleIndexes(e, t) {
    for (let i = 0; i < e.nodeSize.i - 1; i++)
      for (let s = 0; s < e.nodeSize.j - 1; s++) {
        const o = e.getNodeIndex(i, s), r = e.getNodeIndex(i + 1, s), a = e.getNodeIndex(i + 1, s + 1), c = e.getNodeIndex(i, s + 1), d = t[o], l = t[r], h = t[a], p = t[c];
        let f = 0;
        d >= 0 && (f += 1), l >= 0 && (f += 1), h >= 0 && (f += 1), p >= 0 && (f += 1), !(f < 3) && (d < 0 && this.addTriangle(l, h, p), (f === 4 || l < 0) && this.addTriangle(d, h, p), h < 0 && this.addTriangle(d, l, p), (f === 4 || p < 0) && this.addTriangle(d, l, h));
      }
  }
  static createUniqueIndexes(e) {
    const t = new Array(e.nodeSize.size);
    let i = 0;
    for (let s = e.nodeSize.j - 1; s >= 0; s--)
      for (let o = e.nodeSize.i - 1; o >= 0; o--) {
        const r = e.getNodeIndex(o, s);
        if (!e.isNodeDef(o, s)) {
          t[r] = -1;
          continue;
        }
        t[r] = i, i += 1;
      }
    return [t, i];
  }
}
var _n = /* @__PURE__ */ ((n) => (n[n.Rgb = 0] = "Rgb", n[n.HslShort = 1] = "HslShort", n[n.HslLong = 2] = "HslLong", n))(_n || {});
class c_ {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e, t, i) {
    this.color = e, this.fraction = t, this._interpolation = i;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  getMixed(e, t) {
    const s = 1 - (t - this.fraction) / (e.fraction - this.fraction);
    if (this._interpolation === _n.Rgb)
      return Vn(this.color, e.color, s);
    const o = this._interpolation === _n.HslLong;
    return Yy(this.color, e.color, s, o);
  }
}
const Vs = 4, js = 2, wc = 1e3;
class yo {
  constructor() {
    this._items = [], this._maxIndex = 0, this.colorMapType = At.None;
  }
  // ==================================================
  // INSTANCE METHODS: Getters
  // ==================================================
  getColor(e) {
    for (let t = 0; t <= this._maxIndex; t++) {
      const i = this._items[t];
      if (!(e > i.fraction))
        return t === 0 ? i.color : this._items[t - 1].getMixed(i, e);
    }
    return this._items[this._maxIndex].color;
  }
  getColorFast(e, t) {
    for (; t.value <= this._maxIndex; t.value++) {
      const i = this._items[t.value];
      if (!(e > i.fraction))
        return t.value === 0 ? i.color : this._items[t.value - 1].getMixed(i, e);
    }
    return this._items[this._maxIndex].color;
  }
  // ==================================================
  // INSTANCE METHODS: Operations
  // ==================================================
  add(e, t, i) {
    this._items.push(new c_(e, t, i)), this._items.sort((s, o) => av(s.fraction, o.fraction)), this._maxIndex = this._items.length - 1;
  }
  reverse() {
    this._items.reverse();
    for (const e of this._items)
      e.fraction = 1 - e.fraction;
  }
  // ==================================================
  // INSTANCE METHODS: Operations
  // ==================================================
  createColors(e = wc) {
    const t = new Uint8Array(e * Vs * js), i = new xc();
    for (let s = 0, o = e; s < e; s++, o++) {
      const r = s / (e - 1), a = this.getColorFast(r, i);
      ms(t, s, a), ms(t, o, a);
    }
    return t;
  }
  createColorsWithContours(e, t, i, s, o = wc) {
    const r = new Uint8Array(o * Vs * js), a = new xc();
    for (let c = 0, d = o; c < o; c++, d++) {
      const l = c / (o - 1), h = e.getValue(l), p = h % t, f = p / t, g = h - p + t / 2, C = e.getFraction(g);
      let v = s ?? this.getColorFast(C, a);
      f < 0.5 ? v = Vn(vn, v, i * (0.5 - f)) : v = Vn(vr, v, i * (f - 0.5)), ms(r, c, v), ms(r, d, v);
    }
    return r;
  }
}
function ms(n, e, t) {
  const i = e * Vs;
  n[i + 0] = Ao(t.r), n[i + 1] = Ao(t.g), n[i + 2] = Ao(t.b), n[i + 3] = Ii;
}
class xc {
  constructor(e = 0) {
    this.value = e;
  }
}
function d_(n) {
  const e = n.createColors();
  return Jp(e);
}
function l_(n, e, t, i, s) {
  const o = n.createColorsWithContours(e, t, i, s);
  return Jp(o);
}
function Jp(n) {
  const e = n.length / (js * Vs), t = new tm(n, e, js);
  return t.needsUpdate = !0, t;
}
let Vo;
function u_(n) {
  return h_().get(n);
}
function h_() {
  return Vo === void 0 && (Vo = p_()), Vo;
}
function p_() {
  const n = /* @__PURE__ */ new Map();
  return e(n, f_()), e(n, Tc(!1)), e(n, Tc(!0)), e(n, _c(!1)), e(n, _c(!0)), e(n, Sc(!1)), e(n, Sc(!0)), n;
  function e(t, i) {
    t.set(i.colorMapType, i);
  }
}
function _c(n) {
  const e = new yo(), t = 0.2, i = 0.25, s = _n.Rgb;
  return e.add(at(161, 255, 255), 0, s), e.add(at(0, 0, 191), t, s), e.add(at(77, 77, 77), i, s), e.add(at(204, 204, 204), 0.5, s), e.add(at(97, 69, 0), 1 - i, s), e.add(at(191, 0, 0), 1 - t, s), e.add(new D(D.NAMES.yellow), 1, s), e.colorMapType = n ? At.SeismicReverse : At.Seismic, n && e.reverse(), e;
}
function Tc(n) {
  const e = new yo(), t = _n.HslLong;
  return e.add(new D(D.NAMES.magenta), 0, t), e.add(new D(D.NAMES.red), 1, t), e.colorMapType = n ? At.RainbowReverse : At.Rainbow, n && e.reverse(), e;
}
function Sc(n) {
  const e = new yo(), t = _n.HslLong;
  return e.add(new D(D.NAMES.white), 0, t), e.add(new D(D.NAMES.black), 1, t), e.colorMapType = n ? At.GreyScaleReverse : At.GreyScale, n && e.reverse(), e;
}
function f_() {
  const n = new yo(), e = _n.Rgb;
  return n.add(new D(D.NAMES.white), 0, e), n.add(at(168, 144, 140), 0.2, e), n.add(at(255, 255, 150), 0.4, e), n.add(at(87, 221, 119), 0.6, e), n.add(at(0, 147, 255), 0.8, e), n.add(at(50, 50, 156), 1, e), n.colorMapType = At.Terrain, n.reverse(), n;
}
const bc = "Solid", Ac = "Contour";
class g_ extends gt {
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get style() {
    return super.style;
  }
  // ==================================================
  // OVERRIDES of BaseView
  // ==================================================
  update(e) {
    if (super.update(e), !this.isEmpty && (e.isChanged(m.colorMap) && (this.clearMemory(), this.invalidateRenderTarget()), e.isChanged(m.renderStyle))) {
      const t = this.style;
      {
        const i = this.object.getObjectByName(bc);
        i !== void 0 && !t.showSolid ? (this.removeChild(i), this.invalidateRenderTarget()) : i === void 0 && t.showSolid ? (this.addChild(this.createSolid()), this.invalidateRenderTarget()) : i !== void 0 && (Mc(i.material, this.domainObject, t), this.invalidateRenderTarget());
      }
      {
        const i = this.object.getObjectByName(Ac);
        i !== void 0 && !t.showContours ? (this.removeChild(i), this.invalidateRenderTarget()) : i === void 0 && t.showContours ? (this.addChild(this.createContours()), this.invalidateRenderTarget()) : i !== void 0 && (Pc(i.material, this.domainObject, t), this.invalidateRenderTarget());
      }
    }
  }
  // ==================================================
  // OVERRIDES of ThreeView
  // ==================================================
  calculateBoundingBox() {
    const { grid: e } = this.domainObject;
    if (e === void 0)
      return new te().makeEmpty();
    const t = e.boundingBox;
    if (t.isEmpty)
      return new te().makeEmpty();
    const i = t.getBox();
    return i.applyMatrix4(G), i;
  }
  // ==================================================
  // OVERRIDES of GroupThreeView
  // ==================================================
  addChildren() {
    const { grid: e } = this.domainObject;
    e !== void 0 && (this.addChild(this.createSolid()), this.addChild(this.createContours()));
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  createSolid() {
    const { style: e } = this;
    if (!e.showSolid)
      return;
    const { domainObject: t } = this, { grid: i } = t;
    if (i === void 0)
      return;
    const o = new Fr(i, !0).createBufferGeometry(), r = new ze();
    Mc(r, t, e);
    const a = new Ce(o, r);
    return a.name = bc, Ec(a, i), a;
  }
  createContours() {
    const { style: e } = this;
    if (!e.showContours)
      return;
    const { domainObject: t } = this, { grid: i } = t;
    if (i === void 0)
      return;
    const o = new a_(e.increment).createContoursAsPositions(i);
    if (o.length === 0)
      return;
    const r = $e.createBufferGeometry(o), a = new ei();
    Pc(a, t, e);
    const c = new qn(r, a);
    return c.name = Ac, Ec(c, i), c;
  }
}
function Ec(n, e) {
  n.rotateZ(e.rotationAngle), n.position.set(e.origin.x, e.origin.y, 0), n.applyMatrix4(G);
}
function Mc(n, e, t, i = !1) {
  n.side = Qs, n.polygonOffset = t.showContours, n.polygonOffsetFactor = 1, n.polygonOffsetUnits = 4, n.opacity = t.solidOpacityUse ? t.solidOpacity : 1, n.transparent = t.solidOpacityUse, i ? n.shininess = 0 : n.shininess = t.solidShininessUse ? 100 * t.solidShininess : 0, n.specular = vn;
  const s = m_(e, t);
  s !== void 0 ? (s.anisotropy = 2, n.color = vn, n.map = s) : (n.map !== null && (n.map.dispose(), n.map = null), n.color = e.getColorByColorType(t.solidColorType));
}
function Pc(n, e, t) {
  n.color = e.getColorByColorType(t.contoursColorType), n.linewidth = 1;
}
function m_(n, e) {
  if (e.solidColorType !== Re.ColorMap && !e.solidContourUse)
    return;
  const t = u_(e.solidColorMapType);
  if (t === void 0)
    return;
  let i;
  if (e.solidColorType === Re.ColorMap) {
    if (!e.solidContourUse)
      return d_(t);
  } else
    i = n.getColorByColorType(e.solidColorType);
  const { grid: s } = n;
  if (s !== void 0)
    return l_(
      t,
      s.boundingBox.z,
      e.increment,
      e.solidContourVolume,
      i
    );
}
function y_() {
  Je(ke, fx), Je(wi, _x), Je(uo, Mx), Je(Jo, kx), Je(Dr, Nx), Je(xt, zx), Je(Is, Gx), Je(Rr, qx), Je(ho, Zx), Je(er, Jx), Je(Ft, Qp), Je(r_, g_);
}
class zs extends z {
  // ==================================================
  // OVERRIDES
  // ==================================================
  constructor(e) {
    super(), this._horizontal = e;
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return this._horizontal ? {
      untranslated: "Align selected annotation horizontally"
    } : {
      untranslated: "Align selected annotation vertically"
    };
  }
  get icon() {
    return this._horizontal ? "BorderHorizontal" : "BorderVertical";
  }
  get isEnabled() {
    const e = this.getAnnotationsDomainObject();
    return e !== void 0 && e.selectedAnnotation !== void 0 && e.selectedAnnotation.selectedPrimitive !== void 0;
  }
  equals(e) {
    return e instanceof zs ? this._horizontal === e._horizontal : !1;
  }
  invokeCore() {
    const e = this.getAnnotationsDomainObject();
    if (e === void 0)
      return !1;
    const t = e.selectedAnnotation;
    if (t === void 0 || !t.align(this._horizontal))
      return !1;
    const i = new wt(m.changedPart, t);
    e.notify(i);
    const s = e.getGizmo();
    if (s === void 0)
      return !0;
    s.updateThisFromAnnotation(t);
    const o = new ct(m.geometry, bt.GizmoOnly);
    return s.notify(o), !0;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  getAnnotationsDomainObject() {
    return this.rootDomainObject.getSelectedDescendantByType(ke);
  }
}
class on extends z {
  // ==================================================
  // OVERRIDES
  // ==================================================
  get isEnabled() {
    return this.anyInstances;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  get anyInstances() {
    return this.getFirstInstance() !== void 0;
  }
  getFirstInstance() {
    return this.getInstances().next().value;
  }
  *getInstances() {
    for (const e of this.rootDomainObject.getDescendants())
      this.isInstance(e) && (yield e);
  }
}
class v_ extends on {
  // ==================================================
  // OVERRIDES
  // ==================================================
  get icon() {
    return "Bug";
  }
  get tooltip() {
    return { untranslated: "Create a mock annotation" };
  }
  get isEnabled() {
    return !this.anyInstances;
  }
  isInstance(e) {
    return e instanceof ke;
  }
  invokeCore() {
    const { renderTarget: e, rootDomainObject: t } = this;
    let i = this.getFirstInstance();
    return i !== void 0 ? !1 : (i = new ke(), i.applyPendingWhenCreated = !0, i.annotations = I_(), i.setSelectedInteractive(!0), t.addChildInteractive(i), i.setVisibleInteractive(!0, e), i.views.addEventListener(w_), !0);
  }
}
function C_(n) {
  const e = new ye();
  return e.setMatrix(n), e;
}
function Oc(n, e, t) {
  const i = new Y();
  return i.radius = t, i.centerA.copy(n), i.centerB.copy(e), i;
}
function I_() {
  const n = [];
  for (let t = 0; t < 6; t++) {
    const i = 4 * t + 2, s = 4 * t, o = new I(i, s, 0), r = o.clone();
    r.x += 4;
    const a = Oc(o, r, 0.5);
    o.x += 4, r.x = o.x + 2;
    const c = o.clone().add(r).multiplyScalar(0.5), d = new fe().makeTranslation(c);
    d.multiply(new fe().makeScale(1, 2, 1));
    const l = C_(d);
    o.x += 2, r.x = o.x + 6;
    const h = Oc(o, r, 2 * 0.5), p = new Vt();
    p.id = fa(), p.label = "test", p.primitives.push(a, l, h), t % 3 === 0 ? p.status = "rejected" : t % 3 === 1 ? p.status = "suggested" : (p.status = "approved", p.setAssetRefId(fa())), n.push(p);
  }
  return n;
}
function w_(n, e) {
  if (!(n instanceof ke))
    return;
  const t = e.getChangedDescriptionByType(wt);
  t instanceof wt && (t.annotation, t.annotation.selectedPrimitive, t.change, m.changedPart, t.change === m.dragging || t.change === m.deletedPart || (t.change, m.addedPart)), e.isChanged(m.newPending), e.isChanged(m.selected) && n.selectedAnnotation, e.isChanged(m.focus) && n.focusAnnotation;
}
function Vr(n) {
  return n instanceof ke || Us(n);
}
function Us(n) {
  return n instanceof wn || n instanceof xn;
}
class jt extends Mn {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor() {
    super();
  }
  // ==================================================
  // OVERRIDES of BaseCommand
  // ==================================================
  get icon() {
    return "Cursor";
  }
  get tooltip() {
    return { untranslated: "Edit annotations" };
  }
  // ==================================================
  // OVERRIDES of BaseTool
  // ==================================================
  onActivate() {
    super.onActivate();
    const e = this.getSelectedAnnotationsDomainObject();
    e !== void 0 && e.setVisibleInteractive(!0, this.renderTarget);
  }
  onDeactivate() {
    super.onDeactivate();
    for (const e of this.rootDomainObject.getDescendantsByType(
      ke
    ))
      e.removeGizmoInteractive();
  }
  onDeleteKey() {
    const e = this.getSelectedAnnotationsDomainObject();
    e !== void 0 && e.removeSelectedAnnotationInteractive();
  }
  onEscapeKey() {
    this.deselectedAnnotationInteractive();
  }
  async onHoverByDebounce(e) {
    const t = this.getSpecificIntersection(e, Vr), i = jt.getIntersectedAnnotationsDomainObject(t), s = Rc(t), o = Dc(t);
    if (i !== void 0 && s !== void 0)
      this.renderTarget.setDefaultCursor(), s.annotation === i.selectedAnnotation ? i.setFocusAnnotationInteractive(A.None) : i.setFocusAnnotationInteractive(A.Focus, s.annotation);
    else if (o === void 0)
      this.renderTarget.setNavigateCursor(), this.defocusAll();
    else if (o !== void 0 && It(t)) {
      this.defocusAll();
      const r = t.userData;
      o.setFocusInteractive(r.focusType, r.face), this.renderTarget.cursor = o.getEditToolCursor(this.renderTarget, t.point);
    }
  }
  async onClick(e) {
    const t = await this.getIntersection(e), i = jt.getIntersectedAnnotationsDomainObject(t), s = Rc(t), o = Dc(t);
    if (i !== void 0 && s !== void 0) {
      i.setSelectedAnnotationInteractive(
        s.annotation,
        s.primitiveIndex
      );
      return;
    } else i !== void 0 ? i.setSelectedAnnotationInteractive(void 0) : o === void 0 && this.deselectedAnnotationInteractive();
    await super.onClick(e);
  }
  async createDragger(e) {
    const t = await this.getIntersection(e, Us);
    if (t === void 0 || !It(t))
      return;
    const i = t.domainObject;
    if (!Us(i))
      return;
    const s = this.getRay(e), o = G.clone().invert(), r = t.point.clone();
    return r.applyMatrix4(o), s.applyMatrix4(o), i.createDragger({ intersection: t, point: r, ray: s });
  }
  // ==================================================
  // OVERRIDES of BaseEditTool
  // ==================================================
  deselectAll(e) {
  }
  canBeSelected(e) {
    return e instanceof ke;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  getSelectedAnnotationsDomainObject() {
    return this.rootDomainObject.getSelectedDescendantByType(ke);
  }
  defocusAll(e) {
    for (const t of this.getSelectable())
      e !== void 0 && t === e || t instanceof ke && t.setFocusAnnotationInteractive(A.None);
  }
  deselectedAnnotationInteractive() {
    const e = this.getSelectedAnnotationsDomainObject();
    e !== void 0 && e.setSelectedAnnotationInteractive(void 0);
  }
  // ==================================================
  // STATIC METHODS
  // ==================================================
  static getIntersectedAnnotationsDomainObject(e) {
    if (e === void 0 || !It(e))
      return;
    const { domainObject: t } = e;
    if (t instanceof ke)
      return t;
  }
}
function Rc(n) {
  if (n !== void 0 && It(n))
    return n.userData;
}
function Dc(n) {
  if (n === void 0 || !It(n))
    return;
  const { domainObject: e } = n;
  if (Us(e) && e instanceof bt)
    return e;
}
class Ui extends Qi {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor() {
    super(), this._creator = void 0, this.primitiveType = y.Box;
  }
  // ==================================================
  // OVERRIDES of BaseCommand
  // ==================================================
  get icon() {
    return "Shapes";
  }
  get tooltip() {
    return {
      untranslated: "Create new annotation. Select type of annotation in the toolbar below."
    };
  }
  // ==================================================
  // OVERRIDES of BaseTool
  // ==================================================
  onActivate() {
    super.onActivate();
    const e = this.getSelectedAnnotationsDomainObject();
    e !== void 0 && e.setVisibleInteractive(!0, this.renderTarget);
  }
  onDeactivate() {
    super.onDeactivate(), this.escape();
  }
  clearDragging() {
    super.clearDragging(), this._creator = void 0;
  }
  onEscapeKey() {
    this.escape();
  }
  async onHoverByDebounce(e) {
    const { _creator: t } = this;
    if (t !== void 0) {
      const i = this.getRay(e);
      if (t.addPoint(i, void 0, !0)) {
        this.setDefaultCursor();
        return;
      }
      const s = await this.getIntersection(e);
      if (s === void 0) {
        if (t !== void 0 && t.preferIntersection && t.addPoint(i, void 0, !0)) {
          this.setDefaultCursor();
          return;
        }
        this.renderTarget.setNavigateCursor();
        return;
      }
      if (jt.getIntersectedAnnotationsDomainObject(s) !== void 0) {
        this.renderTarget.setNavigateCursor();
        return;
      }
      if (t.addPoint(i, s.point, !0)) {
        this.setDefaultCursor();
        return;
      }
      this.renderTarget.setNavigateCursor();
    } else
      await this.getIntersection(e) !== void 0 ? this.renderTarget.setCrosshairCursor() : this.renderTarget.setNavigateCursor();
  }
  async onClick(e) {
    const { renderTarget: t } = this;
    let i = this._creator;
    if (i !== void 0) {
      const o = this.getRay(e);
      if (i.addPoint(o)) {
        this.endCreatorIfFinished(i);
        return;
      }
    }
    const s = await this.getIntersection(e);
    if (s !== void 0) {
      if (i !== void 0) {
        const o = this.getRay(e);
        i.addPoint(o, s.point) && this.endCreatorIfFinished(i);
        return;
      }
      if (i === void 0) {
        if (this.deselectedAnnotationInteractive(), i = this._creator = this.createCreator(), i === void 0) {
          await super.onClick(e);
          return;
        }
        const o = this.getRay(e);
        if (i.addPoint(o, s.point)) {
          const r = i.domainObject;
          r.setSelectedInteractive(!0), r.setVisibleInteractive(!0, t), r.notify(m.geometry);
        } else {
          this._creator = void 0;
          return;
        }
        this.endCreatorIfFinished(i);
        return;
      }
      this.renderTarget.cursor = "move";
    }
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  createCreator() {
    const t = this.getSelectedAnnotationsDomainObjectByForce().getOrCreateGizmoForPending(this.primitiveType);
    switch (this.primitiveType) {
      case y.Box:
        return t instanceof wn ? new Pr(t) : void 0;
      case y.HorizontalCylinder:
      case y.VerticalCylinder:
        return t instanceof xn ? new kp(t, this.primitiveType, !0) : void 0;
      default:
        return;
    }
  }
  escape() {
    this._creator !== void 0 && this._creator.escape() ? (this.endCreatorIfFinished(this._creator, !0), this.setSelectTool(), this.deselectedAnnotationInteractive()) : this._creator = void 0;
  }
  getSelectedAnnotationsDomainObject() {
    return this.rootDomainObject.getSelectedDescendantByType(ke);
  }
  getSelectedAnnotationsDomainObjectByForce() {
    const e = this.getSelectedAnnotationsDomainObject();
    if (e !== void 0)
      return e;
    const t = new ke();
    return t.applyPendingWhenCreated = !0, this.rootDomainObject.addChildInteractive(t), t.setSelectedInteractive(!0), t.setVisibleInteractive(!0), t;
  }
  setSelectTool() {
    this.renderTarget.commandsController.setActiveToolByType(jt) && Ie.update(this.renderTarget);
  }
  endCreatorIfFinished(e, t = !1) {
    if (!e.isFinished && !t)
      return;
    this._creator = void 0;
    const i = this.getSelectedAnnotationsDomainObject();
    if (i === void 0)
      return;
    const s = e.domainObject;
    let o;
    if (s instanceof wn || s instanceof xn)
      o = s.createAnnotation();
    else
      return;
    i.pendingAnnotation = o, i.applyPendingWhenCreated ? i.applyPendingAnnotationInteractive() : i.notify(m.newPending), this.setSelectTool();
  }
  deselectedAnnotationInteractive() {
    const e = this.getSelectedAnnotationsDomainObject();
    e !== void 0 && e.setSelectedAnnotationInteractive(void 0);
  }
}
class x_ extends z {
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { untranslated: "Delete selected annotations" };
  }
  get icon() {
    return "Delete";
  }
  get buttonType() {
    return "ghost-destructive";
  }
  get isEnabled() {
    const e = this.getAnnotationsDomainObject();
    return e !== void 0 && e.selectedAnnotation !== void 0 && e.selectedAnnotation.selectedPrimitive !== void 0;
  }
  invokeCore() {
    const e = this.getAnnotationsDomainObject();
    return e === void 0 ? !1 : e.removeSelectedAnnotationInteractive();
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  getAnnotationsDomainObject() {
    return this.rootDomainObject.getSelectedDescendantByType(ke);
  }
}
class Ti extends z {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e) {
    super(), this._primitiveType = e;
  }
  // ==================================================
  // OVERRIDES of BaseCommand
  // ==================================================
  get icon() {
    switch (this._primitiveType) {
      case y.Box:
        return "Cube";
      case y.HorizontalCylinder:
        return "CylinderHorizontal";
      case y.VerticalCylinder:
        return "CylinderVertical";
      default:
        throw new Error("Unknown PrimitiveType");
    }
  }
  get tooltip() {
    return __(this._primitiveType);
  }
  get isEnabled() {
    return this.tool !== void 0;
  }
  get isChecked() {
    const { tool: e } = this;
    return e === void 0 ? !1 : e.primitiveType === this._primitiveType;
  }
  invokeCore() {
    const { tool: e } = this;
    return e === void 0 ? !1 : (e.escape(), e.clearDragging(), this.isChecked ? e.primitiveType = y.None : e.primitiveType = this._primitiveType, !0);
  }
  equals(e) {
    return e instanceof Ti ? this._primitiveType === e._primitiveType : !1;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  get tool() {
    return this.getActiveTool(Ui);
  }
}
function __(n) {
  switch (n) {
    case y.Box:
      return {
        untranslated: "Create a new box annotation"
      };
    case y.HorizontalCylinder:
      return {
        untranslated: "Create a new horizontal cylinder annotation. Click two times to get the center endpoints, the third defines the radius."
      };
    case y.VerticalCylinder:
      return {
        untranslated: "Create a new vertical cylinder annotation. Click two times to get the center endpoints, the third defines the radius."
      };
    default:
      throw new Error("Unknown PrimitiveType");
  }
}
class T_ extends z {
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return {
      key: "CLIP_APPLY"
    };
  }
  get icon() {
    return "Crop";
  }
  get buttonType() {
    return "primary";
  }
  get isEnabled() {
    const e = this.getSelectedCropBoxDomainObject();
    return e !== void 0 ? e.focusType !== A.Pending : this.rootDomainObject.getDescendantByType(De) !== void 0;
  }
  get isToggle() {
    return !0;
  }
  get isChecked() {
    return this.renderTarget.isGlobalClippingActive;
  }
  invokeCore() {
    const { renderTarget: e } = this;
    if (this.renderTarget.isGlobalClippingActive)
      return e.clearGlobalClipping(), !0;
    const t = this.getSelectedCropBoxDomainObject();
    return t !== void 0 ? t.focusType !== A.Pending && (t.setThisAsGlobalCropBox(), e.fitView()) : ji(this.rootDomainObject), !0;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  getSelectedCropBoxDomainObject() {
    return this.rootDomainObject.getSelectedDescendantByType(lt);
  }
}
class S_ extends on {
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { untranslated: "Remove all examples" };
  }
  get icon() {
    return "Delete";
  }
  get buttonType() {
    return "ghost-destructive";
  }
  get isEnabled() {
    const e = this.getFirstInstance();
    return e !== void 0 && e.canBeRemoved;
  }
  invokeCore() {
    const e = Array.from(this.getInstances());
    e.reverse();
    for (const t of e)
      this.addTransaction(t.createTransaction(m.deleted)), t.removeInteractive();
    return !0;
  }
  isInstance(e) {
    return e instanceof xt;
  }
}
class b_ extends Mn {
  // ==================================================
  // OVERRIDES of BaseCommand
  // ==================================================
  get icon() {
    return "Circle";
  }
  get tooltip() {
    return { untranslated: "Create or edit a single point" };
  }
  // ==================================================
  // OVERRIDES of BaseTool
  // ==================================================
  onDeleteKey() {
    const e = this.getSelected();
    e instanceof xt && (this.addTransaction(e.createTransaction(m.deleted)), e.removeInteractive());
  }
  async onWheel(e, t) {
    const i = await this.getIntersection(e), s = this.getIntersectedSelectableDomainObject(
      i
    );
    if (s === void 0 || !s.isSelected) {
      await super.onWheel(e, t);
      return;
    }
    if (e.shiftKey) {
      this.addTransaction(s.createTransaction(m.color));
      let o = { h: 0, s: 0, l: 0 };
      o = s.color.getHSL(o), o.h = (o.h + Math.sign(t) * 0.02) % 1, s.color.setHSL(o.h, o.s, o.l), s.notify(m.color);
    } else if (e.ctrlKey || e.metaKey) {
      this.addTransaction(s.createTransaction(m.renderStyle));
      const o = s.renderStyle.opacity + Math.sign(t) * 0.05;
      s.renderStyle.opacity = Di(o, 0.2, 1), s.notify(new ct(m.renderStyle, "opacity"));
    } else {
      this.addTransaction(s.createTransaction(m.renderStyle));
      const o = 1 - Math.sign(t) * 0.1;
      s.renderStyle.radius *= o, s.notify(new ct(m.renderStyle, "radius"));
    }
  }
  async onHoverByDebounce(e) {
    const t = await this.getIntersection(e), i = this.getIntersectedSelectableDomainObject(t);
    i !== void 0 ? this.renderTarget.cursor = i.getEditToolCursor(this.renderTarget) : t !== void 0 ? this.renderTarget.setCrosshairCursor() : this.renderTarget.setNavigateCursor();
  }
  async onClick(e) {
    const t = await this.getIntersection(e);
    if (t === void 0) {
      await super.onClick(e);
      return;
    }
    {
      const o = this.getIntersectedSelectableDomainObject(t);
      if (o !== void 0) {
        this.deselectAll(o), o.setSelectedInteractive(!0);
        return;
      }
    }
    const i = this.renderTarget.convertFromViewerCoordinates(t.point), s = new xt();
    s.center.copy(i), this.deselectAll(), this.rootDomainObject.addChildInteractive(s), s.setVisibleInteractive(!0, this.renderTarget), s.setSelectedInteractive(!0), this.addTransaction(s.createTransaction(m.added)), this.renderTarget.cursor = s.getEditToolCursor(this.renderTarget);
  }
  // ==================================================
  // OVERRIDES of BaseEditTool
  // ==================================================
  canBeSelected(e) {
    return e instanceof xt;
  }
}
class Gs extends z {
  // ==================================================
  // CONSTRUCTORS
  // ==================================================
  constructor(e) {
    super(), this._next = e;
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return this._next ? {
      key: "CLIP_NEXT"
    } : {
      key: "CLIP_PREV"
    };
  }
  get icon() {
    return this._next ? "ArrowRight" : "ArrowLeft";
  }
  get isEnabled() {
    if (!this.renderTarget.isGlobalClippingActive)
      return !1;
    const e = this._next ? 2 : 3, { rootDomainObject: t } = this;
    let i = 0;
    for (const s of t.getDescendants())
      if (s instanceof lt && (i++, i >= e))
        return !0;
    return t.getDescendantByType(De) !== void 0 && i++, i >= e;
  }
  equals(e) {
    return e instanceof Gs ? this._next === e._next : !1;
  }
  invokeCore() {
    const e = this.createCropBoxesAndSliceArray();
    if (e.length <= 1)
      return !1;
    const t = e.findIndex((o) => o.isSelected);
    if (t === void 0)
      return !1;
    const i = this.getNextIndex(t, e.length);
    this.setAllInvisibleAndDeselected(e, i);
    const s = e[i];
    return this.setVisibleAndSelected(s, !0), s instanceof lt ? s.setThisAsGlobalCropBox() : ji(this.rootDomainObject), this.renderTarget.fitView(), !0;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  createCropBoxesAndSliceArray() {
    const { rootDomainObject: e } = this, t = new Array();
    for (const s of e.getDescendantsByType(lt))
      t.push(s);
    const i = e.getSelectedDescendantByType(De);
    if (i !== void 0)
      t.push(i);
    else {
      const s = e.getDescendantByType(De);
      s !== void 0 && t.push(s);
    }
    return t;
  }
  getNextIndex(e, t) {
    const i = this._next ? 1 : -1, s = e + i;
    return s < 0 ? t - 1 : s >= t ? 0 : s;
  }
  setAllInvisibleAndDeselected(e, t) {
    for (let i = 0; i < e.length; i++)
      i !== t && this.setVisibleAndSelected(e[i], !1);
  }
  setVisibleAndSelected(e, t) {
    e.setSelectedInteractive(t), e instanceof De ? this.setAllSliceDomainObjectsVisible(t) : e.setVisibleInteractive(t, this.renderTarget);
  }
  setAllSliceDomainObjectsVisible(e) {
    const { rootDomainObject: t } = this;
    for (const i of t.getDescendantsByType(De))
      i.setVisibleInteractive(e, this.renderTarget);
  }
  getCropBoxesAndSliceCount() {
    const { rootDomainObject: e } = this;
    let t = 0;
    for (const i of e.getDescendants())
      i instanceof lt && t++;
    return e.getDescendantByType(De) !== void 0 && t++, t;
  }
}
class A_ extends on {
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { untranslated: "Reset the visual style for all examples to default" };
  }
  get icon() {
    return "ClearAll";
  }
  invokeCore() {
    for (const e of this.getInstances())
      this.addTransaction(e.createTransaction(m.renderStyle)), e.setRenderStyle(void 0), e.notify(m.renderStyle);
    return !0;
  }
  isInstance(e) {
    return e instanceof xt;
  }
}
class ln extends z {
  get primitiveType() {
    return this._primitiveType;
  }
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e) {
    super(), this._primitiveType = e;
  }
  // ==================================================
  // OVERRIDES of BaseCommand
  // ==================================================
  get icon() {
    return es(this.primitiveType);
  }
  get tooltip() {
    return E_(this.primitiveType);
  }
  get isVisible() {
    return !0;
  }
  get isEnabled() {
    if (this.tool === void 0)
      return !1;
    if (this.primitiveType === y.Box || this.primitiveType === y.PlaneXY)
      return !0;
    let e = 0;
    for (const t of this.rootDomainObject.getDescendantsByType(De))
      if (t.primitiveType === this.primitiveType && (e++, e >= 2))
        return !1;
    return !0;
  }
  get isChecked() {
    const { tool: e } = this;
    return e === void 0 ? !1 : e.primitiveType === this.primitiveType;
  }
  invokeCore() {
    const { tool: e } = this;
    return e === void 0 ? !1 : (e.escape(), e.clearDragging(), e.primitiveType === this.primitiveType ? e.primitiveType = y.None : e.primitiveType = this.primitiveType, !0);
  }
  equals(e) {
    return e instanceof ln ? this.primitiveType === e.primitiveType : !1;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  get tool() {
    return this.getActiveTool(Or);
  }
}
function E_(n) {
  switch (n) {
    case y.PlaneX:
      return {
        key: "ADD_SLICE_X"
      };
    case y.PlaneY:
      return {
        key: "ADD_SLICE_Y"
      };
    case y.PlaneZ:
      return {
        key: "ADD_SLICE_Z"
      };
    case y.PlaneXY:
      return {
        key: "ADD_SLICE_XY"
      };
    case y.Box:
      return {
        key: "ADD_CROP_BOX"
      };
    default:
      throw new Error("Unknown PrimitiveType");
  }
}
class vt extends z {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e) {
    super(), this._primitiveType = e;
  }
  // ==================================================
  // OVERRIDES of BaseCommand
  // ==================================================
  get icon() {
    return es(this._primitiveType);
  }
  get tooltip() {
    return M_(this._primitiveType);
  }
  get isEnabled() {
    return this.tool !== void 0;
  }
  get isChecked() {
    const { tool: e } = this;
    return e === void 0 ? !1 : e.primitiveType === this._primitiveType;
  }
  invokeCore() {
    const { tool: e } = this;
    return e === void 0 ? !1 : (e.escape(), e.clearDragging(), e.primitiveType === this._primitiveType ? e.primitiveType = y.None : e.primitiveType = this._primitiveType, !0);
  }
  equals(e) {
    return e instanceof vt ? this._primitiveType === e._primitiveType : !1;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  get tool() {
    return this.getActiveTool(kr);
  }
}
function M_(n) {
  switch (n) {
    case y.Line:
      return { key: "MEASUREMENTS_ADD_LINE" };
    case y.Polyline:
      return { key: "MEASUREMENTS_ADD_POLYLINE" };
    case y.Polygon:
      return { key: "MEASUREMENTS_ADD_POLYGON" };
    case y.VerticalArea:
      return { key: "MEASUREMENTS_ADD_VERTICAL_AREA" };
    case y.HorizontalArea:
      return { key: "MEASUREMENTS_ADD_HORIZONTAL_AREA" };
    case y.Box:
      return { key: "MEASUREMENTS_ADD_VOLUME" };
    case y.HorizontalCircle:
      return { key: "MEASUREMENTS_ADD_CIRCLE" };
    case y.VerticalCylinder:
      return { key: "MEASUREMENTS_ADD_CYLINDER" };
    default:
      throw new Error("Unknown PrimitiveType");
  }
}
class P_ extends on {
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return {
      key: "CLIP_SHOW_SELECTED_ONLY"
    };
  }
  get icon() {
    return "EyeShow";
  }
  get isChecked() {
    return this.isAnyVisible();
  }
  invokeCore() {
    const e = this.isAnyVisible();
    for (const t of this.getInstances())
      t.isSelected || t.setVisibleInteractive(!e, this.renderTarget);
    return !0;
  }
  isInstance(e) {
    return e instanceof lt || e instanceof De;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  isAnyVisible() {
    for (const e of this.getInstances())
      if (!e.isSelected && e.isVisible(this.renderTarget))
        return !0;
    return !1;
  }
}
class jr extends on {
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { untranslated: "Show or hide" };
  }
  get icon() {
    return "EyeShow";
  }
  get isToggle() {
    return !0;
  }
  get isChecked() {
    return this.isAnyVisible();
  }
  invokeCore() {
    const e = this.isAnyVisible();
    for (const t of this.getInstances())
      t.setVisibleInteractive(!e, this.renderTarget);
    return !0;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  isAnyVisible() {
    for (const e of this.getInstances())
      if (e.isVisible(this.renderTarget))
        return !0;
    return !1;
  }
}
class O_ extends jr {
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { untranslated: "Show or hide all examples" };
  }
  isInstance(e) {
    return e instanceof xt;
  }
}
class os extends on {
  // ==================================================
  // OVERRIDES
  // ==================================================
  get icon() {
    return "Flag";
  }
  get isToggle() {
    return !0;
  }
  get isChecked() {
    return !this.getDepthTest();
  }
  invokeCore() {
    const e = this.getDepthTest();
    for (const t of this.getInstances()) {
      const i = t.getRenderStyle();
      i instanceof Qt && (this.addTransaction(t.createTransaction(m.renderStyle)), i.depthTest = !e, t.notify(m.renderStyle));
    }
    return !0;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  getDepthTest() {
    const e = this.getFirstInstance();
    if (e === void 0)
      return !1;
    const t = e.getRenderStyle();
    return t instanceof Qt ? t.depthTest : !1;
  }
}
class R_ extends os {
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { key: "CLIP_SHOW_ON_TOP" };
  }
  isInstance(e) {
    return e instanceof lt || e instanceof De;
  }
}
class D_ extends os {
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { untranslated: "Show all examples on top" };
  }
  isInstance(e) {
    return e instanceof xt;
  }
}
class k_ extends os {
  // ==================================================
  // OVERRIDES
  // ==================================================
  get icon() {
    return "EyeShow";
  }
  get tooltip() {
    return { key: "MEASUREMENTS_SHOW_ON_TOP" };
  }
  isInstance(e) {
    return e instanceof Gn || e instanceof Un || e instanceof Hn;
  }
}
class un extends z {
  // ==================================================
  // OVERRIDES
  // ==================================================
  get icon() {
    return "Restore";
  }
  get tooltip() {
    return { key: "UNDO" };
  }
  get isEnabled() {
    const e = this.undoManager;
    return e === void 0 ? !1 : e.canUndo;
  }
  get shortCutKey() {
    return "Z";
  }
  get shortCutKeyOnCtrl() {
    return !0;
  }
  get isVisible() {
    return !0;
  }
  invokeCore() {
    var s;
    const e = this.undoManager;
    if (e === void 0)
      return !1;
    const t = e.canUndo, i = e.undo(this.renderTarget);
    return t !== e.canUndo && Ie.update(this.renderTarget), (s = this.activeTool) == null || s.onUndo(), i;
  }
}
function L_() {
  gi(Ui, [
    new jt(),
    new Ti(y.Box),
    new Ti(y.HorizontalCylinder),
    new Ti(y.VerticalCylinder),
    void 0,
    new un()
  ]), gi(jt, [
    new Ui(),
    new x_(),
    new zs(!0),
    new zs(!1),
    new v_(),
    void 0,
    new un()
  ]), gi(Or, [
    new ln(y.PlaneX),
    new ln(y.PlaneY),
    new ln(y.PlaneZ),
    new ln(y.PlaneXY),
    new ln(y.Box),
    void 0,
    new un(),
    new T_(),
    new Gs(!1),
    new Gs(!0),
    new P_(),
    new R_()
  ]), gi(b_, [
    new un(),
    new A_(),
    new O_(),
    new S_(),
    new D_()
  ]), gi(kr, [
    new vt(y.Line),
    new vt(y.Polyline),
    new vt(y.Polygon),
    new vt(y.HorizontalArea),
    new vt(y.VerticalArea),
    new vt(y.Box),
    new vt(y.VerticalCylinder),
    new vt(y.HorizontalCircle),
    void 0,
    new un(),
    new k_()
  ]);
}
class ut extends z {
  constructor() {
    super(...arguments), this._children = void 0;
  }
  get children() {
    return this._children;
  }
  get hasChildren() {
    return this._children !== void 0 && this._children.length > 0;
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get icon() {
    return "Filter";
  }
  *getChildren() {
    if (this._children !== void 0)
      for (const e of this._children)
        yield e;
  }
  // ==================================================
  // VIRTUAL METHODS (To be overridden)
  // ==================================================
  initializeChildrenIfNeeded() {
    this._children === void 0 && (this._children = this.createChildren(), this.attachChildren());
  }
  /**
   * Checks if all the children of the current instance are checked.
   * Override this method to optimize the logic.
   * @returns A boolean value indicating whether all the children are checked.
   */
  get isAllChecked() {
    return this._children === void 0 || this._children.length === 0 ? !1 : this._children.every((e) => e.isChecked);
  }
  /**
   * Checks if some the children of the current instance are checked.
   * Override this method to optimize the logic.
   * @returns A boolean value indicating whether some the children are checked.
   */
  get isSomeChecked() {
    return this._children === void 0 || this._children.length === 0 ? !1 : this._children.some((e) => e.isChecked);
  }
  /**
   * Toggles the checked state of all child filter items.
   * Override this method to optimize the logic.
   * If there are no child items, this method does nothing.
   * @returns A boolean value indicating whether anything is changed
   */
  toggleAllCheckedCore() {
    if (this._children === void 0 || this._children.length === 0)
      return !1;
    const e = this.isAllChecked;
    for (const t of this._children)
      t.setChecked(!e);
    return !0;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  getSelectedLabel() {
    if (this._children === void 0)
      return ut.getNoneString();
    const e = this._children.filter((i) => i.isChecked), t = e.length;
    return t === 0 ? ut.getNoneString() : t === this._children.length ? ut.getAllString() : t === 1 ? e[0].label : t.toString() + " " + ut.getSelectedString();
  }
  toggleAllChecked() {
    return this.toggleAllCheckedCore() ? (Ie.update(this._renderTarget), !0) : !1;
  }
  // ==================================================
  // STATIC METHODS
  // ==================================================
  static getAllString() {
    return mn({ key: "ALL" });
  }
  static getNoneString() {
    return mn({ key: "NONE" });
  }
  static getSelectedString() {
    return mn({ key: "SELECTED" });
  }
}
class ef extends z {
  // ==================================================
  // OVERRIDES
  // ==================================================
  invokeCore() {
    return this.setCheckedCore(!this.isChecked);
  }
  // ==================================================
  // VIRTUAL METHODS (To be overridden)
  // ==================================================
  get color() {
  }
  setChecked(e) {
    this.setCheckedCore(e) && Ie.update(this._renderTarget);
  }
}
class rs extends z {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e, t, i) {
    super(), this.min = e, this.max = t, this.step = i;
  }
  // ==================================================
  // VIRTUAL METHODS (To be overridden)
  // =================================================
  get marks() {
  }
  getValueLabel() {
    return this.value.toString();
  }
}
class zr extends z {
  constructor() {
    super(...arguments), this._children = [];
  }
  get children() {
    return this._children;
  }
  get hasChildren() {
    return this._children.length > 0;
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  *getChildren() {
    for (const e of this._children)
      yield e;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  add(e) {
    if (this._children.find((t) => t.equals(e)) !== void 0) {
      console.error("Duplicated command given: " + e.name);
      return;
    }
    this._children.push(e);
  }
  clear() {
    Lt(this._children);
  }
}
class Ur extends ut {
  constructor() {
    super(...arguments), this._modelId = void 0, this._revisionId = void 0;
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { key: "POINTS_FILTER" };
  }
  get isEnabled() {
    return this.getPointCloud() !== void 0;
  }
  initializeChildrenIfNeeded() {
    const e = F_({ renderTarget: this.renderTarget });
    if (e === void 0) {
      this._children = void 0, this._modelId = void 0, this._revisionId = void 0;
      return;
    }
    this._modelId === e.modelId && this._revisionId === e.revisionId || (this._modelId = e.modelId, this._revisionId = e.revisionId, this._children = void 0, super.initializeChildrenIfNeeded());
  }
  createChildren() {
    const e = this.getPointCloud();
    if (e === void 0)
      return [];
    const t = e.getClasses();
    if (t === void 0 || t.length === 0)
      return [];
    const i = [];
    for (const s of t) {
      const o = new B_(s.name, s.code, s.color);
      i.push(new N_(o, e.modelId, e.revisionId));
    }
    return i;
  }
  get isAllChecked() {
    const e = this.getPointCloud();
    return e === void 0 ? !1 : kc(e);
  }
  toggleAllCheckedCore() {
    const e = this.getPointCloud();
    if (e === void 0)
      return !1;
    const t = kc(e), i = e.getClasses();
    if (i === void 0 || i.length === 0)
      return !1;
    for (const s of i)
      e.setClassVisible(s.code, !t);
    return !0;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  getPointCloud() {
    if (!(this._modelId === void 0 || this._revisionId === void 0)) {
      for (const e of this.renderTarget.getPointClouds())
        if (this._modelId === e.modelId && this._revisionId === e.revisionId)
          return e;
    }
  }
}
class N_ extends ef {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e, t, i) {
    super(), this._modelId = t, this._revisionId = i, this._pointClass = e;
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { untranslated: this._pointClass.displayName };
  }
  get isChecked() {
    const e = this.getPointCloud();
    return e === void 0 ? !1 : e.isClassVisible(this._pointClass.code);
  }
  get color() {
    return this._pointClass.color;
  }
  setCheckedCore(e) {
    const t = this.getPointCloud();
    return t === void 0 || t.isClassVisible(this._pointClass.code) === e ? !1 : (t.setClassVisible(this._pointClass.code, e), !0);
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  getPointCloud() {
    for (const e of this.renderTarget.getPointClouds())
      if (this._modelId === e.modelId && this._revisionId === e.revisionId)
        return e;
  }
}
class B_ {
  constructor(e, t, i) {
    this.name = e, this.code = t, this.color = i;
  }
  get displayName() {
    const e = this.name, t = e.charAt(0).toUpperCase() + e.slice(1).replace(/_/g, " ");
    return e.startsWith("ReservedOr") ? `${t.slice(10)} (legacy)` : t;
  }
}
function F_({
  renderTarget: n
}) {
  for (const e of n.getPointClouds()) {
    const t = e.getClasses();
    if (!(t === void 0 || t.length === 0))
      return e;
  }
}
function kc(n) {
  const e = n.getClasses();
  if (e === void 0 || e.length === 0)
    return !1;
  for (const t of e)
    if (!n.isClassVisible(t.code))
      return !1;
  return !0;
}
const V_ = [
  et.Rgb,
  et.Classification,
  et.Depth,
  et.Height,
  et.Intensity
];
class tf extends Pn {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e = V_) {
    super();
    for (const t of e)
      this.add(new j_(t));
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { key: "POINT_COLOR" };
  }
  get isEnabled() {
    return this.renderTarget.getPointClouds().next().value !== void 0;
  }
}
let j_ = class extends z {
  constructor(e) {
    super(), this._value = e;
  }
  get tooltip() {
    return z_(this._value);
  }
  get isChecked() {
    const e = this.renderTarget.getPointClouds().next().value;
    return e === void 0 ? !1 : e.pointColorType === this._value;
  }
  invokeCore() {
    for (const e of this.renderTarget.getPointClouds())
      e.pointColorType = this._value;
    return !0;
  }
};
function z_(n) {
  switch (n) {
    case et.Rgb:
      return { key: "RGB" };
    case et.Depth:
      return { key: "DEPTH" };
    case et.Height:
      return { key: "HEIGHT" };
    case et.Classification:
      return { key: "CLASSIFICATION" };
    case et.Intensity:
      return { key: "INTENSITY" };
    case et.LevelOfDetail:
      return { untranslated: "LevelOfDetail" };
    case et.PointIndex:
      return { untranslated: "PointIndex" };
    default:
      return { untranslated: "Unknown" };
  }
}
const U_ = [Fn.Circle, Fn.Square, Fn.Paraboloid];
class nf extends Pn {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e = U_) {
    super();
    for (const t of e)
      this.add(new G_(t));
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { key: "POINT_SHAPE" };
  }
  get isEnabled() {
    return this.renderTarget.getPointClouds().next().value !== void 0;
  }
}
class G_ extends z {
  constructor(e) {
    super(), this._value = e;
  }
  get tooltip() {
    switch (this._value) {
      case Fn.Circle:
        return { key: "CIRCLE" };
      case Fn.Square:
        return { key: "SQUARE" };
      case Fn.Paraboloid:
        return { key: "PARABOLOID" };
      default:
        throw new Error("Unknown point shape");
    }
  }
  get isChecked() {
    const e = this.renderTarget.getPointClouds().next().value;
    return e === void 0 ? !1 : e.pointShape === this._value;
  }
  invokeCore() {
    for (const e of this.renderTarget.getPointClouds())
      e.pointShape = this._value;
    return !0;
  }
}
const H_ = 2, q_ = 0, $_ = 4, W_ = 0.1;
class sf extends rs {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor() {
    super(q_, $_, W_);
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { key: "POINT_SIZE" };
  }
  get isEnabled() {
    return this.renderTarget.getPointClouds().next().value !== void 0;
  }
  get value() {
    const e = this.renderTarget.getPointClouds().next().value;
    return (e == null ? void 0 : e.pointSize) ?? H_;
  }
  set value(e) {
    for (const t of this.renderTarget.getPointClouds())
      t.pointSize = e;
  }
}
class K_ extends z {
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get lowQualitySettings() {
    return this._lowQualitySettings === void 0 && (this._lowQualitySettings = Y_(this.renderTarget.viewer)), this._lowQualitySettings;
  }
  get highQualitySettings() {
    if (this._highQualitySettings === void 0) {
      const e = this.lowQualitySettings;
      this._highQualitySettings = {
        cadBudget: {
          maximumRenderCost: this._highQualityFactor * e.cadBudget.maximumRenderCost,
          highDetailProximityThreshold: e.cadBudget.highDetailProximityThreshold
        },
        pointCloudBudget: {
          numberOfPoints: this._highQualityFactor * e.pointCloudBudget.numberOfPoints
        },
        resolutionOptions: {
          maxRenderResolution: 1 / 0,
          movingCameraResolutionFactor: 1
        }
      };
    }
    return this._highQualitySettings;
  }
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e = 3) {
    super(), this._highQualityFactor = e;
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { key: "HIGH_FIDELITY" };
  }
  get isToggle() {
    return !0;
  }
  get isChecked() {
    return !this.isLowQuality(this.renderTarget.viewer);
  }
  invokeCore() {
    const { viewer: e } = this.renderTarget, t = this.isLowQuality(e) ? this.highQualitySettings : this.lowQualitySettings;
    return e.cadBudget = t.cadBudget, e.pointCloudBudget = t.pointCloudBudget, e.setResolutionOptions(t.resolutionOptions), !0;
  }
  isLowQuality(e) {
    const t = this.lowQualitySettings;
    return e.cadBudget.maximumRenderCost <= t.cadBudget.maximumRenderCost && e.pointCloudBudget.numberOfPoints <= t.pointCloudBudget.numberOfPoints;
  }
}
function Y_(n) {
  return {
    cadBudget: { ...n.cadBudget },
    pointCloudBudget: { ...n.pointCloudBudget },
    // This should be fetched from the viewer, but cannot for some unknown reason
    resolutionOptions: {
      maxRenderResolution: 14e5,
      movingCameraResolutionFactor: 1
    }
  };
}
class ci extends z {
  get isVisible() {
    return !0;
  }
  equals(e) {
    return this === e;
  }
  invokeCore() {
    throw Error("invoke should never be called on a divider.");
  }
}
class X_ extends ci {
  get isVisible() {
    return this.renderTarget.getPointClouds().next().value !== void 0;
  }
}
class Z_ extends ci {
  get isVisible() {
    return this.renderTarget.get360ImageCollections().next().value !== void 0;
  }
}
class as extends z {
  get isVisible() {
    return !0;
  }
  equals(e) {
    return this === e;
  }
  invokeCore() {
    throw Error("invoke should never be called on a section.");
  }
}
class Q_ extends as {
  get isVisible() {
    return this.renderTarget.get360ImageCollections().next().value !== void 0;
  }
  get tooltip() {
    return { key: "IMAGES_360" };
  }
}
const J_ = 0, eT = 1, tT = 0.02;
class of extends rs {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor() {
    super(J_, eT, tT);
  }
  // ==================================================
  // OVERRIDES
  // =================================================
  getValueLabel() {
    return Math.round(100 * this.value) + "%";
  }
}
class nT extends of {
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { key: "IMAGE_TRANSPARENCY" };
  }
  get isEnabled() {
    return this.firstCollection !== void 0;
  }
  get value() {
    var e;
    return ((e = this.firstCollection) == null ? void 0 : e.getImagesOpacity()) ?? 1;
  }
  set value(e) {
    for (const t of this.renderTarget.get360ImageCollections())
      t.setImagesOpacity(e);
  }
  get firstCollection() {
    return this.renderTarget.get360ImageCollections().next().value;
  }
}
class iT extends as {
  get isVisible() {
    return this.renderTarget.get360ImageCollections().next().value !== void 0;
  }
  get tooltip() {
    return { key: "MARKERS_360" };
  }
}
class sT extends z {
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { key: "VISIBLE" };
  }
  get isEnabled() {
    return this.firstCollection !== void 0;
  }
  get isToggle() {
    return !0;
  }
  get isChecked() {
    var e;
    return ((e = this.firstCollection) == null ? void 0 : e.getIconsVisibility()) ?? !0;
  }
  invokeCore() {
    const e = !this.isChecked;
    for (const t of this.renderTarget.get360ImageCollections())
      t.setIconsVisibility(e);
    return !0;
  }
  get firstCollection() {
    return this.renderTarget.get360ImageCollections().next().value;
  }
}
class oT extends of {
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { key: "MARKER TRANSPARENCY" };
  }
  get isEnabled() {
    var e;
    return ((e = this.firstCollection) == null ? void 0 : e.getIconsVisibility()) ?? !1;
  }
  get value() {
    var e;
    return ((e = this.firstCollection) == null ? void 0 : e.getIconsOpacity()) ?? 1;
  }
  set value(e) {
    for (const t of this.renderTarget.get360ImageCollections())
      t.setIconsOpacity(e);
  }
  get firstCollection() {
    return this.renderTarget.get360ImageCollections().next().value;
  }
}
class rT extends z {
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { key: "X_RAY" };
  }
  get isEnabled() {
    var e;
    return ((e = this.firstCollection) == null ? void 0 : e.getIconsVisibility()) ?? !1;
  }
  get isToggle() {
    return !0;
  }
  get isChecked() {
    var e;
    return ((e = this.firstCollection) == null ? void 0 : e.isOccludedIconsVisible()) ?? !0;
  }
  invokeCore() {
    const e = !this.isChecked;
    for (const t of this.renderTarget.get360ImageCollections())
      t.setOccludedIconsVisible(e);
    return !0;
  }
  get firstCollection() {
    return this.renderTarget.get360ImageCollections().next().value;
  }
}
class rf extends z {
  getTool() {
    return this.getActiveTool(po);
  }
  getPointsOfInterestDomainObject() {
    return this.rootDomainObject.getDescendantByType(Ft);
  }
}
class aT extends rf {
  get isToggle() {
    return !0;
  }
  get tooltip() {
    return { key: "VISIBLE" };
  }
  get isChecked() {
    var e;
    return ((e = this.poiDomainObject) == null ? void 0 : e.getVisibleState(this.renderTarget)) === q.All;
  }
  invokeCore() {
    var t;
    const e = !this.isChecked;
    return (t = this.poiDomainObject) == null || t.setVisibleInteractive(e, this.renderTarget), !0;
  }
  get poiDomainObject() {
    return this.rootDomainObject.getDescendantByType(Ft);
  }
}
class cT extends ci {
  get isVisible() {
    return this.renderTarget.commandsController.getToolByType(po) !== void 0;
  }
}
class dT extends as {
  get tooltip() {
    return { key: "POINT_OF_INTEREST_PLURAL" };
  }
}
class af extends z {
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { key: "GHOST_MODE" };
  }
  get isEnabled() {
    return !0;
  }
  get isToggle() {
    return !0;
  }
  get isChecked() {
    return this.renderTarget.ghostMode;
  }
  setChecked(e) {
    this.renderTarget.ghostMode = e;
  }
  invokeCore() {
    return this.renderTarget.ghostMode = !this.renderTarget.ghostMode, !0;
  }
}
const Gr = [1, 2, 3, 4, 5], cf = 5, lT = 1;
function df(n) {
  switch (n) {
    case 1:
      return {
        cadBudget: {
          maximumRenderCost: 8e6,
          highDetailProximityThreshold: 0
        },
        pointCloudBudget: {
          numberOfPoints: 15e5
        },
        resolutionOptions: {
          maxRenderResolution: 7e5,
          movingCameraResolutionFactor: 0.1
        }
      };
    case 2:
      return {
        cadBudget: {
          maximumRenderCost: 15e6,
          highDetailProximityThreshold: 0
        },
        pointCloudBudget: {
          numberOfPoints: 3e6
        },
        resolutionOptions: {
          maxRenderResolution: 14e5,
          movingCameraResolutionFactor: 0.5
        }
      };
    case 3:
      return {
        cadBudget: {
          maximumRenderCost: 35e6,
          highDetailProximityThreshold: 0
        },
        pointCloudBudget: {
          numberOfPoints: 7e6
        },
        resolutionOptions: {
          maxRenderResolution: 6e6,
          movingCameraResolutionFactor: 1
        }
      };
    case 4:
      return {
        cadBudget: {
          maximumRenderCost: 8e7,
          highDetailProximityThreshold: 0
        },
        pointCloudBudget: {
          numberOfPoints: 2e7
        },
        resolutionOptions: {
          maxRenderResolution: 1 / 0,
          movingCameraResolutionFactor: 1
        }
      };
    case 5:
      return {
        cadBudget: {
          maximumRenderCost: 13e7,
          highDetailProximityThreshold: 0
        },
        pointCloudBudget: {
          numberOfPoints: 35e6
        },
        resolutionOptions: {
          maxRenderResolution: 1 / 0,
          movingCameraResolutionFactor: 1
        }
      };
    default:
      sn(n);
  }
}
function lf(n) {
  var i;
  const e = Gr.map((s) => ({
    level: s,
    similarity: uT(n, df(s))
  })), t = (i = Zc(e, ({ similarity: s }) => s)) == null ? void 0 : i.level;
  return We(t !== void 0), t;
}
function uT(n, e) {
  const t = ys(
    n.cadBudget.maximumRenderCost,
    e.cadBudget.maximumRenderCost
  ), i = ys(
    n.pointCloudBudget.numberOfPoints,
    e.pointCloudBudget.numberOfPoints
  ), s = ys(
    n.resolutionOptions.maxRenderResolution,
    e.resolutionOptions.maxRenderResolution
  ), o = ys(
    n.resolutionOptions.movingCameraResolutionFactor,
    e.resolutionOptions.movingCameraResolutionFactor
  );
  return t + i + s + o;
}
function ys(n, e) {
  if (n === void 0 || e === void 0)
    return 0;
  const t = Di(n, 1e-3, 1e9), i = Di(e, 1e-3, 1e9);
  return Math.min(t / i, i / t);
}
class hT extends rs {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor() {
    super(lT, cf, 1);
  }
  // ==================================================
  // OVERRIDES
  // =================================================
  get tooltip() {
    return { key: "RENDER_QUALITY_SLIDER_HEADER" };
  }
  get value() {
    const e = this.renderTarget.revealSettingsController.renderQuality();
    return lf(e);
  }
  set value(e) {
    this.update(m.renderStyle);
    const t = Math.round(e);
    if (!pT(t))
      return;
    const i = df(t);
    this.renderTarget.revealSettingsController.renderQuality(i);
  }
  get marks() {
    return Gr.reduce((e, t) => (e[t] = { label: `${t}` }, e), {});
  }
}
function pT(n) {
  return Gr.includes(n);
}
var uf = /* @__PURE__ */ ((n) => (n.Critical = "critical", n.Neutral = "neutral", n.Success = "success", n.Warning = "warning", n))(uf || {});
class Hr extends z {
  get status() {
    return "neutral";
  }
}
class fT extends Hr {
  // ==================================================
  // OVERRIDES
  // ==================================================
  get isVisible() {
    return lf(
      this.renderTarget.revealSettingsController.renderQuality()
    ) === cf;
  }
  get content() {
    return { key: "RENDER_QUALITY_SLIDER_PERFORMANCE_WARNING" };
  }
  get status() {
    return uf.Warning;
  }
  attach(e) {
    super.attach(e), this.addDisposable(
      $i(() => {
        this.renderTarget.revealSettingsController.renderQuality(), this.update();
      })
    );
  }
}
class hf extends zr {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e = !0, t = !1) {
    super(), this.add(new hT()), this.add(new fT()), this.add(new ci()), this.add(new af()), t && (this.add(new cT()), this.add(new dT()), this.add(new aT())), e && (this.add(new Z_()), this.add(new Q_()), this.add(new nT()), this.add(new iT()), this.add(new sT()), this.add(new rT()), this.add(new oT())), this.add(new X_()), this.add(new sf()), this.add(new tf()), this.add(new nf()), this.add(new Ur());
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { key: "SETTINGS_TOOLTIP" };
  }
  get icon() {
    return "Settings";
  }
}
class qr {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e, t) {
    this.i = e ?? 0, this.j = t ?? this.i;
  }
  clone() {
    return new qr(this.i, this.j);
  }
  // ==================================================
  // INSTANCE PROPERTIES
  // ==================================================
  get size() {
    return this.i * this.j;
  }
  get isZero() {
    return this.i === 0 && this.j === 0;
  }
  // ==================================================
  // INSTANCE METHODS: Getters
  // ==================================================
  getComponent(e) {
    switch (e) {
      case 0:
        return this.i;
      case 1:
        return this.j;
      default:
        return Number.NaN;
    }
  }
  toString() {
    return `(${this.i}, ${this.j})`;
  }
  // ==================================================
  // INSTANCE METHODS: Operations
  // ==================================================
  copyFrom(e) {
    return this.i = e.i, this.j = e.j, this;
  }
  add(e) {
    return this.i += e.i, this.j += e.j, this;
  }
  subtract(e) {
    return this.i -= e.i, this.j -= e.j, this;
  }
}
const gT = (n) => {
  const e = mT(n.modelId, n.viewer);
  return e === void 0 ? null : e.getCdfToDefaultModelTransformation();
};
function mT(n, e) {
  return e.models.filter((t) => t instanceof xs).find((t) => t instanceof xs && t.modelId === n);
}
const Lc = new I(0, 0, -1), Nc = Math.PI / 1e3;
function yT(n) {
  if (n.length < 3)
    return;
  const e = zi.getCenter(n);
  if (e === void 0)
    return;
  e.normalize();
  let t = n;
  const i = e.angleTo(Lc);
  if (!r(i)) {
    const c = new I().crossVectors(e, Lc).normalize(), d = new kt().setFromAxisAngle(c, i);
    t = n.map((l) => l.clone().applyQuaternion(d));
  }
  const s = zi.getSignedHorizontalArea(t);
  if (s === 0)
    return;
  let o;
  for (const c of a(t.length, s < 0))
    o = vT(c, t[c], o);
  if (o === void 0)
    return;
  return o = CT(o), IT(o);
  function r(c) {
    return c < Nc || c > Math.PI - Nc;
  }
  function* a(c, d) {
    if (d)
      for (let l = c - 1; l >= 0; l--)
        yield l;
    else
      for (let l = 0; l < c; l++)
        yield l;
  }
}
function vT(n, e, t) {
  const i = new _T(n, e);
  return t !== void 0 && (i.next = t.next, i.prev = t, t.next.prev = i, t.next = i), i;
}
function CT(n) {
  let e = n, t = n, i = !1;
  do
    if (i = !1, e.equals(e.next) || e.getArea() === 0) {
      if (e.remove(), e = t = e.prev, e === e.next)
        break;
      i = !0;
    } else
      e = e.next;
  while (i || e !== t);
  return t;
}
function IT(n) {
  const e = [];
  let t = n;
  for (; n.prev !== n.next; ) {
    const i = n.prev, s = n.next;
    if (wT(n)) {
      e.push(i.index, n.index, s.index), n.remove(), n = s.next, t = s.next;
      continue;
    }
    if (n = s, n === t)
      break;
  }
  return e;
}
function wT(n) {
  if (n.getArea() >= 0)
    return !1;
  const e = n.prev, t = n, i = n.next;
  let s = i.next;
  for (; s !== e; ) {
    if (xT(e, t, i, s) && s.getArea() >= 0)
      return !1;
    s = s.next;
  }
  return !0;
}
function xT(n, e, t, i) {
  return (t.x - i.x) * (n.y - i.y) - (n.x - i.x) * (t.y - i.y) >= 0 && (n.x - i.x) * (e.y - i.y) - (e.x - i.x) * (n.y - i.y) >= 0 && (e.x - i.x) * (t.y - i.y) - (t.x - i.x) * (e.y - i.y) >= 0;
}
class _T {
  constructor(e, t) {
    this.index = e, this.x = t.x, this.y = t.y, this.prev = this, this.next = this;
  }
  equals(e) {
    return this.x === e.x && this.y === e.y;
  }
  remove() {
    this.next.prev = this.prev, this.prev.next = this.next;
  }
  getArea() {
    return e(this.prev, this, this.next);
    function e(t, i, s) {
      return (i.y - t.y) * (s.x - i.x) - (i.x - t.x) * (s.y - i.y);
    }
  }
}
const TT = 5;
class Jt extends Rr {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e) {
    super(y.Polygon), this.center = new I(), this.vectorLength = TT, this.status = "pending", this.connectedImageId = e;
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get icon() {
    return "Polygon";
  }
  get color() {
    switch (this.status) {
      case "suggested":
        return new D(D.NAMES.yellow);
      case "saved":
        return new D(13920994);
      case "pending":
        return new D(5089023);
      case "deleted":
        return new D(D.NAMES.red);
      default:
        return new D(D.NAMES.gray);
    }
  }
  get canChangeColor() {
    return !1;
  }
  get typeName() {
    return { untranslated: "360 image annotation" };
  }
  get hasPanelInfo() {
    return !1;
  }
  clone(e) {
    const t = new Jt(this.connectedImageId);
    return t.copyFrom(this, e), t;
  }
  copyFrom(e, t) {
    super.copyFrom(e, t), this.connectedImageId = e.connectedImageId, this.center.copy(e.center), this.vectorLength = e.vectorLength, this.annotationIdentifier = e.annotationIdentifier, this.assetRef = e.assetRef, this.status = e.status;
  }
  createRenderStyle() {
    const e = new Rp();
    return e.showLabel = !1, e.pipeRadius = 0.01 / 3, e.selectedPipeRadius = 2 * e.pipeRadius, e.depthTest = !1, e.transparent = !0, e.showSolid = !0, e.renderOrder = 100, e;
  }
  getTransformedPoint(e) {
    return this.getCopyOfTransformedPoint(e, new I());
  }
  getCopyOfTransformedPoint(e, t) {
    return t.copy(this.center), t.addScaledVector(e, this.vectorLength), t;
  }
  getTriangleIndexes() {
    return yT(this.points);
  }
}
class Gi extends ri {
  get typeName() {
    return { untranslated: "360 image annotations" };
  }
  clone(e) {
    const t = new Gi();
    return t.copyFrom(this, e), t;
  }
}
class $r extends Mn {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e = !0) {
    super(), this._mustBeInside360Image = e;
  }
  // ==================================================
  // OVERRIDES of BaseCommand
  // ==================================================
  get icon() {
    return "Cursor";
  }
  get tooltip() {
    return { untranslated: "Select 360 polygons" };
  }
  get isEnabled() {
    return this._mustBeInside360Image ? this.renderTarget.isInside360Image : !0;
  }
  update() {
    super.update(), this.isChecked && !this.isEnabled && this.renderTarget.commandsController.activateDefaultTool();
  }
  // ==================================================
  // OVERRIDES of BaseTool
  // ==================================================
  get defaultCursor() {
    return "default";
  }
  async onClick(e) {
    const t = await this.getIntersection(e);
    if (t !== void 0) {
      const i = this.getIntersectedSelectableDomainObject(t);
      if (i !== void 0) {
        this.deselectAll(i), i.setSelectedInteractive(!0);
        return;
      }
    }
    this.deselectAll(), await super.onClick(e);
  }
  onDeleteKey() {
    const e = Array.from(this.getAllSelected());
    for (const t of e)
      this.addTransaction(t.createTransaction(m.deleted)), t.removeInteractive();
  }
  // ==================================================
  // OVERRIDES of BaseEditTool
  // ==================================================
  canBeSelected(e) {
    return e instanceof Jt;
  }
  // ==================================================
  // INSTANCE METHODS
  // ==================================================
  setImage360AnnotationsVisible() {
    const e = this.renderTarget.active360ImageId;
    for (const t of this.getSelectableByType(Jt)) {
      const i = e !== void 0 && t.connectedImageId === e;
      t.setVisibleInteractive(i, this.renderTarget);
    }
  }
}
class ST extends Dp {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e) {
    super(e);
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get preferIntersection() {
    return !1;
  }
  get minimumPointCount() {
    return 3;
  }
  get maximumPointCount() {
    return Number.MAX_SAFE_INTEGER;
  }
  transformInputPoint(e, t, i) {
    return e.direction.clone();
  }
}
class pf extends Mr {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor(e = !0) {
    super(y.Polygon), this._mustBeInside360Image = e;
  }
  // ==================================================
  // OVERRIDES of BaseCommand
  // ==================================================
  get icon() {
    return "Polygon";
  }
  get tooltip() {
    return {
      untranslated: "Create 360 annotation polygons. Click at least 3 points and end with Esc."
    };
  }
  get isEnabled() {
    return this._mustBeInside360Image ? this.renderTarget.isInside360Image : !0;
  }
  update() {
    super.update(), this.isChecked && !this.isEnabled && this.renderTarget.commandsController.activateDefaultTool();
  }
  // ==================================================
  // OVERRIDES of BaseTool
  // ==================================================
  onDeactivate() {
    super.onDeactivate(), this.escape();
  }
  onEscapeKey() {
    this.escape(), this.setSelectTool();
  }
  async onHover(e) {
    const t = this._creator;
    if (t === void 0) {
      this.setDefaultCursor();
      return;
    }
    const i = this.getRay(e);
    if (t.addPoint(i, void 0, !0)) {
      this.setDefaultCursor();
      return;
    }
    super.onHover(e);
  }
  async onHoverByDebounce(e) {
    await Promise.resolve();
  }
  async onClick(e) {
    let t = this._creator;
    if (t !== void 0) {
      const i = this.getRay(e);
      t.addPoint(i) && this.endCreatorIfFinished(t);
    } else {
      if (t = this.createCreator(), t === void 0) {
        await super.onClick(e);
        return;
      }
      const i = this.getRay(e);
      if (!t.addPoint(i))
        return;
      const { domainObject: s } = t;
      this.deselectAll(), this.getOrCreateParent().addChildInteractive(s), s.setSelectedInteractive(!0), s.setVisibleInteractive(!0), this.addTransaction(s.createTransaction(m.added)), this._creator = t;
    }
  }
  // ==================================================
  // OVERRIDES of BaseEditTool
  // ==================================================
  canBeSelected(e) {
    return e instanceof Jt;
  }
  // ==================================================
  // OVERRIDES of PrimitiveEditTool
  // ==================================================
  createCreator() {
    const e = this._mustBeInside360Image ? this.renderTarget.active360ImageId : "NotConnectedToImageId";
    We(e !== void 0, "Image360AnnotationCreator: image360Id is undefined");
    const t = new Jt(e);
    return t.center.copy(i(this.renderTarget)), new ST(t);
    function i(s) {
      const { position: o } = s.cameraManager.getCameraState();
      return We(o !== void 0, "Camera position unknown"), o.clone().applyMatrix4(s.fromViewerMatrix);
    }
  }
  getOrCreateParent() {
    const e = this.rootDomainObject, t = e.getDescendantByType(Gi);
    if (t !== void 0)
      return t;
    const i = new Gi();
    return i.isExpanded = !0, e.addChildInteractive(i), i;
  }
  // ==================================================
  // OVERRIDES of PrimitiveEditTool
  // ==================================================
  setSelectTool() {
    this.renderTarget.commandsController.setActiveToolByType($r) && Ie.update(this.renderTarget);
  }
}
class bT extends on {
  get tooltip() {
    return { untranslated: "Remove selected polygon" };
  }
  get icon() {
    return "Delete";
  }
  get buttonType() {
    return "ghost-destructive";
  }
  get shortCutKey() {
    return "Delete";
  }
  invokeCore() {
    const e = Array.from(this.getInstances());
    e.reverse();
    for (const t of e)
      this.addTransaction(t.createTransaction(m.deleted)), t.removeInteractive();
    return !0;
  }
  isInstance(e) {
    return e instanceof Jt && e.isSelected && e.focusType !== A.Pending;
  }
}
y_();
L_();
const QO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Annotation: Vt,
  AnnotationChangedDescription: wt,
  AnnotationUtils: qp,
  AnnotationsCreateTool: Ui,
  AnnotationsDomainObject: ke,
  AnnotationsRenderStyle: Gp,
  AnnotationsSelectTool: jt,
  BaseBannerCommand: Hr,
  BaseCommand: Bi,
  BaseCreator: ns,
  BaseDragger: is,
  BaseEditTool: Mn,
  BaseFilterCommand: ut,
  BaseFilterItemCommand: ef,
  BaseOptionCommand: Pn,
  BaseRevealConfig: Zh,
  BaseSettingsCommand: zr,
  BaseSliderCommand: rs,
  BaseTool: Xh,
  BaseView: Gh,
  ChangedDescription: $n,
  Changes: m,
  ColorType: Re,
  CommandChanges: Fi,
  CommandsController: Dh,
  CommonRenderStyle: Qt,
  CopyToClipboardCommand: Zi,
  DefaultRevealConfig: Qh,
  DeleteDomainObjectCommand: jh,
  DeleteSelectedImage360AnnotationCommand: bT,
  DomainObject: Yt,
  DomainObjectChange: ct,
  DomainObjectCommand: Ir,
  DomainObjectTransaction: ts,
  FitViewCommand: bp,
  FocusType: A,
  FolderDomainObject: ri,
  GroupThreeView: gt,
  Image360AnnotationCreateTool: pf,
  Image360AnnotationDomainObject: Jt,
  Image360AnnotationFolder: Gi,
  Image360AnnotationSelectTool: $r,
  Index2: qr,
  InstanceCommand: on,
  KeyboardSpeedCommand: Lp,
  NavigationTool: Qi,
  PanelInfo: si,
  PointCloudFilterCommand: Ur,
  PointsOfInterestDomainObject: Ft,
  PointsOfInterestView: Qp,
  PopupStyle: Ve,
  PrimitiveType: y,
  Quantity: V,
  Range1: ht,
  Range3: ft,
  RenderStyle: An,
  RenderTargetCommand: z,
  RevealRenderTarget: Ip,
  RootDomainObject: so,
  SetPointColorTypeCommand: tf,
  SetPointShapeCommand: nf,
  SetPointSizeCommand: sf,
  SetQualityCommand: K_,
  SettingsCommand: hf,
  ShowAllDomainObjectsCommand: jr,
  ShowDomainObjectsOnTopCommand: os,
  Status: we,
  ThreeView: bn,
  ToggleMetricUnitsCommand: io,
  Transaction: Ap,
  TrianglesBuffers: mo,
  UndoCommand: un,
  UndoManager: Kh,
  UnitSystem: no,
  Views: Vh,
  VisibleState: q,
  VisualDomainObject: Me,
  getGlobalMatrix: gT,
  getNextColor: Bh,
  getNextColorByIndex: dv,
  getResizeCursor: Wh,
  isCustomObjectIntersection: Yv,
  isDomainObjectIntersection: It,
  isPointsOfInterestIntersection: Zo
}, Symbol.toStringTag, { value: "Module" })), AT = ({ command: n }) => {
  const { uniqueId: e, isVisible: t, isEnabled: i, isChecked: s } = mt(n);
  return t ? /* @__PURE__ */ u(
    $.Item,
    {
      disabled: !i,
      checked: s,
      variant: "checkbox",
      trailingContent: /* @__PURE__ */ u(MT, { children: n.color !== void 0 && /* @__PURE__ */ u(ET, { backgroundColor: n.color }) }),
      onClick: () => {
        n.invoke();
      },
      label: n.label
    },
    e
  ) : /* @__PURE__ */ u(k, {});
}, ET = b.div`
  width: 16px;
  height: 16px;
  display: inline-block;
  border-radius: 4px;
  background-color: ${(n) => n.backgroundColor.getStyle()};
`, MT = b.div`
  padding: 0px 1px;
  display: flex;
  row-gap: 3px;
  gap: 4px;
  align-items: center;
`, Dn = 12, ff = ({
  inputCommand: n,
  placement: e,
  usedInSettings: t = !1
}) => {
  const i = On(n);
  i.initializeChildrenIfNeeded();
  const { icon: s, isVisible: o, isEnabled: r } = mt(i), a = Ae(i, () => i.isAllChecked), c = Ae(i, () => i.isSomeChecked), d = Ae(i, () => i.getSelectedLabel()), [l, h] = M(!1), p = i.children;
  if (!o || p === void 0 || p.length === 0)
    return /* @__PURE__ */ u(k, {});
  const f = /* @__PURE__ */ u(
    RT,
    {
      command: i,
      isAllChecked: a,
      isSomeChecked: c,
      label: i.label
    }
  );
  return t ? /* @__PURE__ */ u(
    OT,
    {
      label: i.label,
      selectedLabel: d,
      isOpen: l,
      setOpen: h,
      PanelContent: f
    }
  ) : /* @__PURE__ */ u(
    PT,
    {
      command: i,
      placement: ss(e),
      iconName: s,
      label: i.label,
      isOpen: l,
      setOpen: h,
      isEnabled: r,
      PanelContent: f
    }
  );
}, PT = ({
  command: n,
  isOpen: e,
  setOpen: t,
  label: i,
  isEnabled: s,
  placement: o,
  iconName: r,
  PanelContent: a
}) => /* @__PURE__ */ u(
  Ge,
  {
    floatingProps: { middleware: [Ki(Dn)] },
    onOpenChange: t,
    placement: "right-end",
    disableCloseOnClickInside: !0,
    renderTrigger: (c) => /* @__PURE__ */ u(
      ce,
      {
        content: /* @__PURE__ */ u(ai, { label: i, command: n }),
        disabled: e || i === void 0,
        placement: o,
        children: /* @__PURE__ */ u(
          J,
          {
            type: fo(n),
            icon: /* @__PURE__ */ u(In, { iconName: r }),
            disabled: !s,
            toggled: e,
            iconPlacement: "left",
            "aria-label": n.label,
            ...c,
            onClick: (d) => {
              d.stopPropagation(), d.preventDefault(), c.onClick(d), t(!e);
            }
          }
        )
      }
    ),
    children: a
  }
), OT = ({
  label: n,
  selectedLabel: e,
  isOpen: t,
  setOpen: i,
  PanelContent: s
}) => /* @__PURE__ */ _(DT, { children: [
  /* @__PURE__ */ u(kT, { children: n }),
  /* @__PURE__ */ _(BT, { placement: "right-end", visible: t, children: [
    /* @__PURE__ */ u($.Trigger, { children: /* @__PURE__ */ u(
      LT,
      {
        color: "#000044",
        type: "tertiary",
        toggled: t,
        onClick: () => {
          i((o) => !o);
        },
        children: /* @__PURE__ */ _(NT, { children: [
          /* @__PURE__ */ u(FT, { children: e }),
          t ? /* @__PURE__ */ u(ud, { color: Wa }) : /* @__PURE__ */ u(hd, { color: Wa })
        ] })
      }
    ) }),
    /* @__PURE__ */ u($.Body, { style: { overflow: "hidden" }, children: s })
  ] })
] }), RT = ({
  command: n,
  isAllChecked: e,
  isSomeChecked: t,
  label: i
}) => {
  const s = n.children;
  return /* @__PURE__ */ _(k, { children: [
    /* @__PURE__ */ u($.Section, { children: /* @__PURE__ */ u(
      $.Item,
      {
        variant: "checkbox",
        checked: e,
        indeterminate: !e && t,
        onClick: () => {
          n.toggleAllChecked();
        },
        label: ut.getAllString(),
        children: ut.getAllString()
      },
      -1
    ) }),
    /* @__PURE__ */ u($.Body, { style: { maxHeight: "300px" }, children: /* @__PURE__ */ u($.Section, { title: i, children: s == null ? void 0 : s.map((o, r) => /* @__PURE__ */ u(AT, { command: o }, o.uniqueId)) }) })
  ] });
}, DT = b.div`
  display: flex;
  align-self: stretch;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  padding: ${Nr};
`, kT = b.label`
  flex: 2 2;
`, LT = b(J)`
  width: 100%;
  padding: 0px 0px;
`, NT = b(U).attrs({ direction: "row" })`
  width: 100%;
  justify-content: space-between;
`, BT = b($)`
  display: flex;
  flex: 2 2;
  display-direction: row;
  justify-content: space-between;
  align-items: center;

  .cogs-v10.cogs-button {
    padding: 7px 8px;
  }

  .cogs-lab.cogs-dropdown__anchor-el {
    width: inherit;
  }
`, FT = b.label`
  font-weight: 400;
`, VT = ({
  inputCommand: n,
  placement: e
}) => {
  const t = On(n), { isVisible: i, isEnabled: s, icon: o } = mt(t), [r, a] = M(!1);
  if (!i || !t.hasChildren)
    return /* @__PURE__ */ u(k, {});
  const c = t.label, d = Ew(e), l = r || c === void 0;
  return /* @__PURE__ */ u(
    Td,
    {
      disabled: !s,
      content: /* @__PURE__ */ _(QT, { $flexDirection: d, children: [
        /* @__PURE__ */ u(JT, { children: c }),
        t.children.map((h) => jT(h))
      ] }),
      onShow: (h) => {
        a(h);
      },
      onHide: (h) => {
        a(h);
      },
      placement: e ?? "right-end",
      offset: { mainAxis: Dn },
      children: /* @__PURE__ */ u(
        ce,
        {
          content: /* @__PURE__ */ u(ai, { label: c, command: t }),
          disabled: l,
          enterDelay: go,
          placement: ss(e),
          children: /* @__PURE__ */ u(
            J,
            {
              type: fo(t),
              icon: /* @__PURE__ */ u(In, { iconName: o }),
              disabled: !s,
              toggled: r,
              "aria-label": c
            }
          )
        }
      )
    }
  );
};
function jT(n) {
  return n instanceof rs ? /* @__PURE__ */ u(qT, { command: n }, n.uniqueId) : n instanceof Pn ? /* @__PURE__ */ u($T, { command: n }, n.uniqueId) : n instanceof ut ? /* @__PURE__ */ u(WT, { command: n }, n.uniqueId) : n.isToggle ? /* @__PURE__ */ u(GT, { command: n }, n.uniqueId) : n instanceof ci ? /* @__PURE__ */ u(zT, { command: n }, n.uniqueId) : n instanceof as ? /* @__PURE__ */ u(UT, { command: n }, n.uniqueId) : n instanceof Hr ? /* @__PURE__ */ u($w, { command: n }, n.uniqueId) : /* @__PURE__ */ u(HT, { command: n }, n.uniqueId);
}
function zT({ command: n }) {
  return Rn(n) ? /* @__PURE__ */ u(Ge.Divider, {}) : null;
}
function UT({ command: n }) {
  return Rn(n) ? /* @__PURE__ */ _(XT, { children: [
    n.label,
    " "
  ] }) : null;
}
function GT({ command: n }) {
  const { isVisible: e, isChecked: t, isEnabled: i } = mt(n);
  return e ? /* @__PURE__ */ _(
    ZT,
    {
      onClick: () => {
        i && n.invoke();
      },
      children: [
        /* @__PURE__ */ u(yd, { checked: t, disabled: !i }),
        /* @__PURE__ */ u($t, { text: n.label })
      ]
    }
  ) : null;
}
function HT({ command: n }) {
  const { isVisible: e, isEnabled: t, icon: i } = mt(n);
  return e ? /* @__PURE__ */ u(
    Ge.ItemAction,
    {
      disabled: !t,
      icon: /* @__PURE__ */ u(In, { iconName: i }),
      style: { padding: Nr },
      shortcutKeys: n.getShortCutKeys(),
      label: n.label,
      onClick: () => {
        n.invoke();
      }
    }
  ) : null;
}
function qT({ command: n }) {
  const { isVisible: e, isEnabled: t } = mt(n), i = Bw(n);
  if (!e)
    return null;
  const s = n.label + ": " + n.getValueLabel();
  return /* @__PURE__ */ _(KT, { children: [
    /* @__PURE__ */ u("label", { children: s }),
    /* @__PURE__ */ u(
      YT,
      {
        disabled: !t,
        min: n.min,
        max: n.max,
        step: n.step,
        marks: n.marks,
        onChange: (o) => {
          n.value = o, n.update();
        },
        value: i
      }
    )
  ] });
}
function $T({ command: n }) {
  return Rn(n) ? /* @__PURE__ */ u(Up, { inputCommand: n, placement: "bottom", usedInSettings: !0 }) : null;
}
function WT({ command: n }) {
  return n.initializeChildrenIfNeeded(), Rn(n) ? /* @__PURE__ */ u(ff, { inputCommand: n, placement: "bottom", usedInSettings: !0 }) : null;
}
const KT = b.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
  gap: 4px;
  font-size: 14px;
`, YT = b(dy)`
  offset-anchor: right top;
  float: center;
  display: flex;

  justify-content: space-around;
`, XT = b.span`
  color: var(--text-icon-muted, rgba(0, 0, 0, 0.55));
  font-feature-settings: 'cv05' on;

  /* Label/XSmall */
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 166.667% */
  letter-spacing: -0.036px;
`, ZT = b(U).attrs({
  direction: "row"
})`
  width: 100%;
  justify-content: start;
  gap: 8px;
`, QT = b.div`
  max-height: 400px;
  min-width: 340px;
  overflow-x: hidden;
  overflow-y: auto;
  flexdirection: ${({ $flexDirection: n }) => n};

  display: flex;
  padding: var(--Padding-Small-Small-8, 8px) var(--space-8, 8px);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--Padding-Small-Small-8, 8px);

  border-radius: var(--Radius-Large, 8px);
  background: #fff;

  box-shadow:
    0px 1px 16px 4px rgba(79, 82, 104, 0.1),
    0px 1px 8px 0px rgba(79, 82, 104, 0.08),
    0px 1px 2px 0px rgba(79, 82, 104, 0.24);
`, JT = b(U).attrs({
  direction: "row"
})`
  flex: 1 0 0;

  color: var(--color-text-icon-strong, rgba(0, 0, 0, 0.9));

  /* Body/Medium strong */
  font-family: var(--typography-font-family-default, Inter);
  font-size: var(--typography-body-medium-strong-size, 14px);
  font-style: normal;
  font-weight: 500;
  line-height: var(--typography-body-medium-strong-line-height, 20px); /* 142.857% */
  letter-spacing: var(--typography-body-medium-strong-letter-spacing, -0.084px);
`, eS = ({
  inputCommand: n,
  placement: e
}) => {
  const t = me(), i = On(n), { uniqueId: s, isVisible: o, isEnabled: r } = mt(i), a = Ae(i, () => tS(i));
  if (!o || i.children === void 0)
    return /* @__PURE__ */ u(k, {});
  const c = i.label;
  return /* @__PURE__ */ u(
    ce,
    {
      content: /* @__PURE__ */ u(ai, { label: c, command: i }),
      disabled: c === void 0,
      enterDelay: go,
      placement: ss(e),
      children: /* @__PURE__ */ u(
        aa,
        {
          disabled: !r,
          currentKey: a,
          fullWidth: !0,
          onButtonClicked: (d) => {
            if (i.children !== void 0) {
              for (const l of i.children)
                if (tr(l) === d) {
                  l.invoke(), t.domElement.focus();
                  break;
                }
            }
          },
          children: i.children.map((d) => /* @__PURE__ */ u(
            aa.Button,
            {
              icon: /* @__PURE__ */ u(In, { iconName: d.icon }),
              disabled: !r,
              "aria-label": d.label,
              children: d.label
            },
            tr(d)
          ))
        },
        s
      )
    }
  );
};
function tS(n) {
  const e = n.selectedChild;
  return e === void 0 ? "undefined" : tr(e);
}
function tr(n) {
  return n.uniqueId.toString();
}
const nS = ({ inputCommand: n }) => {
  const { t: e } = W(), t = On(n), i = Ae(t, () => t.content), s = Ae(t, () => h(t.getPostButtonLabel())), o = Ae(t, () => h(t.getCancelButtonLabel())), r = Ae(t, () => h(t.getPlaceholder())), a = Ae(t, () => t.isPostButtonEnabled), { uniqueId: c, isVisible: d, isEnabled: l } = mt(t);
  if (!d)
    return /* @__PURE__ */ u(k, {});
  return /* @__PURE__ */ u(
    vd,
    {
      placeholder: r,
      message: i,
      setMessage: (p) => t.content = p,
      onPostMessage: () => {
        t.invoke(), t.content = "";
      },
      postButtonText: s,
      postButtonDisabled: !(a && l),
      cancelButtonText: o,
      cancelButtonDisabled: !1,
      onCancel: t.onCancel,
      showButtons: !0
    },
    c
  );
  function h(p) {
    return p !== void 0 ? e(p) : void 0;
  }
};
class gf extends z {
  constructor() {
    super(...arguments), this._content = "";
  }
  getCancelButtonLabel() {
  }
  get onCancel() {
    return this._onCancel;
  }
  set onCancel(e) {
    this._onCancel = e;
  }
  get content() {
    return this._content;
  }
  set content(e) {
    this._content = e, this.update();
  }
  get isPostButtonEnabled() {
    return this._content.length > 0;
  }
}
const iS = (n, e) => {
  const t = Z(e, [n]);
  R(() => {
    if (n !== void 0)
      return t(), n.addEventListener(t), () => {
        n.removeEventListener(t);
      };
  }, [n, t]);
}, cs = (n, e) => {
  const t = Z(e, [n]);
  R(() => {
    if (n !== void 0)
      return t(), n.views.addEventListener(t), () => {
        n.views.removeEventListener(t);
      };
  }, [n, t]);
}, sS = ({
  inputCommand: n
}) => {
  var S;
  const { t: e } = W(), t = (E) => E !== void 0 ? e(E) : void 0, i = me(), s = P(() => zp(n, i), [n]), [o, r] = M(s.isEnabled), [a, c] = M(
    t(s.getPostButtonLabel())
  ), [d, l] = M(
    t(s.getCancelButtonLabel())
  ), [h, p] = M(!0), f = P(() => s.contents.map((E) => E.type === "submitButtons" ? { type: E.type, content: void 0 } : E.type === "customInput" ? { type: E.type, content: E.content } : { type: E.type, content: E.content }), [s]), [g, C] = M(f), v = (S = s.getAllPlaceholders()) == null ? void 0 : S.map((E) => t(E)), [w, x] = M(
    v
  );
  iS(s, () => {
    var E;
    c(t(s.getPostButtonLabel())), l(t(s.getCancelButtonLabel())), x(
      (E = s.getAllPlaceholders()) == null ? void 0 : E.map((B) => t(B))
    ), r(s.isEnabled);
  });
  const T = Z(
    (E, B) => {
      const L = g !== void 0 ? [...g] : [];
      L[E].content = L[E] !== void 0 ? B : "", C(L);
      const le = L.some(
        (N) => N.type === "text" && ((N == null ? void 0 : N.content) ?? "").trim() === ""
      );
      p(le);
    },
    [g, C]
  ), O = g.map((E, B) => E.type === "text" ? /* @__PURE__ */ u(
    Ts,
    {
      value: E.content,
      disabled: !o,
      onChange: (L) => {
        T(B, L.target.value);
      },
      placeholder: w == null ? void 0 : w[B]
    },
    B
  ) : E.type === "comment" ? /* @__PURE__ */ u(
    ly,
    {
      placeholder: w == null ? void 0 : w[B],
      value: E.content,
      onChange: (L) => {
        T(B, L.target.value);
      }
    },
    B
  ) : E.type === "customInput" ? E.content : E.type === "submitButtons" ? /* @__PURE__ */ _(U, { gap: 8, children: [
    /* @__PURE__ */ u(
      J,
      {
        type: "secondary",
        disabled: !o,
        onClick: () => {
          var L;
          (L = s.onCancel) == null || L.call(s), C([]);
        },
        children: d
      }
    ),
    /* @__PURE__ */ u(
      J,
      {
        type: "primary",
        disabled: h || !o,
        onClick: () => {
          s.invokeWithContent(g ?? []), C([]);
        },
        children: a
      }
    )
  ] }, B) : E.type === "commentWithButtons" ? /* @__PURE__ */ u(
    vd,
    {
      placeholder: w == null ? void 0 : w[B],
      message: E.content,
      setMessage: (L) => {
        T(B, L);
      },
      onPostMessage: () => {
        s.invokeWithContent(g ?? []), C([]);
      },
      postButtonText: a,
      postButtonDisabled: h || !o,
      cancelButtonText: d,
      cancelButtonDisabled: !1,
      onCancel: s.onCancel,
      showButtons: !0
    },
    B
  ) : null);
  return /* @__PURE__ */ u(oS, { direction: "column", gap: 8, children: O });
}, oS = b(U)`
  padding: 6px;
`;
function vo(n, e) {
  if (n instanceof ut)
    return /* @__PURE__ */ u(ff, { inputCommand: n, placement: e }, n.uniqueId);
  if (n instanceof zr)
    return /* @__PURE__ */ u(VT, { inputCommand: n, placement: e }, n.uniqueId);
  if (n instanceof Pn)
    switch (n.optionType) {
      case ks.Dropdown:
        return /* @__PURE__ */ u(Up, { inputCommand: n, placement: e }, n.uniqueId);
      case ks.Segmented:
        return /* @__PURE__ */ u(eS, { inputCommand: n, placement: e }, n.uniqueId);
      default:
        return /* @__PURE__ */ u(k, {});
    }
  return n instanceof gf ? /* @__PURE__ */ u(nS, { inputCommand: n }, n.uniqueId) : n instanceof Fp ? /* @__PURE__ */ u(sS, { inputCommand: n, placement: e }, n.uniqueId) : /* @__PURE__ */ u(qw, { inputCommand: n, placement: e }, n.uniqueId);
}
function de(n, e) {
  const t = P(n, []);
  return vo(t, e.toolbarPlacement ?? "left");
}
const mf = ({
  commands: n,
  placement: e
}) => /* @__PURE__ */ u(k, { children: n.map(
  (t, i) => /* @__PURE__ */ u(
    aS,
    {
      command: t,
      placement: e
    },
    rS(t, i)
  )
) });
function rS(n, e) {
  return n === void 0 ? -e : n.uniqueId;
}
function aS({
  command: n,
  placement: e
}) {
  if (n instanceof ci || n instanceof as || n === void 0) {
    const t = Mw(e);
    return /* @__PURE__ */ u(gn, { weight: "2px", length: "24px", direction: t });
  }
  return vo(n, e);
}
class cS extends Pn {
  // ==================================================
  // CONSTRUCTOR
  // ==================================================
  constructor() {
    super(ks.Segmented), this.add(new Xn(qe.Orbit, !1)), this.add(new Xn(qe.FirstPerson, !1));
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { key: "CONTROLS_TYPE_TOOLTIP" };
  }
  attach(e) {
    super.attach(e), this.addDisposable(
      $i(() => {
        this.renderTarget.revealSettingsController.cameraControlsType(), this.update();
      })
    );
  }
}
class dS extends jr {
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { untranslated: "Show or hide annotations." };
  }
  isInstance(e) {
    return Vr(e);
  }
}
class lS extends os {
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { untranslated: "Show all annotations on top." };
  }
  isInstance(e) {
    return Vr(e);
  }
}
class Wr extends z {
  constructor(e) {
    super(), this._action = e;
  }
  equals(e) {
    return e instanceof Wr ? this._action === e._action : !1;
  }
  get icon() {
    switch (this._action) {
      case Fe.Backward:
        return "ArrowLeft";
      case Fe.Forward:
        return "ArrowRight";
      case Fe.Enter:
        return "View360";
      case Fe.Exit:
        return "CloseLarge";
      default:
        throw new Error("Unknown action");
    }
  }
  get tooltip() {
    switch (this._action) {
      case Fe.Backward:
        return { key: "GO_BACK_360" };
      case Fe.Forward:
        return { key: "GO_FORWARD_360" };
      case Fe.Enter:
        return { key: "ENTER_LAST_360" };
      case Fe.Exit:
        return { key: "EXIT_360" };
      default:
        throw new Error("Unknown action");
    }
  }
  get isEnabled() {
    return this.renderTarget.viewer.canDoImage360Action(this._action);
  }
  invokeCore() {
    return this.renderTarget.viewer.image360Action(this._action).then(() => {
      Ie.update(this.renderTarget);
    }), !1;
  }
}
class uS extends z {
  constructor(e, t) {
    super(), this._position = e, this._pointerEvent = t;
  }
  get hasData() {
    return !0;
  }
  get icon() {
    return "Waypoint";
  }
  get tooltip() {
    return { key: "POINT_OF_INTEREST_CREATE" };
  }
  invokeCore() {
    const e = this.renderTarget.commandsController.getToolByType(po);
    return e === void 0 ? !1 : (this.renderTarget.commandsController.setActiveTool(e), e.openCreateCommandDialog(this._position, this._pointerEvent), !0);
  }
}
class hS extends rf {
  get icon() {
    return "Delete";
  }
  get tooltip() {
    return { key: "POINT_OF_INTEREST_DELETE_THIS" };
  }
  get buttonType() {
    return "ghost-destructive";
  }
  get shortCutKey() {
    return "DELETE";
  }
  get isEnabled() {
    const e = this.getPointsOfInterestDomainObject();
    return (e == null ? void 0 : e.selectedPointsOfInterest) !== void 0;
  }
  invokeCore() {
    const e = this.getPointsOfInterestDomainObject(), t = e == null ? void 0 : e.selectedPointsOfInterest;
    return e === void 0 || t === void 0 ? !1 : (e.removePointsOfInterest(t), e.setSelectedPointOfInterest(void 0), e.save(), !0);
  }
}
const K = class K {
};
K.Settings = (e) => de(
  () => new hf(e.include360Images, e.includePois),
  e
), K.PointCloudFilter = (e) => de(() => new Ur(), e), K.FitView = (e) => de(() => new bp(), e), K.NavigationTool = (e) => de(() => new Qi(), e), K.SetAxisVisible = (e) => de(() => new zI(), e), K.Measurement = (e) => de(() => new kr(), e), K.Clip = (e) => de(() => new Or(), e), K.Undo = (e) => de(() => new un(), e), K.SetOrbitOrFirstPersonMode = (e) => de(() => new cS(), e), K.SetOrbitMode = (e) => de(
  () => new Xn(qe.Orbit),
  e
), K.SetFirstPersonMode = (e) => de(
  () => new Xn(qe.FirstPerson),
  e
), K.PointsOfInterest = (e) => de(() => new po(), e), K.PointsOfInterestInitiateCreation = (e) => de(
  () => new uS(e.point, e.clickEvent),
  e
), K.DeleteSelectedPointOfInterest = (e) => de(() => new hS(), e), K.KeyboardSpeed = (e) => de(() => new Lp(), e), K.Image360Button = (e) => de(() => new Wr(e.action), e), K.Image360Buttons = (e) => /* @__PURE__ */ _(k, { children: [
  /* @__PURE__ */ u(K.Image360Button, { ...e, action: Fe.Enter }),
  /* @__PURE__ */ u(K.Image360Button, { ...e, action: Fe.Backward }),
  /* @__PURE__ */ u(K.Image360Button, { ...e, action: Fe.Forward }),
  /* @__PURE__ */ u(K.Image360Button, { ...e, action: Fe.Exit })
] }), K.Image360AnnotationCreateTool = (e) => de(() => new pf(), e), K.Image360AnnotationSelectTool = (e) => de(() => new $r(), e), K.AnnotationsSelect = (e) => de(() => new jt(), e), K.AnnotationsCreate = (e) => de(() => new Ui(), e), K.AnnotationsShow = (e) => de(() => new dS(), e), K.AnnotationsShowOnTop = (e) => de(() => new lS(), e);
let nr = K;
const pS = () => {
  const n = me();
  if (n === void 0)
    return /* @__PURE__ */ u(k, {});
  const e = bs(n.commandsController.activeToolSignal);
  if (e === void 0)
    return /* @__PURE__ */ u(k, {});
  const t = e.getToolbar();
  if (t === void 0)
    return /* @__PURE__ */ u(k, {});
  const i = e.getToolbarStyle();
  return /* @__PURE__ */ u(fS, { commands: t, style: i });
}, fS = ({
  commands: n,
  style: e
}) => {
  if (n.length === 0)
    return /* @__PURE__ */ u(k, {});
  const t = gS(e);
  return /* @__PURE__ */ u(
    mS,
    {
      style: {
        left: e.leftPx,
        right: e.rightPx,
        top: e.topPx,
        bottom: e.bottomPx,
        margin: e.marginPx
      },
      children: /* @__PURE__ */ u(
        yS,
        {
          style: {
            flexFlow: e.flexFlow,
            padding: 2
          },
          children: /* @__PURE__ */ u(mf, { commands: n, placement: t })
        }
      )
    }
  );
};
function gS(n) {
  return n.isHorizontal ? n.top !== void 0 ? "top" : "bottom" : n.left !== void 0 ? "left" : "right";
}
const mS = b.div`
  zindex: 1000px;
  position: absolute;
  display: block;
`, yS = b(En(Cd))``, jo = "x-small", vS = "medium", CS = () => {
  bs(Cn.update);
  const n = bs(Cn.selectedDomainObject), e = P(() => n == null ? void 0 : n.getPanelToolbar(), [n]);
  if (n === void 0 || e === void 0)
    return /* @__PURE__ */ u(k, {});
  const t = n.getPanelInfo(), i = n.getPanelInfoStyle(), s = Le(n);
  if (s === void 0 || t === void 0 || i === void 0)
    return /* @__PURE__ */ u(k, {});
  const o = s.unitSystem;
  for (const d of e)
    d instanceof Zi && (d.getString = () => IS(n, t, o));
  const r = n.icon, a = n.label;
  return /* @__PURE__ */ _(
    xS,
    {
      style: {
        left: i.leftPx,
        right: i.rightPx,
        top: i.topPx,
        bottom: i.bottomPx,
        margin: i.marginPx,
        padding: i.paddingPx
      },
      children: [
        /* @__PURE__ */ _(U, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ _(U, { gap: 8, children: [
            r !== void 0 && /* @__PURE__ */ u(In, { iconName: r, type: "ghost" }),
            a !== void 0 && /* @__PURE__ */ u(tt, { size: vS, children: a })
          ] }),
          /* @__PURE__ */ u(U, { children: /* @__PURE__ */ u(mf, { commands: e, placement: "bottom" }) })
        ] }),
        /* @__PURE__ */ u("table", { children: /* @__PURE__ */ u("tbody", { children: t.items.map((d, l) => c(d, o)) }) })
      ]
    }
  );
  function c(d, l) {
    const h = d.icon, { quantity: p, value: f } = d, g = d == null ? void 0 : d.getText();
    return /* @__PURE__ */ _("tr", { children: [
      /* @__PURE__ */ _(Bc, { children: [
        g !== void 0 && /* @__PURE__ */ u(tt, { size: jo, children: g }),
        h !== void 0 && /* @__PURE__ */ u(In, { type: h, iconName: h })
      ] }),
      /* @__PURE__ */ u(k, {}),
      /* @__PURE__ */ u(wS, { children: /* @__PURE__ */ u(tt, { size: jo, children: l.toString(f, p) }) }),
      /* @__PURE__ */ u(Bc, { children: /* @__PURE__ */ u(tt, { size: jo, children: l.getUnit(p) }) })
    ] }, JSON.stringify(d));
  }
};
function IS(n, e, t) {
  let i = "";
  {
    const s = n == null ? void 0 : n.label;
    s !== void 0 && (i += `${s}
`);
  }
  for (const s of e.items) {
    const o = s == null ? void 0 : s.getText();
    o !== void 0 && (i += `${o}: `), i += `${t.toStringWithUnit(s.value, s.quantity)}
`;
  }
  return i;
}
const wS = b.th`
  text-align: right;
  padding-right: 8px;
  min-width: 60px;
  size: small;
`, Bc = b.th`
  padding-right: 10px;
  size: small;
`, xS = En(b.div`
  z-index: 1000;
  position: absolute;
  display: block;
  border-radius: 6px;
  flex-direction: column;
  overflow: hidden;
  background-color: white;
  box-shadow: 0px 1px 8px #4f52681a;
`), _S = () => {
  const [n, e] = M(0);
  Ls.setCounterDelegate(e);
  const t = me(), i = t.commandsController.activeTool, s = P(() => i == null ? void 0 : i.getAnchoredDialogContent(), [n]), o = s == null ? void 0 : s.contentCommands.some((r) => r.isEnabled);
  if (R(() => {
    var r;
    return (r = s == null ? void 0 : s.customListeners) == null || r.forEach((a) => {
      window.addEventListener(a.eventName, a.callback, !0);
    }), () => {
      var a;
      (a = s == null ? void 0 : s.customListeners) == null || a.forEach((c) => {
        window.removeEventListener(c.eventName, c.callback, !0);
      });
    };
  }, [s]), !(s === void 0 || o !== !0))
    return t === void 0 || i === void 0 ? /* @__PURE__ */ u(k, {}) : /* @__PURE__ */ u(mI, { position: s == null ? void 0 : s.position, children: /* @__PURE__ */ u(TS, { children: s.contentCommands.map((r) => vo(r, "right")) }) });
}, TS = En(b(uy)`
  background-color: white;
`);
class SS extends z {
  constructor() {
    super(...arguments), this._showTree = fn(!1);
  }
  get showTree() {
    return this._showTree;
  }
  // ==================================================
  // OVERRIDES
  // ==================================================
  get tooltip() {
    return { untranslated: "Show tree view" };
  }
  get icon() {
    return "GraphTree";
  }
  get isEnabled() {
    return !0;
  }
  get isToggle() {
    return !0;
  }
  get isChecked() {
    return this._showTree();
  }
  invokeCore() {
    return this._showTree(!this._showTree()), !0;
  }
  getPanelInfoStyle() {
    return new Ve({ top: 5, right: 5 });
  }
}
const bS = () => {
  const n = me();
  return /* @__PURE__ */ u(
    Dv,
    {
      root: n.rootDomainObject,
      onSelectNode: ES,
      onToggleNode: MS,
      getIconFromIconName: AS
    }
  );
};
function AS(n) {
  return Bs.getIcon(n);
}
function ES(n) {
  if (!(n instanceof Yt))
    return;
  const e = n.root;
  for (const t of e.getThisAndDescendants())
    t !== n && t.setSelectedInteractive(!1);
  n.setSelectedInteractive(!n.isSelected);
}
function MS(n) {
  n instanceof Yt && n.toggleVisibleInteractive();
}
const PS = () => {
  const e = me().commandsController.getCommandByTypeRecursive(SS);
  if (e === void 0)
    return /* @__PURE__ */ u(k, {});
  if (!bs(e.showTree))
    return /* @__PURE__ */ u(k, {});
  const i = e.getPanelInfoStyle();
  return /* @__PURE__ */ u(
    OS,
    {
      style: {
        width: 300,
        left: i.leftPx,
        right: i.rightPx,
        top: i.topPx,
        bottom: i.bottomPx,
        margin: i.marginPx,
        padding: i.paddingPx
      },
      children: /* @__PURE__ */ u(bS, {})
    }
  );
}, OS = b.div`
  z-index: 1000;
  position: absolute;
  display: block;
  border-radius: 6px;
  overflow-x: auto;
  overflow-y: auto;
  background-color: white;
  box-shadow: 0px 1px 8px #4f52681a;
`, JO = () => /* @__PURE__ */ _(k, { children: [
  /* @__PURE__ */ u(pS, {}),
  /* @__PURE__ */ u(CS, {}),
  /* @__PURE__ */ u(_S, {}),
  /* @__PURE__ */ u(PS, {})
] });
class RS extends gf {
  constructor(e) {
    super(), this._poi = e;
  }
  get hasData() {
    return !0;
  }
  get onFinish() {
    return this._onFinish;
  }
  set onFinish(e) {
    this._onFinish = e;
  }
  getPostButtonLabel() {
    return { key: "SEND" };
  }
  getCancelButtonLabel() {
    return { key: "CANCEL" };
  }
  getPlaceholder() {
    return { key: "COMMENT_PLACEHOLDER" };
  }
  invokeCore() {
    const e = this.rootDomainObject.getDescendantByType(Ft);
    return e == null || e.postCommentForPoi(this._poi, this.content).then(() => {
      var t;
      (t = this._onFinish) == null || t.call(this), e == null || e.notify(m.addedPart);
    }), !0;
  }
}
function rn() {
  const n = me(), [e, t] = M(void 0);
  return cs(n.rootDomainObject, () => {
    e === void 0 && t(
      n.rootDomainObject.getDescendantByType(Ft)
    );
  }), e;
}
function DS(n) {
  const e = rn();
  return j({
    queryKey: ne.poiCommentsById(n == null ? void 0 : n.id),
    queryFn: async () => {
      if (!(n === void 0 || e === void 0))
        return [...await e.getCommentsForPoi(n)];
    },
    enabled: e !== void 0 && n !== void 0
  });
}
function Co() {
  const n = rn(), [e, t] = M(
    n == null ? void 0 : n.selectedPointsOfInterest
  );
  return cs(n, () => {
    t(n == null ? void 0 : n.selectedPointsOfInterest);
  }), e;
}
const kS = () => {
  var i;
  const { t: n } = W(), e = Co(), t = DS(e);
  return e === void 0 ? null : /* @__PURE__ */ _(U, { direction: "column", justifyContent: "space-between", gap: 8, children: [
    /* @__PURE__ */ u($t, { text: n({ key: "COMMENTS" }) }),
    /* @__PURE__ */ u(U, { direction: "column", gap: 8, children: (i = t.data) == null ? void 0 : i.map((s) => /* @__PURE__ */ u(LS, { comment: s }, `${s.ownerId}/${s.content}`)) }),
    /* @__PURE__ */ u(BS, { poi: e, refetchComments: t.refetch })
  ] });
}, LS = ({ comment: n }) => /* @__PURE__ */ _(U, { direction: "row", gap: 8, alignContent: "center", alignItems: "center", children: [
  /* @__PURE__ */ u(Id, { text: n.ownerId }),
  n.content
] }), NS = ({
  poi: n,
  refetchComments: e
}) => {
  const t = P(() => {
    const i = new RS(n);
    return i.onFinish = () => {
      e();
    }, i;
  }, [n]);
  return vo(t, "right");
}, BS = b(NS)`
  margin-top: 8px;
`, FS = () => {
  const { t: n } = W(), e = rn(), t = e == null ? void 0 : e.selectedPointsOfInterest, [i, s] = M(
    (t == null ? void 0 : t.properties.visibility) ?? "PRIVATE"
  ), o = async () => {
    const r = window.location.href;
    await navigator.clipboard.writeText(r);
  };
  return cs(e, () => {
    const r = (t == null ? void 0 : t.properties.visibility) ?? "PRIVATE";
    s(r);
  }), /* @__PURE__ */ u(jS, { children: /* @__PURE__ */ _(U, { direction: "column", gap: 8, children: [
    /* @__PURE__ */ _(U, { direction: "row", gap: 16, children: [
      /* @__PURE__ */ u(fr, {}),
      /* @__PURE__ */ u($t, { text: n({ key: "SHARE" }) })
    ] }),
    /* @__PURE__ */ u(VS, { poiDomainObject: e, poiVisibility: i }),
    /* @__PURE__ */ u(J, { icon: /* @__PURE__ */ u(hy, {}), disabled: i === "PRIVATE", onClick: o, children: n({ key: "COPY_URL_TO_SHARE" }) })
  ] }) });
}, VS = ({
  poiDomainObject: n,
  poiVisibility: e
}) => {
  const { t } = W(), i = n == null ? void 0 : n.selectedPointsOfInterest, s = e === "PUBLIC", o = t(s ? { key: "POINT_OF_INTEREST_IS_PUBLIC" } : { key: "POINT_OF_INTEREST_IS_PRIVATE" }), r = t(s ? { key: "POINT_OF_INTEREST_PUBLIC_DESCRIPTION" } : { key: "POINT_OF_INTEREST_PRIVATE_DESCRIPTION" });
  return n === void 0 || i === void 0 ? null : /* @__PURE__ */ u(md, { status: "neutral", icon: !1, children: /* @__PURE__ */ _(U, { direction: "row", gap: 16, alignItems: "center", children: [
    /* @__PURE__ */ u(
      yd,
      {
        checked: s,
        onChange: (a, c) => {
          i.properties.visibility = c === !0 ? "PUBLIC" : "PRIVATE", n.updatePointsOfInterest([i]), n.notify(m.geometry);
        }
      }
    ),
    /* @__PURE__ */ _(U, { direction: "column", children: [
      /* @__PURE__ */ u("h3", { children: o }),
      /* @__PURE__ */ u($t, { text: r })
    ] })
  ] }) });
}, jS = b.div`
  background-color: white;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  gap: 24px;
  padding: 16px;
  width: fit-content;
  max-width: fit-content;
  min-width: 400px;
  box-shadow: var(--cogs-elevation--overlay);
`, zS = () => {
  const { t: n } = W(), e = rn(), t = Co();
  if (t !== void 0)
    return /* @__PURE__ */ _(U, { direction: "column", gap: 8, children: [
      /* @__PURE__ */ _(U, { direction: "row", justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ _(U, { direction: "row", alignContent: "start", gap: 8, children: [
          /* @__PURE__ */ u(gd, {}),
          " ",
          /* @__PURE__ */ u(gr, { level: 5, children: n({ key: "POINT_OF_INTEREST_PLURAL" }) })
        ] }),
        /* @__PURE__ */ u(gn, { direction: "vertical", weight: "2px" }),
        /* @__PURE__ */ _(U, { direction: "row", justifyContent: "flex-start", children: [
          /* @__PURE__ */ u(py, { placement: "bottom-end", content: /* @__PURE__ */ u(FS, {}), zIndex: 1e4, children: /* @__PURE__ */ u(ce, { placement: "top-end", content: n({ key: "SHARE" }), children: /* @__PURE__ */ u(J, { icon: /* @__PURE__ */ u(fr, {}), type: "ghost" }) }) }),
          /* @__PURE__ */ u(nr.DeleteSelectedPointOfInterest, { toolbarPlacement: "top" }),
          /* @__PURE__ */ u(
            J,
            {
              icon: /* @__PURE__ */ u(ld, {}),
              type: "ghost",
              onClick: () => e == null ? void 0 : e.setSelectedPointOfInterest(void 0)
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ u(US, { selectedPoi: t }),
      /* @__PURE__ */ u(gn, { direction: "horizontal", weight: "2px" })
    ] });
}, US = ({
  selectedPoi: n
}) => {
  const { createdTime: e, ownerId: t } = n.properties, i = e !== void 0 ? new Date(e).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit"
  }) : "Date not available";
  return /* @__PURE__ */ _(U, { direction: "row", alignItems: "center", gap: 8, children: [
    /* @__PURE__ */ u(Id, { size: "x-small", text: t }),
    /* @__PURE__ */ u(gn, { direction: "vertical", weight: "2px" }),
    /* @__PURE__ */ u(U, { alignItems: "center", children: /* @__PURE__ */ u($t, { text: i }) })
  ] });
}, GS = () => {
  const { t: n } = W(), e = Co();
  if (e === void 0)
    return;
  const { name: t, description: i } = e.properties;
  return /* @__PURE__ */ _(HS, { direction: "column", justifyContent: "space-between", gap: 8, children: [
    /* @__PURE__ */ _(U, { direction: "column", children: [
      /* @__PURE__ */ u($t, { text: n({ key: "NAME" }) }),
      /* @__PURE__ */ u(Ts, { value: t, fullWidth: !0 })
    ] }),
    /* @__PURE__ */ _(U, { direction: "column", children: [
      /* @__PURE__ */ u($t, { text: n({ key: "DESCRIPTION" }) }),
      /* @__PURE__ */ u(Ts, { placeholder: n({ key: "DESCRIPTION_PLACEHOLDER" }), value: i, fullWidth: !0 })
    ] }),
    e.properties.instanceRef !== void 0 && /* @__PURE__ */ _(U, { direction: "column", children: [
      /* @__PURE__ */ u($t, { text: n({ key: "ASSET" }) }),
      /* @__PURE__ */ u(jp, { instance: e.properties.instanceRef })
    ] })
  ] });
}, HS = b(U)`
  margin-top: 16px;
`, eR = () => /* @__PURE__ */ _(k, { children: [
  /* @__PURE__ */ u(zS, {}),
  /* @__PURE__ */ u(qS, {})
] }), qS = () => /* @__PURE__ */ _(U, { direction: "column", gap: 8, children: [
  /* @__PURE__ */ u(GS, {}),
  /* @__PURE__ */ u(kS, {})
] }), $S = (n, e) => P(() => n.filter((t) => WS(t, e)), [n, e]);
function WS(n, e) {
  var o;
  if (e === void 0)
    return !0;
  const t = e.contains.toLowerCase(), i = (o = n.properties.name) == null ? void 0 : o.toLowerCase().includes(t), s = JSON.stringify(n.id).toLowerCase().includes(t);
  return i || s;
}
const KS = () => {
  const n = rn(), [e, t] = M([]);
  return cs(n, () => {
    t([...(n == null ? void 0 : n.pointsOfInterest) ?? H]);
  }), e;
}, tR = (n, e) => {
  const t = me(), i = rn(), s = ve(void 0);
  cs(i, () => {
    const o = i == null ? void 0 : i.selectedPointsOfInterest;
    s.current === o || i === void 0 || (s.current = o, e(i == null ? void 0 : i.selectedPointsOfInterest));
  }), R(() => {
    i == null || i.setSelectedPointOfInterest(n), n !== void 0 && (i == null || i.setVisibleInteractive(!0, t));
  }, [n, i]);
}, nR = ({
  onRowClick: n,
  filter: e,
  pageLimit: t = 1 / 0,
  values: i
}) => {
  const { t: s } = W(), o = KS(), r = Co(), [a, c] = M(t), d = $S(o, e), l = i ?? d, h = l.length > a, p = rn(), f = P(
    () => Qc(l, a).map((v) => ({
      id: JSON.stringify(v.id),
      name: v.properties.name ?? JSON.stringify(v.id),
      poi: v
    })),
    [l, a, e]
  ), g = [
    {
      field: "name",
      headerName: s({ key: "NAME" }),
      flex: 3
    }
  ], C = Z(() => {
    h && c((v) => Math.min(l.length, v + t));
  }, [l, c, h, t]);
  return /* @__PURE__ */ _(U, { direction: "column", alignContent: "center", children: [
    /* @__PURE__ */ u(
      Dy,
      {
        onRowClick: (v) => {
          p == null || p.setSelectedPointOfInterest(v.row.poi), n == null || n(v.row.poi);
        },
        columns: g,
        data: f,
        selectedRows: [JSON.stringify(r == null ? void 0 : r.id)],
        pagination: !1,
        disableColumnResize: !0,
        disableRowStripes: !0
      }
    ),
    /* @__PURE__ */ u(U, { direction: "row", gap: 16, justifyContent: "center", alignContent: "center", children: h && /* @__PURE__ */ u(J, { onClick: C, children: s({ key: "SHOW_MORE" }) }) })
  ] });
};
function en(n, e) {
  return n !== void 0 && e.models.includes(n);
}
function YS(n, e) {
  return n !== void 0 && e.get360ImageCollections().includes(n);
}
function Tn(n) {
  return n.models.length + n.get360ImageCollections().length;
}
function XS(n, e) {
  return n === e ? !0 : n === void 0 || e === void 0 ? !1 : n.boundingBox === e.boundingBox ? !0 : n.boundingBox === void 0 || e.boundingBox === void 0 ? !1 : n.boundingBox.equals(e.boundingBox) && n.isBoundingBoxInModelCoordinates === e.isBoundingBoxInModelCoordinates;
}
function tn(n, e) {
  const t = Zt(n), i = Zt(e), s = Ee(n), o = Ee(e), r = Tt(n), a = Tt(e);
  return t !== i ? !1 : t && i ? ZS(n, e) : s && o ? n.modelId === e.modelId && n.revisionId === e.revisionId && Hs(n.transform, e.transform) : r && a ? n.revisionExternalId === e.revisionExternalId && n.revisionSpace === e.revisionSpace && Hs(n.transform, e.transform) : !1;
}
function ZS(n, e) {
  const t = Kn(n), i = Kn(e);
  return t !== i ? !1 : t && i ? n.siteId === e.siteId && Hs(n.transform, e.transform) : !t && !i ? n.externalId === e.externalId && n.space === e.space && Hs(n.transform, e.transform) : !1;
}
const Fc = new fe();
function Hs(n, e) {
  return (n === void 0 || n.equals(Fc)) && (e === void 0 || e.equals(Fc)) ? !0 : n === void 0 || e === void 0 ? !1 : n.equals(e);
}
function QS(n) {
  return "nodeIds" in n;
}
function JS(n) {
  return "treeIndexSet" in n;
}
const eb = (n, e) => {
  const t = oe(), i = _e(), s = (e == null ? void 0 : e.defaultStyle) ?? Ys.Default, o = e == null ? void 0 : e.groups;
  R(() => {
    !en(n, t) || o === void 0 || tb(i, n, o);
  }, [o, n]), R(() => {
    en(n, t) && n.setDefaultNodeAppearance(s);
  }, [s, n]);
};
async function tb(n, e, t) {
  const i = await s();
  for (let o = e.styledNodeCollections.length - 1; o >= i; o--) {
    const r = e.styledNodeCollections[o];
    e.unassignStyledNodeCollection(r.nodeCollection);
  }
  for (let o = i; o < t.length; o++) {
    const r = t[o];
    if (r.style !== void 0)
      if (JS(r)) {
        const a = new Ri(r.treeIndexSet);
        e.assignStyledNodeCollection(a, r.style);
      } else if (QS(r)) {
        const a = new Yc(n, e);
        await a.executeFilter(r.nodeIds), e.assignStyledNodeCollection(a, r.style);
      } else
        sn(r);
  }
  async function s() {
    for (let o = 0; o < e.styledNodeCollections.length; o++) {
      const r = t[o], a = e.styledNodeCollections[o];
      if (!await nb(r, a))
        return o;
    }
    return e.styledNodeCollections.length;
  }
}
async function nb(n, e) {
  if ((n == null ? void 0 : n.style) === void 0 || !sb(e.appearance, n.style)) return !1;
  return s(), await i(), !0;
  async function i() {
    if (!(e.nodeCollection instanceof Yc) || !("nodeIds" in n))
      return;
    const o = e.nodeCollection.serialize().state.nodeIds;
    Jn(o, n.nodeIds) && await e.nodeCollection.executeFilter(n.nodeIds);
  }
  function s() {
    if (!(e.nodeCollection instanceof Ri) || !("treeIndexSet" in n))
      return;
    const o = new Ri(n.treeIndexSet);
    ib(e.nodeCollection, o) || e.nodeCollection.updateSet(n.treeIndexSet);
  }
}
function ib(n, e) {
  const t = n.getIndexSet(), i = e.getIndexSet();
  return t.clone().differenceWith(i).count === 0 && t.count === i.count;
}
function sb(n, e) {
  const { color: t, ...i } = n, { color: s, ...o } = e;
  return (t === void 0 || s === void 0 ? !!(t ?? s) : t.equals(s)) && Jn(i, o);
}
class Et {
  static getByRevealModel(e, t) {
    if (t instanceof Oi) {
      for (const i of e.getChildrenByType(Jo))
        if (i.model === t)
          return i;
    } else if (t instanceof xs) {
      for (const i of e.getChildrenByType(er))
        if (i.model === t)
          return i;
    } else
      for (const i of e.getChildrenByType(Is))
        if (i.model === t)
          return i;
  }
  static async addModel(e, t) {
    const i = e.rootDomainObject;
    if (i === void 0)
      throw new Error("Root domain object is not set");
    return await e.viewer.addCadModel(t).then((s) => {
      const o = new Jo(s);
      return i.addChildInteractive(o), s.visible && o.setVisibleInteractive(!0), s;
    });
  }
  static async addPointCloud(e, t) {
    const i = e.rootDomainObject;
    if (i === void 0)
      throw new Error("Root domain object is not set");
    return await e.viewer.addPointCloudModel(t).then((s) => {
      const o = new er(s);
      return i.addChildInteractive(o), s.visible && o.setVisibleInteractive(!0), s;
    });
  }
  static async addImage360Collection(e, t) {
    const i = e.rootDomainObject;
    if (i === void 0)
      throw new Error("Root domain object is not set");
    return t.source === "events" ? await e.viewer.add360ImageSet("events", { site_id: t.siteId }, { preMultipliedRotation: !1 }).then((s) => {
      const o = new Is(s);
      return i.addChildInteractive(o), s.getIconsVisibility() && o.setVisibleInteractive(!0), s;
    }) : await e.viewer.add360ImageSet("datamodels", {
      source: t.source,
      image360CollectionExternalId: t.externalId,
      space: t.space
    }).then((s) => {
      const o = new Is(s);
      return i.addChildInteractive(o), s.getIconsVisibility() && o.setVisibleInteractive(!0), s;
    });
  }
  static remove(e, t) {
    const i = e.rootDomainObject;
    if (i === void 0)
      throw new Error("Root domain object is not set");
    const s = Et.getByRevealModel(i, t);
    s !== void 0 && s.removeInteractive();
  }
}
const ob = {
  useRevealKeepAlive: ii,
  useRenderTarget: me,
  useReveal3DResourcesCount: nn,
  useReveal3DResourceLoadFailCount: Yi,
  useApplyCadModelStyling: eb,
  createCadDomainObject: Et.addModel.bind(void 0),
  removeCadDomainObject: Et.remove.bind(void 0)
}, rb = Ye(
  ob
);
function ab({
  addModelOptions: n,
  transform: e,
  styling: t,
  onLoad: i,
  onLoadError: s
}) {
  const {
    useRenderTarget: o,
    useReveal3DResourceLoadFailCount: r,
    useReveal3DResourcesCount: a,
    useRevealKeepAlive: c,
    useApplyCadModelStyling: d,
    createCadDomainObject: l,
    removeCadDomainObject: h
  } = Xe(rb), p = c(), f = o(), g = f.viewer, { setRevealResourcesCount: C } = a(), { setReveal3DResourceLoadFailCount: v } = r(), w = ve(void 0), x = ve(void 0), [T, O] = M(void 0), { modelId: S, revisionId: E, geometryFilter: B } = n;
  return R(() => {
    if (Jn(w.current, n) || n === void 0)
      return;
    w.current = n;
    const N = L(n, e).then((ee) => (i == null || i(ee), C(Tn(g)), () => {
      le(ee);
    })).catch((ee) => ((s ?? cb)(n, ee), v((ue) => ue + 1), () => {
      v((ue) => ue - 1);
    }));
    return () => {
      N.then((ee) => {
        ee();
      });
    };
  }, [S, E, B]), R(() => {
    !en(T, g) || e === void 0 || T.setModelTransformation(e);
  }, [e, T]), d(T, t), /* @__PURE__ */ u(k, {});
  async function L(N, ee) {
    const ie = await ue();
    return ee !== void 0 && ie.setModelTransformation(ee), O(ie), ie;
    async function ue() {
      const Ze = g.models.find((pi) => {
        const yg = { ...pi, transform: pi.getModelTransformation() };
        return tn(yg, N) && XS(B, x.current);
      });
      return Ze !== void 0 ? await Promise.resolve(Ze) : (x.current = B, await l(f, N));
    }
  }
  function le(N) {
    en(N, g) && (p !== void 0 && !p.isRevealContainerMountedRef.current || (h(f, N), C(Tn(g))));
  }
}
function cb(n, e) {
  console.warn(
    `Failed to load (${n.modelId}, ${n.revisionId}): ${JSON.stringify(e)}`
  );
}
const db = {
  color: new D("rgb(150, 150, 242)"),
  visible: !0
}, lb = (n, e) => {
  const t = oe(), [i, s] = M([]), o = ve(new AbortController()), r = (e == null ? void 0 : e.defaultStyle) ?? db, a = e == null ? void 0 : e.groups, c = Z(() => {
    n !== void 0 && (i.forEach((d) => {
      d.setColor(void 0);
    }), s([]), n.setDefaultAnnotationStyle(r), t.requestRedraw());
  }, [t, r, a]);
  R(() => {
    if (n !== void 0)
      return n.on("image360Entered", c), () => {
        n.off("image360Entered", c);
      };
  }, [t, n]), R(() => {
    !YS(n, t) || a === void 0 || (a.length === 0 ? (c(), o.current.abort(), o.current = new AbortController()) : ub(
      n,
      a,
      t,
      c,
      s,
      o.current.signal
    ));
  }, [a, n]);
};
async function ub(n, e, t, i, s, o) {
  if (!(e === void 0 || e.length === 0)) {
    for (const r of e)
      if (r.assetRefs !== void 0) {
        const a = r.assetRefs.map(async () => await n.findImageAnnotations({
          assetRef: typeof r.assetRefs[0] == "number" ? { id: r.assetRefs[0] } : r.assetRefs[0]
        })), c = (await Promise.all(a)).flat();
        if (c.length === 0 || o.aborted)
          return;
        i(), c.forEach((d) => {
          d.annotation.setColor(r.style.color);
        }), s(c.map((d) => d.annotation)), t.requestRedraw();
      }
  }
}
const hb = 1 / 0, pb = 50;
function fb({
  addImage360CollectionOptions: n,
  styling: e,
  onLoad: t,
  onLoadError: i
}) {
  const s = ii(), o = ve(), r = me(), a = r.viewer, { setRevealResourcesCount: c } = nn(), { setReveal3DResourceLoadFailCount: d } = Yi(), l = ve(
    void 0
  );
  return R(() => {
    if (n.source === "events" && l.current === n)
      return;
    l.current = n;
    const f = h(n.transform);
    return () => {
      f.then((g) => {
        g();
      });
    };
  }, [n]), lb(o.current, e), gb(o.current, n.iconCullingOptions), R(() => {
    o.current === void 0 || n.transform === void 0 || !a.get360ImageCollections().includes(o.current) || o.current.setModelTransformation(n.transform);
  }, [o, n.transform, a]), /* @__PURE__ */ u(k, {});
  async function h(f) {
    return await g().then((C) => (f !== void 0 && C.setModelTransformation(f), yf(
      C,
      n.iconCullingOptions
    ), o.current = C, t == null || t(C), c(Tn(a)), p)).catch((C) => ((i ?? mb)(n, C), d((w) => w + 1), () => {
      d((w) => w - 1);
    }));
    async function g() {
      const C = a.get360ImageCollections(), v = n.source === "events" ? n.siteId : n.externalId, w = C.find((x) => x.id === v);
      return w !== void 0 ? w : await Et.addImage360Collection(
        r,
        n
      );
    }
  }
  function p() {
    o.current !== void 0 && (s !== void 0 && !s.isRevealContainerMountedRef.current || (Et.remove(r, o.current), c(Tn(a)), o.current = void 0));
  }
}
const gb = (n, e) => {
  const t = e == null ? void 0 : e.radius, i = e == null ? void 0 : e.iconCountLimit;
  R(() => {
    yf(n, e);
  }, [n, t, i]);
};
function yf(n, e) {
  n == null || n.set360IconCullingRestrictions(
    (e == null ? void 0 : e.radius) ?? hb,
    (e == null ? void 0 : e.iconCountLimit) ?? pb
  );
}
function mb(n, e) {
  console.warn(
    `Failed to load image collection ${"siteId" in n ? n.siteId : n.externalId}: ${JSON.stringify(e)}`
  );
}
function yb(n) {
  return n.every((e) => typeof e == "number");
}
function vb(n) {
  return n.every(
    (e) => typeof e == "object" && e !== null && "externalId" in e && "space" in e
  );
}
const Cb = (n, e) => {
  const t = oe(), i = (e == null ? void 0 : e.defaultStyle) ?? Ys.Default, s = e == null ? void 0 : e.groups;
  R(() => {
    !en(n, t) || s === void 0 || Ib(n, s);
  }, [s, n]), R(() => {
    en(n, t) && n.setDefaultPointCloudAppearance(i);
  }, [i, n]);
};
function Ib(n, e) {
  if (e !== void 0) {
    n.styledCollections.length > 0 && n.removeAllStyledObjectCollections();
    for (const t of e)
      if (t.pointCloudVolumes.length !== 0) {
        if (yb(t.pointCloudVolumes)) {
          const i = new _g(t.pointCloudVolumes);
          n.assignStyledObjectCollection(i, t.style);
        } else if (vb(t.pointCloudVolumes)) {
          const i = new Tg(t.pointCloudVolumes);
          n.assignStyledObjectCollection(i, t.style);
        }
      }
  }
}
const Kr = (n) => n.map((e) => Ee(e) ? `${e.modelId}/${e.revisionId}` : Tt(e) ? `${e.revisionExternalId}/${e.revisionSpace}` : "");
function wb(n) {
  return n.includes("gltf-directory:9") || n.includes("reveal-directory:8") ? "CAD" : n.includes("ept-pointcloud:1") ? "PointCloud" : "unknown";
}
function xb(n) {
  return {
    equals: {
      property: ["node", "externalId"],
      value: n
    }
  };
}
function _b(n) {
  return {
    equals: {
      property: ["node", "space"],
      value: n
    }
  };
}
function Tb(n) {
  return n.map((e) => {
    const t = e.lastRevisionInfo;
    if (t === void 0)
      return {
        id: e.id,
        sourceType: "classic",
        resourceType: "unknown",
        displayName: e.name,
        createdTime: new Date(e.createdTime),
        lastUpdatedTime: new Date(e.createdTime),
        revisionCount: 0
      };
    const i = wb(t.types ?? []);
    return {
      id: e.id,
      sourceType: "classic",
      resourceType: i,
      displayName: e.name,
      createdTime: new Date(e.createdTime),
      lastUpdatedTime: new Date(t.createdTime),
      revisionCount: t.revisionCount,
      latestRevisionInfo: {
        sourceType: "classic",
        id: t.revisionId,
        createdTime: new Date(t.createdTime)
      }
    };
  });
}
async function Yr(n, e, t) {
  const i = Sb(n, e), s = await t.queryNodesAndEdges(i);
  if (s.items.revision.length === 0)
    throw new Error(`No revision view found for external ID ${n}`);
  const r = s.items.revision[0].properties.cdf_cdm["Cognite3DRevision/v1"].model3D.externalId, a = Vc(r), c = Vc(n);
  if (a === void 0 || c === void 0)
    throw new Error(
      `No numeric ID found in external ID ${r} or ${n}`
    );
  return { modelId: a, revisionId: c };
}
function Vc(n) {
  const e = n.lastIndexOf("_");
  if (e === -1)
    return;
  const t = n.slice(e + 1);
  return t.length > 0 && !isNaN(Number(t)) ? parseInt(t, 10) : void 0;
}
function Sb(n, e) {
  return {
    with: {
      revision: {
        nodes: {
          filter: {
            and: [
              xb(n),
              _b(e)
            ]
          }
        },
        limit: 1
      }
    },
    select: {
      revision: {
        sources: [
          {
            source: br,
            properties: ["model3D"]
          }
        ]
      }
    }
  };
}
function bb(n, e) {
  return jg({
    queries: (n == null ? void 0 : n.map((t) => Ab(t, e))) ?? []
  });
}
const Ab = (n, e) => {
  const t = Kr([n]);
  return Ee(n) ? {
    queryKey: [ne.modelRevisionId(t)],
    queryFn: async () => await Promise.resolve(n),
    staleTime: 1 / 0
  } : Tt(n) ? {
    queryKey: [ne.modelRevisionId(t)],
    queryFn: async () => {
      const { modelId: i, revisionId: s } = await Yr(
        n.revisionExternalId,
        n.revisionSpace,
        e
      );
      return {
        ...n,
        modelId: i,
        revisionId: s
      };
    },
    staleTime: 1 / 0
  } : {
    queryKey: [ne.modelRevisionId(t)],
    queryFn: async () => await Promise.reject(new Error("Unknown identifier type")),
    staleTime: 1 / 0
  };
}, Eb = {
  useQueriedAddModelOptions: bb,
  useFdmSdk: Te
}, Mb = Ye(
  Eb
), di = (n) => {
  const { useQueriedAddModelOptions: e, useFdmSdk: t } = Xe(
    Mb
  ), i = t(), s = ve([]), o = e(n, i) ?? [];
  return o.some(
    (a) => a.isFetching || a.isLoading || a.isRefetching || a.isError
  ) ? [] : (s.current.length === o.length && s.current.every((a, c) => a.data === o[c].data) || (s.current = o), s.current);
};
function Pb({
  addModelOptions: n,
  styling: e,
  transform: t,
  onLoad: i,
  onLoadError: s
}) {
  var T;
  const o = ii(), [r, a] = M(void 0), c = me(), d = c.viewer, { setRevealResourcesCount: l } = nn(), { setReveal3DResourceLoadFailCount: h } = Yi(), p = ve(void 0), g = (T = di([n])[0]) == null ? void 0 : T.data, C = g == null ? void 0 : g.modelId, v = g == null ? void 0 : g.revisionId;
  return R(() => {
    if (Jn(p.current, n) || C === void 0 || v === void 0)
      return;
    p.current = Mt(n);
    const O = w(n, t).then((S) => (i == null || i(S), l(Tn(d)), x)).catch((S) => ((s ?? Ob)(n, S), h((B) => B + 1), () => {
      h((B) => B - 1);
    }));
    return () => {
      O.then((S) => {
        S();
      });
    };
  }, [C, v]), R(() => {
    !en(r, d) || t === void 0 || r.setModelTransformation(t);
  }, [t, r]), Cb(r, e), /* @__PURE__ */ u(k, {});
  async function w(O, S) {
    const E = await B();
    return S !== void 0 && E.setModelTransformation(S), a(E), E;
    async function B() {
      const L = d.models.find((le) => {
        const N = {
          ...le,
          transform: le.getModelTransformation()
        };
        return tn(N, O);
      });
      return L !== void 0 ? await Promise.resolve(L) : await Et.addPointCloud(c, O);
    }
  }
  function x() {
    en(r, d) && (o !== void 0 && !o.isRevealContainerMountedRef.current || (Et.remove(c, r), l(Tn(d)), a(void 0)));
  }
}
function Ob(n, e) {
  Ee(n) ? console.warn(
    `Failed to load (${n.modelId}, ${n.revisionId}): ${JSON.stringify(e)}`
  ) : Tt(n) && console.warn(
    `Failed to load (${n.revisionExternalId}, ${n.revisionSpace}): ${JSON.stringify(e)}`
  );
}
function Io(n) {
  return n.fdmAssetExternalIds !== void 0;
}
function wo(n) {
  return n.assetIds !== void 0;
}
function vf(n) {
  return n.assetIds !== void 0;
}
function Cf(n) {
  return n.assetRefs !== void 0;
}
function Rb(n) {
  return vf(n) || Cf(n);
}
function Db(n) {
  return wo(n) || Io(n);
}
function kb(n, e) {
  const { setRevealResourcesCount: t } = nn();
  R(() => {
    const i = e.viewer;
    Lb(n, i).forEach((r) => {
      Et.remove(e, r);
    }), Nb(n, i).forEach((r) => {
      Et.remove(e, r);
    }), t(Tn(i));
  }, [n]);
}
function Lb(n, e) {
  const t = e.models, i = new Set(n.filter((s) => !Zt(s)));
  return t.filter((s) => {
    const o = (() => {
      for (const r of i) {
        if (Zt(r))
          continue;
        if (tn(r, {
          modelId: s.modelId,
          revisionId: s.revisionId,
          transform: s.getModelTransformation()
        }))
          return r;
      }
    })();
    return o !== void 0 ? (i.delete(o), !1) : !0;
  });
}
function Nb(n, e) {
  const t = n.filter(Zt), i = e.get360ImageCollections(), s = new Set(t);
  return i.filter((o) => {
    const r = (() => {
      for (const a of s) {
        const c = Ar(a) && o.id === a.externalId, d = Kn(a) && o.id === a.siteId;
        if (c || d)
          return a;
      }
    })();
    return r !== void 0 ? (s.delete(r), !1) : !0;
  });
}
const zt = () => {
  const n = oe(), { reveal3DResourcesCount: e } = nn();
  return P(() => n.models, [n, e]);
};
function Bb(n, e) {
  return P(() => n.flatMap((t) => {
    if (t.type !== "pointcloud")
      return H;
    const i = t, s = e.find((o) => dr(i) && Tt(o) ? i.modelIdentifier.revisionExternalId === o.revisionExternalId && i.modelIdentifier.revisionSpace === o.revisionSpace : Sg(i) ? i.modelIdentifier.modelId === o.modelId && i.modelIdentifier.revisionId === o.revisionId : !1);
    return s !== void 0 ? [{ viewerModel: t, model: s }] : H;
  }), [n, e]);
}
const ds = () => me().cdfCaches, ls = () => ds().fdmNodeCache, us = () => ds().assetMappingAndNode3dCache, Xr = () => ds().pointCloudAnnotationCache, Fb = () => ds().image360Cache, li = () => ds().fdm3dDataProvider, Vb = (n) => {
  var r, a;
  const e = Xr(), t = (n == null ? void 0 : n.type) === "pointcloud", [i, s, o] = t ? [
    n.model.modelId,
    n.model.revisionId,
    ((r = n.assetRef) == null ? void 0 : r.externalId) ?? ((a = n.assetRef) == null ? void 0 : a.id)
  ] : [void 0, void 0, void 0];
  return j({
    queryKey: [
      ne.pointCloudAnnotationForAssetId(
        `${i}/${s}`,
        (o == null ? void 0 : o.toString()) ?? ""
      )
    ],
    queryFn: async () => i === void 0 || s === void 0 || o === void 0 ? H : await Lr(
      i,
      s,
      [o],
      e
    ) ?? H,
    staleTime: 1 / 0,
    enabled: t && o !== void 0
  });
}, iR = (n, e) => {
  const t = Xr(), i = di(n), s = P(
    () => i.map((o) => o.data).filter(F),
    [i]
  );
  return j({
    queryKey: [
      ne.pointCloudAnnotationForAssetIds(
        s.map((o) => `${o.modelId}/${o.revisionId}`).sort(),
        (e == null ? void 0 : e.map((o) => o.toString()).sort()) ?? []
      )
    ],
    queryFn: async () => (await Promise.all(
      s.map(async (r) => await Lr(
        r.modelId,
        r.revisionId,
        e,
        t
      ) ?? H)
    )).flat(),
    staleTime: 1 / 0,
    enabled: e !== void 0 && e.length > 0
  });
}, jb = (n) => {
  const e = Xr(), t = di(n), i = P(
    () => t.map((s) => s.data).filter(F),
    [t]
  );
  return j({
    queryKey: [
      ne.pointCloudAnnotationMappings(
        i.map((s) => `${s.modelId}/${s.revisionId}`).sort()
      )
    ],
    queryFn: async () => await Promise.all(
      i.map(async (s) => {
        const o = await e.getPointCloudAnnotationsForModel(
          s.modelId,
          s.revisionId
        );
        return {
          model: s,
          annotationModel: o
        };
      })
    ),
    staleTime: 1 / 0,
    enabled: n.length > 0
  });
}, zb = (n, e, t) => {
  var a;
  const i = P(
    () => n.filter((c) => c.type === "pointcloud"),
    [n]
  ), s = Yb(
    i,
    (a = t == null ? void 0 : t.pointcloud) == null ? void 0 : a.mapped
  ), o = Ub(
    i,
    e
  );
  return P(() => wf(i, [
    ...s,
    ...o
  ]), [s, o, i]);
};
function Ub(n, e) {
  const { data: t } = jb(n), i = Gb(
    t,
    n,
    e
  ), s = If(n), o = qb(
    s,
    n,
    e
  );
  return P(
    () => wf(n, [
      ...i,
      ...o
    ]),
    [i, o]
  );
}
function Gb(n, e, t) {
  return P(() => n === void 0 || n.length === 0 ? H : n.map((i) => Hb(
    t.filter(wo),
    i
  )), [n, e, t]);
}
function Hb(n, e) {
  const t = n.map((i) => Wb(e, i)).filter((i) => i !== void 0);
  return { model: e.model, styleGroups: t };
}
function qb(n, e, t) {
  return P(() => n.length === 0 ? H : n.map((i) => $b(
    t.filter(Io),
    i
  )), [n, e, t]);
}
function $b(n, e) {
  const t = n.map((i) => Kb(e, i)).filter((i) => i !== void 0);
  return { model: e.model, styleGroups: t };
}
function Wb(n, e) {
  const t = /* @__PURE__ */ new Set(), i = new Set(e.assetIds.map((o) => o)), s = n.annotationModel.filter((o) => {
    const r = o.data.assetRef;
    return i.has((r == null ? void 0 : r.id) ?? Number(r == null ? void 0 : r.externalId)) && !t.has(o.id) ? (t.add(o.id), !0) : !1;
  });
  if (s.length !== 0)
    return {
      pointCloudVolumes: s.map((o) => o.id),
      style: e.style.pointcloud ?? {}
    };
}
function Kb(n, e) {
  const t = /* @__PURE__ */ new Set(), i = new Set(e.fdmAssetExternalIds.map(X)), s = n.pointCloudVolumes.reduce(
    (o, r, a) => {
      var c;
      if (typeof r != "number") {
        const d = (c = n.asset) == null ? void 0 : c[a], l = X(r);
        i.has(X(d)) && !t.has(l) && (t.add(l), o.push(r));
      }
      return o;
    },
    []
  );
  if (s.length !== 0)
    return {
      pointCloudVolumes: s,
      style: e.style.pointcloud ?? {}
    };
}
function Yb(n, e) {
  const t = If(n);
  return Xb(
    n,
    t,
    e
  );
}
function If(n) {
  const e = zt(), t = di(n), i = P(
    () => t.map((r) => r.data).filter(F),
    [t]
  ), s = e.filter(
    (r) => r.type === "pointcloud"
  ), o = Bb(
    s,
    i
  );
  return P(() => o.length === 0 || s.length === 0 ? n.map((r) => ({
    model: r,
    pointCloudVolumes: H
  })) : o.map(({ viewerModel: r, model: a }) => {
    const c = r.stylableObjects.reduce((h, p) => {
      var f, g;
      return bg(p) ? h.push({
        pointCloudVolume: p.annotationId,
        asset: ((f = p.assetRef) == null ? void 0 : f.id) ?? ((g = p.assetRef) == null ? void 0 : g.externalId)
      }) : Ag(p) && h.push({
        pointCloudVolume: p.volumeInstanceRef,
        asset: p.assetRef
      }), h;
    }, []), d = c.map((h) => h.pointCloudVolume), l = c.map((h) => h.asset);
    return { model: a, pointCloudVolumes: d, asset: l };
  }), [o, s, n]);
}
function Xb(n, e, t) {
  return P(() => n.length === 0 || e.length === 0 ? H : e.map((i) => {
    var r;
    const s = ((r = i.model.styling) == null ? void 0 : r.mapped) ?? t, o = s !== void 0 ? [Zb([i], s)] : H;
    return { model: i.model, styleGroups: o };
  }), [n, e, t]);
}
function Zb(n, e) {
  return { pointCloudVolumes: n.flatMap((i) => i.pointCloudVolumes), style: e };
}
function wf(n, e) {
  const t = n.map((i) => ({ model: i, styleGroups: [] }));
  return e.reduce((i, s) => {
    const o = i.find(
      (r) => tn(r.model, s.model)
    );
    return o == null || o.styleGroups.push(...s.styleGroups), i;
  }, t);
}
const Qb = (n, e) => {
  const t = ls();
  return j({
    queryKey: [
      "reveal",
      "react-components",
      "fdm-asset-mappings",
      n,
      e.map((i) => [i.modelId, i.revisionId])
    ],
    queryFn: async () => await t.getMappingsForFdmInstances(n, e),
    enabled: n.length > 0 && e.length > 0,
    staleTime: dC
  });
};
function xf() {
  return me().cdfCaches.coreDmOnly ?? !1;
}
const ui = (n) => {
  const e = us(), t = xf();
  return j({
    queryKey: [
      "reveal",
      "react-components",
      "models-asset-mappings",
      ...n.map((i) => `${i.modelId}/${i.revisionId}`).sort()
    ],
    queryFn: async () => {
      const i = n.map(
        async (s) => await e.getAssetMappingsForModel(s.modelId, s.revisionId).then((o) => ({ model: s, assetMappings: o }))
      );
      return await Promise.all(i);
    },
    staleTime: 1 / 0,
    enabled: n.length > 0 && !t
  });
}, Jb = (n) => {
  const e = us(), t = _e(), i = (n == null ? void 0 : n.type) === "cad", [s, o, r] = i ? [n.model.modelId, n.model.revisionId, n.treeIndex] : [void 0, void 0, void 0];
  return j({
    queryKey: [
      "reveal",
      "react-components",
      "tree-index-asset-mapping",
      `${s}/${o}`,
      r
    ],
    queryFn: async () => {
      if (!(s !== void 0 && o !== void 0 && r !== void 0))
        return { mappings: [] };
      const c = await Sr(
        s,
        o,
        r,
        t
      );
      return await e.getAssetMappingsForLowestAncestor(
        s,
        o,
        c
      );
    },
    staleTime: 1 / 0
  });
}, eA = (n) => {
  const e = ls(), t = (n == null ? void 0 : n.type) === "cad", [i, s, o] = t ? [n.model.modelId, n.model.revisionId, n.treeIndex] : [void 0, void 0, void 0], r = e !== void 0 && t && o !== void 0;
  return j({
    queryKey: [
      "reveal",
      "react-components",
      "tree-index-to-external-id",
      i,
      s,
      o
    ],
    queryFn: async () => (We(r), e.getClosestParentDataPromises(i, s, o)),
    enabled: r
  });
}, tA = (n, e) => {
  const t = us();
  P(() => {
    n.forEach(async ({ modelId: i, revisionId: s }) => {
      const o = e == null ? void 0 : e.filter(
        (r) => r.model.modelId === i && r.model.revisionId === s
      );
      o !== void 0 && o.length > 0 && await t.generateAssetMappingsCachePerItemFromModelCache(
        i,
        s,
        o
      );
    });
  }, [n, e]);
}, nA = (n, e) => {
  const t = us();
  P(() => {
    n.forEach(async ({ modelId: i, revisionId: s }) => {
      const o = e == null ? void 0 : e.filter(
        (a) => a.model.modelId === i && a.model.revisionId === s
      ), r = o == null ? void 0 : o.flatMap(
        (a) => a.assetMappings.map((c) => c.nodeId)
      );
      r === void 0 || r.length === 0 || await t.generateNode3DCachePerItem(
        i,
        s,
        r
      );
    });
  }, [n, e]);
}, _f = (n, e = !1, t = !0) => {
  const i = ls();
  return j({
    queryKey: [
      "reveal",
      "react-components",
      ...n.map((s) => s.revisionId.toString()).sort(),
      e
    ],
    queryFn: async () => await i.getAllMappingExternalIds(n, e),
    staleTime: 1 / 0,
    enabled: t && n.length > 0
  });
}, iA = (n, e) => {
  const t = us();
  return j({
    queryKey: [
      "reveal",
      "react-components",
      "asset-mapping-nodes",
      ...n.map((i) => `${i.modelId}/${i.revisionId}`),
      ...e.map((i) => `${i}`)
    ],
    queryFn: async () => {
      const i = n.map(async (s) => {
        const o = await t.getNodesForAssetIds(
          s.modelId,
          s.revisionId,
          e
        );
        return { modelId: s.modelId, revisionId: s.revisionId, assetToNodeMap: o };
      });
      return await Promise.all(i);
    },
    staleTime: 1 / 0,
    enabled: e.length > 0
  });
}, sA = (n, e, t) => {
  var r;
  const i = oA(
    n,
    (r = t == null ? void 0 : t.cad) == null ? void 0 : r.mapped
  ), s = rA(
    n,
    e
  );
  return {
    styledModels: dA(
      n,
      i.combinedMappedStyleGroups,
      s.combinedMappedStyleGroups
    ),
    isModelMappingsLoading: s.isModelMappingsLoading || i.isModelMappingsLoading
  };
};
function oA(n, e) {
  const t = P(
    () => g(),
    [n, e]
  ), {
    data: i,
    isLoading: s,
    isFetched: o,
    isError: r
  } = _f(t), {
    data: a,
    isLoading: c,
    isFetched: d,
    isError: l
  } = ui(t), h = P(() => n.length === 0 || i === void 0 || i.size === 0 || s ? [] : t.map((v) => {
    var O;
    const w = (i == null ? void 0 : i.get(`${v.modelId}/${v.revisionId}`)) ?? [], x = ((O = v.styling) == null ? void 0 : O.mapped) ?? e, T = x !== void 0 ? [uA(w, x)] : [];
    return { model: v, styleGroup: T };
  }), [
    t,
    i,
    e,
    s
  ]), p = P(() => n.length === 0 || a === void 0 || a.length === 0 || c ? [] : a.map((v) => {
    var T;
    const w = ((T = v.model.styling) == null ? void 0 : T.mapped) ?? e, x = w !== void 0 ? [hA(v.assetMappings, w)] : [];
    return { model: v.model, styleGroup: x };
  }), [
    t,
    a,
    e,
    c
  ]);
  return {
    combinedMappedStyleGroups: P(
      () => Tf(n, [
        ...p,
        ...h
      ]),
      [p, h]
    ),
    isModelMappingsLoading: !r && s && !o || !l && c && !d
  };
  function g() {
    return e !== void 0 ? n : n.filter((C) => {
      var v;
      return ((v = C.styling) == null ? void 0 : v.mapped) !== void 0;
    });
  }
}
function rA(n, e) {
  const { data: t } = Qb(
    e.filter(Io).flatMap((h) => h.fdmAssetExternalIds),
    n
  ), i = e.filter(wo).flatMap((h) => h.assetIds), {
    data: s,
    isLoading: o,
    isFetched: r,
    isError: a
  } = iA(n, i), c = cA(
    n,
    e,
    t
  ), d = aA(
    n,
    e,
    s
  );
  return {
    combinedMappedStyleGroups: P(
      () => Tf(n, [
        ...c,
        ...d
      ]),
      [c, d]
    ),
    isModelMappingsLoading: !a && o && !r
  };
}
function aA(n, e, t) {
  return P(() => t === void 0 || t.length === 0 ? [] : n.map((i, s) => fA(
    e.filter(wo),
    t[s].assetToNodeMap,
    i
  )), [n, e, t]);
}
function cA(n, e, t) {
  return P(() => n.length === 0 || t === void 0 ? [] : n.map((i) => {
    const s = t !== void 0 ? pA(
      e.filter(Io),
      t,
      i
    ) : [];
    return { model: i, styleGroup: s };
  }), [n, e, t]);
}
function dA(n, e, t) {
  return P(() => t.length === 0 && e.length === 0 ? lA(n) : n.map((s) => {
    var a, c;
    const o = ((a = e.find((d) => tn(d.model, s))) == null ? void 0 : a.styleGroup) ?? [], r = t.filter((d) => tn(d.model, s)).flatMap((d) => d.styleGroup);
    return ((c = s.styling) == null ? void 0 : c.nodeGroups) !== void 0 && r.push(...s.styling.nodeGroups), {
      model: s,
      styleGroups: [...o, ...r]
    };
  }), [n, t, e]);
}
function Tf(n, e) {
  const t = n.map((i) => ({ model: i, styleGroup: [] }));
  return e.reduce((i, s) => {
    const o = i.find(
      (r) => tn(r.model, s.model)
    );
    return o == null || o.styleGroup.push(...s.styleGroup), i;
  }, t);
}
function lA(n) {
  return n.map((e) => ({
    model: e,
    styleGroups: []
  }));
}
function uA(n, e) {
  const t = new Xs();
  return n.forEach((i) => {
    const s = Sf(i.cadNode);
    t.addRange(s);
  }), { treeIndexSet: t, style: e };
}
function hA(n, e) {
  const t = new Xs();
  return n.forEach((i) => {
    const s = new Hi(i.treeIndex, i.subtreeSize);
    t.addRange(s);
  }), { treeIndexSet: t, style: e };
}
function pA(n, e, t) {
  const i = gA(e, t);
  return n.map((s) => {
    const o = s.fdmAssetExternalIds.map((a) => i.get(a.externalId)).filter((a) => a !== void 0).map((a) => [...a.values()]), r = new Xs();
    return o.forEach((a) => {
      a.forEach((c) => {
        r.addRange(Sf(c));
      });
    }), {
      style: s.style.cad,
      treeIndexSet: r
    };
  }).filter((s) => s.treeIndexSet.count > 0);
}
function fA(n, e, t) {
  const i = n.map((s) => {
    const o = new Xs();
    return s.assetIds.map((r) => e.get(r)).forEach(
      (r) => r == null ? void 0 : r.filter((a) => a !== void 0).forEach((a) => {
        o.addRange(new Hi(a.treeIndex, a.subtreeSize));
      })
    ), {
      treeIndexSet: o,
      style: s.style.cad
    };
  }).filter((s) => s.treeIndexSet.count > 0);
  return {
    model: t,
    styleGroup: i
  };
}
function Sf(n) {
  return new Hi(n.treeIndex, n.subtreeSize);
}
function gA(n, e) {
  return n.filter(
    (t) => t.modelId === e.modelId && t.revisionId === e.revisionId
  ).reduce(
    // reduce is added to avoid duplication of a models that span several pages.
    (t, i) => (mA(t.mappings, i.mappings), t),
    {
      modelId: e.modelId,
      revisionId: e.revisionId,
      mappings: /* @__PURE__ */ new Map()
    }
  ).mappings;
}
function mA(n, e) {
  return [...e.entries()].reduce((t, [i, s]) => {
    const o = t.get(i);
    return o !== void 0 ? s.forEach((r) => o.set(r.id, r)) : t.set(i, new Map(s.map((r) => [r.id, r]))), t;
  }, n);
}
const yA = (n) => P(
  () => n.filter(
    (e) => !Zt(e)
  ),
  [n]
), vA = (n) => {
  const e = di(n);
  return P(
    () => e.map(({ data: t }) => t).filter(F),
    [e]
  );
}, CA = (n, e, t) => {
  const i = yA(e), s = vA(i), o = j({
    queryKey: ["typedModels", s, i],
    queryFn: async () => await IA(s, n, i, t),
    staleTime: 1 / 0,
    enabled: s.length > 0 && i.length > 0
  });
  return wA(o, i), o;
}, IA = async (n, e, t, i) => {
  const s = i ?? xA, o = n.map(async (c, d) => {
    const { modelId: l, revisionId: h } = c, p = await e.determineModelType(l, h).catch((g) => (s(c, g), ""));
    return {
      ...t[d],
      type: p,
      ...p === "cad" && { modelId: l, revisionId: h }
    };
  });
  return (await Promise.all(o)).filter(
    (c) => c.type === "cad" || c.type === "pointcloud"
  );
};
function wA(n, e) {
  const { setReveal3DResourceLoadFailCount: t } = Yi();
  R(() => {
    if (n.data === void 0 || n.isLoading)
      return;
    const i = e.length - n.data.length;
    return t((s) => s + i), () => {
      t((s) => s - i);
    };
  }, [n.data, n.isLoading, e]);
}
const xA = (n, e) => {
  console.warn(`Could not load resource ${JSON.stringify(n)}: ${JSON.stringify(e)}`);
};
function _A(n, e) {
  const t = nn().reveal3DResourcesCount, i = Uy(), { reveal3DResourceLoadFailCount: s } = Yi();
  R(() => {
    t === n.length - s && (e == null || e());
  }, [t, i]);
}
function TA(n) {
  const e = Gy(), { setRevealResourcesCount: t } = nn();
  R(() => {
    e(n.length);
  }, [n, t]);
}
const SA = (n) => n === void 0 || n.length === 0 ? H : n.filter(Rb).map((e) => {
  if (vf(e))
    return { assetRefs: e.assetIds, style: e.style.image360 };
  if (Cf(e))
    return { assetRefs: e.assetRefs, style: e.style.image360 };
}).filter(F).filter((e) => e.style !== void 0), bA = {
  // Hooks
  useReveal: oe,
  useRenderTarget: me,
  useRemoveNonReferencedModels: kb,
  useTypedModels: CA,
  useSetExpectedLoadCount: TA,
  useCallCallbackOnFinishedLoading: _A,
  useAssetMappedNodesForRevisions: ui,
  useGenerateAssetMappingCachePerItemFromModelCache: tA,
  useGenerateNode3DCache: nA,
  useCalculateCadStyling: sA,
  useReveal3DResourcesStylingLoadingSetter: qy,
  useCalculatePointCloudStyling: zb,
  useCalculateImage360Styling: SA,
  // SubComponents
  CadModelContainer: ab,
  PointCloudContainer: Pb,
  Image360CollectionContainer: fb
}, AA = Ye(
  bA
);
function EA() {
  return Xe(AA);
}
const MA = ({
  resources: n,
  defaultResourceStyling: e,
  instanceStyling: t,
  onResourcesAdded: i,
  onResourceLoadError: s,
  onResourceIsLoaded: o,
  image360Settings: r
}) => {
  const { CadModelContainer: a, Image360CollectionContainer: c, PointCloudContainer: d, ...l } = EA(), h = l.useRenderTarget(), p = l.useReveal();
  l.useRemoveNonReferencedModels(n, h);
  const { data: f } = l.useTypedModels(p, n, s);
  l.useSetExpectedLoadCount(n), l.useCallCallbackOnFinishedLoading(n, i);
  const g = P(() => n.filter(Zt).map((B) => ({ ...r, ...B })), [n, r]), C = P(() => f === void 0 ? H : f.filter((B) => B.type === "cad"), [f]), { data: v } = l.useAssetMappedNodesForRevisions(C);
  l.useGenerateAssetMappingCachePerItemFromModelCache(C, v), l.useGenerateNode3DCache(C, v);
  const w = (t == null ? void 0 : t.filter(Db)) ?? H, { styledModels: x, isModelMappingsLoading: T } = l.useCalculateCadStyling(
    C,
    w,
    e
  ), O = l.useReveal3DResourcesStylingLoadingSetter();
  R(() => {
    O(T);
  }, [T]);
  const S = l.useCalculatePointCloudStyling(
    f ?? H,
    w,
    e
  ), E = l.useCalculateImage360Styling(t);
  return /* @__PURE__ */ _(k, { children: [
    x.map(({ styleGroups: B, model: L }, le) => {
      var ie, ue;
      const ee = {
        defaultStyle: ((ie = L.styling) == null ? void 0 : ie.default) ?? ((ue = e == null ? void 0 : e.cad) == null ? void 0 : ue.default),
        groups: B
      };
      return /* @__PURE__ */ u(
        a,
        {
          addModelOptions: L,
          styling: ee,
          transform: L.transform,
          onLoad: o,
          onLoadError: s
        },
        `${L.modelId}/${L.revisionId}/${le}`
      );
    }),
    S.map(({ styleGroups: B, model: L }, le) => {
      var ue, Ze;
      const ee = {
        defaultStyle: ((ue = L.styling) == null ? void 0 : ue.default) ?? ((Ze = e == null ? void 0 : e.pointcloud) == null ? void 0 : Ze.default),
        groups: B
      };
      let ie;
      return Ee(L) ? ie = `${L.modelId}/${L.revisionId}/${le}` : ie = `${L.revisionExternalId}/${L.revisionSpace}/${le}`, /* @__PURE__ */ u(
        d,
        {
          addModelOptions: L,
          styling: ee,
          transform: L.transform,
          onLoad: o,
          onLoadError: s
        },
        ie
      );
    }),
    g.map((B) => {
      var N;
      const L = {
        defaultStyle: (N = e == null ? void 0 : e.image360) == null ? void 0 : N.default,
        groups: E
      };
      let le;
      return "siteId" in B ? le = `${B.siteId}` : "externalId" in B && (le = `${B.externalId}`), "externalId" in B || "siteId" in B ? /* @__PURE__ */ u(
        c,
        {
          addImage360CollectionOptions: B,
          styling: L,
          onLoad: o,
          onLoadError: s
        },
        le
      ) : /* @__PURE__ */ u(k, {});
    })
  ] });
};
async function PA(n) {
  const e = n ?? _e();
  let t = [], i;
  do {
    const s = i !== void 0 ? { includerevisioninfo: !0, limit: 1e3, cursor: i } : { includerevisioninfo: !0, limit: 1e3 }, o = await e.get(
      `/api/v1/projects/${e.project}/3d/models`,
      { params: s }
    );
    if (o.status !== 200) {
      const r = new Error("Failed to fetch models");
      throw r.cause = o, r;
    }
    t = t.concat(o.data.items), i = o.data.nextCursor;
  } while (i !== void 0);
  return Tb(t);
}
const OA = (n) => j({
  queryKey: ne.all3DResources(),
  queryFn: async () => await PA(n),
  staleTime: 1 / 0
}), jc = 25, RA = ({
  modelType: n,
  models: e,
  selectedRevisions: t,
  handleModelClick: i
}) => {
  const { t: s } = W(), o = DA(n, s);
  return e === void 0 || e.length === 0 ? /* @__PURE__ */ u($.Section, { title: s({ key: "NO_MODELS_FOUND" }), children: /* @__PURE__ */ u(
    U,
    {
      justifyContent: "center",
      style: {
        maxWidth: "320px",
        padding: "20px 8px"
      },
      children: /* @__PURE__ */ u(wd, { title: s({ key: "NO_MODELS_FOUND" }), illustration: /* @__PURE__ */ u(xd, {}) })
    }
  ) }) : /* @__PURE__ */ u($.Section, { title: o, children: e.map((r) => {
    const a = r.displayName.length > jc, c = a ? `${r.displayName.slice(0, jc)}...` : r.displayName;
    return /* @__PURE__ */ u(ce, { disabled: !a, content: r.displayName, children: /* @__PURE__ */ u(
      $.Item,
      {
        variant: "toggle",
        label: c,
        checked: t[r.id] !== void 0,
        onClick: () => {
          i(r);
        }
      }
    ) }, r.id);
  }) });
}, DA = (n, e) => {
  switch (n) {
    case "CAD":
      return e({ key: "CAD_MODELS" });
    case "Point cloud":
      return e({ key: "POINT_CLOUDS" });
    case "360 image":
      return e({ key: "IMAGES_360" });
    default:
      return e({ key: "ALL_3D_RESOURCES" });
  }
}, kA = ({
  revisions: n,
  isRevisionsLoading: e,
  selectedModel: t,
  selectedRevisions: i,
  handleRevisionSelect: s
}) => {
  const { t: o } = W();
  return /* @__PURE__ */ u($.Section, { title: o({ key: "REVISIONS" }), children: e ? /* @__PURE__ */ u(Wi, {}) : n.sort((r, a) => r.createdTime.getTime() - a.createdTime.getTime()).map((r, a) => /* @__PURE__ */ u(
    $.Item,
    {
      label: `Revision ${a + 1}`,
      variant: "toggle",
      checked: i[t.id] === r.id,
      onClick: () => {
        s(r.id);
      }
    },
    r.id
  )) });
};
async function LA(n, e) {
  return (await (e ?? _e()).revisions3D.list(n)).items;
}
const NA = async ({
  modelData: n,
  setSelectedModel: e,
  setCurrentPage: t,
  setIsRevisionsLoading: i,
  setRevisions: s,
  sdk: o
}) => {
  e(n), t(2), i(!0);
  const r = await LA(n.id, o);
  s(
    r.map((a) => ({
      id: a.id,
      createdTime: new Date(a.createdTime)
    }))
  ), i(!1);
}, BA = ({
  revisionId: n,
  selectedModel: e,
  setSelectedRevisions: t
}) => {
  t({
    [e.id]: n
  });
}, FA = (n, e) => {
  e(n.target.value);
};
function sR({
  sdk: n,
  modelType: e,
  onRevisionSelect: t,
  selectedModel: i,
  setSelectedModel: s,
  selectedRevisions: o,
  setSelectedRevisions: r
}) {
  const { t: a } = W(), { data: c, isLoading: d } = OA(n), [l, h] = M([]), [p, f] = M(1), [g, C] = M(!1), [v, w] = M(""), x = e !== void 0 ? c == null ? void 0 : c.filter((S) => S.resourceType === e) : c, T = x == null ? void 0 : x.filter(
    (S) => S.displayName.toLowerCase().includes(v.toLowerCase())
  ), O = (S) => {
    i !== void 0 && (BA({
      revisionId: S,
      selectedModel: i,
      setSelectedRevisions: r
    }), t !== void 0 && t(i.id, S));
  };
  return /* @__PURE__ */ u(jA, { children: /* @__PURE__ */ _($, { visible: !0, children: [
    /* @__PURE__ */ _($.Header, { title: a({ key: "RESOURCES_3D" }), children: [
      p !== 1 && /* @__PURE__ */ u(
        $.BackButton,
        {
          onClick: (S) => {
            f((E) => E - 1 > 0 ? E - 1 : E);
          }
        }
      ),
      p !== 2 && /* @__PURE__ */ u(
        $.SearchBar,
        {
          onChange: (S) => {
            FA(S, w);
          }
        }
      )
    ] }),
    /* @__PURE__ */ u($.Body, { length: "small", children: d ? /* @__PURE__ */ u(Wi, {}) : /* @__PURE__ */ _(k, { children: [
      p === 1 && (T !== void 0 && T.length > 0 ? /* @__PURE__ */ u(
        RA,
        {
          modelType: e,
          models: T,
          selectedRevisions: o,
          handleModelClick: async (S) => {
            await NA({
              modelData: S,
              setSelectedModel: s,
              setCurrentPage: f,
              setIsRevisionsLoading: C,
              setRevisions: h,
              sdk: n
            });
          }
        }
      ) : /* @__PURE__ */ u(VA, {})),
      p === 2 && i !== void 0 && /* @__PURE__ */ u(
        kA,
        {
          revisions: l,
          isRevisionsLoading: g,
          selectedModel: i,
          selectedRevisions: o,
          handleRevisionSelect: O
        }
      )
    ] }) }),
    /* @__PURE__ */ u($.Footer, {})
  ] }) });
}
function VA() {
  const { t: n } = W();
  return /* @__PURE__ */ u(
    U,
    {
      justifyContent: "center",
      style: {
        maxWidth: "320px",
        padding: "20px 8px"
      },
      children: /* @__PURE__ */ u(
        wd,
        {
          illustration: /* @__PURE__ */ u(xd, {}),
          size: "small",
          title: n({ key: "TRY_AGAIN" }),
          description: n({ key: "NO_RESULTS" })
        }
      )
    }
  );
}
const jA = b.div`
  position: absolute;
  top: 50px;
  left: 10px;
  display: flex;
  flex-direction: column;
  height: 400px;
  width: 300px;
  z-index: 10000;
`, bf = () => {
  const n = ls(), e = oe(), t = (d) => {
    e.fitCameraToVisualSceneBoundingBox(d);
  }, i = (d) => {
    const l = e.models;
    l.length !== 0 && e.fitCameraToModels(l, d, !0);
  }, s = async (d, l) => {
    const h = e.models.find((g) => g.revisionId === d);
    if (h === void 0) {
      await Promise.reject(new Error(`Could not find model with revision ${d}`));
      return;
    }
    const f = (await h.getBoundingBoxesByNodeIds(l)).reduce(
      (g, C) => g.union(C),
      new te()
    );
    e.cameraManager.fitCameraToBoundingBox(f);
  }, o = async (d, l) => {
    await s(d, [l]);
  }, r = async (d) => {
    const l = e.models.map((f) => ({
      modelId: f.modelId,
      revisionId: f.revisionId
    })), h = (await n.getMappingsForFdmInstances(d, l)).find((f) => f.mappings.size > 0), p = [...(h == null ? void 0 : h.mappings.values()) ?? []].flat().map((f) => f.id);
    if (h === void 0 || p.length === 0) {
      await Promise.reject(new Error("Could not find a model connected to the instances"));
      return;
    }
    await s(h.revisionId, p);
  };
  return {
    fitCameraToVisualSceneBoundingBox: t,
    fitCameraToAllModels: i,
    fitCameraToInstance: async (d, l) => {
      await r([{ externalId: d, space: l }]);
    },
    fitCameraToInstances: r,
    fitCameraToModelNode: o,
    fitCameraToModelNodes: s,
    fitCameraToState: (d) => {
      e.cameraManager.setCameraState(d);
    }
  };
}, Af = () => {
  const n = bf(), { t: e } = W(), t = Z(() => {
    n.fitCameraToVisualSceneBoundingBox();
  }, []);
  return /* @__PURE__ */ u(ce, { content: e({ key: "FIT_VIEW_TOOLTIP" }), placement: "right", children: /* @__PURE__ */ u(
    J,
    {
      type: "ghost",
      icon: /* @__PURE__ */ u(pd, {}),
      "aria-label": "Fit camera to models",
      onClick: t
    }
  ) });
}, Ef = () => {
  const n = oe(), { t: e } = W(), t = zt(), { bottom: i, top: s } = { bottom: 0, top: 1 }, [o, r] = M({
    minHeight: 0,
    maxHeight: 0,
    topRatio: s,
    bottomRatio: i
  }), { minHeight: a, maxHeight: c, topRatio: d, bottomRatio: l } = o;
  R(() => {
    if (t.length === 0)
      return;
    const f = new te();
    t.forEach((v) => f.union(v.getModelBoundingBox(void 0, !0)));
    const g = f.max.y, C = f.min.y;
    (c !== g || a !== C) && r({
      maxHeight: g,
      minHeight: C,
      topRatio: d,
      bottomRatio: l
    });
  }, [t]);
  function h(f) {
    p(f[0], f[1], c, a), r({
      maxHeight: c,
      minHeight: a,
      bottomRatio: f[0],
      topRatio: f[1]
    });
  }
  function p(f, g, C, v) {
    const w = [];
    f !== 0 && w.push(
      new ot(new I(0, 1, 0), -(v + f * (C - v)))
    ), g !== 1 && w.push(new ot(new I(0, -1, 0), v + g * (C - v))), n.setGlobalClippingPlanes(w);
  }
  return /* @__PURE__ */ u(
    zA,
    {
      placement: "right-start",
      floatingProps: { middleware: [Ki(Dn)] },
      renderTrigger: (f) => /* @__PURE__ */ u(ce, { content: e({ key: "SLICE_TOOLTIP" }), placement: "right", children: /* @__PURE__ */ u(J, { ...f, type: "ghost", icon: /* @__PURE__ */ u(gy, {}), "aria-label": "Slice models" }) }),
      children: /* @__PURE__ */ u(
        UA,
        {
          min: 0,
          max: 1,
          step: 0.01,
          setValue: h,
          marks: {},
          value: [l, d],
          vertical: !0
        }
      )
    }
  );
}, zA = b(Ge)`
  height: 512px;
  width: 32px !important;
  max-width: 32px !important;
  min-width: 32px !important;
  padding: 12px 8px 12px 8px !important;
  overflow: hidden !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;

  .cogs-v10.cogs-slider .rc-slider-rail {
    height: 100% !important;
    width: 4px !important;
  }

  .cogs-v10.cogs-slider .rc-slider-track {
    left: auto !important;
  }

  .cogs-v10.cogs-slider .rc-slider-handle {
    margin-left: 0.75px !important;
  }
`, UA = b(fy)`
  height: 100% !important;
  width: 4px !important;
  display: flex !important;
  flex-direction: row !important;
  justify-content: center !important;
}
`, ir = {
  cadBudget: {
    maximumRenderCost: 15e6,
    highDetailProximityThreshold: 10
  },
  pointCloudBudget: {
    numberOfPoints: 3e6
  },
  resolutionOptions: {
    maxRenderResolution: 14e5,
    movingCameraResolutionFactor: 1
  }
}, GA = {
  cadBudget: {
    maximumRenderCost: 45e6,
    highDetailProximityThreshold: 30
  },
  pointCloudBudget: {
    numberOfPoints: 12e6
  },
  resolutionOptions: {
    maxRenderResolution: 1 / 0,
    movingCameraResolutionFactor: 1
  }
}, HA = ({
  lowQualitySettings: n,
  highQualitySettings: e
}) => {
  const { t } = W(), i = oe(), [s, o] = M(!qA(i)), r = {
    ...ir,
    ...n
  }, a = {
    ...GA,
    ...e
  }, c = () => {
    const d = s ? r : a;
    i.cadBudget = d.cadBudget, i.pointCloudBudget = d.pointCloudBudget, i.setResolutionOptions(d.resolutionOptions), o((l) => !l);
  };
  return /* @__PURE__ */ u(
    Ge.ItemToggled,
    {
      toggled: s,
      label: t({ key: "HIGH_FIDELITY" }),
      onClick: c
    }
  );
};
function qA(n) {
  return n.cadBudget.maximumRenderCost <= ir.cadBudget.maximumRenderCost && n.pointCloudBudget.numberOfPoints <= ir.pointCloudBudget.numberOfPoints;
}
const Mf = ({
  customSettingsContent: n,
  lowQualitySettings: e,
  highQualitySettings: t
}) => {
  const { t: i } = W(), [s, o] = M(!1);
  return /* @__PURE__ */ _(
    $A,
    {
      placement: "right",
      floatingProps: { middleware: [Ki(Dn)] },
      disableCloseOnClickInside: !0,
      renderTrigger: (r) => /* @__PURE__ */ u(
        ce,
        {
          content: i({ key: "SETTINGS_TOOLTIP" }),
          placement: "right",
          disabled: s,
          children: /* @__PURE__ */ u(
            J,
            {
              icon: /* @__PURE__ */ u(fd, {}),
              type: "ghost",
              "aria-label": "Show settings",
              toggled: s,
              onClick: () => {
                o((a) => !a);
              },
              ...r
            }
          )
        }
      ),
      children: [
        /* @__PURE__ */ u(
          HA,
          {
            lowQualitySettings: e,
            highQualitySettings: t
          }
        ),
        n ?? /* @__PURE__ */ u(k, {})
      ]
    }
  );
}, $A = b(Ge)`
  z-index: 998 !important;
  max-height: 300px !important;
  overflow-y: auto !important;
`, WA = (n) => /* @__PURE__ */ _(
  "svg",
  {
    width: "78",
    height: "119",
    viewBox: "0 0 78 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ u(
        "path",
        {
          d: "M38.9666 117C18.635 117 2 100.422 2 80.1595V38.8405C2 18.5782 18.635 2 38.9666 2C59.2982 2 75.9332 18.5782 75.9332 38.8405V80.1595C75.9332 100.422 59.2982 117 38.9666 117Z",
          stroke: "#ABB9FB",
          strokeWidth: "3",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M38.9666 49.8932C34.9002 49.8932 31.5732 46.5776 31.5732 42.5251V20.4208C31.5732 16.3684 34.9002 13.0527 38.9666 13.0527C43.0329 13.0527 46.3599 16.3684 46.3599 20.4208V42.5251C46.3599 46.5776 43.0329 49.8932 38.9666 49.8932Z",
          stroke: "#ABB9FB",
          strokeWidth: "3",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ u("path", { d: "M38.9668 13.0521V2", stroke: "#ABB9FB", strokeWidth: "3", strokeMiterlimit: "10" }),
      /* @__PURE__ */ u("path", { d: "M38.9658 49.8926V66.194", stroke: "#ABB9FB", strokeWidth: "3", strokeMiterlimit: "10" }),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M2 60.9453C2 60.9453 2.74644 66.1945 38.9666 66.1945C75.9332 66.1945 75.9332 60.9453 75.9332 60.9453",
          stroke: "#ABB9FB",
          strokeWidth: "3",
          strokeMiterlimit: "10"
        }
      )
    ]
  }
), KA = b.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: fit-content;
  max-width: fit-content;
`, YA = b(gr).attrs({ level: 3 })`
  color: #ffffff;
`, XA = b(gr).attrs({ level: 5 })`
  color: #ffffff;
`, ZA = b.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 100%;
`, ae = b(tt).attrs({
  level: 3,
  strong: !0
})`
  color: rgba(255, 255, 255, 0.9);
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`, ws = b(tt).attrs({
  size: "small"
})`
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.006em;
  white-space: pre-line;
`, QA = b.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1.5fr;
  gap: 8px;
  width: fit-content;
  justify-items: center;
  align-items: center;
  padding-top: 12px;

  ${ae}:first-of-type {
    padding-left: 10px;
    grid-column: 1/-1;
    text-align: right;
  }

  ${ae}:last-of-type {
    text-align: left;
  }
`, JA = b.div`
  grid-column: 2 / 3;
  grid-row: 2 / 3;
`, zc = b.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
  width: fit-content;
  justify-items: center;
  align-items: center;
  text-align: center;
`, eE = b.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
  padding-left: 12px;
  width: fit-content;
  justify-items: center;
  align-items: center;

  ${ae}:first-of-type {
    padding-left: 10px;
    grid-column: 1/-1;
    text-align: right;
  }

  ${ae}:last-of-type {
    text-align: center;
  }
`, tE = b.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1.5fr;
  width: fit-content;
  justify-items: center;
  padding-top: 12px;

  ${ae}:first-of-type {
    padding-left: 10px;
    grid-column: 1/-1;
    text-align: right;
  }

  ${ae}:last-of-type {
    text-align: center;
  }
`, nE = b.div`
  grid-column: 2 / 3;
  grid-row: 1 / 3;
  padding-top: 40px;
`, iE = b(WA)`
  display: flex;
  justify-content: center;

  ::before {
    content: '';
    position: absolute;
    display: inline-block;
    margin-top: 12px;
    width: 110px;
    border-top: 1px solid white;
  }
`, Zr = ({
  children: n,
  title: e,
  description: t,
  subTitle: i
}) => /* @__PURE__ */ _(KA, { children: [
  /* @__PURE__ */ u(YA, { children: e }),
  /* @__PURE__ */ u(XA, { children: i }),
  /* @__PURE__ */ u(ws, { children: t }),
  /* @__PURE__ */ u(ZA, { children: n })
] }), sE = ({ fallbackLanguage: n }) => {
  const { t: e } = W(n);
  return /* @__PURE__ */ u(
    Zr,
    {
      title: e({ key: "MOUSE_NAVIGATION_TITLE" }),
      subTitle: e({ key: "MOUSE_TOUCH_NAVIGATION_SUBTITLE" }),
      description: e({ key: "MOUSE_NAVIGATION_DESCRIPTION" }),
      children: /* @__PURE__ */ _(QA, { children: [
        /* @__PURE__ */ u(ae, { children: e({ key: "MOUSE_ZOOM" }) }),
        /* @__PURE__ */ _(
          ae,
          {
            style: { marginBottom: 30, textAlign: "right", width: "max-content", maxWidth: "100px" },
            children: [
              e({ key: "MOUSE_ROTATE" }),
              /* @__PURE__ */ u(ws, { children: e({ key: "MOUSE_INSTRUCTIONS" }) })
            ]
          }
        ),
        /* @__PURE__ */ u(JA, { children: /* @__PURE__ */ u(iE, {}) }),
        /* @__PURE__ */ _(
          ae,
          {
            style: { marginBottom: 30, textAlign: "left", width: "max-content", maxWidth: "100px" },
            children: [
              e({ key: "PAN" }),
              /* @__PURE__ */ u(ws, { children: e({ key: "MOUSE_INSTRUCTIONS" }) })
            ]
          }
        ),
        /* @__PURE__ */ _(
          ae,
          {
            style: { marginTop: -50, textAlign: "right", width: "max-content", maxWidth: "100px" },
            children: [
              e({ key: "MOUSE_SELECT" }),
              /* @__PURE__ */ u(ws, { children: e({ key: "MOUSE_SELECT_INSTRUCTION" }) })
            ]
          }
        )
      ] })
    }
  );
}, oE = (n) => /* @__PURE__ */ _(
  "svg",
  {
    width: "100",
    height: "100",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ u(
        "path",
        {
          d: "M30 44C30 40.686 27.314 38 24 38C20.686 38 18 40.686 18 44V64C18 80.568 31.432 94 48 94C64.568 94 78 80.568 78 64V48C78 44.686 75.314 42 72 42C68.686 42 66 44.686 66 48V44C66 40.686 63.314 38 60 38C56.686 38 54 40.686 54 44V40C54 36.686 51.314 34 48 34C44.686 34 42 36.686 42 40V12C42 8.686 39.314 6 36 6C32.686 6 30 8.686 30 12V58V44Z",
          stroke: "#ABB9FB",
          strokeWidth: "2",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M80 16H52",
          stroke: "white",
          strokeWidth: "2",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M74 10L80 16L74 22",
          stroke: "white",
          strokeWidth: "2",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M58 10L52 16L58 22",
          stroke: "white",
          strokeWidth: "2",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), rE = (n) => /* @__PURE__ */ _(
  "svg",
  {
    width: "100",
    height: "100",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ u(
        "path",
        {
          d: "M53.98 36C53.98 32.686 56.666 30 59.98 30C63.294 30 65.98 32.686 65.98 36V40C65.98 36.686 68.666 34 71.98 34C75.294 34 77.98 36.686 77.98 40V46V43.876C77.98 40.562 80.666 37.876 83.98 37.876C87.294 37.876 89.98 40.562 89.98 43.876V64C89.98 80.568 76.548 94 59.98 94C51.696 94 44.1961 90.642 38.7661 85.214L17.2961 58.178C15.4061 55.798 15.6021 52.38 17.7501 50.23C20.0861 47.894 23.8721 47.894 26.2081 50.23L34.658 58.68C37.36 61.382 41.9781 59.468 41.9781 55.648V46V12C41.9781 8.686 44.6641 6 47.9781 6C51.2921 6 53.9781 8.686 53.9781 12V40",
          stroke: "#ABB9FB",
          strokeWidth: "2",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M10 40L32 18",
          stroke: "white",
          strokeWidth: "2",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M32 26V18H24",
          stroke: "white",
          strokeWidth: "2",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M10 32V40H18",
          stroke: "white",
          strokeWidth: "2",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), aE = (n) => /* @__PURE__ */ _(
  "svg",
  {
    width: "100",
    height: "100",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ u(
        "path",
        {
          d: "M32.01 30.6575C27.2747 28.4126 24 23.5887 24 18C24 10.268 30.268 4 38 4C45.732 4 52 10.268 52 18C52 23.5887 48.7253 28.4126 43.99 30.6575",
          stroke: "white",
          strokeWidth: "2",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M32 50C32 46.686 29.314 44 26 44C22.686 44 20 46.686 20 50V64C20 80.568 33.432 94 50 94C66.568 94 80 80.568 80 64V50C80 46.686 77.314 44 74 44C70.686 44 68 46.686 68 50V46C68 42.686 65.314 40 62 40C58.686 40 56 42.686 56 46V42C56 38.686 53.314 36 50 36C46.686 36 44 38.686 44 42V18C44 14.686 41.314 12 38 12C34.686 12 32 14.686 32 18V62V50Z",
          stroke: "#ABB9FB",
          strokeWidth: "2",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), cE = ({ fallbackLanguage: n }) => {
  const { t: e } = W(n);
  return /* @__PURE__ */ u(
    Zr,
    {
      title: e({ key: "TOUCH_NAVIGATION_TITLE" }),
      subTitle: e({ key: "MOUSE_TOUCH_NAVIGATION_SUBTITLE" }),
      description: e({ key: "TOUCH_NAVIGATION_DESCRIPTION" }),
      children: /* @__PURE__ */ _(tE, { children: [
        /* @__PURE__ */ _("div", { children: [
          /* @__PURE__ */ u(oE, {}),
          /* @__PURE__ */ u(ae, { children: e({ key: "PAN" }) })
        ] }),
        /* @__PURE__ */ _(nE, { children: [
          /* @__PURE__ */ u(aE, {}),
          /* @__PURE__ */ u(ae, { children: e({ key: "TOUCH_SELECT" }) })
        ] }),
        /* @__PURE__ */ _("div", { children: [
          /* @__PURE__ */ u(rE, {}),
          /* @__PURE__ */ u(ae, { children: e({ key: "TOUCH_ZOOM" }) })
        ] })
      ] })
    }
  );
}, dE = (n) => /* @__PURE__ */ _(
  "svg",
  {
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ u(
        "rect",
        {
          x: "1.20903",
          y: "1.20903",
          width: "43.5819",
          height: "43.5819",
          rx: "4.79097",
          stroke: "#ABB9FB",
          strokeWidth: "2.41806"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M22.9999 14.3652V34.3793M22.9999 14.3652L28.992 20.1758M22.9999 14.3652L17.0078 20.1758",
          stroke: "white",
          strokeWidth: "2.41806"
        }
      )
    ]
  }
), lE = (n) => /* @__PURE__ */ _(
  "svg",
  {
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ u(
        "rect",
        {
          x: "1.20903",
          y: "1.20903",
          width: "43.5819",
          height: "43.5819",
          rx: "4.79097",
          stroke: "#ABB9FB",
          strokeWidth: "2.41806"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M32.4424 22.6757L12.4283 22.6757M32.4424 22.6757L26.6319 28.6678M32.4424 22.6757L26.6319 16.6836",
          stroke: "white",
          strokeWidth: "2.41806"
        }
      )
    ]
  }
), uE = (n) => /* @__PURE__ */ _(
  "svg",
  {
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ u(
        "rect",
        {
          x: "1.20903",
          y: "1.20903",
          width: "43.5819",
          height: "43.5819",
          rx: "4.79097",
          stroke: "#ABB9FB",
          strokeWidth: "2.41806"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M23.0001 29.8184L23.0001 9.80432M23.0001 29.8184L17.008 24.0078M23.0001 29.8184L28.9922 24.0078",
          stroke: "white",
          strokeWidth: "2.41806"
        }
      )
    ]
  }
), hE = (n) => /* @__PURE__ */ _(
  "svg",
  {
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ u(
        "rect",
        {
          x: "1.20903",
          y: "1.20903",
          width: "43.5819",
          height: "43.5819",
          rx: "4.79097",
          stroke: "#ABB9FB",
          strokeWidth: "2.41806"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M13.96 20.7481L33.974 20.7481M13.96 20.7481L19.7705 14.756M13.96 20.7481L19.7705 26.7402",
          stroke: "white",
          strokeWidth: "2.41806"
        }
      )
    ]
  }
), pE = (n) => /* @__PURE__ */ _(
  "svg",
  {
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ u(
        "rect",
        {
          x: "1.20903",
          y: "1.20903",
          width: "43.5819",
          height: "43.5819",
          rx: "4.79097",
          stroke: "#ABB9FB",
          strokeWidth: "2.41806"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M22.0463 26.9534H24.8307L26.7908 29.5088L27.7159 30.6446L30.8392 34.7205H27.9449L25.8566 32.0002L25.1421 31.011L22.0463 26.9534ZM31.4437 23.656C31.4437 25.6589 31.0774 27.3808 30.3446 28.8219C29.6119 30.2568 28.6074 31.3621 27.3312 32.1375C26.0611 32.9069 24.617 33.2916 22.9989 33.2916C21.3746 33.2916 19.9244 32.9069 18.6482 32.1375C17.3781 31.3621 16.3767 30.2538 15.6439 28.8127C14.9112 27.3717 14.5448 25.6528 14.5448 23.656C14.5448 21.6532 14.9112 19.9343 15.6439 18.4993C16.3767 17.0583 17.3781 15.9531 18.6482 15.1837C19.9244 14.4082 21.3746 14.0204 22.9989 14.0204C24.617 14.0204 26.0611 14.4082 27.3312 15.1837C28.6074 15.9531 29.6119 17.0583 30.3446 18.4993C31.0774 19.9343 31.4437 21.6532 31.4437 23.656ZM28.641 23.656C28.641 22.1295 28.3937 20.8441 27.8991 19.8C27.4106 18.7497 26.7389 17.9559 25.884 17.4185C25.0353 16.8751 24.0735 16.6034 22.9989 16.6034C21.9181 16.6034 20.9533 16.8751 20.1045 17.4185C19.2558 17.9559 18.5841 18.7497 18.0895 19.8C17.601 20.8441 17.3567 22.1295 17.3567 23.656C17.3567 25.1826 17.601 26.471 18.0895 27.5213C18.5841 28.5654 19.2558 29.3592 20.1045 29.9027C20.9533 30.44 21.9181 30.7087 22.9989 30.7087C24.0735 30.7087 25.0353 30.44 25.884 29.9027C26.7389 29.3592 27.4106 28.5654 27.8991 27.5213C28.3937 26.471 28.641 25.1826 28.641 23.656Z",
          fill: "white"
        }
      )
    ]
  }
), fE = (n) => /* @__PURE__ */ _(
  "svg",
  {
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ u(
        "rect",
        {
          x: "1.20903",
          y: "1.20903",
          width: "43.5819",
          height: "43.5819",
          rx: "4.79097",
          stroke: "#ABB9FB",
          strokeWidth: "2.41806"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M16.1271 33.0352L10.9246 14.2769H13.9014L17.5559 28.8036H17.73L21.5311 14.2769H24.4804L28.2815 28.8127H28.4555L32.1009 14.2769H35.0868L29.8752 33.0352H27.0267L23.079 18.9848H22.9325L18.9848 33.0352H16.1271Z",
          fill: "white"
        }
      )
    ]
  }
), gE = (n) => /* @__PURE__ */ _(
  "svg",
  {
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ u(
        "rect",
        {
          x: "1.20903",
          y: "1.20903",
          width: "43.5819",
          height: "43.5819",
          rx: "4.79097",
          stroke: "#ABB9FB",
          strokeWidth: "2.41806"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M17.2903 33.0352V14.2769H29.0509V16.7133H20.1205V22.4287H28.4372V24.8559H20.1205V30.5988H29.1608V33.0352H17.2903Z",
          fill: "white"
        }
      )
    ]
  }
), mE = (n) => /* @__PURE__ */ _(
  "svg",
  {
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ u(
        "rect",
        {
          x: "1.20903",
          y: "1.20903",
          width: "43.5819",
          height: "43.5819",
          rx: "4.79097",
          stroke: "#ABB9FB",
          strokeWidth: "2.41806"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M17.6155 33.0352H14.6112L21.3616 14.2769H24.6315L31.3819 33.0352H28.3777L23.0744 17.6842H22.9279L17.6155 33.0352ZM18.1192 25.6894H27.8647V28.0708H18.1192V25.6894Z",
          fill: "white"
        }
      )
    ]
  }
), yE = (n) => /* @__PURE__ */ _(
  "svg",
  {
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ u(
        "rect",
        {
          x: "1.20903",
          y: "1.20903",
          width: "43.5819",
          height: "43.5819",
          rx: "4.79097",
          stroke: "#ABB9FB",
          strokeWidth: "2.41806"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M26.9923 19.2046C26.8946 18.3375 26.4916 17.6658 25.7833 17.1896C25.075 16.7072 24.1835 16.466 23.1088 16.466C22.3394 16.466 21.6738 16.5881 21.112 16.8323C20.5503 17.0705 20.1137 17.4002 19.8023 17.8216C19.4969 18.2368 19.3443 18.71 19.3443 19.2412C19.3443 19.687 19.4481 20.0717 19.6557 20.3953C19.8694 20.7189 20.1473 20.9907 20.4892 21.2105C20.8373 21.4242 21.2097 21.6043 21.6066 21.7509C22.0035 21.8913 22.3852 22.0074 22.7516 22.0989L24.5834 22.5752C25.1818 22.7218 25.7955 22.9202 26.4244 23.1706C27.0534 23.4209 27.6365 23.7507 28.1739 24.1598C28.7112 24.5689 29.1447 25.0757 29.4745 25.6802C29.8103 26.2848 29.9782 27.0083 29.9782 27.851C29.9782 28.9135 29.7035 29.8569 29.1539 30.6812C28.6105 31.5056 27.8197 32.1559 26.7816 32.6321C25.7497 33.1084 24.501 33.3466 23.0355 33.3466C21.6311 33.3466 20.4159 33.1237 19.3901 32.6779C18.3642 32.2322 17.5613 31.6002 16.9812 30.782C16.4011 29.9576 16.0805 28.9806 16.0195 27.851H18.8589C18.9138 28.5288 19.1336 29.0936 19.5183 29.5455C19.9091 29.9912 20.4068 30.324 21.0113 30.5438C21.6219 30.7575 22.2905 30.8644 23.0172 30.8644C23.8171 30.8644 24.5285 30.7392 25.1513 30.4889C25.7802 30.2324 26.2748 29.8782 26.6351 29.4264C26.9954 28.9684 27.1755 28.4341 27.1755 27.8235C27.1755 27.2678 27.0167 26.8129 26.6992 26.4588C26.3878 26.1046 25.9634 25.8115 25.4261 25.5795C24.8948 25.3474 24.2934 25.1429 23.6217 24.9658L21.4051 24.3613C19.903 23.9522 18.7123 23.3507 17.833 22.5569C16.9598 21.7631 16.5232 20.7128 16.5232 19.4061C16.5232 18.3253 16.8163 17.3819 17.4025 16.5759C17.9887 15.7699 18.7825 15.144 19.7839 14.6982C20.7854 14.2464 21.915 14.0204 23.1729 14.0204C24.443 14.0204 25.5635 14.2433 26.5343 14.6891C27.5113 15.1348 28.2807 15.7485 28.8425 16.5301C29.4043 17.3056 29.6974 18.1971 29.7218 19.2046H26.9923Z",
          fill: "white"
        }
      )
    ]
  }
), vE = (n) => /* @__PURE__ */ _(
  "svg",
  {
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ u(
        "rect",
        {
          x: "1.20903",
          y: "1.20903",
          width: "43.5819",
          height: "43.5819",
          rx: "4.79097",
          stroke: "#ABB9FB",
          strokeWidth: "2.41806"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M21.8265 33.0352H15.7538V14.2769H22.0188C23.8568 14.2769 25.4352 14.6524 26.7542 15.4035C28.0731 16.1485 29.0837 17.2201 29.7859 18.6184C30.4942 20.0106 30.8484 21.6807 30.8484 23.6286C30.8484 25.5825 30.4912 27.2617 29.7767 28.6662C29.0684 30.0706 28.0426 31.1514 26.6992 31.9086C25.3558 32.6596 23.7316 33.0352 21.8265 33.0352ZM18.5841 30.5621H21.6708C23.0996 30.5621 24.2873 30.2935 25.2337 29.7561C26.1802 29.2127 26.8885 28.428 27.3587 27.4022C27.8289 26.3702 28.0639 25.1124 28.0639 23.6286C28.0639 22.157 27.8289 20.9082 27.3587 19.8824C26.8946 18.8566 26.2016 18.078 25.2795 17.5468C24.3575 17.0155 23.2126 16.7499 21.8448 16.7499H18.5841V30.5621Z",
          fill: "white"
        }
      )
    ]
  }
), vs = {
  Up: dE,
  Down: uE,
  Left: hE,
  Right: lE
}, Ln = {
  Q: pE,
  W: fE,
  E: gE,
  A: mE,
  S: yE,
  D: vE
}, CE = ({ fallbackLanguage: n }) => {
  const { t: e } = W(n);
  return /* @__PURE__ */ u(
    Zr,
    {
      title: e({ key: "KEYBOARD_NAVIGATION_TITLE" }),
      subTitle: e({ key: "KEYBOARD_NAVIGATION_SUBTITLE" }),
      description: e({ key: "KEYBOARD_NAVIGATION_DESCRIPTION" }),
      children: /* @__PURE__ */ _(U, { gap: 8, style: { paddingTop: 12 }, children: [
        /* @__PURE__ */ _(U, { direction: "column", children: [
          /* @__PURE__ */ _(zc, { children: [
            /* @__PURE__ */ _(ae, { children: [
              " ",
              e({ key: "KEYBOARD_DOWN" }),
              " "
            ] }),
            /* @__PURE__ */ u(ae, { children: e({ key: "KEYBOARD_FORWARD" }) }),
            /* @__PURE__ */ u(ae, { children: e({ key: "KEYBOARD_UP" }) }),
            /* @__PURE__ */ u(Ln.Q, {}),
            /* @__PURE__ */ u(Ln.W, {}),
            /* @__PURE__ */ u(Ln.E, {})
          ] }),
          /* @__PURE__ */ _(zc, { style: { paddingLeft: 15, paddingTop: 8 }, children: [
            /* @__PURE__ */ u(Ln.A, {}),
            /* @__PURE__ */ u(Ln.S, { style: { marginLeft: 6 } }),
            /* @__PURE__ */ u(Ln.D, { style: { marginLeft: 6 } }),
            /* @__PURE__ */ u(ae, { children: e({ key: "KEYBOARD_LEFT" }) }),
            /* @__PURE__ */ u(ae, { children: e({ key: "KEYBOARD_BACK" }) }),
            /* @__PURE__ */ u(ae, { children: e({ key: "KEYBOARD_RIGHT" }) })
          ] })
        ] }),
        /* @__PURE__ */ _(eE, { children: [
          /* @__PURE__ */ u(ae, { children: e({ key: "KEYBOARD_LOOK_UP" }) }),
          /* @__PURE__ */ u(ae, { children: e({ key: "KEYBOARD_LOOK_LEFT" }) }),
          /* @__PURE__ */ u(vs.Up, {}),
          /* @__PURE__ */ u(ae, { children: e({ key: "KEYBOARD_LOOK_RIGHT" }) }),
          /* @__PURE__ */ u(vs.Left, {}),
          /* @__PURE__ */ u(vs.Down, {}),
          /* @__PURE__ */ u(vs.Right, {}),
          /* @__PURE__ */ u("br", {}),
          /* @__PURE__ */ u(ae, { children: e({ key: "KEYBOARD_LOOK_DOWN" }) })
        ] })
      ] })
    }
  );
}, Pf = ({ fallbackLanguage: n, placement: e }) => {
  const { t } = W(n), [i, s] = M(!1);
  return /* @__PURE__ */ u(
    Td,
    {
      onClickOutside: () => {
        s(!1);
      },
      placement: e ?? "right",
      content: /* @__PURE__ */ _(IE, { children: [
        /* @__PURE__ */ u(sE, { fallbackLanguage: n }),
        /* @__PURE__ */ u(CE, { fallbackLanguage: n }),
        /* @__PURE__ */ u(cE, { fallbackLanguage: n })
      ] }),
      children: /* @__PURE__ */ u(ce, { content: t({ key: "HELP_TOOLTIP" }), placement: "right", children: /* @__PURE__ */ u(
        J,
        {
          type: "ghost",
          icon: /* @__PURE__ */ u(my, {}),
          "aria-label": "help-button",
          toggled: i,
          onClick: () => {
            s((o) => !o);
          }
        }
      ) })
    }
  );
}, IE = b.div`
  background-color: #516efa;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
  width: fit-content;
  max-height: 20vw;
  overflow-y: auto;
`, Of = () => {
  const { t: n } = W(), e = async () => {
    const t = window.location.href;
    await navigator.clipboard.writeText(t);
  };
  return /* @__PURE__ */ u(ce, { content: n({ key: "COPY_URL_TO_SHARE" }), placement: "right", children: /* @__PURE__ */ u(J, { icon: /* @__PURE__ */ u(fr, {}), type: "ghost", "aria-label": "share-button", onClick: e }) });
}, Qr = {
  type: "view",
  space: "scene",
  externalId: "SceneConfiguration",
  version: "v1"
}, wE = {
  type: "view",
  space: "cdf_3d_schema",
  externalId: "Transformation3d",
  version: "v1"
}, Rf = {
  type: "view",
  space: "scene",
  externalId: "EnvironmentMap",
  version: "v1"
}, Df = {
  type: "view",
  space: "scene",
  externalId: "Image360CollectionProperties",
  version: "v1"
}, kf = {
  type: "view",
  space: "scene",
  externalId: "RevisionProperties",
  version: "v1"
}, Lf = {
  type: "view",
  space: "scene",
  externalId: "TexturedPlane",
  version: "v1"
}, Nf = [
  {
    source: Lf,
    properties: ["file", "label", "wrapping", "repeatU", "repeatV"]
  }
], xo = [
  {
    source: wE,
    properties: [
      "translationX",
      "translationY",
      "translationZ",
      "eulerRotationX",
      "eulerRotationY",
      "eulerRotationZ",
      "scaleX",
      "scaleY",
      "scaleZ"
    ]
  }
], Bf = [
  {
    source: Qr,
    properties: [
      "name",
      "skybox",
      "cameraTranslationX",
      "cameraTranslationY",
      "cameraTranslationZ",
      "cameraEulerRotationX",
      "cameraEulerRotationY",
      "cameraEulerRotationZ",
      "cameraTargetX",
      "cameraTargetY",
      "cameraTargetZ",
      "updatedAt"
    ]
  }
], Ff = [
  {
    source: kf,
    properties: ["revisionId", ...xo[0].properties]
  }
], Vf = [
  {
    source: Df,
    properties: [
      "image360CollectionExternalId",
      "image360CollectionSpace",
      ...xo[0].properties
    ]
  }
], jf = [
  {
    source: Rf,
    properties: ["label", "file", "isSpherical"]
  }
], xE = {
  with: {
    myScene: {
      nodes: {
        filter: {
          and: [
            {
              equals: {
                property: ["node", "space"],
                value: { parameter: "sceneSpace" }
              }
            },
            {
              equals: {
                property: ["node", "externalId"],
                value: { parameter: "sceneExternalId" }
              }
            }
          ]
        }
      },
      limit: 1
    },
    sceneModels: {
      edges: {
        from: "myScene",
        maxDistance: 1,
        direction: "outwards",
        filter: {
          equals: {
            property: ["edge", "type"],
            value: {
              space: "scene",
              externalId: "SceneConfiguration.model3ds"
            }
          }
        }
      },
      limit: 100
    },
    image360CollectionsEdges: {
      edges: {
        from: "myScene",
        maxDistance: 1,
        direction: "outwards",
        filter: {
          equals: {
            property: ["edge", "type"],
            value: {
              space: "scene",
              externalId: "SceneConfiguration.images360Collections"
            }
          }
        }
      },
      limit: 100
    },
    skybox: {
      nodes: {
        from: "myScene",
        through: {
          view: Qr,
          identifier: "skybox"
        },
        direction: "outwards"
      }
    },
    groundPlaneEdges: {
      edges: {
        from: "myScene",
        maxDistance: 1,
        direction: "outwards",
        filter: {
          equals: {
            property: ["edge", "type"],
            value: {
              space: "scene",
              externalId: "SceneConfiguration.texturedGroundPlanes"
            }
          }
        }
      },
      limit: 100
    },
    groundPlanes: {
      nodes: {
        from: "groundPlaneEdges",
        chainTo: "destination"
      },
      limit: 100
    }
  },
  select: {
    myScene: {
      sources: Bf
    },
    sceneModels: {
      sources: Ff
    },
    image360CollectionsEdges: {
      sources: Vf
    },
    skybox: {
      sources: jf
    },
    groundPlaneEdges: {
      sources: xo
    },
    groundPlanes: {
      sources: Nf
    }
  }
};
async function hi(n, e) {
  return (await n.getViewsByIds(e)).items.length === e.length;
}
function Jr(n) {
  const e = Number(n);
  if (!isNaN(e))
    return e;
  const t = ao(n);
  if (!isNaN(t))
    return t;
}
const zf = 2;
async function Uf(n, e, t) {
  return (await St(
    e.map((i, s) => async () => n[s] === void 0 ? void 0 : await hp(n[s], i, t)),
    zf
  )).filter(F);
}
async function Gf(n, e) {
  return (await St(
    n.map((t) => async () => await dp(t, e)),
    zf
  )).flat().filter(F);
}
async function _E(n, e, t) {
  const i = n.includes("cog_3d_model"), s = Jr(n);
  if (!i || s === void 0)
    return;
  const o = await Gf([s], t), r = await Uf(
    o,
    [e],
    t
  );
  return {
    revisionExternalId: r[0].externalId,
    revisionSpace: r[0].space
  };
}
const TE = {
  sceneConfiguration: {
    name: "",
    cameraTranslationX: 0,
    cameraTranslationY: 0,
    cameraTranslationZ: 0,
    cameraEulerRotationX: 0,
    cameraEulerRotationY: 0,
    cameraEulerRotationZ: 0
  },
  skybox: void 0,
  groundPlanes: [],
  sceneModels: [],
  image360Collections: []
}, _o = (n, e) => {
  const t = Te();
  return j({
    queryKey: ["reveal", "react-components", "sync-scene-config", n, e],
    queryFn: async () => {
      var d;
      if (n === void 0 || e === void 0)
        return null;
      if (!await SE(t))
        return TE;
      const s = {
        ...xE,
        parameters: { sceneExternalId: n, sceneSpace: e }
      }, r = await t.queryNodesAndEdges(s), a = Zn(
        (d = r.items.myScene[0]) == null ? void 0 : d.properties
      );
      return {
        sceneConfiguration: {
          name: a.name,
          cameraTranslationX: a.cameraTranslationX,
          cameraTranslationY: a.cameraTranslationY,
          cameraTranslationZ: a.cameraTranslationZ,
          cameraEulerRotationX: a.cameraEulerRotationX,
          cameraEulerRotationY: a.cameraEulerRotationY,
          cameraEulerRotationZ: a.cameraEulerRotationZ,
          cameraTargetX: a.cameraTargetX,
          cameraTargetY: a.cameraTargetY,
          cameraTargetZ: a.cameraTargetZ,
          updatedAt: a.updatedAt
        },
        skybox: ME(r),
        groundPlanes: EE(r),
        sceneModels: await bE(r, t),
        image360Collections: AE(r)
      };
    },
    enabled: n !== void 0 && e !== void 0,
    staleTime: 1 / 0
  });
};
async function SE(n) {
  return await hi(n, [
    Qr,
    kf,
    Df,
    Rf,
    Lf
  ]);
}
function Zn(n) {
  const e = Object.keys(n)[0], t = Object.keys(n[e])[0];
  return n[e][t];
}
async function bE(n, e) {
  const t = n.items.sceneModels;
  if (t.length === 0)
    return H;
  const i = t.map(async (s) => {
    const o = Zn(s.properties), r = await _E(
      s.endNode.externalId,
      o.revisionId,
      e
    );
    if (r !== void 0)
      return PE(o, r);
    {
      const a = Jr(s.endNode.externalId);
      if (a === void 0)
        throw new Error(
          `Could not parse model Id from externalId ${s.endNode.externalId}`
        );
      return OE(o, a);
    }
  });
  return await Promise.all(i);
}
function AE(n) {
  const e = [];
  return n.items.image360CollectionsEdges.length > 0 && n.items.image360CollectionsEdges.forEach((i) => {
    const o = {
      ...Zn(
        i.properties
      )
    };
    e.push(o);
  }), e;
}
function EE(n) {
  const e = [];
  if (n.items.groundPlanes.length > 0) {
    const t = n.items.groundPlanes;
    n.items.groundPlaneEdges.forEach((s) => {
      const o = t.find(
        (r) => r.externalId === s.endNode.externalId && r.space === s.endNode.space
      );
      if (o !== void 0) {
        const { label: r, file: a, wrapping: c, repeatU: d, repeatV: l } = Zn(o.properties), h = Zn(
          s.properties
        ), p = {
          label: r,
          file: a,
          wrapping: c,
          repeatU: d ?? 1,
          repeatV: l ?? 1,
          ...h
        };
        e.push(p);
      }
    });
  }
  return e;
}
function ME(n) {
  if (n.items.skybox.length === 0)
    return;
  const { label: e, isSpherical: t, file: i } = Zn(
    n.items.skybox[0].properties
  );
  return {
    label: e,
    isSpherical: t,
    file: i
  };
}
function PE(n, e) {
  return {
    modelIdentifier: {
      revisionExternalId: e.revisionExternalId,
      revisionSpace: e.revisionSpace
    },
    ...n
  };
}
function OE(n, e) {
  return {
    modelIdentifier: {
      modelId: e,
      revisionId: n.revisionId
    },
    ...n
  };
}
const RE = (n, e) => {
  const { data: t, isFetched: i } = _o(n, e), s = oe(), o = zt();
  return P(() => {
    if (t === null)
      return {
        fitCameraToSceneDefault: () => {
          s.fitCameraToModels(o, 0, !0);
        }
      };
    if (t === void 0 || !i)
      return;
    if (t.sceneConfiguration.cameraTranslationX === 0 && t.sceneConfiguration.cameraTranslationY === 0 && t.sceneConfiguration.cameraTranslationZ === 0 && t.sceneConfiguration.cameraEulerRotationX === 0 && t.sceneConfiguration.cameraEulerRotationY === 0 && t.sceneConfiguration.cameraEulerRotationZ === 0 && t.sceneConfiguration.cameraTargetX === void 0 && t.sceneConfiguration.cameraTargetY === void 0 && t.sceneConfiguration.cameraTargetZ === void 0)
      return {
        fitCameraToSceneDefault: () => {
          if (o.length === 0) {
            const d = new I(-100, 200, 400), l = new I();
            s.cameraManager.setCameraState({ position: d, target: l });
          } else
            s.fitCameraToModels(o, 0, !0);
        }
      };
    const a = new I(
      t.sceneConfiguration.cameraTranslationX,
      t.sceneConfiguration.cameraTranslationY,
      t.sceneConfiguration.cameraTranslationZ
    ), c = DE(t.sceneConfiguration);
    return a.applyMatrix4(G), c.applyMatrix4(G), {
      fitCameraToSceneDefault: () => {
        const d = s.cameraManager.getCameraState();
        if (d.target.x === 0 && d.target.y === 0 && d.target.z === 0)
          s.cameraManager.setCameraState({ position: a, target: c });
        else {
          const l = kE(a, c);
          s.cameraManager.setCameraState({ position: a, rotation: l });
        }
      }
    };
  }, [s, t, i, o]);
};
function DE(n) {
  if (n.cameraTargetX !== void 0 || n.cameraTargetY !== void 0 || n.cameraTargetZ !== void 0)
    return new I(n.cameraTargetX, n.cameraTargetY, n.cameraTargetZ);
  {
    const e = new kt().setFromEuler(
      new Zs(
        Rt.degToRad(n.cameraEulerRotationX),
        Rt.degToRad(n.cameraEulerRotationY),
        Rt.degToRad(n.cameraEulerRotationZ),
        "XYZ"
      )
    );
    return new I(
      n.cameraTranslationX,
      n.cameraTranslationY,
      n.cameraTranslationZ
    ).clone().add(new I(0, 0, -50).applyQuaternion(e));
  }
}
function kE(n, e) {
  const t = new I().subVectors(n, e).normalize(), i = new I(0, 1, 0), s = new I().crossVectors(i, t).normalize(), o = new I().crossVectors(t, s).normalize(), r = new fe();
  return r.makeBasis(s, o, t), new kt().setFromRotationMatrix(r);
}
const LE = ({
  sceneExternalId: n,
  sceneSpaceId: e
}) => {
  const { t } = W(), i = oe(), s = bf(), o = RE(n, e), r = Z(() => {
    if (i.get360ImageCollections() !== void 0 && i.exit360Image(), n !== void 0 && e !== void 0 && o !== void 0) {
      o.fitCameraToSceneDefault();
      return;
    }
    s.fitCameraToAllModels();
  }, [n, e, s, o, i]);
  return /* @__PURE__ */ u(ce, { content: t({ key: "RESET_CAMERA_TO_HOME" }), placement: "bottom", children: /* @__PURE__ */ u(
    J,
    {
      type: "ghost",
      icon: /* @__PURE__ */ u(yy, {}),
      "aria-label": "Reset camera to home",
      onClick: r
    }
  ) });
}, sr = 100, Hf = (n) => {
  const e = _e(n), t = P(() => new Xi(e), [e]);
  return j({
    queryKey: ["reveal-react-components", "cdf", "3d", "scenes"],
    queryFn: async () => {
      var c;
      const s = {
        scenes: [],
        sceneModels: [],
        scene360Collections: [],
        sceneGroundPlanes: [],
        sceneGroundPlaneEdges: [],
        sceneSkybox: []
      };
      let o = !0, r;
      for (; o; ) {
        const d = zE(sr, r), l = await t.queryNodesAndEdges(d);
        s.scenes.push(...l.items.scenes), s.sceneModels.push(...l.items.sceneModels), s.scene360Collections.push(...l.items.scene360Collections), s.sceneGroundPlanes.push(...l.items.sceneGroundPlanes), s.sceneGroundPlaneEdges.push(...l.items.sceneGroundPlaneEdges), s.sceneSkybox.push(...l.items.sceneSkybox), r = (c = l.nextCursor) == null ? void 0 : c.scenes, o = sr === l.items.scenes.length && r !== void 0;
      }
      const a = NE(s.scenes, s.sceneSkybox);
      return BE(s.sceneModels, a), FE(s.scene360Collections, a), VE(
        s.sceneGroundPlanes,
        s.sceneGroundPlaneEdges,
        a
      ), a;
    }
  });
};
function NE(n, e) {
  return n.reduce(
    (t, i) => {
      const { space: s, externalId: o } = i, r = Object.values(Object.values(i.properties)[0])[0];
      if (t[s] === void 0 && (t[s] = {}), t[s][o] === void 0) {
        let a;
        const c = r.skybox;
        if (c !== void 0) {
          const d = e.find(
            (l) => l.externalId === c.externalId && l.space === c.space
          );
          d !== void 0 && (a = Object.values(Object.values(d.properties)[0])[0]);
        }
        t[s][o] = {
          name: r.name,
          cameraTranslationX: r.cameraTranslationX,
          cameraTranslationY: r.cameraTranslationY,
          cameraTranslationZ: r.cameraTranslationZ,
          cameraEulerRotationX: r.cameraEulerRotationX,
          cameraEulerRotationY: r.cameraEulerRotationY,
          cameraEulerRotationZ: r.cameraEulerRotationZ,
          modelOptions: [],
          image360CollectionOptions: [],
          groundPlanes: [],
          skybox: a
        };
      }
      return t;
    },
    {}
  );
}
function BE(n, e) {
  n.forEach((t) => {
    var l, h;
    const { space: i, externalId: s } = t.startNode, o = Object.values(Object.values(t.properties)[0])[0], r = Jr(t.endNode.externalId), a = Number(o == null ? void 0 : o.revisionId);
    if (r === void 0 || isNaN(a) || ((l = e[i]) == null ? void 0 : l[s]) === void 0)
      return;
    const c = qf(o), d = {
      modelId: r,
      revisionId: a,
      transformation: c
    };
    (h = e[i]) == null || h[s].modelOptions.push(d);
  });
}
function FE(n, e) {
  n.forEach((t) => {
    var c, d;
    const { space: i, externalId: s } = t.startNode;
    if (((c = e[i]) == null ? void 0 : c[s]) === void 0)
      return;
    const o = Object.values(Object.values(t.properties)[0])[0], r = qf(o), a = {
      source: "dm",
      externalId: o.image360CollectionExternalId,
      space: o.image360CollectionSpace,
      transform: r
    };
    (d = e[i]) == null || d[s].image360CollectionOptions.push(a);
  });
}
function VE(n, e, t) {
  e.forEach((i) => {
    var l, h;
    const { space: s, externalId: o } = i.startNode, r = n.find(
      (p) => p.externalId === i.endNode.externalId && p.space === i.endNode.space
    );
    if (((l = t[s]) == null ? void 0 : l[o]) === void 0 || r === void 0)
      return;
    const a = Object.values(Object.values(i.properties)[0])[0], c = Object.values(Object.values(r.properties)[0])[0], d = {
      label: c.label,
      file: c.file,
      wrapping: c.wrapping,
      repeatU: c.repeatU ?? 1,
      repeatV: c.repeatV ?? 1,
      ...a
      // Transformation3d
    };
    (h = t[s]) == null || h[o].groundPlanes.push(d);
  });
}
function qf(n) {
  const e = new fe();
  e.makeRotationFromEuler(
    new Zs(
      Rt.degToRad(n.eulerRotationX),
      Rt.degToRad(n.eulerRotationY),
      Rt.degToRad(n.eulerRotationZ)
    )
  ), jE(n);
  const t = new fe().makeScale(
    n.scaleX,
    n.scaleY,
    n.scaleZ
  );
  e.multiply(t);
  const i = new fe().makeTranslation(
    n.translationX,
    n.translationY,
    n.translationZ
  );
  return e.premultiply(i), e.premultiply(G), e;
}
function jE(n) {
  return n.scaleX === 0 && (n.scaleX = 1), n.scaleY === 0 && (n.scaleY = 1), n.scaleZ === 0 && (n.scaleZ = 1), n;
}
function zE(n = sr, e) {
  return {
    with: {
      scenes: {
        nodes: {
          filter: {
            hasData: [
              {
                type: "view",
                space: "scene",
                externalId: "SceneConfiguration",
                version: "v1"
              }
            ]
          }
        },
        limit: n
      },
      sceneModels: {
        edges: {
          from: "scenes",
          maxDistance: 1,
          direction: "outwards",
          filter: {
            equals: {
              property: ["edge", "type"],
              value: {
                space: "scene",
                externalId: "SceneConfiguration.model3ds"
              }
            }
          }
        },
        limit: 1e4
      },
      scene360Collections: {
        edges: {
          from: "scenes",
          maxDistance: 1,
          direction: "outwards",
          filter: {
            equals: {
              property: ["edge", "type"],
              value: {
                space: "scene",
                externalId: "SceneConfiguration.images360Collections"
              }
            }
          }
        },
        limit: 1e4
      },
      sceneSkybox: {
        nodes: {
          from: "scenes",
          through: {
            view: {
              type: "view",
              space: "scene",
              externalId: "SceneConfiguration",
              version: "v1"
            },
            identifier: "skybox"
          },
          direction: "outwards"
        },
        limit: 1e4
      },
      sceneGroundPlaneEdges: {
        edges: {
          from: "scenes",
          maxDistance: 1,
          direction: "outwards",
          filter: {
            equals: {
              property: ["edge", "type"],
              value: {
                space: "scene",
                externalId: "SceneConfiguration.texturedGroundPlanes"
              }
            }
          }
        },
        limit: 1e4
      },
      sceneGroundPlanes: {
        nodes: {
          from: "sceneGroundPlaneEdges",
          chainTo: "destination"
        },
        limit: 1e4
      }
    },
    select: {
      scenes: {
        sources: Bf
      },
      sceneModels: {
        sources: Ff
      },
      scene360Collections: {
        sources: Vf
      },
      sceneSkybox: {
        sources: jf
      },
      sceneGroundPlaneEdges: {
        sources: xo
      },
      sceneGroundPlanes: {
        sources: Nf
      }
    },
    cursors: e !== void 0 ? { scenes: e } : void 0
  };
}
const UE = ({ selectedScene: n, onSceneChange: e }) => {
  const { data: t } = Hf();
  return Object.keys(t ?? {}).length === 0 ? /* @__PURE__ */ u(k, {}) : /* @__PURE__ */ u(k, { children: Object.keys(t ?? {}).map((i) => t === void 0 ? /* @__PURE__ */ u(k, {}) : Object.keys(t[i] ?? {}).map((s) => {
    const o = t[i][s].name;
    return /* @__PURE__ */ u(
      Ge.ItemToggled,
      {
        toggled: (n == null ? void 0 : n.externalId) === s && (n == null ? void 0 : n.space) === i,
        onClick: () => {
          e({ externalId: s, space: i, name: o });
        },
        children: t[i][s].name
      },
      `${i}-${s}`
    );
  })) });
}, GE = ({
  selectedScene: n,
  setSelectedScene: e,
  orientation: t = "none"
}) => {
  const { data: i } = Hf(), { t: s } = W(), [o, r] = M(), a = Z(
    (c) => {
      e(c), r(c == null ? void 0 : c.name);
    },
    [r]
  );
  return Object.keys(i ?? {}).length === 0 ? /* @__PURE__ */ u(k, {}) : /* @__PURE__ */ _(
    HE,
    {
      placement: "right-start",
      floatingProps: { middleware: [Ki(Dn)] },
      renderTrigger: (c) => /* @__PURE__ */ u(ce, { content: s({ key: "SCENE_SELECT_HEADER" }), children: /* @__PURE__ */ u(J, { icon: /* @__PURE__ */ u(vy, {}), "aria-label": "Select 3D location", type: "ghost", ...c, children: t === "horizontal" && o }) }),
      children: [
        t === "none" && /* @__PURE__ */ u(Ge.Section, { label: s({ key: "SCENE_SELECT_HEADER" }) }),
        /* @__PURE__ */ u(UE, { selectedScene: n, onSceneChange: a })
      ]
    }
  );
}, HE = b(Ge)`
  max-height: 400px;
  overflow: auto;
`, $f = async (n, e) => await (async () => (await n.relationships.list({
  filter: e,
  fetchResources: !0
}).autoPagingToArray({ limit: -1 })).filter(qE))(), qE = (n) => {
  const e = n;
  return !!e.source && !!e.target;
}, $E = async (n, e) => (await $f(n, e)).map((i) => ({
  ...i,
  relation: "Source"
})), WE = async (n, e) => (await $f(n, e)).map((i) => ({
  ...i,
  relation: "Target"
})), ea = async (n, e) => {
  const { resourceExternalIds: t, relationshipResourceTypes: i, ...s } = e, [o, r] = await Promise.all([
    $E(n, {
      targetExternalIds: t,
      sourceTypes: i,
      ...s
    }),
    WE(n, {
      sourceExternalIds: t,
      targetTypes: i,
      ...s
    })
  ]);
  return [...o, ...r];
}, Wf = async (n, e) => {
  const i = Q(e, lC).map(
    async (o) => await n.timeseries.retrieve(o, { ignoreUnknownIds: !0 })
  );
  return (await Promise.all(i)).flat();
}, KE = 100, Kf = async (n, e) => {
  const t = Q(e, KE);
  return (await St(
    t.map(
      (o) => async () => await n.datapoints.retrieveLatest(o)
    ),
    2
  )).filter(F).flat();
}, YE = 1e3;
function XE({
  timeseriesExternalIds: n,
  assetNodes: e
}) {
  const t = _e(), i = ["asset"];
  return j({
    queryKey: [
      ne.timeseriesLinkedToAssets(),
      n,
      i
    ],
    queryFn: async () => {
      const s = n.map((f) => ({
        externalId: f
      })), [o, r, a] = await Promise.all([
        ZE(t, n, i),
        Wf(t, s),
        Kf(t, s)
      ]), c = (r == null ? void 0 : r.map((f) => QE(
        e,
        f,
        o
      )).flat().filter(F)) ?? [], d = Ue(c, "externalId"), l = c.length > 0 ? await Ns(t, d) : [];
      return {
        assetIdsWithTimeseries: (r == null ? void 0 : r.map((f) => JE(
          l,
          f,
          o
        )).flat().filter(F)) ?? [],
        timeseriesDatapoints: a
      };
    },
    enabled: n.length > 0
  });
}
const ZE = async (n, e, t) => {
  const i = Q(e, YE), o = (await St(
    i.map(
      (a) => async () => await ea(n, {
        resourceExternalIds: a,
        relationshipResourceTypes: t
      })
    ),
    2
  )).filter(F).flat();
  return (o == null ? void 0 : o.map((a) => {
    const c = {
      assetIds: { externalId: "" },
      timeseriesIds: { externalId: "" }
    };
    return a.sourceType === "asset" ? c.assetIds.externalId = a.sourceExternalId : a.targetType === "asset" && (c.assetIds.externalId = a.targetExternalId), a.sourceType === "timeSeries" ? c.timeseriesIds.externalId = a.sourceExternalId : a.targetType === "timeSeries" && (c.timeseriesIds.externalId = a.targetExternalId), c;
  })) ?? [];
}, QE = (n, e, t) => {
  const i = n.find(
    (c) => c.id === e.assetId
  ), s = (i == null ? void 0 : i.externalId) !== void 0 ? {
    externalId: i.externalId
  } : void 0, o = t == null ? void 0 : t.filter(
    (c) => c.timeseriesIds.externalId === e.externalId && c.assetIds.externalId !== (s == null ? void 0 : s.externalId)
  ), r = o == null ? void 0 : o.map((c) => c.assetIds.externalId !== void 0 ? { externalId: c.assetIds.externalId } : void 0);
  return r == null ? void 0 : r.concat(s).filter(F);
}, JE = (n, e, t) => {
  const i = n == null ? void 0 : n.find((c) => c.id === e.assetId), s = i !== void 0 ? { externalId: i.externalId, id: i.id } : void 0, o = s !== void 0 ? {
    assetIds: s,
    timeseries: e
  } : void 0, r = t == null ? void 0 : t.filter(
    (c) => c.timeseriesIds.externalId === e.externalId && c.assetIds.externalId !== (i == null ? void 0 : i.externalId)
  ), a = (r == null ? void 0 : r.map((c) => ({
    assetIds: c.assetIds,
    timeseries: e
  }))) ?? [];
  return o !== void 0 && a.push(o), a;
}, eM = (n, e) => P(() => {
  const t = /* @__PURE__ */ new Map();
  return n.forEach((i) => {
    if (!(i instanceof Oi))
      return;
    const s = (e == null ? void 0 : e.filter((o) => o.model.modelId === i.modelId).map((o) => o.assetMappings).flat().filter(F)) ?? [];
    t.set(i, s);
  }), t;
}, [e, n]), tM = (n) => P(() => {
  const t = ((n == null ? void 0 : n.map((s) => s.assetMappings).flat()) ?? []).flatMap((s) => ({
    id: s.assetId
  })).filter((s) => F(s.id));
  return Ue(t, (s) => s.id);
}, [n]);
function nM(n) {
  return {
    ...n,
    metadata: Object.fromEntries(
      Object.entries(n.metadata ?? {}).map(
        ([e, t]) => [e.toLowerCase(), t]
      )
    )
  };
}
const iM = (n) => P(() => (n == null ? void 0 : n.filter(F).map(nM)) ?? [], [n]), sM = (n) => n.type === "metadata", oM = (n) => n.type === "fdm", rM = (n) => {
  const e = n.trigger;
  if (!sM(e) && !oM(e))
    return [e.externalId];
}, or = (n) => {
  const e = n == null ? void 0 : n.map((t) => {
    let i = [];
    switch (t.type) {
      case "or":
      case "and": {
        i = or(t.expressions);
        break;
      }
      case "not": {
        i = or([t.expression]);
        break;
      }
      case "numericExpression": {
        i = rM(t);
        break;
      }
    }
    return (i == null ? void 0 : i.filter(F)) ?? [];
  }).flat();
  return yn(e);
}, aM = (n) => P(() => {
  const e = n == null ? void 0 : n.rulesWithOutputs.map((t) => t.rule.expression).filter(F);
  return or(e) ?? [];
}, [n]), Uc = 4;
function cM(n) {
  const e = Te(), t = P(() => n.map((s) => X(s.connection.instance)), [n]), i = P(() => new Map(
    n.map((s) => [X(s.connection.instance), s])
  ), [n]);
  return j({
    queryKey: [
      "reveal-react-components",
      "get-all-3d-related-direct-connections",
      ...t.sort()
    ],
    queryFn: async () => {
      const s = "node", o = n.map((x) => ({
        externalId: x.connection.instance.externalId,
        space: x.connection.instance.space,
        instanceType: s
      })), r = n.flatMap((x) => x.views), a = Ue(r, (x) => x === void 0 ? "" : X(x)), d = Q(o, 1e3).flatMap((x) => a.map((T) => ({ chunk: x, view: T }))).flat().filter(F), l = await St(
        d.map((x) => async () => {
          const T = await e.getByExternalIds(
            x.chunk,
            x.view !== void 0 ? [x.view] : void 0
          );
          return {
            items: T.items,
            typing: T.typing
          };
        }),
        Uc
      ), h = l.filter(F).flat();
      if (l === void 0)
        return [];
      const p = h.flatMap((x) => x.items.map((T) => ({
        item: T,
        typing: x.typing
      }))), f = Q(p, 1e3), v = (await St(
        f.flatMap((x) => async () => await e.inspectInstances({
          inspectionOperations: { involvedViews: {} },
          items: x.map((T) => ({
            instanceType: T.item.instanceType,
            externalId: T.item.externalId,
            space: T.item.space
          }))
        })),
        Uc
      )).filter(F).flatMap(
        (x) => x.items.flatMap(
          (T) => h.flatMap((O) => ({
            items: O.items.filter(
              (E) => E.space === T.space && E.externalId === T.externalId
            ),
            typing: O.typing ?? {}
          }))
        )
      ).filter((x) => x.items.length > 0);
      return (v == null ? void 0 : v.flatMap((x) => {
        let T;
        return x.items.every((O) => {
          const S = X(O);
          return i.has(S) ? (T = i.get(S), !1) : !0;
        }), {
          ...T,
          ...x
        };
      })) ?? [];
    },
    enabled: n.length > 0
  });
}
const dM = ({
  contextualizedAssetNode: n,
  assetIdsAndTimeseries: e,
  timeseriesDatapoints: t
}) => {
  const i = e.filter(
    (r) => {
      var a;
      return ((a = r.assetIds) == null ? void 0 : a.externalId) === n.externalId;
    }
  ), s = t == null ? void 0 : t.filter(
    (r) => i == null ? void 0 : i.find(
      (a) => {
        var c;
        return ((c = a == null ? void 0 : a.timeseries) == null ? void 0 : c.externalId) === r.externalId;
      }
    )
  );
  return i.map((r) => {
    if (r.timeseries === void 0) return;
    const a = s == null ? void 0 : s.find(
      (d) => {
        var l;
        return d.externalId === ((l = r.timeseries) == null ? void 0 : l.externalId);
      }
    );
    return a === void 0 ? void 0 : {
      ...r.timeseries,
      ...a
    };
  }).filter(F);
};
function To(n, e) {
  if (n === void 0) return;
  const t = n[e.key.space], i = t == null ? void 0 : t[`${e.key.view.externalId}/${e.key.view.version}`];
  return i == null ? void 0 : i[e.key.property];
}
const lM = (n, e) => {
  const t = e.type === "booleanExpression" ? e.condition : void 0, i = e.type === "booleanExpression" ? e.trigger : void 0;
  let s = !1;
  if (t === void 0 || i === void 0) return;
  const o = n.find(
    (l) => l.type === (i == null ? void 0 : i.type)
  ), r = (i == null ? void 0 : i.type) === "fdm" && (o == null ? void 0 : o.type) === "fdm";
  if (r && o.instanceNode.items.length === 0) return;
  const a = r && o.instanceNode.items[0] !== void 0 ? o.instanceNode.items[0] : void 0, c = r ? a == null ? void 0 : a.properties : void 0, d = To(c, i);
  switch (t.type) {
    case "equals": {
      s = d === !0;
      break;
    }
    case "notEquals": {
      s = d === !1;
      break;
    }
  }
  return s;
}, uM = (n, e) => {
  const { trigger: t, condition: i } = e;
  let s = !1;
  const o = n.find(
    (l) => l.type === (t == null ? void 0 : t.type)
  ), r = (t == null ? void 0 : t.type) === "fdm" && (o == null ? void 0 : o.type) === "fdm";
  if (r && o.instanceNode.items.length === 0) return;
  const a = r && o.instanceNode.items[0] !== void 0 ? o.instanceNode.items[0] : void 0, c = r ? a == null ? void 0 : a.properties : void 0, d = new Date(
    To(c, t) ?? ""
  );
  switch (i.type) {
    case "before": {
      const l = new Date(i.parameter);
      s = d !== void 0 ? d < l : !1;
      break;
    }
    case "notBefore": {
      const l = new Date(i.parameter);
      s = d !== void 0 ? d >= l : !1;
      break;
    }
    case "onOrBefore": {
      const l = new Date(i.parameter);
      s = d !== void 0 ? d <= l : !1;
      break;
    }
    case "between": {
      const l = new Date(i.lowerBound), h = new Date(i.upperBound);
      s = d !== void 0 ? l < d && d < h : !1;
      break;
    }
    case "notBetween": {
      const l = new Date(i.lowerBound), h = new Date(i.upperBound);
      s = d !== void 0 ? !(l < d && d < h) : !1;
      break;
    }
    case "after": {
      const l = new Date(i.parameter);
      s = d !== void 0 ? d > l : !1;
      break;
    }
    case "notAfter": {
      const l = new Date(i.parameter);
      s = d !== void 0 ? d <= l : !1;
      break;
    }
    case "onOrAfter": {
      const l = new Date(i.parameter);
      s = d !== void 0 ? d >= l : !1;
      break;
    }
    case "on": {
      const l = new Date(i.parameter);
      s = d !== void 0 ? d === l : !1;
      break;
    }
    case "notOn": {
      const l = new Date(i.parameter);
      s = d !== void 0 ? d !== l : !1;
      break;
    }
  }
  return s;
}, hM = (n, e) => {
  var o;
  if (e.type !== "timeseries" || n.type !== "timeseries") return;
  const i = n.timeseries.timeseriesWithDatapoints.find((r) => r.externalId === e.externalId), s = (o = i == null ? void 0 : i.datapoints[(i == null ? void 0 : i.datapoints.length) - 1]) == null ? void 0 : o.value;
  return Number(s);
}, pM = (n, e) => {
  var i;
  const t = n.find(
    (s) => s.type === (e == null ? void 0 : e.type)
  );
  if (t !== void 0) {
    if (t.type === "metadata" && e.type === "metadata")
      return Number((i = t.asset[e.type]) == null ? void 0 : i[e.key]);
    if (t.type === "timeseries" && e.type === "timeseries")
      return hM(t, e);
  }
}, fM = (n, e) => {
  const { trigger: t, condition: i } = e;
  let s = !1, o;
  const r = n.find(
    (h) => h.type === (t == null ? void 0 : t.type)
  ), a = (t == null ? void 0 : t.type) === "fdm" && (r == null ? void 0 : r.type) === "fdm", c = a ? void 0 : pM(n, t), d = a && r.instanceNode.items[0] !== void 0 ? r.instanceNode.items[0] : void 0, l = a ? d == null ? void 0 : d.properties : void 0;
  if (!(c === void 0 && l === void 0) && (a ? o = To(l, t) : o = c, o !== void 0)) {
    switch (i.type) {
      case "equals": {
        const h = i.parameters[0];
        s = o === h;
        break;
      }
      case "notEquals": {
        const h = i.parameters[0];
        s = o !== h;
        break;
      }
      case "lessThan": {
        const h = i.parameters[0];
        s = o < h;
        break;
      }
      case "greaterThan": {
        const h = i.parameters[0];
        s = o > h;
        break;
      }
      case "lessThanOrEquals": {
        const h = i.parameters[0];
        s = o <= h;
        break;
      }
      case "greaterThanOrEquals": {
        const h = i.parameters[0];
        s = o >= h;
        break;
      }
      case "within": {
        const h = i.lowerBoundInclusive, p = i.upperBoundInclusive;
        s = h < o && o < p;
        break;
      }
      case "outside": {
        const h = i.lowerBoundExclusive, p = i.upperBoundExclusive;
        s = o <= h && p <= o;
        break;
      }
    }
    return s;
  }
}, gM = (n, e) => {
  var p;
  const { trigger: t, condition: i } = e;
  let s = !1, o;
  const r = n.find(
    (f) => f.type === (t == null ? void 0 : t.type)
  ), a = (t == null ? void 0 : t.type) === "metadata" && (r == null ? void 0 : r.type) === "metadata" && (r == null ? void 0 : r.asset) !== void 0, c = (t == null ? void 0 : t.type) === "fdm" && (r == null ? void 0 : r.type) === "fdm", d = a ? (p = r == null ? void 0 : r.asset[t.type]) == null ? void 0 : p[t.key] : void 0, l = c && r.instanceNode.items[0] !== void 0 ? r.instanceNode.items[0] : void 0, h = c ? l == null ? void 0 : l.properties : void 0;
  switch (a ? o = d : c && (o = To(h, t)), i.type) {
    case "equals": {
      s = o === i.parameter;
      break;
    }
    case "notEquals": {
      s = o !== i.parameter;
      break;
    }
    case "contains": {
      s = o == null ? void 0 : o.includes(i.parameter);
      break;
    }
    case "startsWith": {
      s = o == null ? void 0 : o.startsWith(i.parameter);
      break;
    }
    case "endsWith": {
      s = o == null ? void 0 : o.endsWith(i.parameter);
      break;
    }
  }
  return s;
}, Si = (n, e) => {
  let t = !1;
  const i = [];
  return e.forEach((s) => {
    switch (s.type) {
      case "or": {
        t = Si(n, s.expressions).find((r) => r) ?? !1;
        break;
      }
      case "and": {
        t = Si(n, s.expressions).every((r) => r === !0) ?? !1;
        break;
      }
      case "not": {
        const o = Si(n, [s.expression]);
        t = o[0] !== void 0 ? !o[0] : !1;
        break;
      }
      case "numericExpression": {
        t = fM(n, s);
        break;
      }
      case "stringExpression": {
        t = gM(n, s);
        break;
      }
      case "datetimeExpression": {
        t = uM(n, s);
        break;
      }
      case "booleanExpression": {
        t = lM(n, s);
        break;
      }
    }
    i.push(t);
  }), i;
};
function Yf(n) {
  return { renderGhosted: !1, visible: !0, ...n };
}
const mM = (n, e) => {
  const t = {
    styleIndex: new Ri()
  }, i = t.styleIndex.getIndexSet();
  i.clear();
  const s = [];
  for (const c of n) {
    const d = new Hi(c.treeIndex, c.subtreeSize);
    i.addRange(d), s.push(c.assetId);
  }
  t.styleIndex.updateSet(i);
  const o = Yf({
    color: new D(e.fill)
  }), r = {
    assetIds: s,
    style: { cad: o, pointcloud: o }
  };
  return {
    styleIndex: t.styleIndex,
    assetStylingGroup: r
  };
}, yM = async ({
  contextualizedAssetNodes: n,
  assetIdsAndTimeseries: e,
  timeseriesDatapoints: t,
  assetMappings: i,
  expression: s,
  outputSelected: o
}) => {
  const r = [];
  for (const c of n) {
    const d = [], l = {
      type: "metadata",
      asset: c
    };
    if (d.push(l), t !== void 0 && t.length > 0 && e !== void 0 && e.length > 0) {
      const p = dM({
        contextualizedAssetNode: c,
        assetIdsAndTimeseries: e,
        timeseriesDatapoints: t
      });
      if (p.length > 0) {
        const f = {
          type: "timeseries",
          timeseries: {
            timeseriesWithDatapoints: p,
            linkedAssets: c
          }
        };
        d.push(f);
      }
    }
    if (Si(d, [s])[0] ?? !1) {
      const p = i.filter(
        (f) => f.assetId === c.id
      );
      r.push(p);
    }
  }
  const a = r.flat();
  return mM(a, o);
}, vM = (n, e) => {
  var c, d;
  const t = {
    styleIndex: new Ri()
  }, i = Yf({
    color: new D(e.fill)
  }), s = [], o = t.styleIndex.getIndexSet();
  o.clear();
  for (const l of n) {
    if (l.cadNode === void 0) continue;
    const h = new Hi(l.cadNode.treeIndex, l.cadNode.subtreeSize);
    o.addRange(h), l.connection !== void 0 && s.push({
      space: (c = l.connection) == null ? void 0 : c.instance.space,
      externalId: (d = l.connection) == null ? void 0 : d.instance.externalId
    });
  }
  t.styleIndex.updateSet(o);
  const r = {
    fdmAssetExternalIds: s,
    style: { cad: i, pointcloud: i }
  };
  return {
    styleIndex: t.styleIndex,
    fdmStylingGroup: r
  };
}, CM = async ({
  fdmMappings: n,
  expression: e,
  outputSelected: t
}) => {
  const s = (await Promise.all(
    n.map(async (o) => {
      const r = [], a = {
        type: "fdm",
        instanceNode: o
      };
      if (r.push(a), Si(r, [e])[0] ?? !1)
        return o;
    })
  )).flat().filter(F);
  return vM(s, t);
}, IM = (n, e) => {
  const t = n.find((s) => s.type === e);
  return (t == null ? void 0 : t.type) !== "color" ? void 0 : {
    externalId: t.externalId,
    type: "color",
    fill: t.fill,
    outline: t.outline
  };
};
function rr(n, e) {
  switch (e(n), n.type) {
    case "or":
    case "and": {
      n.expressions.forEach((t) => {
        rr(t, e);
      });
      return;
    }
    case "not": {
      rr(n.expression, e);
      return;
    }
    case "numericExpression":
    case "stringExpression":
    case "datetimeExpression":
    case "booleanExpression":
      return;
    default:
      sn(n);
  }
}
const wM = (n) => {
  n.type !== "stringExpression" || n.type === "stringExpression" && n.trigger.type === "fdm" || (n.trigger.key = n.trigger.type === "metadata" ? n.trigger.key.toLowerCase() : n.trigger.key);
}, xM = async ({
  contextualizedAssetNodes: n,
  assetMappings: e,
  fdmMappings: t,
  ruleSet: i,
  assetIdsAndTimeseries: s,
  timeseriesDatapoints: o
}) => {
  const r = "color", a = i == null ? void 0 : i.rulesWithOutputs;
  return (await Promise.all(
    a == null ? void 0 : a.map(async (c) => {
      const { rule: d, outputs: l } = c, h = d.expression;
      if (h === void 0) return;
      rr(h, wM);
      const p = IM(
        l,
        r
      );
      if (p === void 0) return;
      const f = await yM({
        contextualizedAssetNodes: n,
        assetIdsAndTimeseries: s,
        timeseriesDatapoints: o,
        assetMappings: e,
        expression: h,
        outputSelected: p
      }), g = await CM({
        fdmMappings: t,
        expression: h,
        outputSelected: p
      });
      return {
        assetMappingsStylingGroupAndIndex: f,
        fdmStylingGroupAndStyleIndex: g
      };
    })
  )).filter(F);
}, zo = /* @__PURE__ */ new Map();
function _M({
  ruleSet: n,
  onRuleSetChanged: e,
  onAllMappingsFetched: t
}) {
  if (n === void 0) return;
  const i = zt(), [s, o] = M(), r = i.filter((L) => L instanceof Oi).map((L) => ({ type: "cad", modelId: L.modelId, revisionId: L.revisionId })), { data: a, isLoading: c } = ui(r), d = tM(a), {
    data: l,
    isLoading: h,
    isFetched: p
  } = Vp(d), { data: f, isLoading: g } = _f(r, !0), C = P(() => f !== void 0 ? Array.from(f.values()).flat() : [], [f]), { data: v, isLoading: w } = cM(C), x = !c && !h && !g && !w;
  R(() => {
    p && o(l);
  }, [l, p]), R(() => {
    t(x);
  }, [x]);
  const T = iM(s), O = aM(n), { isLoading: S, data: E } = XE({
    timeseriesExternalIds: O,
    assetNodes: T
  }), B = eM(i, a);
  return R(() => {
    if (a === void 0 && v === void 0 || i === void 0 || O.length > 0 && S || n === void 0 || !x) return;
    const L = async () => {
      const N = (await Promise.all(
        i.map(async (ee) => {
          if (!(ee instanceof Oi))
            return;
          const ie = B.get(ee) ?? [];
          return ie.length === 0 && (v == null ? void 0 : v.length) === 0 ? [] : await TM({
            assetMappings: ie,
            fdmMappings: v ?? [],
            contextualizedAssetNodes: T,
            ruleSet: n,
            assetIdsAndTimeseries: (E == null ? void 0 : E.assetIdsWithTimeseries) ?? [],
            timeseriesDatapoints: (E == null ? void 0 : E.timeseriesDatapoints) ?? []
          });
        })
      )).flat().filter(F).flat();
      zo.set(n.id, N), e !== void 0 && e(N);
    };
    zo.has(n.id) ? (t(!0), e !== void 0 && e(zo.get(n.id))) : L();
  }, [
    n,
    a,
    v,
    T,
    E,
    i
  ]), /* @__PURE__ */ u(k, {});
}
async function TM({
  assetMappings: n,
  fdmMappings: e,
  contextualizedAssetNodes: t,
  ruleSet: i,
  assetIdsAndTimeseries: s,
  timeseriesDatapoints: o
}) {
  return await xM({
    contextualizedAssetNodes: t,
    assetMappings: n,
    fdmMappings: e,
    ruleSet: i,
    assetIdsAndTimeseries: s,
    timeseriesDatapoints: o
  });
}
const re = {
  type: "view",
  version: "1",
  externalId: "FdmRuleOutputSet",
  space: "rule_based_outputs_space"
}, SM = () => {
  const n = Te();
  return j({
    queryKey: ["react-components", "color-overlay-rules", "all"],
    queryFn: async () => {
      if (!await hi(n, [re]))
        return [];
      const t = `${re.externalId}/${re.version}`, i = {
        in: {
          property: [re.space, t, "shamefulOutputTypes"],
          values: ["color"]
        }
      }, s = await n.filterAllInstances(
        i,
        "node",
        re
      ), o = [];
      return s.instances.forEach((r) => {
        o.push({
          isEnabled: !1,
          rule: r
        });
      }), o;
    }
  });
}, Gc = ({
  onChange: n,
  label: e,
  key: t,
  id: i,
  checked: s,
  isLoading: o,
  isEmptyRuleItem: r
}) => /* @__PURE__ */ u(
  Ge.ItemToggled,
  {
    onClick: () => {
      n(i);
    },
    label: e,
    toggled: s,
    trailingContent: /* @__PURE__ */ _(bM, { justifyContent: "space-between", alignItems: "center", gap: 8, children: [
      !r && o && s === !0 && /* @__PURE__ */ u(Wi, {}),
      /* @__PURE__ */ u(AM, { gap: 4, alignItems: "center", children: /* @__PURE__ */ u(_d, {}) })
    ] })
  },
  t
), bM = b(U)`
  min-height: 24px;
`, AM = b(U)`
  padding-right: 4px;
`, EM = (n) => ({
  rule: {
    properties: {
      id: void 0,
      name: n,
      isNoSelection: !0
    }
  },
  isEnabled: !1
}), MM = (n, e) => e == null ? void 0 : e.find((t) => t.rule.properties.id === n), Xf = ({
  onRuleSetStylingChanged: n,
  onRuleSetSelectedChanged: e
}) => {
  const { t } = W(), s = zt().filter((N) => N.type === "cad"), [o, r] = M(), [a, c] = M(), [d, l] = M(), [h, p] = M(), [f, g] = M(!1), { isLoading: C, isFetched: v } = ui(s), [w, x] = M(), T = Hy(), [O, S] = M(!1), { data: E } = SM(), B = C && !v;
  R(() => {
    p(E);
  }, [E]), R(() => {
    r(w), e !== void 0 && e(w), g(w !== void 0);
  }, [w]), R(() => {
    const N = d !== void 0 && d.length > 0 && T || !O;
    g(N);
  }, [O, d, T, w]);
  const L = Z(
    (N) => {
      const ee = EM(t({ key: "RULESET_NO_SELECTION" }));
      h == null || h.forEach((ue) => {
        ue !== void 0 && (ue.isEnabled = !1);
      });
      const ie = MM(N, h);
      ie !== void 0 ? ie.isEnabled = !0 : (ee.isEnabled = !0, n !== void 0 && n(void 0)), c(ee), x(ie);
    },
    [h, a, n, e]
  ), le = (N) => {
    l(N);
    const ee = N == null ? void 0 : N.map(
      (Ze) => Ze.assetMappingsStylingGroupAndIndex.assetStylingGroup
    ), ie = N == null ? void 0 : N.map(
      (Ze) => Ze.fdmStylingGroupAndStyleIndex.fdmStylingGroup
    );
    n !== void 0 && n({
      assetStylingGroup: ee ?? [],
      fdmStylingGroup: ie ?? []
    });
  };
  return h === void 0 || h.length === 0 ? /* @__PURE__ */ u(k, {}) : /* @__PURE__ */ _(
    Ge,
    {
      placement: "right-start",
      style: {
        maxHeight: 300,
        overflow: "auto",
        marginBottom: "20px"
      },
      floatingProps: { middleware: [Ki(Dn)] },
      disableCloseOnClickInside: !0,
      renderTrigger: (N) => /* @__PURE__ */ u(ce, { content: t({ key: "RULESET_SELECT_HEADER" }), placement: "right", children: /* @__PURE__ */ u(
        J,
        {
          icon: /* @__PURE__ */ u(_d, {}),
          disabled: B,
          "aria-label": "Select RuleSet",
          type: "ghost",
          ...N
        }
      ) }),
      children: [
        /* @__PURE__ */ u(Ge.Section, { label: t({ key: "RULESET_SELECT_HEADER" }) }),
        /* @__PURE__ */ u(
          Gc,
          {
            id: "no-rule-selected",
            label: t({ key: "RULESET_NO_SELECTION" }),
            checked: o === void 0 || (a == null ? void 0 : a.isEnabled),
            onChange: L,
            isLoading: f,
            isEmptyRuleItem: !0
          },
          "no-rule-selected"
        ),
        h == null ? void 0 : h.map((N) => {
          var ee, ie, ue;
          return /* @__PURE__ */ u(
            Gc,
            {
              id: (ee = N == null ? void 0 : N.rule) == null ? void 0 : ee.properties.id,
              label: (ie = N == null ? void 0 : N.rule) == null ? void 0 : ie.properties.name,
              checked: N == null ? void 0 : N.isEnabled,
              onChange: L,
              isLoading: f,
              isEmptyRuleItem: !1
            },
            (ue = N == null ? void 0 : N.rule) == null ? void 0 : ue.properties.id
          );
        }),
        h !== void 0 && (h == null ? void 0 : h.length) > 0 && /* @__PURE__ */ u(
          _M,
          {
            onRuleSetChanged: le,
            onAllMappingsFetched: S,
            ruleSet: o == null ? void 0 : o.rule.properties
          }
        )
      ]
    }
  );
}, Hc = {
  true: {
    key: "CONTEXTUALIZED_ASSETS_LOADING_TOOLTIP"
  },
  false: {
    key: "CONTEXTUALIZED_ASSETS_TOOLTIP"
  }
}, PM = ({
  setEnableMappedStyling: n
}) => {
  const { t: e } = W(), i = zt().filter((h) => h.type === "cad"), [s, o] = M(!1), { isLoading: r, isFetched: a } = ui(i), c = r && !a, d = c ? Hc.true : Hc.false, l = Z(() => {
    o((h) => !h), n(!s);
  }, [s, n]);
  return /* @__PURE__ */ u(ce, { content: e(d), placement: "right", children: /* @__PURE__ */ u(
    J,
    {
      type: "ghost",
      icon: /* @__PURE__ */ u(Cy, {}),
      toggled: s,
      "aria-label": "asset-labels-button",
      onClick: l,
      disabled: c
    }
  ) });
};
class ta {
  constructor(e, t) {
    this.model = e, this.name = t;
  }
  isSame(e) {
    return e.model === this.model;
  }
}
class OM extends ta {
  constructor(e, t) {
    super(e, t ?? `cad-${e.modelId}-${e.revisionId}`), this._cadModel = e;
  }
  key() {
    return `cad-${this._cadModel.modelId}-${this._cadModel.revisionId}`;
  }
  visible() {
    return this._cadModel.visible;
  }
  setVisibility(e) {
    this._cadModel.visible = e;
  }
  getRevisionId() {
    return this._cadModel.revisionId;
  }
}
class RM extends ta {
  constructor(e, t) {
    super(
      e,
      t ?? `pointcloud-${e.modelId}-${e.revisionId}`
    ), this._pointCloudModel = e;
  }
  key() {
    return `pointcloud-${this._pointCloudModel.modelId}-${this._pointCloudModel.revisionId}`;
  }
  visible() {
    return this._pointCloudModel.visible;
  }
  setVisibility(e) {
    this._pointCloudModel.visible = e;
  }
  getRevisionId() {
    return this._pointCloudModel.revisionId;
  }
}
class DM extends ta {
  constructor(e, t, i) {
    super(e, e.label ?? e.id), this._image360Collection = e, this._isCurrentlyEntered = t, this._exit360Image = i;
  }
  key() {
    return `image360-${this._image360Collection.id}`;
  }
  visible() {
    return this._image360Collection.getIconsVisibility();
  }
  setVisibility(e) {
    !e && this._isCurrentlyEntered(this._image360Collection) && this._exit360Image(), this._image360Collection.setIconsVisibility(e);
  }
  getSiteId() {
    return this._image360Collection.id;
  }
}
const kM = (n, e, t, i, s) => {
  const o = P(
    () => t.get360ImageCollections(),
    [t, t.get360ImageCollections().length]
  ), r = P(() => i.map((h) => h.modelId), [i]), a = s(r), [c, d] = M(
    Uo(i, a.data, o, t)
  );
  R(() => {
    const h = Uo(i, a.data, o, t);
    NM(h, c, e), d(h);
  }, [i, a.data, o, t]);
  const l = Z(
    (h, p) => {
      const f = Uo(h, a.data, p, t);
      d(f);
      const g = LM(f);
      n == null || n(g), t.requestRedraw();
    },
    [n, i, a.data, t]
  );
  return [
    c,
    () => {
      l(i, t.get360ImageCollections());
    }
  ];
};
function Uo(n, e, t, i) {
  const s = (r) => {
    var a;
    return ((a = i.getActive360ImageInfo()) == null ? void 0 : a.image360Collection) === r;
  }, o = () => {
    i.exit360Image();
  };
  return {
    cadHandlers: n.map((r, a) => [a, r]).filter(
      (r) => r[1].type === "cad"
    ).map(
      (r) => new OM(r[1], e == null ? void 0 : e[r[0]])
    ),
    pointCloudHandlers: n.map((r, a) => [a, r]).filter(
      (r) => r[1].type === "pointcloud"
    ).map(
      (r) => new RM(r[1], e == null ? void 0 : e[r[0]])
    ),
    image360Handlers: t.map(
      (r) => new DM(r, s, o)
    )
  };
}
function LM(n) {
  return {
    cadLayers: n.cadHandlers.map((e, t) => ({
      applied: e.visible(),
      revisionId: e.getRevisionId(),
      index: t
    })),
    pointCloudLayers: n.pointCloudHandlers.map((e, t) => ({
      applied: e.visible(),
      revisionId: e.getRevisionId(),
      index: t
    })),
    image360Layers: n.image360Handlers.map((e, t) => ({
      applied: e.visible(),
      siteId: e.getSiteId(),
      index: t
    }))
  };
}
function NM(n, e, t) {
  const i = n.cadHandlers.length > 0, s = n.pointCloudHandlers.length > 0;
  n.cadHandlers.forEach((o) => {
    e.cadHandlers.some((r) => r.isSame(o)) || o.setVisibility((t == null ? void 0 : t.cad) ?? !0);
  }), n.pointCloudHandlers.forEach((o) => {
    e.pointCloudHandlers.some((r) => r.isSame(o)) || o.setVisibility(i ? (t == null ? void 0 : t.pointcloud) ?? !0 : !0);
  }), n.image360Handlers.forEach((o) => {
    e.image360Handlers.some((r) => r.isSame(o)) || (!i && !s ? o.setVisibility(!0) : o.setVisibility((t == null ? void 0 : t.image360) ?? !0));
  });
}
function BM(n, e) {
  const t = {
    cadLayers: n.cadHandlers.map((i, s) => ({
      revisionId: i.getRevisionId(),
      applied: i.visible(),
      index: s
    })),
    pointCloudLayers: n.pointCloudHandlers.map((i, s) => ({
      revisionId: i.getRevisionId(),
      applied: i.visible(),
      index: s
    })),
    image360Layers: n.image360Handlers.map((i) => ({
      applied: i.visible(),
      siteId: i.getSiteId()
    }))
  };
  e == null || e(t);
}
function FM(n, e) {
  var o, r, a;
  if (n === void 0)
    return;
  const t = e.models.filter((c) => c.type === "cad"), i = e.models.filter(
    (c) => c.type === "pointcloud"
  ), s = e.get360ImageCollections();
  (o = n.cadLayers) == null || o.forEach((c) => {
    c.index < t.length && t[c.index].revisionId === c.revisionId && (t[c.index].visible = c.applied);
  }), (r = n.pointCloudLayers) == null || r.forEach((c) => {
    c.index < i.length && i[c.index].revisionId === c.revisionId && (i[c.index].visible = c.applied);
  }), (a = n.image360Layers) == null || a.forEach((c) => {
    var d;
    (d = s.find((l) => l.id === c.siteId)) == null || d.setIconsVisibility(c.applied);
  });
}
const VM = (n, e, t, i) => {
  const s = ve(e), o = ve(n), r = oe();
  R(() => {
    jM(n, e) || (o.current === n || s.current !== e ? (FM(e, r), i(r.models, r.get360ImageCollections())) : BM(n, t), s.current = e, o.current = n);
  }, [e, n]);
};
function jM(n, e) {
  var o, r, a, c, d, l;
  if (e === void 0)
    return n.cadHandlers.length === 0 && n.pointCloudHandlers.length === 0 && n.image360Handlers.length === 0;
  const t = ((o = e.cadLayers) == null ? void 0 : o.length) === n.cadHandlers.length && (((r = e.cadLayers) == null ? void 0 : r.every(
    (h, p) => n.cadHandlers[p].getRevisionId() === h.revisionId && n.cadHandlers[p].visible() === h.applied
  )) ?? !1), i = ((a = e.pointCloudLayers) == null ? void 0 : a.length) === n.pointCloudHandlers.length && (((c = e.pointCloudLayers) == null ? void 0 : c.every(
    (h, p) => n.pointCloudHandlers[p].getRevisionId() === h.revisionId && n.pointCloudHandlers[p].visible() === h.applied
  )) ?? !1), s = ((d = e.image360Layers) == null ? void 0 : d.length) === n.image360Handlers.length && (((l = e.image360Layers) == null ? void 0 : l.every(
    (h) => {
      var p;
      return ((p = n.image360Handlers.find((f) => f.getSiteId() === h.siteId)) == null ? void 0 : p.visible()) === h.applied;
    }
  )) ?? !1);
  return t && i && s;
}
const Zf = ({
  label: n,
  trailingContent: e,
  modelLayerHandlers: t,
  update: i,
  disabled: s
}) => {
  const o = t.some((r) => r.visible());
  return /* @__PURE__ */ u(
    $.Item,
    {
      variant: "checkbox",
      label: n,
      checked: o,
      disabled: s,
      onClick: () => {
        t.forEach((r) => {
          r.setVisibility(!o);
        }), i();
      },
      trailingContent: /* @__PURE__ */ _(k, { children: [
        /* @__PURE__ */ u(cd, { counter: t.length }),
        e
      ] }),
      size: "medium"
    }
  );
}, zM = ({
  modelLayerHandlers: n,
  update: e,
  label: t,
  disabled: i
}) => i === !0 ? /* @__PURE__ */ u(k, {}) : /* @__PURE__ */ _(k, { children: [
  t !== void 0 && /* @__PURE__ */ u($.Section, { children: /* @__PURE__ */ u(
    Zf,
    {
      label: t,
      modelLayerHandlers: n,
      update: e
    }
  ) }),
  /* @__PURE__ */ u($.Section, { children: n.map((s) => /* @__PURE__ */ u(
    $.Item,
    {
      label: s.name,
      variant: "checkbox",
      checked: s.visible(),
      onClick: () => {
        s.setVisibility(!s.visible()), e();
      }
    },
    s.key()
  )) })
] }), UM = ({
  label: n,
  modelLayerHandlers: e,
  update: t
}) => {
  const i = e.length === 0, s = Z(() => {
    t();
  }, [t]);
  return /* @__PURE__ */ _($, { placement: "right", hideOnOutsideClick: !0, openOnHover: !i, children: [
    /* @__PURE__ */ u($.Trigger, { children: /* @__PURE__ */ u(
      Zf,
      {
        label: n,
        modelLayerHandlers: e,
        update: s,
        trailingContent: /* @__PURE__ */ u(Iy, { size: 16, children: /* @__PURE__ */ u(wy, {}) }),
        disabled: i
      }
    ) }),
    /* @__PURE__ */ u($.Body, { children: /* @__PURE__ */ u(
      zM,
      {
        modelLayerHandlers: e,
        update: s,
        disabled: i
      }
    ) })
  ] });
}, GM = {
  useModelHandlers: kM,
  useSyncExternalLayersState: VM,
  ModelLayerSelection: UM,
  useReveal: oe,
  use3dModels: zt
}, HM = Ye(
  GM
), qM = (n) => {
  const e = _e();
  return j({
    queryKey: ["cdf", "3d", "model", n],
    queryFn: async () => {
      const s = await Promise.allSettled(
        n.map(async (r) => (await e.models3D.retrieve(r)).name)
      ), o = [];
      return s.forEach((r) => {
        r.status === "fulfilled" ? o.push(r.value) : r.status === "rejected" && (console.error("Error while retriving Model Name", r.reason), o.push(void 0));
      }), o;
    },
    staleTime: 1 / 0
  });
}, oR = ({
  externalId: n,
  space: e
}) => {
  const t = oe(), i = ls();
  return j({
    queryKey: ["reveal", "react-components", "3dNodeByExternalId", n, e],
    queryFn: async () => {
      var a;
      if (n === void 0 || e === void 0) {
        await Promise.reject(
          new Error("No externalId and space provided to use3dNodeByExternalId hook")
        );
        return;
      }
      const s = t.models.map((c) => ({
        modelId: c.modelId,
        revisionId: c.revisionId
      })), o = (await i.getMappingsForFdmInstances([{ externalId: n, space: e }], s)).find((c) => c.mappings.size > 0), r = (a = o == null ? void 0 : o.mappings.get(n)) == null ? void 0 : a[0];
      if (r === void 0) {
        await Promise.reject(
          new Error(`Could not find a connected model to instance ${n} in space ${e}`)
        );
        return;
      }
      return r;
    }
  });
};
function rR(n) {
  const e = Te(), t = li();
  return j({
    queryKey: [
      "reveal-react-components",
      "get-3d-related-direct-connections",
      n == null ? void 0 : n.externalId,
      n == null ? void 0 : n.space
    ],
    queryFn: async () => {
      We(n !== void 0);
      const s = (await e.inspectInstances({
        inspectionOperations: { involvedViews: {} },
        items: [{ instanceType: "node", externalId: n.externalId, space: n.space }]
      })).items[0].inspectionResults.involvedViews[0], o = (await e.getByExternalIds(
        [{ instanceType: "node", externalId: n.externalId, space: n.space }],
        s !== void 0 ? [s] : void 0
      )).items[0], r = Object.values(o.properties).flatMap(
        (g) => Object.values(g).flatMap(
          (C) => Object.values(C).filter(
            (v) => v.externalId !== void 0 && v.space !== void 0
          )
        )
      );
      if (r.length === 0)
        return [];
      const d = (await e.inspectInstances({
        inspectionOperations: { involvedViews: {} },
        items: r.map((g) => ({
          externalId: g.externalId,
          space: g.space,
          instanceType: "node"
        }))
      })).items.map(
        (g) => g.inspectionResults.involvedViews
      ).map((g, C) => g.map((v) => [C, v])).flat(), [l, h] = $M(
        d
      ), p = await e.getViewsByIds(l);
      return d.filter(([g, C]) => {
        const v = h.get(Qf(C));
        We(v !== void 0);
        const w = p.items[v];
        return t.is3dView(w);
      }).map(([g, C]) => ({
        ...r[g],
        view: C
      }));
    },
    enabled: n !== void 0
  });
}
function Qf(n) {
  return `${n.externalId}/${n.space}/${n.version}`;
}
function $M(n) {
  const e = [], t = /* @__PURE__ */ new Map();
  return n.forEach(([i, s]) => {
    const o = Qf(s);
    t.get(o) === void 0 && (t.set(o, e.length), e.push(s));
  }), [e, t];
}
function aR(n) {
  const e = Te(), t = li();
  return j({
    queryKey: [
      "reveal-react-components",
      "get-3d-related-edge-connections",
      n == null ? void 0 : n.externalId,
      n == null ? void 0 : n.space
    ],
    queryFn: async () => {
      if (n === void 0)
        return [];
      const i = await t.getEdgeConnected3dInstances(n);
      if (i.length === 0)
        return [];
      const s = await e.inspectInstances({
        inspectionOperations: { involvedViews: {} },
        items: i.map((o) => ({
          externalId: o.externalId,
          space: o.space,
          instanceType: "node"
        }))
      });
      return Ng(i, s.items, (o, r) => ({
        ...o,
        view: r.inspectionResults.involvedViews[0]
      }));
    },
    enabled: n !== void 0
  });
}
async function WM(n, e) {
  return (await e.get(
    `api/v1/projects/${e.project}/3d/mappings/${n}/modelnodes`,
    {
      params: { limit: 1e3 }
    }
  )).data.items.map(({ modelId: i, revisionId: s }) => ({
    type: "cad",
    addOptions: { modelId: i, revisionId: s }
  }));
}
async function KM(n, e) {
  const i = (await e.annotations.reverseLookup({
    filter: { annotatedResourceType: "threedmodel", data: { assetRef: { id: n } } },
    limit: 1e3
  }).autoPagingToArray({ limit: 1 / 0 })).reduce((r, a) => (a.id === void 0 || r.push(a.id), r), []), s = Q(i, 4), o = [];
  for (const r of s) {
    const a = await Promise.all(
      r.map(
        async (c) => await e.revisions3D.list(c, { limit: 1 }).autoPagingToArray({ limit: 1 })
      )
    );
    o.push(...a.flat());
  }
  return o.map((r, a) => ({
    type: "pointcloud",
    addOptions: {
      modelId: i[a],
      revisionId: r.id
      // Always choose the newest revision
    }
  }));
}
async function YM(n, e) {
  const i = (await e.annotations.reverseLookup({
    filter: { annotatedResourceType: "file", data: { assetRef: { id: n } } },
    limit: 1e3
  })).items.filter(XM);
  if (i.length === 0)
    return [];
  const s = await e.files.retrieve(i, { ignoreUnknownIds: !0 });
  return yn(s.map((r) => {
    var a;
    return (a = r == null ? void 0 : r.metadata) == null ? void 0 : a.site_id;
  })).filter(F).map((r) => ({
    type: "image360",
    addOptions: { source: "events", siteId: r }
  }));
}
function XM(n) {
  return n.externalId !== void 0 || n.id !== void 0;
}
function Jf(n) {
  const { type: e, addOptions: t } = n;
  switch (e) {
    case "cad":
      return `${e}-${t.modelId}-${t.revisionId}`;
    case "pointcloud":
      if (Ee(t))
        return `${e}-${t.modelId}-${t.revisionId}`;
      if (Tt(t))
        return `${e}-${t.revisionExternalId}-${t.revisionSpace}`;
      break;
    case "image360":
      if (Ar(t))
        return `${e}-${t.externalId}/${t.space}`;
      if (Kn(t))
        return `${e}-${t.siteId}`;
      break;
    default:
      throw new Error("Unrecognized add option type");
  }
  throw new Error("Unrecognized add option type");
}
const ZM = {
  with: {
    asset: {
      nodes: {
        filter: {
          and: [
            {
              equals: {
                property: ["node", "externalId"],
                value: { parameter: "instanceExternalId" }
              }
            },
            {
              equals: {
                property: ["node", "space"],
                value: { parameter: "instanceSpace" }
              }
            }
          ]
        }
      }
    },
    object_3ds: {
      nodes: {
        from: "asset",
        through: {
          view: st,
          identifier: "object3D"
        },
        direction: "outwards"
      }
    },
    pointcloud_volumes: {
      nodes: {
        from: "object_3ds",
        through: { view: Ke, identifier: "object3D" }
      }
    }
  },
  select: {
    pointcloud_volumes: {
      sources: [
        {
          source: Ke,
          properties: ["revisions"]
        }
      ]
    }
  }
}, QM = async (n, e) => {
  const t = {
    instanceExternalId: n.externalId,
    instanceSpace: n.space
  }, i = {
    ...ZM,
    parameters: t
  };
  return (await e.queryAllNodesAndEdges(i)).items.pointcloud_volumes.flatMap((o) => o.properties.cdf_cdm["CognitePointCloudVolume/v1"].revisions.map((a) => ({
    type: "pointcloud",
    addOptions: {
      revisionExternalId: a.externalId,
      revisionSpace: a.space
    }
  })));
}, cR = (n) => {
  const e = _e(), t = li(), i = Te();
  return j({
    queryKey: ["reveal", "react-components", "models-for-instance", n],
    queryFn: async () => {
      if (n !== void 0) {
        if (Xt(n))
          return await JM(n, e);
        if (_t(n))
          return await eP(n, i, t);
        throw Error(
          `Can not fetch models for instance: ${JSON.stringify(n)}. InternalId or DMS ID required`
        );
      }
    },
    enabled: n !== void 0
  });
};
async function JM(n, e) {
  const t = WM(n.id, e), i = KM(n.id, e), s = YM(n.id, e), o = (await Promise.all([t, i, s])).flat();
  return Ue(o, Jf);
}
async function eP(n, e, t) {
  const i = t.getCadModelsForInstance(n), s = QM(n, e), o = (await Promise.all([i, s])).flat();
  return Ue(o, Jf);
}
function tP(n) {
  return _t(n);
}
function eg(n) {
  const e = n.id;
  return e !== void 0 && typeof e == "number";
}
function nP(n, e) {
  var t, i;
  if (eg(n)) {
    const s = n.name.toLowerCase().includes(e.toLowerCase()), o = (t = n.description) == null ? void 0 : t.toLowerCase().includes(e.toLowerCase());
    return s || o === !0;
  } else {
    const s = n.properties.name.toLowerCase().includes(e.toLowerCase()), o = (i = n.properties.description) == null ? void 0 : i.toLowerCase().includes(e.toLowerCase());
    return s || o;
  }
}
function qc(n) {
  return typeof n == "number";
}
function $c(n) {
  return n.externalId !== void 0 && n.space !== void 0;
}
function tg(n) {
  return n.annotatedResourceType !== void 0 && n.annotatedResourceId !== void 0;
}
function ng(n) {
  const e = n;
  return e.text !== void 0 && e.textRegion !== void 0 && e.assetRef !== void 0;
}
function iP(n) {
  return n.annotationIdentifier !== void 0;
}
function dR(n) {
  if (!tg(n))
    return n.assetRef;
  if (ng(n.data))
    return Nt(n.data.assetRef) ? n.data.assetRef : void 0;
}
function lR(n) {
  if (tg(n))
    return n.id;
  if (iP(n))
    return {
      externalId: n.annotationIdentifier.externalId,
      space: n.annotationIdentifier.space
    };
  sn(n);
}
function uR(n, e) {
  return $c(n) && $c(e) && sP(n, e) || qc(n) && qc(e) && n === e;
}
function sP(n, e) {
  return Jh(n, e);
}
function oP(n) {
  return n === "" ? void 0 : {
    or: [
      { search: { property: ["name"], value: n } },
      { search: { property: ["description"], value: n } }
    ]
  };
}
function rP(n) {
  if (n.length === 0)
    return;
  const [e, t] = Kt(n, Xt), i = e.map((a) => a.id), s = t.map((a) => a.externalId), o = s.length > 0 ? cP(s) : void 0, r = i.length > 0 ? aP(i) : void 0;
  return o !== void 0 && r !== void 0 ? { and: [o, r] } : o ?? r;
}
function aP(n) {
  return {
    in: {
      property: ["id"],
      values: n
    }
  };
}
function cP(n) {
  return {
    in: {
      property: ["externalId"],
      values: n
    }
  };
}
function dP(n) {
  const e = n.filter(F);
  if (e.length !== 0)
    return e.length === 1 ? e[0] : { and: e };
}
const lP = [{ property: ["_score_"] }], na = async (n, {
  cursor: e,
  limit: t = 1e3,
  sort: i = lP,
  filters: s,
  aggregatedProperties: o = ["path"]
}) => await n.post(`/api/v1/projects/${n.project}/assets/list`, {
  headers: {
    "cdf-version": "alpha"
  },
  data: {
    limit: t,
    sort: i,
    ...s,
    aggregatedProperties: o,
    cursor: e
  }
}).then(({ data: r }) => ({
  items: r.items,
  nextCursor: r.nextCursor
}));
function ig(n) {
  return (n == null ? void 0 : n.filter) !== void 0 || (n == null ? void 0 : n.advancedFilter) !== void 0;
}
const sg = 5, uP = 1e3, og = 100;
async function rg(n, e, t) {
  return n.length === 0 ? [] : ig(e) ? await pP(n, e, t) : await hP(n, t);
}
async function hP(n, e) {
  const t = Q(n, uP), i = [];
  for (const s of Q(t, sg)) {
    const o = await Promise.all(
      s.map(
        async (r) => await e.assets.retrieve(r, { ignoreUnknownIds: !0 })
      )
    );
    i.push(...o.flat());
  }
  return i;
}
async function pP(n, e, t) {
  const i = Q(n, og), s = [];
  for (const o of Q(i, sg)) {
    const r = await fP(o, e, t);
    s.push(...r.flat());
  }
  return s;
}
async function fP(n, e, t) {
  return await Promise.all(
    n.map(async (i) => {
      const s = rP(i), o = dP([e.advancedFilter, s]), { items: r } = await na(t, {
        filters: {
          ...e,
          advancedFilter: o
        },
        limit: og
      });
      return r;
    })
  );
}
const gP = 5, mP = 5;
async function ag(n, e, t) {
  const i = await CP(n, t), s = await IP(
    i,
    t,
    e.image360AnnotationFilterOptions
  );
  return await yP(s, e.assetFilters, t);
}
async function yP(n, e, t) {
  const i = n.map((r) => {
    const a = r.data.assetRef;
    if (Nt(a))
      return {
        assetReference: a,
        annotationId: r.id
      };
  }).filter(F), s = Ue(
    i,
    (r) => ro(r.assetReference)
  ), o = await rg(
    s.map((r) => r.assetReference),
    e,
    t
  );
  return vP(o, i);
}
function vP(n, e) {
  const t = [];
  return n.forEach((i) => {
    const s = e.find((o) => oo(o.assetReference, i));
    if (s !== void 0) {
      const o = t.find(
        (r) => r.asset.id === i.id
      );
      o !== void 0 ? o.annotationIds.push(s.annotationId) : t.push({
        asset: i,
        annotationIds: [s.annotationId]
      });
    }
  }), t;
}
async function CP(n, e) {
  const t = [], i = Q(n, mP);
  for (const s of i) {
    const o = s.map(async (a) => await wP({
      metadata: { site_id: a }
    }, e)), r = await Promise.all(o);
    t.push(...r.flat());
  }
  return t;
}
async function IP(n, e, t) {
  const i = Q(n, 1e3), s = [];
  for (const o of Q(i, gP)) {
    const r = o.map(async (c) => {
      const d = {
        annotatedResourceIds: c.map((h) => ({ id: h })),
        annotatedResourceType: "file",
        annotationType: "images.AssetLink"
      };
      return (await e.annotations.list({
        filter: d,
        limit: 1e3
      }).autoPagingToArray({ limit: 1 / 0 })).filter(
        (h) => h.status === t.status || t.status === "all"
      ).filter((h) => ng(h.data));
    }), a = await Promise.all(r);
    s.push(...a.flat());
  }
  return s;
}
async function wP(n, e) {
  const t = { filter: n, limit: 1e3 };
  return (await e.files.list(t).autoPagingToArray({ limit: 1 / 0 })).map((s) => s.id);
}
const cg = (n, e, t = { status: "approved" }) => j({
  queryKey: [
    "reveal",
    "react-components",
    "all-assets-mapped-360-annotations",
    e,
    t.status
  ],
  queryFn: async () => await xP(
    n,
    e,
    t
  ),
  staleTime: 1 / 0
}), hR = (n, e, t, i) => {
  const { data: s, isFetched: o } = cg(
    e,
    n,
    i
  );
  return j({
    queryKey: [
      "reveal",
      "react-components",
      "search-assets-mapped-360-annotations",
      t,
      n,
      i == null ? void 0 : i.status
    ],
    queryFn: async () => {
      if (t === "")
        return s;
      const r = (s == null ? void 0 : s.map((d) => d.asset)) ?? [], a = (r == null ? void 0 : r.filter((d) => nP(d, t))) ?? [];
      return (s == null ? void 0 : s.filter(
        (d) => a.includes(d.asset)
      )) ?? [];
    },
    staleTime: 1 / 0,
    enabled: o && s !== void 0
  });
};
async function xP(n, e, t) {
  const [i, s] = Kt(e, (o) => typeof o == "string");
  return await ag(
    i,
    {
      image360AnnotationFilterOptions: t
    },
    n
  );
}
function _P(n) {
  return typeof n == "number" ? { id: n } : { externalId: n };
}
async function dg(n, e, t) {
  const i = n.map((o) => o.modelId), s = await TP(i, t);
  return await SP(s, e, t);
}
async function TP(n, e) {
  return (await Promise.all(
    Q(n, 1e3).map(async (i) => {
      const s = {
        annotatedResourceIds: i.map((r) => ({ id: r })),
        annotatedResourceType: "threedmodel",
        annotationType: "pointcloud.BoundingVolume"
      };
      return await e.annotations.list({
        filter: s,
        limit: 1e3
      }).autoPagingToArray({ limit: 1 / 0 });
    })
  )).flatMap((i) => i);
}
async function SP(n, e, t) {
  const i = n.map(
    (r) => {
      var a, c;
      return ((a = r.data.assetRef) == null ? void 0 : a.id) ?? ((c = r.data.assetRef) == null ? void 0 : c.externalId);
    }
  ).filter((r) => r !== void 0), o = yn(i).map(_P);
  return await rg(o, e, t);
}
const lg = (n, e) => j({
  queryKey: ["reveal", "react-components", "all-assets-mapped-point-cloud-annotations", e],
  queryFn: async () => await dg(e, void 0, n),
  staleTime: 1 / 0
}), pR = (n, e, t) => {
  const { data: i, isFetched: s } = lg(e, n);
  return j({
    queryKey: [
      "reveal",
      "react-components",
      "search-assets-mapped-point-cloud-annotations",
      t,
      n
    ],
    queryFn: async () => t === "" ? i : (i == null ? void 0 : i.filter((r) => {
      var d;
      const a = r.name.toLowerCase().includes(t.toLowerCase()), c = (d = r.description) == null ? void 0 : d.toLowerCase().includes(t.toLowerCase());
      return a || c;
    })) ?? [],
    staleTime: 1 / 0,
    enabled: s && i !== void 0
  });
}, bP = 10;
async function ia(n, e) {
  const t = [];
  for (const i of Q(e, bP)) {
    const s = i.map(async ({ mappings: o, model: r }) => {
      if (o.items.length === 0)
        return { model: r, assets: [], mappings: o };
      const c = Array.from(
        new Set(o.items.map((l) => l.assetId))
      ).map((l) => ({ id: l })), d = await n.assets.retrieve(c, { ignoreUnknownIds: !0 });
      return { model: r, assets: d, mappings: o };
    });
    t.push(...await Promise.all(s));
  }
  return t;
}
const fR = (n, e, t = 100, i) => {
  const s = _e(i), { data: o, isFetched: r } = ui(e.map((l) => ({ ...l, type: "cad" }))), a = P(() => o === void 0 ? /* @__PURE__ */ new Set() : new Set(
    o.flatMap(
      (l) => l.assetMappings.map((h) => h.assetId)
    )
  ), [o]), c = P(
    () => [
      "reveal",
      "react-components",
      "search-mapped-asset-mappings",
      n,
      ...e.map((l) => [l.modelId, l.revisionId])
    ],
    [n, e]
  ), d = async (l, h, p) => {
    const f = oP(n), g = await na(s, {
      limit: 1e3,
      cursor: l,
      filters: {
        advancedFilter: f
      }
    }), v = g.items.filter(F).filter(
      (w) => a.has(w.id) && !p.has(w.id)
    );
    return h.push(...v), h.length >= t || g.nextCursor === void 0 ? { assets: h, nextCursor: g.nextCursor } : (v.forEach((w) => {
      p.add(w.id);
    }), await d(
      g.nextCursor,
      h,
      p
    ));
  };
  return ur({
    queryKey: c,
    queryFn: async ({ pageParam: l }) => {
      if (n === "" || o === void 0)
        return { assets: [], nextCursor: void 0 };
      const h = /* @__PURE__ */ new Set(), { assets: p, nextCursor: f } = await d(l, [], h);
      return {
        assets: p,
        nextCursor: f
      };
    },
    initialPageParam: void 0,
    staleTime: 1 / 0,
    getNextPageParam: (l, h) => h[h.length - 1].nextCursor,
    enabled: r && o !== void 0 && o.length > 0
  });
}, AP = (n, e, t = 1e3) => {
  const i = _e(e);
  return ur({
    queryKey: [
      "reveal",
      "react-components",
      "all-mapped-equipment-asset-mappings",
      t,
      ...n.map((s) => [s.modelId, s.revisionId])
    ],
    queryFn: async ({ pageParam: s }) => {
      const o = n.map(async (c) => {
        var p;
        const l = (p = s.find(
          (f) => f.model.modelId === c.modelId && f.model.revisionId === c.revisionId
        )) == null ? void 0 : p.cursor;
        return l === void 0 ? { mappings: { items: [] }, model: c } : { mappings: await i.assetMappings3D.filter(c.modelId, c.revisionId, {
          cursor: l === "start" ? void 0 : l,
          limit: t
        }), model: c };
      }), r = await Promise.all(o);
      return await ia(i, r);
    },
    initialPageParam: n.map((s) => ({ cursor: "start", model: s })),
    staleTime: 1 / 0,
    getNextPageParam: ug
  });
}, gR = (n, e) => {
  const t = _e();
  return ur({
    queryKey: [
      "reveal",
      "react-components",
      "mappings-for-asset-ids",
      ...n.map((i) => [i.modelId, i.revisionId]),
      ...e
    ],
    queryFn: async ({ pageParam: i }) => {
      const s = n.map(async (a) => {
        var h;
        const d = (h = i.find(
          (p) => p.model.modelId === a.modelId && p.model.revisionId === a.revisionId
        )) == null ? void 0 : h.cursor;
        return d === void 0 || e.length === 0 ? { mappings: { items: [] }, model: a } : { mappings: await t.assetMappings3D.filter(a.modelId, a.revisionId, {
          cursor: d === "start" ? void 0 : d,
          limit: 1e3,
          filter: { assetIds: e }
        }), model: a };
      }), o = await Promise.all(s);
      return await ia(t, o);
    },
    initialPageParam: n.map((i) => ({ cursor: "start", model: i })),
    staleTime: 1 / 0,
    getNextPageParam: ug
  });
};
function ug(n) {
  const e = n.map(({ mappings: t, model: i }) => ({ cursor: t.nextCursor, model: i })).filter((t) => t.cursor !== void 0);
  if (e.length !== 0)
    return e;
}
function EP(n) {
  const e = n.map((i) => ({
    type: "view",
    externalId: i.externalId,
    space: i.space,
    version: i.version
  })), t = n.map((i) => {
    if (!(i.externalId === xe.externalId && i.space === xe.space))
      return {
        exists: {
          property: [
            i.space,
            `${i.externalId}/${i.version}`,
            "object3D"
          ]
        }
      };
  }).filter(F);
  return {
    and: [
      {
        hasData: e
      },
      {
        exists: {
          property: [
            xe.space,
            `${xe.externalId}/${xe.version}`,
            "object3D"
          ]
        }
      },
      ...t
    ]
  };
}
const mR = (n, e, t, i, s = 100) => {
  if (s > 1e3)
    throw new Error("Limit cannot be greater than 1000");
  const o = Te(), r = li(), a = Jc(), c = P(
    () => yn(e.map((l) => l.space)),
    [e]
  ), d = P(() => Kr(t), [t]);
  return j({
    queryKey: [
      "reveal",
      "react-components",
      "search-mapped-fdm",
      n,
      d,
      e,
      i,
      s
    ],
    queryFn: async () => {
      if (t.length === 0)
        return [];
      const l = await pg(a, o, e), h = Q(l, 10);
      h.length === 0 && h.push([]);
      const p = [];
      for (const f of h) {
        const g = await MP(
          n,
          c,
          f,
          t,
          i,
          o,
          r,
          s
        );
        p.push(...g);
      }
      return p;
    },
    staleTime: 1 / 0
  });
};
function yR(n, e, t) {
  const i = li(), s = Te(), o = Jc();
  return Z(
    async (r) => {
      const a = await pg(o, s, [e]);
      return (await i.filterNodesByMappedTo3d(
        [{ instances: r, view: a[0] }],
        n,
        [e.space],
        t
      )).flatMap((d) => d.instances);
    },
    [t, n, e, i, s, o]
  );
}
const MP = async (n, e, t, i, s, o, r, a = 100) => {
  if (n === "") {
    const d = await r.listMappedFdmNodes(
      i,
      t,
      s,
      a
    ), l = PP(d);
    return t.map((p) => {
      var f;
      return {
        view: Yn(p),
        instances: ((f = l.find(
          (g) => g.view.externalId === p.externalId && g.view.space === p.space
        )) == null ? void 0 : f.instances) ?? []
      };
    });
  }
  const c = [];
  for (const d of t) {
    const l = await o.searchInstances(
      Yn(d),
      n,
      "node",
      a,
      s
    );
    c.push({
      view: d,
      instances: l.instances
    });
  }
  return await r.filterNodesByMappedTo3d(c, i, e, !0);
}, vR = (n, e, t = !0) => {
  const i = li();
  return j({
    queryKey: ["reveal", "react-components", "all-mapped-equipment-fdm", e, n],
    queryFn: async () => {
      const s = hg(e), o = EP(s);
      return await i.listAllMappedFdmNodes(
        n,
        s,
        o
      );
    },
    staleTime: 1 / 0,
    enabled: t
  });
};
function PP(n) {
  return n.reduce((e, t) => {
    const i = Cs(t);
    return Object.keys(i.properties).forEach((s) => {
      var l;
      const o = i.properties[s], r = (l = Object.keys(o).find((h) => !Jn(o[h], {}))) == null ? void 0 : l.split("/");
      if (r === void 0 || r.length !== 2)
        return e;
      const a = r[0], c = r[1], d = e.find(
        (h) => h.view.externalId === a && h.view.space === s
      );
      if (d === void 0)
        return e.push({
          view: {
            space: s,
            externalId: a,
            version: c,
            type: "view"
          },
          instances: [i]
        }), e;
      d.instances.push(i);
    }), e;
  }, []);
}
function hg(n) {
  return n.map((e) => ({
    ...e,
    type: "view"
  }));
}
async function pg(n, e, t) {
  return await n.fetchQuery({
    queryKey: [
      "reveal",
      "react-components",
      "search-mapped-fdm",
      "get-view-definitions-from-simple-source",
      t
    ],
    queryFn: async () => {
      const i = Q(t, 1e3), s = [];
      for (const o of i) {
        const r = await e.getViewsByIds(hg(o));
        s.push(...r.items);
      }
      return s;
    }
  });
}
function CR(n) {
  const e = _e();
  return j({
    queryKey: ne.timeseriesById(n),
    queryFn: async () => await Wf(e, n),
    enabled: n.length > 0
  });
}
const IR = (n, e) => {
  const t = _e(), i = n.map((o) => ({ id: o })), { data: s } = j({
    queryKey: [ne.timeseriesLatestDatapoint(), n],
    queryFn: async () => await Kf(t, i),
    enabled: !e && i.length > 0
  });
  return s;
}, OP = async (n, e, t) => e.length === 0 || e.filter((i) => i.length > 0).length === 0 ? [] : await ea(n, {
  resourceExternalIds: e,
  relationshipResourceTypes: t
}), wR = ({
  asset: n,
  filter: e,
  resourceTypes: t
}) => {
  const i = _e();
  return j({
    queryKey: [
      ne.timeseriesFromRelationship(),
      n.externalId,
      e == null ? void 0 : e.isStep,
      ...t
    ],
    queryFn: async () => {
      const s = await OP(
        i,
        [n.externalId ?? ""],
        t
      );
      return s.length > 0 ? s == null ? void 0 : s.map((r) => {
        if (r.targetType === "timeSeries" && r.target !== void 0) {
          const a = r.target;
          return ((e == null ? void 0 : e.isStep) === !1 || (e == null ? void 0 : e.isStep) === void 0) && a.isStep ? void 0 : a;
        }
        if (r.sourceType === "timeSeries" && r.source !== void 0) {
          const a = r.source;
          return ((e == null ? void 0 : e.isStep) === !1 || (e == null ? void 0 : e.isStep) === void 0) && a.isStep ? void 0 : a;
        }
      }).filter((r) => !Bg(r)) : [];
    }
  });
}, RP = (n, e, t) => e.filter((s) => t.find((r) => r.assetIds.externalId === n.externalId && r.timeseriesIds.externalId === s.externalId) !== void 0 ? !0 : s.assetId === n.id), DP = 1e3, kP = async (n, e, t) => {
  const i = Q(e, DP), o = (await St(
    i.map(
      (a) => async () => await ea(n, {
        resourceExternalIds: a,
        relationshipResourceTypes: t
      })
    ),
    2
  )).filter(F).flat();
  return (o == null ? void 0 : o.map((a) => {
    const c = {
      assetIds: { externalId: "" },
      timeseriesIds: { externalId: "" }
    };
    return a.sourceType === "asset" ? c.assetIds.externalId = a.sourceExternalId : a.targetType === "asset" && (c.assetIds.externalId = a.targetExternalId), a.sourceType === "timeSeries" ? c.timeseriesIds.externalId = a.sourceExternalId : a.targetType === "timeSeries" && (c.timeseriesIds.externalId = a.targetExternalId), c;
  })) ?? [];
};
function xR(n) {
  const e = _e(), t = P(() => yn(n.map((o) => o.externalId).filter(F)), [n]), i = P(() => yn(
    n == null ? void 0 : n.map((o) => o.assetId === void 0 ? void 0 : { id: o.assetId }).filter(F)
  ), [n]), s = ["asset"];
  return j({
    queryKey: [
      ne.timeseriesLinkedToAssets(),
      s,
      t
    ],
    queryFn: async () => {
      const o = await kP(
        e,
        t,
        s
      ), r = o.map(
        (C) => C.assetIds
      ), a = Ue(i, "id"), d = Ue(
        r,
        "externalId"
      ).map((C) => C.externalId === void 0 ? void 0 : { externalId: C.externalId }).filter(F), l = await Ns(e, a), h = await Ns(e, d), p = l.concat(h);
      return Ue(p, "id").map((C) => ({
        asset: C,
        timeseries: RP(
          C,
          n,
          o
        )
      }));
    },
    enabled: t.length > 0,
    placeholderData: zg
  });
}
const LP = (n) => ({
  with: {
    pointCloudVolumes: {
      nodes: {
        filter: {
          and: [
            $0,
            W0([
              {
                externalId: n[0].externalId,
                space: n[0].space
              }
            ])
          ]
        }
      },
      limit: 1e3
    },
    object3D: {
      nodes: {
        from: "pointCloudVolumes",
        through: {
          view: Ke,
          identifier: "object3D"
        },
        direction: "outwards"
      },
      limit: 1e3
    },
    assets: {
      nodes: {
        from: "object3D",
        through: {
          view: st,
          identifier: "object3D"
        }
      },
      limit: 1e3
    }
  },
  select: {
    pointCloudVolumes: {
      sources: [
        {
          source: Ke,
          properties: ["volumeReferences", "object3D", "revisions", "volumeType", "volume"]
        }
      ]
    },
    object3D: {},
    assets: {
      sources: [
        {
          source: xe,
          properties: ["object3D", "name", "description"]
        }
      ]
    }
  }
}), NP = (n) => {
  const e = Te();
  return j({
    queryKey: [
      ne.pointCloudDMVolumeMappings(
        n.map((t) => `${t.modelId}/${t.revisionId}`).sort()
      )
    ],
    queryFn: async () => await Promise.all(
      n.map(async (t) => {
        const i = await BP(
          t.modelId,
          t.revisionId,
          e
        );
        return {
          model: t,
          pointCloudDMVolumeWithAsset: i
        };
      })
    ),
    staleTime: 1 / 0,
    enabled: n.length > 0
  });
}, BP = async (n, e, t) => {
  const i = await Gf([n], t), s = await Uf(
    i,
    [e],
    t
  ), o = LP(s), r = await t.queryNodesAndEdges(o), a = r.items.pointCloudVolumes.map((l) => {
    var f;
    const h = l.properties.cdf_cdm["CognitePointCloudVolume/v1"], p = h.revisions.indexOf(s[0]);
    return {
      externalId: l.externalId,
      space: l.space,
      volumeReference: (f = h.volumeReferences) == null ? void 0 : f[p],
      object3D: h.object3D,
      volumeType: h.volumeType,
      volume: h.volume
    };
  }), c = r.items.assets.map((l) => {
    const h = l.properties.cdf_cdm["CogniteAsset/v1"];
    return {
      externalId: l.externalId,
      space: l.space,
      object3D: h.object3D,
      name: h.name,
      description: h.description
    };
  });
  return a.map((l) => {
    const h = c.find((p) => {
      const f = p.object3D;
      return f.space === l.object3D.space && f.externalId === l.object3D.externalId;
    });
    return {
      ...l,
      dmAsset: h
    };
  });
}, FP = Ye({
  use3dModels: zt,
  useFdmSdk: Te
}), VP = () => {
  const { use3dModels: n, useFdmSdk: e } = Xe(FP), t = n(), i = e(), s = P(() => t.filter(
    (c) => c.type === "pointcloud"
  ).filter(dr), [t]), o = P(
    () => Kr(s.map((c) => c.modelIdentifier)),
    [s]
  ), r = [ne.pointCloudDMModelIdRevisionIds(o)];
  return j({
    queryKey: r,
    queryFn: async () => await Promise.all(
      s.map(async (d) => {
        const { modelId: l, revisionId: h } = await Yr(
          d.modelIdentifier.revisionExternalId,
          d.modelIdentifier.revisionSpace,
          i
        );
        return {
          modelId: l,
          revisionId: h,
          type: "pointcloud"
        };
      })
    ),
    staleTime: 1 / 0
  });
}, jP = (n) => (n == null ? void 0 : n.type) === "pointcloud" && n.volumeMetadata !== void 0 && "assetRef" in n.volumeMetadata && "volumeInstanceRef" in n.volumeMetadata, zP = (n) => {
  const { data: e } = VP(), t = di(e), i = P(
    () => t.map((o) => o.data).filter(F),
    [t]
  ), { data: s } = NP(i);
  return P(() => i.length === 0 || n.length === 0 ? H : (s == null ? void 0 : s.flatMap(
    (r) => r.pointCloudDMVolumeWithAsset.filter(
      (a) => n.some(
        (c) => a.dmAsset !== void 0 && c.externalId === a.dmAsset.externalId && c.space === a.dmAsset.space
      )
    ).map((a) => {
      if (a.dmAsset !== void 0)
        return {
          volumeInstanceRef: {
            externalId: a.externalId,
            space: a.space
          },
          asset: a.dmAsset
        };
    }).filter(F)
  )) ?? H, [i, n]);
}, UP = (n) => {
  const e = Te(), t = P(() => {
    var s;
    if (jP(n)) {
      const o = (s = n.volumeMetadata) == null ? void 0 : s.assetRef;
      if (o !== void 0)
        return [o];
    }
    return [];
  }, [n]), i = zP(t);
  return j({
    queryKey: [
      ne.pointCloudDMVolumeAssetMappingsWithViews(
        t.map((s) => `${s.externalId}/${s.space}`).sort()
      )
    ],
    queryFn: async () => i === void 0 || i.length === 0 ? H : await Promise.all(
      i.map(async (o) => {
        const r = {
          externalId: o.asset.externalId,
          space: o.asset.space
        };
        return {
          views: (await Os(e, [r])).items[0].inspectionResults.involvedViews,
          assetInstance: o.asset
        };
      })
    ),
    enabled: i !== void 0 && i.length > 0
  });
}, _R = (n) => {
  const e = (n == null ? void 0 : n.leftClick) ?? !0, t = (n == null ? void 0 : n.rightClick) ?? !1, i = (n == null ? void 0 : n.disableOnEditTool) ?? !0, s = oe(), o = me(), [r, a] = M(void 0), [c, d] = M(void 0), [l, h] = M(void 0), [p, f] = M(void 0);
  R(() => {
    const x = (T) => {
      (async () => {
        const O = e && T.button === qo.LEFT, S = t && T.button === qo.RIGHT;
        if (!(O || S) || i && UI(o.commandsController)) {
          h(void 0), f(void 0);
          return;
        }
        const E = new Ct(T.offsetX, T.offsetY);
        h(E), f(T.button);
        const B = await s.getAnyIntersectionFromPixel(E), L = await s.get360AnnotationIntersectionFromPixel(
          T.offsetX,
          T.offsetY
        );
        a(B !== void 0 ? B : void 0), d(L !== null ? L : void 0);
      })();
    };
    return s.on("click", x), () => {
      s.off("click", x);
    };
  }, [s]);
  const { data: g } = eA(r), { data: C } = Jb(r), v = Vb(r), w = UP(r);
  return GP(
    p,
    l,
    g,
    C,
    v,
    w,
    c ?? r
  );
}, GP = (n, e, t, i, s, o, r) => {
  const a = HP(t);
  return P(() => {
    if (r === void 0)
      return;
    const d = i === void 0 ? void 0 : i.node === void 0 ? null : {
      cadNode: i.node,
      assetIds: i.mappings.map((p) => p.assetId)
    }, l = c(s), h = c(o);
    return {
      mouseButton: n,
      position: e,
      fdmResult: a,
      assetMappingResult: d,
      pointCloudAnnotationMappingResult: l,
      pointCloudFdmVolumeMappingResult: h,
      intersection: r
    };
  }, [
    r,
    a,
    i == null ? void 0 : i.node,
    s.data,
    s.isFetching,
    o.data,
    o.isFetching
  ]);
  function c(d) {
    return d.isFetching ? void 0 : d.data === void 0 || d.data.length === 0 ? null : d.data;
  }
}, HP = (n) => {
  const [e, t] = M();
  return R(() => {
    if (n === void 0) {
      t(void 0);
      return;
    }
    i(n);
    async function i(s) {
      const o = await s.cadAndFdmNodesPromise;
      if (o === void 0 || o.fdmIds.length === 0) {
        t(null);
        return;
      }
      t({
        fdmNodes: o.fdmIds,
        cadNode: o.cadNode,
        views: void 0
      });
      const r = await s.viewsPromise;
      if (r === void 0 || r.length === 0) {
        t({
          fdmNodes: o.fdmIds,
          cadNode: o.cadNode,
          views: null
        });
        return;
      }
      t({
        fdmNodes: o.fdmIds,
        cadNode: o.cadNode,
        views: r
      });
    }
  }, [n]), e;
}, qP = (n, e) => {
  const { data: t } = _o(n, e), i = _e(), s = oe(), { data: o } = j({
    queryKey: ["reveal", "react-components", "groundplaneUrls", t ?? "noSceneData"],
    queryFn: async () => {
      if ((t == null ? void 0 : t.groundPlanes) === void 0 || t.groundPlanes.length === 0)
        return [];
      const a = await i.files.getDownloadUrls(
        t.groundPlanes.map((c) => ({
          externalId: c.file
        }))
      );
      return await Promise.all(
        a.map(async (c, d) => {
          let l;
          const h = "Failed to load groundplane texture";
          try {
            l = await new rd().loadAsync(c.downloadUrl);
          } catch {
            console.error(h);
            return;
          }
          if (l === null) {
            console.error(h);
            return;
          }
          if (t.groundPlanes[d].wrapping === "repeat") {
            const p = t.groundPlanes[d].repeatU, f = t.groundPlanes[d].repeatV;
            l.repeat.set(p, f), l.wrapS = oa, l.wrapT = oa;
          }
          return l;
        })
      );
    },
    staleTime: 1 / 0
  });
  R(() => {
    if (t == null || o === void 0 || o.length === 0)
      return;
    const a = 1e4, c = [], d = r(t.sceneConfiguration.updatedAt);
    return t.groundPlanes.forEach((l, h) => {
      if ((o == null ? void 0 : o[h]) === void 0)
        return;
      const p = o[h], f = new qi({ map: p, side: Qs }), g = l.scaleX, C = d ? l.scaleZ : l.scaleY, v = new nm(
        a * g,
        a * C
      );
      v.name = "CogniteGroundPlane";
      const w = new Ce(v, f);
      w.position.set(
        l.translationX,
        l.translationY,
        l.translationZ
      ), w.rotation.set(-Math.PI / 2, 0, 0), w.position.applyMatrix4(G);
      const x = new _s(w);
      x.isPartOfBoundingBox = !1, x.shouldPick = !0, s.addCustomObject(x), c.push(x);
    }), () => {
      c.forEach((l) => {
        var f;
        const h = l.object;
        h.geometry.dispose();
        const p = h.material;
        (f = p.map) == null || f.dispose(), p.dispose(), s.removeCustomObject(l);
      }), Lt(c);
    };
  }, [o]);
  function r(a) {
    return a === void 0 ? !1 : new Date(a) > /* @__PURE__ */ new Date("2024-08-01T10:44:00.000Z");
  }
}, TR = () => {
  const n = ii();
  return (n == null ? void 0 : n.renderTargetRef.current) !== void 0;
}, fg = (n, e) => {
  const t = _o(n, e), [i, s] = M([]), o = xf();
  return R(() => {
    if (t.data === void 0 || t.data === null)
      return;
    const r = [];
    t.data.sceneModels.forEach((a) => {
      if (Ee(a.modelIdentifier)) {
        const c = {
          modelId: a.modelIdentifier.modelId,
          revisionId: a.modelIdentifier.revisionId
        }, d = Go(a);
        r.push({ ...c, transform: d });
      } else if (Tt(a.modelIdentifier)) {
        const c = {
          revisionExternalId: a.modelIdentifier.revisionExternalId,
          revisionSpace: a.modelIdentifier.revisionSpace
        }, d = Go(a);
        r.push({ ...c, transform: d });
      }
    }), t.data.image360Collections.forEach((a) => {
      const c = Go(a), d = {
        source: o ? "cdm" : "dm",
        externalId: a.image360CollectionExternalId,
        space: a.image360CollectionSpace
      };
      r.push({ ...d, transform: c });
    }), s(r);
  }, [t.data]), i;
};
function Go(n) {
  const e = new fe();
  n.scaleX === 0 && (n.scaleX = 1), n.scaleY === 0 && (n.scaleY = 1), n.scaleZ === 0 && (n.scaleZ = 1), e.makeRotationFromEuler(
    new Zs(
      Rt.degToRad(n.eulerRotationX),
      Rt.degToRad(n.eulerRotationY),
      Rt.degToRad(n.eulerRotationZ),
      "XYZ"
    )
  );
  const t = new fe().makeScale(
    n.scaleX,
    n.scaleY,
    n.scaleZ
  );
  e.multiply(t);
  const i = new fe().makeTranslation(
    n.translationX,
    n.translationY,
    n.translationZ
  );
  return e.premultiply(i), e.premultiply(G), e;
}
const $P = (n, e) => {
  const t = _o(n, e), i = oe(), s = _e(), { data: o } = j({
    queryKey: ["reveal", "react-components", "skyboxUrl", t.data],
    queryFn: async () => {
      var d;
      if (((d = t.data) == null ? void 0 : d.skybox) === void 0)
        return null;
      const r = t.data.skybox.file, a = await s.files.getDownloadUrls([{ externalId: r }]);
      if (a.length === 0)
        return null;
      const c = a[0].downloadUrl;
      try {
        return await new rd().loadAsync(c);
      } catch {
        return console.error("Failed to load skybox texture"), null;
      }
    },
    staleTime: 1 / 0
  });
  R(() => {
    if (o == null)
      return;
    const [r, a] = WP(o, i), c = new _s(r);
    return c.isPartOfBoundingBox = !1, i.addCustomObject(c), a;
  }, [o]);
};
function WP(n, e) {
  const i = new sd(10, 20, 20), s = new qi({
    side: pr,
    map: n
  });
  s.depthWrite = !1;
  const o = new Ce(i, s);
  o.renderOrder = -2, o.frustumCulled = !1, o.boundingBox = new te().makeEmpty();
  const r = (c, d, l) => {
    o.position.copy(l.position), o.updateMatrix(), o.updateMatrixWorld(!0), o.updateWorldMatrix(!1, !0), l.lastNear = l.near, l.lastFar = l.far, l.near = 0.1, l.far = 10 + 0.1, l.updateProjectionMatrix();
  }, a = (c, d, l) => {
    l.near = l.lastNear, l.far = l.lastFar, l.updateProjectionMatrix();
  };
  return o.onBeforeRender = r, o.onAfterRender = a, [
    o,
    () => {
      i.dispose(), n.dispose(), o.material.dispose(), e.removeObject3D(o);
    }
  ];
}
const SR = (n) => {
  const e = zt(), t = Tp(), i = Te(), s = P(() => n === void 0 ? H : e.filter((a) => a.visible), [e, n]), o = P(() => n === void 0 ? H : t.filter((a) => a.getIconsVisibility()), [t, n]);
  return {
    models: j({
      queryKey: [
        "visible-3d-models",
        s.map((a) => `${a.modelId}/${a.revisionId}`).sort()
      ],
      queryFn: async () => {
        const a = s.map(async (c) => {
          if (c.type === "pointcloud" && dr(c)) {
            const d = c, { modelId: l, revisionId: h } = await Yr(
              d.modelIdentifier.revisionExternalId,
              d.modelIdentifier.revisionSpace,
              i
            );
            return {
              modelId: l,
              revisionId: h
            };
          }
          return {
            modelId: c.modelId,
            revisionId: c.revisionId
          };
        });
        return await Promise.all(a);
      },
      enabled: s.length > 0,
      staleTime: 1 / 0
    }).data ?? H,
    image360Collections: o
  };
}, bR = () => {
  const e = me().commandsController.getCommandByTypeRecursive(af);
  return Rw(e, () => e == null ? void 0 : e.isChecked) ?? !1;
}, AR = (n, e) => {
  const t = Fb();
  return j({
    queryKey: [
      "reveal",
      "react-components",
      "image360-annotations-info",
      ...(n == null ? void 0 : n.sort()) ?? [],
      ...(e == null ? void 0 : e.map((i) => i).sort()) ?? []
    ],
    queryFn: async () => {
      if (n === void 0 || n.length === 0 || e === void 0 || e.length === 0)
        return [];
      const i = new Set(n.map(ro));
      return (await t.getReveal360Annotations(e)).filter((r) => {
        const a = Tr(
          r.assetAnnotationImage360Info.annotationInfo
        );
        return a !== void 0 && i.has(a);
      });
    },
    staleTime: 1 / 0,
    enabled: n !== void 0 && e !== void 0
  });
}, KP = Ye({
  useReveal3dResourcesFromScene: fg,
  useAllMappedEquipmentAssetMappings: AP,
  useAllAssetsMapped360Annotations: cg,
  useAllAssetsMappedPointCloudAnnotations: lg
}), ER = (n, e) => {
  const {
    useReveal3dResourcesFromScene: t,
    useAllMappedEquipmentAssetMappings: i,
    useAllAssetsMapped360Annotations: s,
    useAllAssetsMappedPointCloudAnnotations: o
  } = Xe(KP), r = t(e.externalId, e.space), a = r.filter(
    (O) => !Zt(O)
  ).map((O) => {
    if (Ee(O))
      return {
        modelId: O.modelId,
        revisionId: O.revisionId
      };
  }).filter(F), {
    data: c,
    isFetching: d,
    hasNextPage: l,
    fetchNextPage: h
  } = i(a, n), f = r.filter(
    (O) => "siteId" in O
  ).map((O) => "siteId" in O ? O.siteId : O.externalId), { data: g, isLoading: C } = s(n, f), { data: v, isLoading: w } = o(n, a);
  R(() => {
    l && !d && h();
  }, [l, d, h]);
  const x = P(() => {
    if (d || l || C || w)
      return;
    const O = (c == null ? void 0 : c.pages.flat().map((L) => L.assets).flat()) ?? [], S = (g == null ? void 0 : g.map((L) => L.asset)) ?? [], E = [
      ...O,
      ...S,
      ...v ?? []
    ], B = /* @__PURE__ */ new Map();
    for (const L of E)
      B.set(L.id, L);
    return B;
  }, [
    c,
    g,
    v,
    d,
    l,
    C,
    w
  ]), T = Z(
    (O) => O.filter((S) => (x == null ? void 0 : x.has(S.id)) === !0),
    [x]
  );
  if (x !== void 0)
    return T;
};
async function YP(n, e, t, i) {
  const [s, o] = Kt(n, Kn), r = [
    ...s.map((c) => c.siteId),
    ...o.map((c) => c.externalId)
  ], a = await ag(
    r,
    {
      assetFilters: e,
      image360AnnotationFilterOptions: {
        status: "approved"
      }
    },
    i
  );
  return Qc(a, t).map((c) => c.asset);
}
const XP = 10;
async function ZP(n, e, t, i) {
  const s = t === void 0, o = [];
  for (const d of Q(n, XP)) {
    const l = d.map(
      async (p) => await JP(p, t, s, e, i)
    ), h = await Promise.all(l);
    o.push(...h);
  }
  const r = await ia(i, o), a = QP(r);
  return {
    nextCursor: a.some(
      (d) => d.cursor !== void 0
    ) ? JSON.stringify(a) : void 0,
    data: r.flatMap((d) => d.assets)
  };
}
function QP(n) {
  return n.map(({ mappings: e, model: t }) => ({ cursor: e.nextCursor, model: t })).filter((e) => e.cursor !== void 0);
}
async function JP(n, e, t, i, s) {
  var a;
  const o = (a = e == null ? void 0 : e.find(
    (c) => tn(c.model, n)
  )) == null ? void 0 : a.cursor;
  return !t && o === void 0 ? { mappings: { items: [] }, model: n } : { mappings: await s.assetMappings3D.filter(n.modelId, n.revisionId, {
    cursor: o,
    limit: i
  }), model: n };
}
async function eO(n, e, t, i, s, o) {
  if (n.length === 0)
    return { data: [], nextCursor: void 0 };
  const r = n.map((f) => ({ ...f, type: "cad" })), a = await tO(
    r,
    o
  ), c = new Set(
    a.flatMap(
      (f) => f.assetMappings.map((g) => g.assetId)
    )
  ), d = async (f, g, C) => {
    const v = await na(s, {
      limit: 1e3,
      cursor: f,
      filters: i
    }), x = v.items.filter(F).filter(
      (T) => c.has(T.id) && !C.has(T.id)
    );
    return g.push(...x), g.length >= e || v.nextCursor === void 0 ? { assets: g, nextCursor: v.nextCursor } : (x.forEach((T) => {
      C.add(T.id);
    }), await d(
      v.nextCursor,
      g,
      C
    ));
  }, l = /* @__PURE__ */ new Set(), { assets: h, nextCursor: p } = await d(t, [], l);
  return { data: h, nextCursor: p };
}
async function tO(n, e) {
  const t = n.map(async (i) => {
    const s = await e.getAssetMappingsForModel(
      i.modelId,
      i.revisionId
    );
    return { model: i, assetMappings: s };
  });
  return await Promise.all(t);
}
async function nO(n, e, t, i, s, o) {
  if (!ig(i)) {
    const r = t === void 0 ? void 0 : JSON.parse(t);
    return await ZP(n, e, r, s);
  }
  return await eO(
    n,
    e,
    t,
    i,
    s,
    o
  );
}
async function MR(n, { limit: e, cadAssetsCursor: t, filters: i }, s, o) {
  const r = t === void 0, a = o.cdfCaches.assetMappingAndNode3dCache, c = n.filter((T) => T.type === "cad").map((T) => T.addOptions).filter(Ee), d = n.filter((T) => T.type === "pointcloud").map((T) => T.addOptions).filter(Ee), l = n.filter((T) => T.type === "image360").map((T) => T.addOptions), h = nO(
    c,
    e,
    t,
    i,
    s,
    a
  ), p = r ? dg(d, i, s) : Promise.resolve([]), f = r ? YP(l, i, e, s) : Promise.resolve([]), { nextCursor: g, data: C } = await h, v = await p, w = await f, x = Ue(
    [...C, ...v, ...w],
    (T) => T.id
  );
  return { nextCursor: g, data: x };
}
function iO(n, e, t) {
  const {
    useModelHandlers: i,
    useSyncExternalLayersState: s,
    ModelLayerSelection: o,
    use3dModels: r,
    useReveal: a
  } = Xe(HM), c = a(), d = r(), [l, h] = i(
    n,
    e,
    c,
    d,
    qM
  );
  return s(
    l,
    t,
    n,
    h
  ), {
    modelLayerHandlers: l,
    updateCallback: h,
    ModelLayerSelection: o
  };
}
const gg = ({
  layersState: n,
  setLayersState: e,
  defaultLayerConfiguration: t
}) => {
  const { t: i } = W(), { modelLayerHandlers: s, updateCallback: o, ModelLayerSelection: r } = iO(
    e,
    t,
    n
  );
  return /* @__PURE__ */ u(k, { children: /* @__PURE__ */ _($, { placement: "right", hideOnOutsideClick: !0, offset: Dn, children: [
    /* @__PURE__ */ u($.Trigger, { children: /* @__PURE__ */ u(
      ce,
      {
        content: /* @__PURE__ */ u(ai, { label: i({ key: "LAYERS_FILTER_TOOLTIP" }) }),
        placement: "right",
        children: /* @__PURE__ */ u(
          J,
          {
            icon: /* @__PURE__ */ u(xy, {}),
            type: "ghost",
            "aria-label": i({ key: "LAYERS_FILTER_TOOLTIP" })
          }
        )
      }
    ) }),
    /* @__PURE__ */ u($.Body, { children: /* @__PURE__ */ _($.Section, { children: [
      /* @__PURE__ */ u(
        r,
        {
          label: i({ key: "CAD_MODELS" }),
          modelLayerHandlers: s.cadHandlers,
          update: o
        }
      ),
      /* @__PURE__ */ u(
        r,
        {
          label: i({ key: "POINT_CLOUDS" }),
          modelLayerHandlers: s.pointCloudHandlers,
          update: o
        }
      ),
      /* @__PURE__ */ u(
        r,
        {
          label: i({ key: "IMAGES_360" }),
          modelLayerHandlers: s.image360Handlers,
          update: o
        }
      )
    ] }) })
  ] }) });
}, sO = b(Cd)`
  position: absolute !important;
  left: 20px;
  top: 70px;
  width: 48px;
  padding: 6px;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid rgba(83, 88, 127, 0.24);
`, oO = (n) => /* @__PURE__ */ _(k, { children: [
  /* @__PURE__ */ u(gg, {}),
  /* @__PURE__ */ u(Af, {}),
  /* @__PURE__ */ u(Xf, {}),
  /* @__PURE__ */ u(gn, { weight: "2px", length: "75%" }),
  /* @__PURE__ */ u(Ef, {}),
  /* @__PURE__ */ u(gn, { weight: "2px", length: "75%" }),
  /* @__PURE__ */ u(Of, {}),
  /* @__PURE__ */ u(gn, { weight: "2px", length: "75%" }),
  /* @__PURE__ */ u(
    Mf,
    {
      customSettingsContent: n.customSettingsContent,
      lowQualitySettings: n.lowFidelitySettings,
      highQualitySettings: n.highFidelitySettings
    }
  ),
  /* @__PURE__ */ u(Pf, {})
] }), mg = Xc(
  ({
    customSettingsContent: n,
    lowFidelitySettings: e,
    highFidelitySettings: t,
    toolBarContent: i,
    storeStateInUrl: s,
    ...o
  }, r) => /* @__PURE__ */ u(sO, { ...o, ref: r, children: i ?? /* @__PURE__ */ u(
    oO,
    {
      customSettingsContent: n,
      highFidelitySettings: t,
      lowFidelitySettings: e,
      storeStateInUrl: s
    }
  ) })
);
mg.displayName = "RevealToolbarContainer";
const Pt = En(
  mg
);
Pt.FitModelsButton = Af;
Pt.SlicerButton = Ef;
Pt.LayersButton = gg;
Pt.ShareButton = Of;
Pt.SettingsButton = Mf;
Pt.HelpButton = Pf;
Pt.ResetCameraButton = LE;
Pt.SelectSceneButton = GE;
Pt.RuleBasedOutputsButton = Xf;
Pt.AssetContextualizedButton = PM;
const rO = (n, e) => {
  const t = rn();
  R(() => (t == null || t.setCurrentScene({ externalId: n, space: e }), () => {
    t == null || t.setCurrentScene(void 0);
  }), [n, e, t]);
};
function PR({
  sceneExternalId: n,
  sceneSpaceId: e,
  ...t
}) {
  const i = fg(n, e);
  return qP(n, e), $P(n, e), rO(n, e), i.length > 0 && /* @__PURE__ */ u(MA, { resources: i, ...t });
}
const OR = () => {
  const n = Te();
  return Z(
    async (t) => await hi(n, [re]) ? await n.createInstance([
      {
        instanceType: "node",
        space: re.space,
        externalId: t.id,
        sources: [
          {
            properties: {
              name: t.name,
              id: t.id,
              createdAt: t.createdAt,
              createdBy: t.createdBy,
              rulesWithOutputs: JSON.parse(JSON.stringify(t.rulesWithOutputs)),
              shamefulOutputTypes: ["color"]
            },
            source: {
              type: re.type,
              space: re.space,
              externalId: re.externalId,
              version: re.version
            }
          }
        ]
      }
    ]) : { items: [] },
    []
  );
}, RR = () => {
  const n = Te();
  return Z(
    async (t) => await hi(n, [re]) ? await n.editInstance([
      {
        instanceType: "node",
        space: re.space,
        externalId: t.id,
        sources: [
          {
            properties: {
              name: t.name,
              id: t.id,
              createdAt: t.createdAt,
              createdBy: t.createdBy,
              rulesWithOutputs: JSON.parse(JSON.stringify(t.rulesWithOutputs)),
              shamefulOutputTypes: ["color"]
            },
            source: {
              type: re.type,
              space: re.space,
              externalId: re.externalId,
              version: re.version
            }
          }
        ]
      }
    ]) : { items: [] },
    []
  );
}, DR = () => {
  const n = Te();
  return Z(
    async (t) => await hi(n, [re]) ? await n.deleteInstances([
      {
        instanceType: "node",
        space: re.space,
        externalId: t.externalId
      }
    ]) : { items: [] },
    []
  );
}, kR = () => {
  const n = Te();
  return Z(
    async (t) => {
      if (!await hi(n, [re]))
        return [];
      const s = `${re.externalId}/${re.version}`, o = {
        in: {
          property: [re.space, s, "id"],
          values: [t]
        }
      };
      return (await n.searchInstances(
        re,
        "",
        "node",
        1,
        o
      )).instances;
    },
    []
  );
}, aO = ({ onShowMore: n, isShowMore: e }) => {
  const { t } = W();
  return /* @__PURE__ */ u(cO, { $showMore: e, children: /* @__PURE__ */ u(U, { justifyContent: "center", gap: 8, children: /* @__PURE__ */ u(
    J,
    {
      size: "small",
      onClick: n,
      icon: e ? /* @__PURE__ */ u(Ty, {}) : /* @__PURE__ */ u(_y, {}),
      type: "ghost-accent",
      children: t(e ? { key: "SHOW_LESS" } : { key: "SHOW_MORE" })
    }
  ) }) }, "rule-based-panel-show-more");
}, cO = b.div`
  display: flex;
  width: 100%;
  gap: 8px;
  align-items: center;
  padding-bottom: ${({ $showMore: n }) => n === !0 ? "10px" : "inherit"};
  align-content: baseline;
`, dO = ({ index: n, output: e }) => /* @__PURE__ */ _(lO, { children: [
  /* @__PURE__ */ u(uO, { $backgroundColor: e.type === "color" ? e.fill : "" }),
  /* @__PURE__ */ u(hO, { children: e.label ?? (e.type === "color" ? e.fill : "") })
] }, n), lO = b.div`
  display: flex;
  width: 100%;
  gap: 8px;
  align-items: center;
`, uO = b.span`
  height: 15px;
  width: 15px;
  background: ${({ $backgroundColor: n }) => n};
  border-radius: 50%;
  display: inline-block;
`, hO = b.span`
  color: ${({ $color: n }) => n};
  line-height: 20px;
`, Wc = 5, pO = "300px", LR = ({
  ruleOutputs: n
}) => {
  const [e, t] = M(!1);
  return /* @__PURE__ */ u(k, { children: n !== void 0 && (n == null ? void 0 : n.length) > 0 && /* @__PURE__ */ u(fO, { $showMore: e, children: /* @__PURE__ */ _(U, { direction: "column", gap: 14, children: [
    n.map((i, s) => /* @__PURE__ */ u(k, { children: e || s <= Wc - 1 ? /* @__PURE__ */ u(dO, { index: s, output: i }) : /* @__PURE__ */ u(k, {}) })),
    n.length > Wc && /* @__PURE__ */ u(
      aO,
      {
        isShowMore: e,
        onShowMore: () => {
          t((i) => !i);
        }
      }
    )
  ] }) }) });
}, fO = En(b.div`
  display: flex;
  position: absolute;
  bottom: 16px;
  left: 16px;
  min-width: 200px;
  max-width: 400px;
  max-height: ${({ $showMore: n }) => n ?? !1 ? pO : "inherit"};
  border-radius: var(--cogs-border-radius--default);
  font-size: 13px;
  line-height: 18px;
  outline: none;
  transition-property: transform, visibility, opacity;
  background-color: #ffffff;
  color: var(--cogs-text-color);
  box-shadow: var(--cogs-elevation--overlay);
  margin: auto;
  justify-content: left;
  align-content: space-around;
  align-items: stretch;
  padding: 10px;
  overflow-y: auto;
`);
function ar(n) {
  if (n.type === "and" || n.type === "or")
    return n.expressions.flatMap(ar);
  if (n.type === "not")
    return ar(n.expression);
  if (n.type === "numericExpression" || n.type === "stringExpression" || n.type === "datetimeExpression" || n.type === "booleanExpression")
    return [n.trigger.type];
  sn(n);
}
function NR(n) {
  if (n.rule.expression !== void 0)
    return ar(n.rule.expression);
}
function BR(n) {
  if (tP(n))
    return { externalId: n.externalId, space: n.space };
  if (eg(n))
    return { id: n.id, externalId: n.externalId };
  sn(n);
}
export {
  QO as Architecture,
  WO as AxisGizmo,
  jR as AxisGizmoOptions,
  ab as CadModelContainer,
  YO as ContextMenu,
  Bs as IconFactory,
  fb as Image360CollectionContainer,
  qO as Image360Details,
  uI as Image360HistoricalDetails,
  eR as PoiInfoPanelContent,
  nR as PoiList,
  Pb as PointCloudContainer,
  MA as Reveal3DResources,
  sR as Reveal3DResourcesList,
  nr as RevealButtons,
  XC as RevealCanvas,
  HO as RevealContainer,
  qC as RevealContext,
  $O as RevealKeepAlive,
  Pt as RevealToolbar,
  LR as RuleBasedOutputsPanel,
  PR as SceneContainer,
  JO as ToolUI,
  mI as ViewerAnchor,
  KO as WindowWidget,
  ro as createInstanceReferenceKey,
  BR as getAssetInstanceReference,
  dR as getImage360AnnotationAssetRef,
  lR as getImage360AnnotationId,
  NR as getRuleTriggerTypes,
  eg as isClassicAsset,
  Ee as isClassicIdentifier,
  tg as isClassicImage360Annotation,
  qc as isClassicImage360AnnotationId,
  ng as isClassicImage360AssetAnnotationData,
  Tt as isDM3DModelIdentifier,
  iP as isDMImage360Annotation,
  $c as isDMImage360AnnotationId,
  tP as isDmAsset,
  _t as isDmsInstance,
  Ps as isExternalId,
  Nt as isIdEither,
  Xt as isInternalId,
  UO as isSameAssetReference,
  sP as isSameDMAnnotationId,
  Jh as isSameDmsId,
  i0 as isSameExternalId,
  oo as isSameIdEither,
  uR as isSameImage360AnnotationId,
  n0 as isSameInternalId,
  MR as searchClassicAssetsForModels,
  qM as use3DModelName,
  zt as use3dModels,
  oR as use3dNodeByExternalId,
  rR as use3dRelatedDirectConnections,
  aR as use3dRelatedEdgeConnections,
  Hf as use3dScenes,
  SR as useActiveReveal3dResources,
  cM as useAll3dDirectConnectionsWithProperties,
  cg as useAllAssetsMapped360Annotations,
  lg as useAllAssetsMappedPointCloudAnnotations,
  AP as useAllMappedEquipmentAssetMappings,
  vR as useAllMappedEquipmentFDM,
  ui as useAssetMappedNodesForRevisions,
  Jb as useAssetMappingForTreeIndex,
  XE as useAssetsAndTimeseriesLinkageDataQuery,
  xR as useAssetsAndTimeseriesLinkages,
  Vp as useAssetsByIdsQuery,
  bf as useCameraNavigation,
  _R as useClickedNodeData,
  eM as useCreateAssetMappingsMapPerModel,
  OR as useCreateRuleInstance,
  DR as useDeleteRuleInstance,
  RR as useEditRuleInstance,
  eA as useFdm3dNodeDataPromises,
  Qb as useFdmAssetMappings,
  SM as useFetchRuleInstances,
  wR as useFetchTimeseriesFromRelationshipByAsset,
  yR as useFilterNodesByMappedToModelsCallback,
  ER as useFilterOnClassicAssetsInScene,
  $S as useFilterPointsOfInterest,
  tA as useGenerateAssetMappingCachePerItemFromModelCache,
  nA as useGenerateNode3DCache,
  bR as useGhostMode,
  qP as useGroundPlaneFromScene,
  AR as useImage360AnnotationMappingsForInstanceReferences,
  Tp as useImage360Collections,
  KC as useIsDraggingOnViewer,
  TR as useIsRevealInitialized,
  GO as useLoadedScene,
  _f as useMappedEdgesForRevisions,
  gR as useMappingsForAssetIds,
  cR as useModelsForInstanceQuery,
  iA as useNodesForAssets,
  rn as usePoiDomainObject,
  Vb as usePointCloudAnnotationMappingForIntersection,
  iR as usePointCloudAnnotationMappingsForAssetIds,
  jb as usePointCloudAnnotationMappingsForModels,
  zP as usePointCloudVolumeMappingForAssetInstances,
  KS as usePointsOfInterest,
  me as useRenderTarget,
  oe as useReveal,
  zO as useReveal3DLoadedResourceCount,
  Uy as useReveal3DResourcesExpectedInViewerCount,
  fg as useReveal3dResourcesFromScene,
  _o as useSceneConfig,
  RE as useSceneDefaultCamera,
  hR as useSearchAssetsMapped360Annotations,
  pR as useSearchAssetsMappedPointCloudAnnotations,
  fR as useSearchMappedEquipmentAssetMappings,
  mR as useSearchMappedEquipmentFDM,
  kR as useSearchRuleInstance,
  $P as useSkyboxFromScene,
  tR as useSyncSelectedPoi,
  CR as useTimeseriesByIdsQuery,
  IR as useTimeseriesLatestDatapointQuery,
  En as withSuppressRevealEvents
};
//# sourceMappingURL=index.js.map
